
'use strict';
/* ---------------- hardware (from thegigrig.com specs) ---------------- */
const SUPPLIES = {
  X14:{code:'X14', name:'GENX14', price:389, sub:'14 isolated outputs + link', link:true,
    outs:[].concat(
      Array.from({length:8},(_,i)=>({v:[9],ma:200})),
      Array.from({length:4},(_,i)=>({v:[9],ma:500})),
      Array.from({length:2},(_,i)=>({v:[9,12],ma:1000})))},
  X8:{code:'X8', name:'GENX8', price:299, sub:'8 isolated outputs + link', link:true,
    outs:[].concat(
      Array.from({length:6},(_,i)=>({v:[9],ma:500})),
      Array.from({length:2},(_,i)=>({v:[9,12],ma:1000})))},
  X4LC:{code:'X4LC', name:'GENX4LC', price:99, sub:'Isolator V2 · 4 × 100mA', isExpansion:true,
    outs:Array.from({length:4},(_,i)=>({v:[9],ma:100}))}
};
/* fancy daisy chain: one DC in, six high-current DC outs. Needed as soon as more than
   one thing (high-current adapters, expansion units) hangs off the single link output */
const DISTRIBUTOR = {name:'Distributor', price:59, outs:6, url:'/products/distributor', variant:'45251951329564'};
const ADAPTERS = {
  9: {name:'Mr Universe',out:'9V', maxMa:1000, price:69, plug:'2.1mm', pol:'CN'},
  12:{name:'Supa Nova', out:'12V', maxMa:1000, price:69, plug:'2.1mm', pol:'CN'},
  15:{name:'El Paso',   out:'15V', maxMa:400,  price:69, plug:'2.1mm', pol:'CP'},
  18:{name:'Doubler',   out:'18V', maxMa:500,  price:69, plug:'2.1mm', pol:'CN'},
  24:{name:'ElectroMan',out:'24V', maxMa:300,  price:69, plug:'2.5mm', pol:'CP'}
};
const SHOP = {
  base:'https://shop.thegigrig.com',
  products:{X14:'/products/gen-x-14', X8:'/products/genx8', X4LC:'/products/genx4lc', adapter:'/products/high-current-power-adapter', cable:'/products/cable-adapters'},
  variants:{
    X14:{UK:'45324301435164',EU:'45324301467932',US:'45324301500700',AU:'45324301533468'},
    X8:{UK:'55482808959354',EU:'55482808992122',US:'55482809024890',AU:'55482809057658'},
    X4LC:'55725168230778',
    adapters:{'Mr Universe':'45252074570012','Supa Nova':'45252074602780','El Paso':'45252074635548','Doubler':'45252074668316','ElectroMan':'45252093706524'},
    cables:{reverse:'45253475107100', to25:'45253523964188', mini:'45253475074332', line6:'45253523931420', vb:'45252420469020', aca:'45252267344156'}
  }
};
let region='UK';
// when the tool lives on thegigrig.com itself, use the native cart; anywhere else, fall back to a checkout permalink
const ON_SHOP=/(^|\.)(thegigrig\.com|myshopify\.com)$/i.test(location.hostname);
let cartData=null;
const VCOLOR = {9:'var(--v9)',12:'var(--v12)',15:'var(--v15)',18:'var(--v18)',24:'var(--v24)'};
const VHEX   = {9:'#4a7c59',12:'#a2701f',15:'#33707a',18:'#6b4f9e',24:'#b05c2e'};

/* ---------------- demo pedal database (specs to be verified) ---------------- */
/* [brand, model, volts, mA, plug, polarity] */
const DB = [
 ["1981 Inventions","DRV",9,58,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["1981 Inventions","DRV MOD 2",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["1981 Inventions","DRV2 No3",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["1981 Inventions","LVL",9,60,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["1981 Inventions","MMHMM",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["29 Pedals","EUNA",9,120,"2.1mm","CN","util",0,"M",0,""],
 ["29 Pedals","FLWR",9,120,"2.1mm","CN","drive",4,"M",0,""],
 ["29 Pedals","JFET",9,100,"2.1mm","CN","drive",1,"M",0,""],
 ["29 Pedals","OAMP",9,120,"2.1mm","CN","preamp",0,"M",0,""],
 ["29 Pedals","TOKI",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Aguilar","AG Preamp",18,36,"2.1mm","CN","preamp",0,"M",0,""],
 ["Aguilar","Agro",9,7,"2.1mm","CN","drive",3,"M",0,""],
 ["Aguilar","Chorusaurus",9,12,"2.1mm","CN","mod",0,"MS",0,""],
 ["Aguilar","DB 316 Mid-EQ",9,20,"2.1mm","CN","eq",0,"M",0,""],
 ["Aguilar","DB 599 Bass Compressor",9,7,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Aguilar","DB 924",0,0,"none","NA","preamp",0,"M",0,"eol"],
 ["Aguilar","DB 925",9,3,"2.1mm","CN","preamp",0,"M",0,"eol"],
 ["Aguilar","Filter Twin",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Aguilar","Fuzzistor",9,13,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Aguilar","Grape Phaser",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Aguilar","Octamizer",9,6,"2.1mm","CN","pitch",0,"M",0,""],
 ["Aguilar","Octamizer DLX",9,500,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Aguilar","Storm King",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Aguilar","TLC Compressor",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["Aguilar","TLC Compressor EQ DLX",9,500,"2.1mm","CN","comp",0,"M",0,"dg"],
 ["Aguilar","Tone Hammer (v1)",18,7,"2.1mm","CN","preamp",0,"M",0,"eol"],
 ["Aguilar","Tone Hammer Preamp (V2)",18,36,"2.1mm","CN","preamp",0,"M",0,""],
 ["Alexander Pedals","Dynaflanger Model 213",9,250,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Alexander Pedals","F.13",9,100,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Fever Pitch",9,250,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Alexander Pedals","Forget-Me-Not",9,250,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Alexander Pedals","History Lesson",9,100,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Hot Pink Drive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Alexander Pedals","Jubilee Silver Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Alexander Pedals","Luminous",9,250,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Alexander Pedals","Marshmallow",9,100,"2.1mm","CN","pitch",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Micro Detuner",9,250,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Alexander Pedals","Now We Are Ghosts",9,250,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Alexander Pedals","Oblivion",9,100,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Radical Delay II+",9,60,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Rewind",9,250,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Alexander Pedals","Sky Fi",9,100,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Slide Away",9,250,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Alexander Pedals","Space Force",9,250,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Alexander Pedals","Super Radical Delay",9,125,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Syntax Error",9,100,"2.1mm","CN","synth",0,"M",0,"dg;eol"],
 ["Alexander Pedals","Syntax Error 2",9,250,"2.1mm","CN","synth",0,"S",0,"dg"],
 ["Alexander Pedals","Syntax Error XP",9,250,"2.1mm","CN","synth",0,"S",0,"dg"],
 ["Ampeg","Classic Analog Bass Preamp",9,20,"2.1mm","CN","preamp",0,"M",0,""],
 ["Ampeg","Liquifier Analog Chorus",9,56,"2.1mm","CN","mod",0,"M",0,""],
 ["Ampeg","Opto Comp Analog Optical Compressor",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Ampeg","SCR-DI Bass DI with Scrambler Overdrive",9,100,"2.1mm","CN","preamp",0,"M",0,""],
 ["Ampeg","Scrambler (1969 original)",9,3,"batt","NA","fuzz",4,"M",0,"eol"],
 ["Ampeg","Scrambler (SCP-OD, 2005 reissue)",9,3,"2.1mm","CN","fuzz",4,"M",0,"eol"],
 ["Ampeg","Scrambler Bass Overdrive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Ampeg","SGT-DI",9,500,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Ampeg","Sub-Blaster (SCP-OCT)",9,3,"2.1mm","CN","pitch",0,"M",0,"eol"],
 ["Analog Man","AMAZE0 Delay Controller",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["Analog Man","ARDX20 Dual Analog Delay",9,15,"2.1mm","CN","delay",0,"M",0,""],
 ["Analog Man","Astro Tone Fuzz",9,3,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Analog Man","Bad Bob Booster",9,3,"2.1mm","CN","drive",1,"M",0,""],
 ["Analog Man","Beano Boost",9,5,"2.1mm","CN","fuzz",1,"M",0,"ff"],
 ["Analog Man","Bi-Chorus",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Analog Man","Chorus (Standard/Clone)",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Analog Man","CompROSSor",9,7,"2.1mm","CN","comp",0,"M",0,""],
 ["Analog Man","Envelope Filter (Block Logo)",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Analog Man","Juicer",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Analog Man","King of Tone",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Analog Man","Mini Chorus",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Analog Man","Peppermint Fuzz",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Analog Man","Prince of Tone",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Analog Man","Sun Bender (MK1.5/MKII/MKIV)",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Analog Man","Sun Face (NKT275 germanium)",9,1,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Analog Man","Sun Lion (Sun Face + Beano)",9,8,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Anarchy Audio","Aftermath",9,35,"2.1mm","CN","mod",0,"M",0,""],
 ["Anarchy Audio","BaaBzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Anarchy Audio","Chaos Star",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Anarchy Audio","Checkmate",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Anarchy Audio","Deadwoods",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Anarchy Audio","F-Bomb",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Anarchy Audio","Flutterby",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Anarchy Audio","GIRT",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Anarchy Audio","Gold Class",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Anarchy Audio","Hereafter",9,35,"2.1mm","CN","delay",0,"M",0,""],
 ["Anarchy Audio","Reignmaker",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Anarchy Audio","Sentinel",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Arion","HU-8500 Tuner",9,26,"2.1mm","CN","tuner",0,"M",0,"eol"],
 ["Arion","MOC-1 Octave",9,5,"2.1mm","CN","pitch",0,"M",0,"eol"],
 ["Arion","MTE-1 Tubulator",9,5,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Arion","SAD-1 Stereo Delay",9,5,"2.1mm","CN","delay",0,"MS",0,"eol"],
 ["Arion","SCH-1 Stereo Chorus",9,13,"2.1mm","CN","mod",0,"MS",0,"eol"],
 ["Arion","SCH-Z Stereo Chorus",9,5,"2.1mm","CN","mod",0,"MS",0,"eol"],
 ["Arion","SFL-1 Stereo Flanger",9,20,"2.1mm","CN","mod",0,"MS",0,"eol"],
 ["Arion","SOD-1 Stereo Overdrive",9,5,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Barber","Barb EQ",9,15,"2.1mm","CN","eq",0,"M",0,""],
 ["Barber","Burn Unit",9,12,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Barber","Direct Drive",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Barber","Dirty Bomb",9,12,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Barber","Exacta",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Barber","FWW BUSS",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Barber","FWW BUSS HG",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["Barber","FWW Plus",9,12,"2.1mm","CN","drive",2,"M",0,""],
 ["Barber","Gain Changer SR",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Barber","Linden EQ",9,40,"2.1mm","CN","eq",0,"M",0,""],
 ["Barber","LTD SR",9,12,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Barber","Small Fry",9,12,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Barber","Tone Press",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Barber","Trifecta",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["BearFoot FX","Arctic White Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["BearFoot FX","Baby Pink Booster",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["BearFoot FX","Blue Bee",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Blueberry Bass Overdrive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Bone Bender MKI Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["BearFoot FX","Bumble Bee",9,13,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Burgundy BossHorn Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["BearFoot FX","Candiru Germanium Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["BearFoot FX","Candy Apple Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["BearFoot FX","Dyna Red Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["BearFoot FX","Emerald Green Distortion Machine",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["BearFoot FX","Emerald Green Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Ever Green Compressor",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["BearFoot FX","Honey Bee Overdrive",9,13,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Honey Bee Overdrive Plus",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Honey Beest",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Little Red Trebler",9,10,"2.1mm","CN","fuzz",1,"M",0,""],
 ["BearFoot FX","Mallard Green Compressor",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["BearFoot FX","Mint Green Mini Vibe",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["BearFoot FX","Model G",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Model H",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Model Hs",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Pale Green Compressor",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["BearFoot FX","Pink Purple Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["BearFoot FX","Polar Bear",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["BearFoot FX","Putting Green",9,12,"2.1mm","CN","comp",0,"M",0,""],
 ["BearFoot FX","Red Rooster Booster",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["BearFoot FX","Royal Gold Overdrive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Sea Blue EQ",9,10,"2.1mm","CN","eq",0,"M",0,""],
 ["BearFoot FX","Silver Bee Overdrive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Silver Bird Overdrive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BearFoot FX","Sparkling Yellow Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BearFoot FX","Über Bee Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Beetronics","Abelha",9,60,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","BeeBeeDee",9,200,"2.1mm","CN","delay",0,"M",0,""],
 ["Beetronics","Fatbee",9,36,"2.1mm","CN","drive",3,"M",0,""],
 ["Beetronics","Larva",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Beetronics","Nectar",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Beetronics","Octahive",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Octahive Dual FS Great Pumpkin",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Octahive V2",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Overhive",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Beetronics","Pollinator",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Beetronics","Royal Jelly",9,60,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Seabee",9,250,"2.1mm","CN","mod",0,"MS",1,"dg"],
 ["Beetronics","Seabee Lite",9,250,"2.1mm","CN","mod",0,"MS",1,"dg"],
 ["Beetronics","Swarm",9,7,"2.1mm","CN","synth",0,"M",0,""],
 ["Beetronics","Tuna Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Beetronics","Vezzpa",9,36,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Wannabee",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Beetronics","Whoctahell",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Whoctahell V2 Low Octave Beeast",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Beetronics","Zzombee",9,100,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","69 Vibe",9,200,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","AB100 Instrument/Amp Selector",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Behringer","AB200 Dual A/B Switch",9,15,"2.1mm","CN","util",0,"M",0,""],
 ["Behringer","ADI21 V-Tone Acoustic Driver DI",9,25,"2.1mm","CN","preamp",0,"M",0,""],
 ["Behringer","AM100 Acoustic Modeler",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","AM400 Ultra Acoustic Modeler",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","B-Tron III Envelope Filter",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","Bass Brassmaster Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Behringer","BCH100 Bass Chorus",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","BDI21 V-Tone Bass Driver DI",9,26,"2.1mm","CN","preamp",0,"M",0,""],
 ["Behringer","BEQ700 Bass Graphic Equalizer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Behringer","BLE100 Bass Limiter Enhancer",9,8,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","BLE400 Bass Limiter Enhancer",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","BM-11M Low Pass Filter",9,300,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","BM-12 Ring Modulator",9,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","BM-13 Phaser",9,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","BM-14M Analog Delay",9,400,"2.1mm","CN","delay",0,"M",0,""],
 ["Behringer","BM-15M Resonance Filter",9,300,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","BM-17 Frequency Box",9,300,"2.1mm","CN","synth",0,"M",0,""],
 ["Behringer","BM-18M Cluster Box",9,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","BO100 Blues Overdrive",9,13,"2.1mm","CN","drive",2,"M",0,""],
 ["Behringer","BO300 Blues Overdrive",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Behringer","BOD100 Bass Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","BOD400 Bass Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","BSY600 Bass Synthesizer",9,72,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Behringer","BUC400 Ultra Bass Chorus",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","BUF300 Ultra Bass Flanger",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","CC300 Chorus Space-C",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","CD400 Chorus Space-D",9,50,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Behringer","Chorus Symphony",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","CL9 Compressor/Limiter",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","CO600 Chorus Orchestra",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","CS100 Compressor Sustainer",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","CS400 Compressor Sustainer",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","DC9 Dynamics Compressor",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Behringer","DD100 Digital Delay",9,80,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Behringer","DD400 Digital Delay",9,87,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Behringer","DD600 Digital Delay",9,70,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Behringer","DM100 Distortion Modeler",9,4,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","DR400 Digital Reverb/Delay",9,80,"2.1mm","CN","reverb",0,"MS",0,"dg"],
 ["Behringer","DR600 Digital Reverb",9,90,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Behringer","Dual-Phase",9,670,"2.1mm","CN","mod",0,"S",0,""],
 ["Behringer","EM600 Echo Machine",9,100,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Behringer","EQ700 Graphic Equalizer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Behringer","FCB1010 MIDI Foot Controller",0,0,"none","NA","util",0,"M",1,""],
 ["Behringer","FCV100 Foot Controller",9,10,"2.1mm","CN","volume",0,"S",0,""],
 ["Behringer","FD300 Ultra Feedback/Distortion",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","FL600 Flanger Machine",9,100,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Behringer","Flange With No Name",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","FM600 Filter Machine",9,100,"2.1mm","CN","filter",0,"M",0,"dg"],
 ["Behringer","Fuzz Bender",9,25,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Behringer","FX100 Digital Multi-FX",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Behringer","FX600 Digital Multi-FX",9,130,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Behringer","GDI21 V-Tone Guitar Driver DI",9,25,"2.1mm","CN","preamp",0,"M",0,""],
 ["Behringer","HB01 Hellbabe Wah",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Behringer","HD300 Heavy Distortion",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","HF300 Hi-Band Flanger",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","HM300 Heavy Metal",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","IG9 Intelligate",9,30,"2.1mm","CN","gate",0,"M",0,""],
 ["Behringer","Meatball",9,50,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","NR100 Noise Reducer",9,30,"2.1mm","CN","gate",0,"M",0,""],
 ["Behringer","NR300 Noise Reducer",9,30,"2.1mm","CN","gate",0,"M",0,""],
 ["Behringer","Octave Divider",9,300,"2.1mm","CN","pitch",0,"M",0,""],
 ["Behringer","Octavia Octave Fuzz",9,25,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Behringer","OD300 Overdrive/Distortion",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","OD400 Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","PB100 Preamp Booster",9,30,"2.1mm","CN","drive",1,"M",0,""],
 ["Behringer","PH9 Phaser",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","PO300 Power Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","Real McCoy WahWah",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Behringer","Ring Stinger",9,400,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","RM600 Rotary Machine",9,67,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Behringer","RV600 Reverb Machine",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Behringer","SE200 Spectrum Enhancer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Behringer","SF300 Super Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Behringer","SF400 Super Flanger",9,50,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Behringer","SM200 Slow Motion",9,30,"2.1mm","CN","volume",0,"M",0,""],
 ["Behringer","SM400 Super Metal",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","SO400 Super Octaver",9,50,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Behringer","SP400 Super Phase Shifter",9,50,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Behringer","Spring Reverberation 646",12,500,"2.1mm","CN","reverb",0,"M",0,""],
 ["Behringer","TM300 Tube Amp Modeler",9,30,"2.1mm","CN","preamp",0,"M",0,""],
 ["Behringer","TO100 Tube Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","TO800 Vintage Tube Overdrive",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","TP300 Ultra Tremolo/Pan",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","TU100 Chromatic Tuner",9,50,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Behringer","TU300 Chromatic Tuner",9,70,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Behringer","UC100 Ultra Chorus",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","UC200 Ultra Chorus",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Behringer","UD300 Ultra Distortion",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","UF100 Ultra Flanger",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","UF300 Ultra Flanger",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","UM100 Ultra Metal",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","UM300 Ultra Metal",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","UO100 Ultra Octaver",9,30,"2.1mm","CN","pitch",0,"M",0,""],
 ["Behringer","UO300 Ultra Octaver",9,30,"2.1mm","CN","pitch",0,"M",0,""],
 ["Behringer","UP100 Ultra Phase Shifter",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","US600 Ultra Shifter/Harmonist",9,100,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Behringer","UT100 Ultra Tremolo",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","UT300 Ultra Tremolo",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","UV300 Ultra Vibrato",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","UW300 Ultra Wah",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","UZ400 Ultra Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Behringer","VB1 Vintage Bass",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Behringer","VD1 Vintage Distortion",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Behringer","VD400 Vintage Delay",9,30,"2.1mm","CN","delay",0,"M",0,""],
 ["Behringer","VM1 Vintage Time Machine",9,22,"2.1mm","CN","delay",0,"M",0,""],
 ["Behringer","VP1 Vintage Phaser",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Behringer","VT911 Vintage Tube Overdrive",9,200,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","VT999 Vintage Tube Monster",9,250,"2.1mm","CN","drive",3,"M",0,""],
 ["Behringer","WD300 Warp Distortion",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","X V-AMP",0,0,"none","NA","multi",0,"S",1,"dg"],
 ["Behringer","XD300 Distortion-X",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Behringer","Zentara Overdrive",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Benson Amps","Delay",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Benson Amps","Germanium Boost",9,85,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Benson Amps","Germanium Fuzz",9,70,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Benson Amps","Preamp",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Benson Amps","Stonk Box",9,100,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Benson Amps","Studio Tall Bird",0,0,"none","NA","reverb",0,"S",0,""],
 ["Bixonic","Expandora EXP-2000",9,15,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Bixonic","Expandora EXP-2000R",9,200,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Bixonic","Expandora II EXP-2001",9,15,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["BJFe","Arctic White Fuzz",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BJFe","Baby Blue OD",9,5,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["BJFe","Baby Pink Booster",9,5,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["BJFe","Blueberry Bass OD",9,5,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["BJFe","Candy Apple Fuzz",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BJFe","Cliff Hanger",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BJFe","Deep Blue Delay Deluxe",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["BJFe","Dyna Red Distortion",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["BJFe","Emerald Green Distortion Machine",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["BJFe","Folk Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BJFe","Honey Bee Deluxe OD",12,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BJFe","Honey Bee OD",9,4,"2.1mm","CN","drive",2,"M",0,""],
 ["BJFe","Little Green Wonder",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BJFe","Mighty Green MiniVibe",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["BJFe","Model G",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["BJFe","Model H",9,5,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["BJFe","Pine Green Compressor",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["BJFe","Pink Purple Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["BJFe","Purple Humper",18,5,"2.1mm","CN","eq",1,"M",0,""],
 ["BJFe","Red Rooster Booster",9,5,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["BJFe","Saffron Yellow OD",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BJFe","Saffron Yellow Tremolo",9,10,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["BJFe","Sea Blue EQ",9,5,"2.1mm","CN","eq",0,"M",0,""],
 ["BJFe","Snow White Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BJFe","Sparkle Face",9,2,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["BJFe","Sparkling Yellow OD",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Black Cat","Bass Octave Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Black Cat","Bee Buzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Black Cat","Mini Trem",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Black Cat","Monster K-Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Black Cat","N-Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Black Cat","OD-1",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Black Cat","OD-Boost",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Black Cat","OD-Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Black Cat","Super Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Black Cat","Wee Buzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Blue Colander","Archangels Thunderbird",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Blue Colander","Astronomy Domine",9,290,"2.1mm","CN","fuzz",5,"M",0,"dg"],
 ["Blue Colander","Black Emperor",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Blue Colander","Crooked Axis",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Blue Colander","El Daoud MKI",9,5,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Blue Colander","FFAS",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["Blue Colander","Fuxi",9,20,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Blue Colander","Grimrobe",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Blue Colander","Horne",9,5,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Blue Colander","Mudfly",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["Blue Colander","Sailor's Buzz",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Blue Colander","Small Fracture",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Blue Colander","Tibetan Quaalude",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Blue Colander","Tremond",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Bogner","Burnley",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Bogner","Ecstasy Blue",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Bogner","Ecstasy Blue Mini",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Bogner","Ecstasy Red",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Bogner","Ecstasy Red Mini",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Bogner","Harlow",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["Bogner","La Grange",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Bogner","Lyndhurst",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Bogner","Oxford",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Bogner","Uberschall",9,100,"2.1mm","CN","drive",5,"M",0,""],
 ["Bogner","Wessex",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Bondi Effects","2026 Compressor",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Bondi Effects","Art Van Delay",9,100,"2.1mm","CN","delay",0,"M",1,""],
 ["Bondi Effects","Breakers Overdrive",9,60,"2.1mm","CN","drive",2,"M",0,""],
 ["Bondi Effects","Del Mar Overdrive",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Bondi Effects","Del Mar Overdrive mk2",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Bondi Effects","Sick As High Shredroom",9,65,"2.1mm","CN","drive",4,"M",0,""],
 ["Bondi Effects","Sick As Overdrive",9,70,"2.1mm","CN","drive",2,"M",0,""],
 ["Bondi Effects","Squish As Compressor",9,70,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","AC-3 Acoustic Simulator",9,70,"2.1mm","CN","preamp",0,"M",0,""],
 ["BOSS","AW-3 Dynamic Wah",9,50,"2.1mm","CN","filter",0,"M",0,""],
 ["BOSS","BB-1X Bass Driver",9,55,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","BC-1X Bass Comp",9,90,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","BD-2 Blues Driver",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","BD-2W Blues Driver",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","BF-2 (ACA label)",9,15,"2.1mm","CN","mod",0,"M",0,"aca"],
 ["BOSS","BF-2 Flanger",9,18,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","BF-3 Flanger",9,60,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["BOSS","BP-1W Booster/Preamp",9,60,"2.1mm","CN","drive",2,"M",0,""],
 ["BOSS","CE-1 Chorus Ensemble",0,0,"none","NA","mod",0,"MS",0,""],
 ["BOSS","CE-2 (ACA label)",9,9,"2.1mm","CN","mod",0,"M",0,"aca"],
 ["BOSS","CE-2 Chorus",9,9,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","CE-2W Chorus",9,25,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","CE-3 (ACA label)",9,14,"2.1mm","CN","mod",0,"MS",0,"aca"],
 ["BOSS","CE-3 Chorus",9,13,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","CE-5 Chorus Ensemble",9,55,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","CEB-3 Bass Chorus",9,55,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","CH-1 Super Chorus",9,55,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","CP-1X Compressor",9,90,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","CS-1 Compression Sustainer",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","CS-2 Compression Sustainer",9,4,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","CS-3 Compression Sustainer",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","DC-2 (ACA label)",9,30,"2.1mm","CN","mod",0,"MS",0,"aca"],
 ["BOSS","DC-2 Dimension C",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["BOSS","DC-2W Dimension C",9,65,"2.1mm","CN","mod",0,"S",0,""],
 ["BOSS","DD-2 Digital Delay",9,57,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","DD-200 Digital Delay",9,225,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["BOSS","DD-3 Digital Delay",9,55,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","DD-3T Digital Delay",9,70,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","DD-5 Digital Delay",9,57,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","DD-500 Digital Delay",9,200,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["BOSS","DD-6 Digital Delay",9,55,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","DD-7 Digital Delay",9,52,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["BOSS","DD-8 Digital Delay",9,100,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["BOSS","DF-2 Super Feedbacker & Distortion",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","DM-101 Delay Machine",9,260,"2.1mm","CN","delay",0,"S",1,""],
 ["BOSS","DM-2 (ACA label)",9,11,"2.1mm","CN","delay",0,"M",0,"aca"],
 ["BOSS","DM-2 Delay",9,11,"2.1mm","CN","delay",0,"M",0,""],
 ["BOSS","DM-2W Delay",9,35,"2.1mm","CN","delay",0,"MS",0,""],
 ["BOSS","DM-3 (ACA label)",9,15,"2.1mm","CN","delay",0,"MS",0,"aca"],
 ["BOSS","DM-3 Delay",9,11,"2.1mm","CN","delay",0,"MS",0,""],
 ["BOSS","DS-1 (ACA label)",9,4,"2.1mm","CN","drive",4,"M",0,"aca"],
 ["BOSS","DS-1 Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","DS-1W Distortion",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","DS-1X Distortion",9,45,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","DS-2 Turbo Distortion",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","EQ-200 Graphic Equalizer",9,170,"2.1mm","CN","eq",0,"S",1,""],
 ["BOSS","ES-5 Switcher",9,125,"2.1mm","CN","switcher",0,"M",0,""],
 ["BOSS","ES-8 Switcher",9,400,"2.1mm","CN","switcher",0,"M",0,""],
 ["BOSS","EV-30 Dual Expression",0,0,"none","NA","util",0,"M",0,""],
 ["BOSS","EV-5 Expression",0,0,"none","NA","util",0,"M",0,""],
 ["BOSS","FT-2 Dynamic Filter",9,16,"2.1mm","CN","filter",0,"M",0,""],
 ["BOSS","FV-500H Volume",0,0,"none","NA","volume",0,"M",0,""],
 ["BOSS","FV-500L Volume",0,0,"none","NA","volume",0,"S",0,""],
 ["BOSS","FZ-1W Fuzz",9,16,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BOSS","FZ-2 Hyper Fuzz",9,65,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BOSS","FZ-5 Fuzz",9,60,"2.1mm","CN","fuzz",5,"M",0,""],
 ["BOSS","GE-6 Graphic Equalizer",9,7,"2.1mm","CN","eq",0,"M",0,""],
 ["BOSS","GE-7 (ACA label)",9,12,"2.1mm","CN","eq",0,"M",0,"aca"],
 ["BOSS","GE-7 Graphic Equalizer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["BOSS","GEB-7 Bass Equalizer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["BOSS","HM-2 (ACA label)",9,8,"2.1mm","CN","drive",4,"M",0,"aca"],
 ["BOSS","HM-2 Heavy Metal",9,5,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","HM-2W Heavy Metal",9,30,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","IR-2 Amp & Cabinet",9,160,"2.1mm","CN","preamp",0,"MS",0,"amp"],
 ["BOSS","IR-200 Amp & IR Cabinet",9,335,"2.1mm","CN","preamp",0,"MS",1,"amp"],
 ["BOSS","JB-2 Angry Driver",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","LMB-3 Bass Limiter Enhancer",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["BOSS","LS-2 Line Selector",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["BOSS","MD-2 Mega Distortion",9,18,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","MD-200 Modulation",9,225,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["BOSS","MD-500 Modulation",9,225,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["BOSS","ML-2 Metal Core",9,60,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","MS-3 Multi Effects Switcher",9,280,"2.1mm","CN","switcher",0,"M",0,""],
 ["BOSS","MT-2 Metal Zone",9,30,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","MT-2W Metal Zone",9,35,"2.1mm","CN","drive",5,"M",0,""],
 ["BOSS","MZ-2 Digital Metalizer",9,70,"2.1mm","CN","drive",5,"MS",0,""],
 ["BOSS","NF-1 Noise Gate",9,4,"2.1mm","CN","gate",0,"M",0,""],
 ["BOSS","NS-1X Noise Suppressor",9,60,"2.1mm","CN","gate",0,"M",0,""],
 ["BOSS","NS-2 Noise Suppressor",9,25,"2.1mm","CN","gate",0,"M",0,""],
 ["BOSS","OC-2 Octave",9,4,"2.1mm","CN","pitch",0,"M",0,""],
 ["BOSS","OC-3 Super Octave",9,45,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["BOSS","OC-5 Octave",9,60,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["BOSS","OD-1 (ACA label)",9,4,"2.1mm","CN","drive",3,"M",0,"aca"],
 ["BOSS","OD-1 OverDrive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["BOSS","OD-1X OverDrive",9,45,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","OD-2 Turbo OverDrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","OD-200 Hybrid Drive",9,220,"2.1mm","CN","drive",5,"M",1,""],
 ["BOSS","OD-3 OverDrive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","ODB-3 Bass OverDrive",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","OS-2 OverDrive/Distortion",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["BOSS","PH-1 (ACA label)",9,8,"2.1mm","CN","mod",0,"M",0,"aca"],
 ["BOSS","PH-1 Phaser",9,7,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","PH-1R (ACA label)",9,10,"2.1mm","CN","mod",0,"M",0,"aca"],
 ["BOSS","PH-1R Phaser",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","PH-3 Phase Shifter",9,50,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["BOSS","PS-2 Pitch Shifter/Delay",9,60,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["BOSS","PS-3 Pitch Shifter/Delay",9,70,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["BOSS","PS-6 Harmonist",9,65,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["BOSS","RC-1 Loop Station",9,95,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["BOSS","RC-10R Rhythm Loop Station",9,250,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["BOSS","RC-2 Loop Station",9,50,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["BOSS","RC-3 Loop Station",9,70,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["BOSS","RC-30 Loop Station",9,195,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["BOSS","RC-300 Loop Station",9,350,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["BOSS","RC-5 Loop Station",9,170,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["BOSS","RC-500 Loop Station",9,330,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["BOSS","RC-600 Loop Station",9,1200,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["BOSS","RE-2 Space Echo",9,75,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["BOSS","RE-202 Space Echo",9,140,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["BOSS","RV-2 Digital Reverb",9,130,"2.1mm","CN","reverb",0,"MS",0,"dg"],
 ["BOSS","RV-200 Reverb",9,260,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["BOSS","RV-3 Reverb/Delay",9,63,"2.1mm","CN","reverb",0,"MS",0,"dg"],
 ["BOSS","RV-5 Digital Reverb",9,50,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["BOSS","RV-500 Reverb",9,225,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["BOSS","RV-6 Reverb",9,95,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["BOSS","SD-1 (ACA label)",9,5,"2.1mm","CN","drive",3,"M",0,"aca"],
 ["BOSS","SD-1 Super OverDrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","SD-1W Super OverDrive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","SD-2 DUAL OverDrive",9,21,"2.1mm","CN","drive",3,"M",0,""],
 ["BOSS","SDE-3 Dual Delay",9,75,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","SG-1 (ACA label)",9,6,"2.1mm","CN","volume",0,"M",0,"aca"],
 ["BOSS","SG-1 Slow Gear",9,7,"2.1mm","CN","volume",0,"M",0,""],
 ["BOSS","SL-2 Slicer",9,95,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["BOSS","SP-1 (ACA label)",9,5,"2.1mm","CN","eq",0,"M",0,"aca"],
 ["BOSS","SP-1 Spectrum",9,23,"2.1mm","CN","eq",0,"M",0,""],
 ["BOSS","SY-1 Synthesizer",9,115,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["BOSS","SY-200 Synthesizer",9,230,"2.1mm","CN","synth",0,"MS",1,"dg"],
 ["BOSS","SYB-5 Bass Synthesizer",9,50,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["BOSS","TB-2W Tone Bender Fuzz",9,60,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["BOSS","TE-2 Tera Echo",9,53,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["BOSS","TR-2 Tremolo",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","TU-2 Chromatic Tuner",9,31,"2.1mm","CN","tuner",0,"M",0,""],
 ["BOSS","TU-3 Chromatic Tuner",9,20,"2.1mm","CN","tuner",0,"M",0,""],
 ["BOSS","TU-3W Chromatic Tuner",9,50,"2.1mm","CN","tuner",0,"M",0,""],
 ["BOSS","TW-1 (ACA label)",9,6,"2.1mm","CN","filter",0,"M",0,"aca"],
 ["BOSS","TW-1 Touch Wah",9,5,"2.1mm","CN","filter",0,"M",0,""],
 ["BOSS","VB-2 (ACA label)",9,18,"2.1mm","CN","mod",0,"M",0,"aca"],
 ["BOSS","VB-2 Vibrato",9,14,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","VB-2W Vibrato",9,35,"2.1mm","CN","mod",0,"M",0,""],
 ["BOSS","WL-20 Wireless",0,0,"none","NA","util",0,"M",0,""],
 ["BOSS","WL-50 Wireless",9,320,"2.1mm","CN","util",0,"M",0,""],
 ["BOSS","WL-60 Wireless",9,100,"2.1mm","CN","util",0,"M",0,""],
 ["Broughton","Always On High Pass Filter",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Broughton","Apex VCA Compressor",9,60,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Broughton","Ascalon",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["Broughton","Buffer Bandwidth Amplifier",9,10,"2.1mm","CN","util",1,"M",0,""],
 ["Broughton","Calamity",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Broughton","Carina",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Broughton","Fliptop",9,12,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Broughton","High Pass Filter",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Broughton","JoshWah",9,30,"2.1mm","CN","filter",2,"M",0,"eol"],
 ["Broughton","Low + High Pass Filter",9,10,"2.1mm","CN","filter",1,"M",0,""],
 ["Broughton","Low Pass Filter",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Broughton","Lowtec",9,10,"2.1mm","CN","eq",0,"M",0,""],
 ["Broughton","Messenger",9,250,"2.1mm","CN","preamp",1,"M",0,"eol"],
 ["Broughton","Messenger Pro",9,200,"2.1mm","CN","preamp",1,"M",0,""],
 ["Broughton","Mini Fridge Cab Sim",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Broughton","Monocomp",9,20,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Broughton","Omnicomp",9,150,"2.1mm","CN","comp",0,"M",0,""],
 ["Broughton","Phase Locked Loop",9,8,"2.1mm","CN","synth",5,"M",0,""],
 ["Broughton","Resonant Filter Equalizer",9,20,"2.1mm","CN","filter",0,"M",0,""],
 ["Broughton","Scorpion Deluxe",9,10,"2.1mm","CN","preamp",3,"M",0,""],
 ["Broughton","Silver Deluxe",9,10,"2.1mm","CN","preamp",2,"M",0,"eol"],
 ["Broughton","Sonoran",12,300,"2.1mm","CN","preamp",2,"M",0,""],
 ["Broughton","Subsonic",9,10,"2.1mm","CN","pitch",0,"M",0,""],
 ["Broughton","Super Stack",12,250,"2.1mm","CN","preamp",2,"M",0,"amp;eol"],
 ["Broughton","SV-Pre",9,20,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Broughton","Wavering Radiant",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Browne Amplification","Atom",9,11,"2.1mm","CN","drive",2,"M",0,""],
 ["Browne Amplification","Carbon",9,37,"2.1mm","CN","drive",3,"M",0,""],
 ["Browne Amplification","Carbon V2",9,37,"2.1mm","CN","drive",3,"M",0,""],
 ["Browne Amplification","Protein",9,130,"2.1mm","CN","drive",3,"M",0,""],
 ["Browne Amplification","T4 Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Caline","CP-09 Tuner Power",9,30,"2.1mm","CN","tuner",0,"M",0,""],
 ["Caline","CP-10 Hot Mushroom",9,15,"2.1mm","CN","comp",0,"M",0,""],
 ["Caline","CP-11 Puffer",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Caline","CP-12 Pure Sky",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","CP-13 Super Chorus",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-14 English Man",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-15 Tantrum",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-16 Mark 4",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-17 Time Space",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","CP-18 Orange Burst",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-19 Blue Ocean",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","CP-20 Crazy Cacti",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-21 Rock Face",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-22 Purple Smoke",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","CP-24 10 Band EQ",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Caline","CP-25 Highway Man",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","CP-26 Snake Bite",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-27 Sand Storm",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-28 Ultra Chorus",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-29 White Heat",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","CP-30 Red Devil",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-31 Hot Spice",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Caline","CP-32 Clear Veil",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-34 Head Room",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-35 Golden Halo",9,50,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Caline","CP-36 Big Dipper",9,100,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Caline","CP-37 Drifter",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","CP-38 Lucky 7",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Caline","CP-39 The Noise",9,30,"2.1mm","CN","gate",0,"M",0,""],
 ["Caline","CP-40 Acoustic DI",9,50,"2.1mm","CN","preamp",0,"M",0,""],
 ["Caline","CP-41 Ghost Rain",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","CP-42 Candy Floss",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Caline","CP-43 Pegasus",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","CP-44 Reflector",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-45 Pressure Point",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Caline","CP-46 Fuzzy Bear",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Caline","CP-47 Pressure Tank",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Caline","CP-48 Honeycomb",9,300,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Caline","CP-49 Midlander",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-50 Leon Drive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-501 Osmium",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-502 Mellow Drive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-503 Queen Bee",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","CP-504 M-Fuzz",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Caline","CP-505 Wave Machine",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-506 MultiMod",9,80,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Caline","CP-507 Mariana",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-508 Wonderland",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-511 Enchanted Tone",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","CP-512 Old School Reverb",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-513 Super Simon",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","CP-514 Santa Carla",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","CP-515 Carmilla",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-516 Orange Burst (mini)",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-53 Voodoo Octave",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Caline","CP-54 The Big Orange",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-55 American Sound",9,25,"2.1mm","CN","preamp",3,"M",0,""],
 ["Caline","CP-56 AC Tone",9,25,"2.1mm","CN","preamp",3,"M",0,""],
 ["Caline","CP-57 California Sound",9,25,"2.1mm","CN","preamp",4,"M",0,""],
 ["Caline","CP-58 British Sound",9,25,"2.1mm","CN","preamp",3,"M",0,""],
 ["Caline","CP-59 Press Pass",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","CP-60 Wine Cellar",9,30,"2.1mm","CN","preamp",0,"M",0,""],
 ["Caline","CP-61 T-Drive Phase",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-62 Reflector Tremolo",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-63 Sidewinder",9,50,"2.1mm","CN","delay",0,"M",0,""],
 ["Caline","CP-64 Direct Route",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Caline","CP-65 Bass Overdrive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-66 So What",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-73 6-Band Bass EQ",9,25,"2.1mm","CN","eq",0,"M",0,""],
 ["Caline","CP-74 Action Replay",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","CP-77 Bounty Hunter",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-78 Red Thorn",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-79 Wolfpack",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-80 Ragnarok",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caline","CP-81 10-Band EQ",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Caline","CP-82 Broadsword",9,20,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Caline","CP-83 Bass Chorus",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Caline","CP-97 Recluse",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","CP-98 Seahawk",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","CP-99 Medusa",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Caline","DCP-01 Artemis",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["Caline","DCP-02 Brutus",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","DCP-03 Devilfish",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caline","DCP-04 Easy Driver",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","DCP-05 Key West",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","DCP-06 Sundance Special",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","DCP-07 Brigade",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","DCP-08 Nightwolf",9,50,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Caline","DCP-09 Tigershark",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","DCP-10 Stella",9,50,"2.1mm","CN","eq",0,"M",0,""],
 ["Caline","DCP-11 Andes",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","G001 Tiger Eye",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Caline","G002 Green Mamba",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Caline","G010 Parrot",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","2Wah",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Carl Martin","3-Band Parametric Preamp",9,90,"2.1mm","CN","eq",1,"M",0,""],
 ["Carl Martin","AC-Tone (9V)",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","AC-Tone (mains)",0,0,"none","CN","drive",3,"M",0,""],
 ["Carl Martin","AC-Tone Single",9,62,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","Acoustic Gig",9,500,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Carl Martin","Ampster",9,600,"2.1mm","CN","preamp",2,"M",0,""],
 ["Carl Martin","Andy Timmons Compressor/Limiter",9,130,"2.1mm","CN","comp",0,"M",0,""],
 ["Carl Martin","Atlantic Chorus",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","Axis Flanger",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","Bass Chorus",9,130,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","Bass Drive (mains)",0,0,"none","CN","drive",3,"M",0,""],
 ["Carl Martin","Blue Ranger",9,7,"2.1mm","CN","drive",1,"M",0,""],
 ["Carl Martin","Boost Kick",9,12,"2.1mm","CN","drive",1,"M",0,""],
 ["Carl Martin","Buff Deluxe",9,12,"2.1mm","CN","util",0,"M",0,""],
 ["Carl Martin","Chorus xII (9V)",9,90,"2.1mm","CN","mod",0,"MS",0,""],
 ["Carl Martin","Chorus xII (mains)",0,0,"none","CN","mod",0,"MS",0,""],
 ["Carl Martin","Classic Chorus",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","Classic Flanger",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","Classic Optical Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Carl Martin","Classic Optical Envelope Filter",9,14,"2.1mm","CN","filter",0,"M",0,""],
 ["Carl Martin","Compressor/Limiter (9V)",9,130,"2.1mm","CN","comp",0,"M",0,""],
 ["Carl Martin","Compressor/Limiter (mains)",0,0,"none","CN","comp",0,"M",0,""],
 ["Carl Martin","Contour'n Boost",9,90,"2.1mm","CN","eq",1,"M",0,""],
 ["Carl Martin","Crunch Drive",9,12,"2.1mm","CN","drive",2,"M",0,""],
 ["Carl Martin","DC-Drive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","DeLayla (9V)",9,240,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","DeLayla (mains)",0,0,"none","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","DeLayla XL (mains)",0,0,"none","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","Dual Compressor Limiter",9,150,"2.1mm","CN","comp",0,"M",0,""],
 ["Carl Martin","Dual Injection",9,68,"2.1mm","CN","drive",1,"M",0,""],
 ["Carl Martin","Echotone",9,160,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","Greg Howe's Lick Box",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Carl Martin","HeadRoom",9,10,"2.1mm","CN","reverb",0,"M",0,""],
 ["Carl Martin","HeadRoom Mini",9,120,"2.1mm","CN","reverb",0,"MS",0,"dg"],
 ["Carl Martin","Heavy Drive",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["Carl Martin","Honey Comp",9,130,"2.1mm","CN","comp",0,"M",0,""],
 ["Carl Martin","Hot Drive'n Boost (mains)",0,0,"none","CN","drive",3,"M",0,""],
 ["Carl Martin","Hot Drive'n Boost MK3 (9V)",9,60,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","Hydra Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Carl Martin","Match Box",9,12,"2.1mm","CN","util",0,"M",0,""],
 ["Carl Martin","Noise Terminator",9,12,"2.1mm","CN","gate",0,"M",0,""],
 ["Carl Martin","Octa-Switch MK2",9,380,"2.1mm","CN","switcher",0,"M",0,""],
 ["Carl Martin","Octa-Switch MK3",9,380,"2.1mm","CN","switcher",0,"M",0,""],
 ["Carl Martin","Octa-Switch The Strip",9,560,"2.1mm","CN","switcher",0,"M",1,""],
 ["Carl Martin","Ottawa",9,14,"2.1mm","CN","filter",0,"M",0,""],
 ["Carl Martin","Panama",9,65,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","ParaLoop",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Carl Martin","PlexiRanger",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","PlexiTone (9V)",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["Carl Martin","PlexiTone (mains)",0,0,"none","CN","drive",4,"M",0,""],
 ["Carl Martin","PlexiTone Lo-Gain",9,62,"2.1mm","CN","drive",2,"M",0,""],
 ["Carl Martin","PlexiTone Single Channel",9,62,"2.1mm","CN","drive",4,"M",0,""],
 ["Carl Martin","Purple Moon",9,62,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Carl Martin","Quattro (mains)",0,0,"none","CN","multi",0,"M",0,"dg"],
 ["Carl Martin","Red Repeat",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Carl Martin","Rock Bug",9,25,"2.1mm","CN","util",0,"M",0,""],
 ["Carl Martin","Rock Drive",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Carl Martin","Route Box",9,15,"2.1mm","CN","util",0,"M",0,""],
 ["Carl Martin","Surf Trem",9,28,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","The Fuzz",9,150,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Carl Martin","Tone Tweaker",9,45,"2.1mm","CN","eq",1,"M",0,""],
 ["Carl Martin","TremO'vibe (9V)",9,200,"2.1mm","CN","mod",0,"M",0,""],
 ["Carl Martin","TremO'vibe (mains)",0,0,"none","CN","mod",0,"M",0,""],
 ["Carl Martin","Tuner",9,80,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Carl Martin","Two Faze",9,90,"2.1mm","CN","mod",0,"M",0,""],
 ["Caroline Guitar Company","Cannonball",9,45,"2.1mm","CN","drive",4,"M",0,""],
 ["Caroline Guitar Company","Hawaiian Pizza",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Caroline Guitar Company","Icarus V2",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Caroline Guitar Company","Kilobyte",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caroline Guitar Company","Kilobyte 2000",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Caroline Guitar Company","Météore",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Caroline Guitar Company","Parabola",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Caroline Guitar Company","Somersault",9,30,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Caroline Guitar Company","Wave Cannon",9,45,"2.1mm","CN","drive",4,"M",0,""],
 ["Caroline Guitar Company","Wave Cannon MkII",9,45,"2.1mm","CN","drive",4,"M",0,""],
 ["Catalinbread","Adineko",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Antichthon",9,1,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Catalinbread","Belle Epoch",9,61,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Belle Epoch Deluxe",9,200,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Bicycle Delay",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Blood Donor",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Catalinbread","Callisto",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Catalinbread","Callisto MkII",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Catalinbread","Cloak",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Catalinbread","CSIDMAN",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Dirty Little Secret Deluxe",9,7,"2.1mm","CN","drive",4,"M",0,""],
 ["Catalinbread","Dirty Little Secret MkIII",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Dreamcoat",9,44,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Echorec",18,61,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Catalinbread","Epoch Boost",9,2,"2.1mm","CN","drive",1,"M",0,""],
 ["Catalinbread","Epoch Pre",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Catalinbread","Formula 51",9,2,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Formula 55",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Formula No. 5",9,2,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Fuzzrite",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Catalinbread","Galileo",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["Catalinbread","Giygas",9,18,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Catalinbread","Heliotrope",9,1,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Catalinbread","Karma Suture",9,1,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Catalinbread","Katzenkönig",9,7,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Catalinbread","Many Worlds",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Catalinbread","RAH",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Sabbra Cadabra",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["Catalinbread","Semaphore",9,200,"2.1mm","CN","mod",0,"M",0,""],
 ["Catalinbread","SFT",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Catalinbread","Skewer",9,1,"2.1mm","CN","fuzz",1,"M",0,"ff"],
 ["Catalinbread","Soft Focus",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Catalinbread","Soft Focus Deluxe",9,120,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Catalinbread","STS-88",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Catalinbread","Topanga",9,64,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Catalinbread","Tribute",9,50,"2.1mm","CN","drive",2,"M",0,""],
 ["Catalinbread","Valcoder",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Catalinbread","Zero Point",9,65,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Chase Bliss Audio","Bliss Factory",9,50,"2.1mm","CN","fuzz",5,"M",1,""],
 ["Chase Bliss Audio","Blooper",9,150,"2.1mm","CN","looper",0,"M",1,"eol;dg"],
 ["Chase Bliss Audio","Brothers",9,60,"2.1mm","CN","drive",4,"M",1,""],
 ["Chase Bliss Audio","Brothers AM",9,200,"2.1mm","CN","drive",3,"M",1,""],
 ["Chase Bliss Audio","Clean",9,300,"2.1mm","CN","comp",0,"S",1,""],
 ["Chase Bliss Audio","Condor",9,70,"2.1mm","CN","eq",0,"M",1,""],
 ["Chase Bliss Audio","CXM 1978",9,500,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Chase Bliss Audio","Dark World",9,150,"2.1mm","CN","reverb",0,"M",1,"dg"],
 ["Chase Bliss Audio","Generation Loss",9,150,"2.1mm","CN","mod",0,"M",1,"dg"],
 ["Chase Bliss Audio","Generation Loss MkII",9,250,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Chase Bliss Audio","Gravitas",9,20,"2.1mm","CN","mod",0,"M",1,""],
 ["Chase Bliss Audio","Habit",9,150,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Chase Bliss Audio","Lossy",9,400,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Chase Bliss Audio","Midibox",9,10,"2.1mm","CN","util",0,"M",0,"eol"],
 ["Chase Bliss Audio","Midibox 2",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["Chase Bliss Audio","MOOD",9,150,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Chase Bliss Audio","MOOD MkII",9,270,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Chase Bliss Audio","Onward",9,200,"2.1mm","CN","looper",0,"S",1,"dg"],
 ["Chase Bliss Audio","Preamp MkII",9,500,"2.1mm","CN","drive",4,"M",1,""],
 ["Chase Bliss Audio","Reverse Mode C",9,270,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Chase Bliss Audio","Spectre",9,50,"2.1mm","CN","mod",0,"M",1,""],
 ["Chase Bliss Audio","Thermae",9,180,"2.1mm","CN","delay",0,"M",1,""],
 ["Chase Bliss Audio","Tonal Recall",9,150,"2.1mm","CN","delay",0,"M",1,""],
 ["Chase Bliss Audio","Tonal Recall RKM Red Knob Mod",9,150,"2.1mm","CN","delay",0,"M",1,""],
 ["Chase Bliss Audio","Warped Vinyl",9,25,"2.1mm","CN","mod",0,"M",1,""],
 ["Chase Bliss Audio","Warped Vinyl HiFi",9,70,"2.1mm","CN","mod",0,"M",1,""],
 ["Chase Bliss Audio","Wombtone",9,50,"2.1mm","CN","mod",0,"M",1,""],
 ["Chase Tone","'68 Red Velvet Fuzz (original)",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","'68 Red Velvet Fuzz (Reissue)",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","Candy Apple Red Glazed Germanium Fuzz Face Replica",9,3,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Chase Tone","Dallas Arbiter Germanium Fuzz Face Replica",9,3,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Chase Tone","Fuzz Fella 2.0 Ocean Blue BC108C",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","Fuzz Fella Blue BC108C",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","Fuzz Fella Candy Apple Red Germanium",9,3,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Chase Tone","Fuzz Fella Red BC183C",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","Fuzz Fella Teal BC109C",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Chase Tone","Gypsy Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Chase Tone","Italian Crybaby Wah Replica",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Chase Tone","Picture Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Chase Tone","Purple Stardust Hi-Octave (Reissue)",9,5,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Chase Tone","Roadster Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Chase Tone","Script Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Chase Tone","Scripture Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Chase Tone","Secret Preamp",9,150,"2.1mm","CN","preamp",0,"M",0,""],
 ["Chase Tone","Secret T. Booster",9,5,"2.1mm","CN","fuzz",1,"M",0,"ff"],
 ["Chicago Iron","Octavian",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Chicago Iron","Tycobrahe Octavia",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["ClinchFX","Burnish Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["ClinchFX","EP Plus (EP+)",9,5,"2.1mm","CN","preamp",1,"M",0,""],
 ["ClinchFX","EP-PRE",9,10,"2.1mm","CN","preamp",1,"M",0,""],
 ["ClinchFX","Pico-PRE",9,10,"2.1mm","CN","preamp",1,"M",0,""],
 ["ClinchFX","The Blue Classic",9,17,"2.1mm","CN","drive",2,"M",0,""],
 ["Colorsound","Jumbo Tone Bender",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Colorsound","Octivider",9,5,"batt","NA","pitch",0,"M",0,"eol"],
 ["Colorsound","One Knob Fuzz",9,2,"batt","NA","fuzz",5,"M",0,""],
 ["Colorsound","Overdriver",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Colorsound","Power Boost",18,5,"batt","NA","drive",2,"M",0,""],
 ["Colorsound","Supa Tone Bender",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Colorsound","Tone Bender MK1.5",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Colorsound","Tone Bender MKI",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Colorsound","Tone Bender MKIII",9,1,"batt","NA","fuzz",5,"M",0,"ff;eol"],
 ["Colorsound","Tone Bender MKIV",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Colorsound","Tone Bender Professional MKII",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Colorsound","Tremolo",9,5,"batt","NA","mod",0,"M",0,""],
 ["Colorsound","Wah Wah",9,1,"batt","NA","wah",0,"M",0,""],
 ["Colorsound","Wah-Fuzz",9,2,"batt","NA","wah",5,"M",0,""],
 ["CopperSound Pedals","Broadway Treble Booster & Germanium Preamp",9,5,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["CopperSound Pedals","Foxcatcher (V1)",9,30,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["CopperSound Pedals","Foxcatcher V2",9,50,"2.1mm","CN","drive",2,"M",0,""],
 ["CopperSound Pedals","Gravity Bomb V2",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["CopperSound Pedals","Ion Warped Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["CopperSound Pedals","Iris Optical Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["CopperSound Pedals","Kingpin Germanium Clipper",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["CopperSound Pedals","Polaris Analog Chorus & Vibrato",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["CopperSound Pedals","Telegraph Stutter (V1)",9,30,"2.1mm","CN","util",0,"M",0,"eol"],
 ["CopperSound Pedals","Telegraph V2 Autostutter & Killswitch",9,60,"2.1mm","CN","util",0,"M",0,""],
 ["CopperSound Pedals","Triplegraph",9,250,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Cornerstone","Antique V3",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Cornerstone","Aquarium",18,250,"2.1mm","CN","mod",0,"M",0,""],
 ["Cornerstone","Centurio",9,120,"2.1mm","CN","drive",2,"M",0,""],
 ["Cornerstone","Colosseum",9,200,"2.1mm","CN","drive",3,"M",0,""],
 ["Cornerstone","Gladio Double Preamp",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Cornerstone","Gladio SC",9,60,"2.1mm","CN","drive",3,"M",0,""],
 ["Cornerstone","Imperium V2",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Cornerstone","Nero",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cornerstone","Nucleo",9,180,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Countryman","Type 10",48,2,"batt","NA","util",0,"M",0,""],
 ["Countryman","Type 10S",48,2,"batt","NA","util",0,"S",0,""],
 ["Countryman","Type 85",48,1,"batt","NA","util",0,"M",0,""],
 ["Countryman","Type 85S",48,1,"batt","NA","util",0,"S",0,""],
 ["Crazy Tube Circuits","Black Magic MkII",9,58,"2.1mm","CN","drive",4,"M",0,""],
 ["Crazy Tube Circuits","Blackface Stardust V2",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Constellation",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Crazy Tube Circuits","Crossfire",9,83,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Cyclone",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["Crazy Tube Circuits","Falcon",9,40,"2.1mm","CN","drive",2,"M",0,""],
 ["Crazy Tube Circuits","Golden Ratio Phi",9,45,"2.1mm","CN","comp",0,"M",0,""],
 ["Crazy Tube Circuits","Golden Ratio Phi V2",9,80,"2.1mm","CN","comp",0,"M",0,""],
 ["Crazy Tube Circuits","Heatseeker",9,115,"2.1mm","CN","drive",4,"M",0,""],
 ["Crazy Tube Circuits","Hi-Power",9,84,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Killer V",9,45,"2.1mm","CN","preamp",0,"M",0,""],
 ["Crazy Tube Circuits","Limelight",9,7,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Crazy Tube Circuits","Locomotive",9,400,"2.1mm","CN","drive",2,"M",0,""],
 ["Crazy Tube Circuits","Memphis",9,17,"2.1mm","CN","mod",0,"M",0,""],
 ["Crazy Tube Circuits","Mirage",9,210,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Crazy Tube Circuits","Mirage Jr",9,115,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Crazy Tube Circuits","Motherload",9,35,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Crazy Tube Circuits","Orama",9,82,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Crazy Tube Circuits","Pin Up",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Crazy Tube Circuits","Sidekick",9,230,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Crazy Tube Circuits","Sidekick Jr",9,210,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Crazy Tube Circuits","Space Charged",9,350,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Splash",9,115,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Crazy Tube Circuits","Stardust V3",9,49,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Starlight",9,2,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Crazy Tube Circuits","Super Conductor",9,67,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Crazy Tube Circuits","TI:ME",9,84,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Crazy Tube Circuits","Triptychon",9,80,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Crazy Tube Circuits","Unobtanium",9,83,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Unobtanium Raw",9,83,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Venus",9,400,"2.1mm","CN","drive",4,"M",0,""],
 ["Crazy Tube Circuits","White Whale",9,180,"2.1mm","CN","reverb",0,"M",0,""],
 ["Crazy Tube Circuits","White Whale Junior",9,110,"2.1mm","CN","reverb",0,"M",0,""],
 ["Crazy Tube Circuits","White Whale V2",9,180,"2.1mm","CN","reverb",0,"M",0,""],
 ["Crazy Tube Circuits","Ziggy",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Crazy Tube Circuits","Ziggy V2",9,59,"2.1mm","CN","drive",4,"M",0,""],
 ["Crowther Audio","Double Hot Cake",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Crowther Audio","Hot Cake (pre-XLF 3-knob)",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Crowther Audio","Hot Cake (XLF)",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Crowther Audio","Prunes & Custard",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Cable Tester",9,3,"2.1mm","CN","util",0,"M",0,""],
 ["Cusack Music","Carolina Reaper",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Cusack Music","Deal Breaker Boost",9,8,"2.1mm","CN","drive",1,"M",0,""],
 ["Cusack Music","Delay TME (current)",9,22,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Delay TME (original)",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Delay TME w/ Tap",9,32,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Double Buffer",9,18,"2.1mm","CN","util",0,"S",0,""],
 ["Cusack Music","Louder",9,8,"2.1mm","CN","drive",1,"M",0,""],
 ["Cusack Music","Meta Plexi",9,19,"2.1mm","CN","drive",4,"M",0,""],
 ["Cusack Music","MIDI to PBT",9,5,"2.1mm","CN","util",1,"M",0,""],
 ["Cusack Music","More Louder",9,8,"2.1mm","CN","drive",1,"M",0,""],
 ["Cusack Music","Orthrus",9,19,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Pedal Board Tamer PBT6",9,50,"2.1mm","CN","switcher",0,"M",0,""],
 ["Cusack Music","Pedal Board Tamer PBT9",9,50,"2.1mm","CN","switcher",0,"M",0,""],
 ["Cusack Music","Pedal Cracker",9,70,"2.1mm","CN","preamp",0,"M",0,""],
 ["Cusack Music","Pedal Cracker V2",9,190,"2.1mm","CN","preamp",0,"M",0,""],
 ["Cusack Music","Project 34",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Cusack Music","Rebound",9,85,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Resound (V1)",9,85,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Cusack Music","Resound V2",9,85,"2.1mm","CN","reverb",0,"MS",0,"dg"],
 ["Cusack Music","Reverb SME",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Cusack Music","Scream Bass",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Scream Whee",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Screamer Bass",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Screamer Fuzz Bass",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Screamer Fuzz Germanium",9,6,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Screamer Fuzz V2",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Screamer Fuzz V3",9,6,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Screamer V2",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Screamer V3",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Scruzz",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Scruzz Bass",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Single Pedal Tamer",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Cusack Music","Stereo Pedal Tamer",9,5,"2.1mm","CN","util",0,"S",0,""],
 ["Cusack Music","Sub Fuzz",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Tap-A-Delay",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Tap-A-Delay Deluxe",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Tap-A-Fuzz",9,20,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Cusack Music","Tap-A-Phase",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tap-A-Scream",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Cusack Music","Tap-A-Whirl (V1)",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tap-A-Whirl V2",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tap-A-Whirl V3",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tap-A-Whirl V4",9,22,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tiny Tap-A-Delay",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Cusack Music","Tremolo AME (current)",9,22,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Tremolo AME (original)",9,22,"2.1mm","CN","mod",0,"M",0,""],
 ["Cusack Music","Twirl",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Damnation Audio","Bass Amp Grinder",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Damnation Audio","Bass Fuzz Enforcer",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Damnation Audio","Bass Power Distorter",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Damnation Audio","Contour Pre",9,40,"2.1mm","CN","preamp",1,"M",0,""],
 ["Damnation Audio","Curmudgeon 2",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Damnation Audio","Dirtfixer",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Damnation Audio","Dirtmixer",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Damnation Audio","Dirtripper",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Damnation Audio","GMP-1 Germanium MOSFET Preamp",9,40,"2.1mm","CN","preamp",2,"M",0,""],
 ["Damnation Audio","MBD",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Damnation Audio","MBD-1",9,30,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Damnation Audio","MBD2",9,30,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Damnation Audio","Retro Bass Distortion",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Damnation Audio","Spite Box",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Damnation Audio","True Bypass Looper & Clean Blend",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["Damnation Audio","Ugly Twin",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Danelectro","3699 fUZZ",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Danelectro","Back Talk Reverse Delay",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","Billionaire Big Spender Spinning Speaker (BK-1)",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","Billionaire Billion Dollar Boost (BB-1)",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Danelectro","Billionaire Filthy Rich Tremolo (BT-1)",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Danelectro","Billionaire Pride of Texas (BP-1)",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","Black Coffee Metal Distortion",9,10,"2.1mm","CN","drive",5,"M",0,""],
 ["Danelectro","BLT Slap Echo",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","Chicken Salad Vibrato",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Danelectro","Chili Dog Octave",9,20,"2.1mm","CN","pitch",0,"M",0,""],
 ["Danelectro","Cool Cat Chorus (CC-1, 2008)",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Danelectro","Cool Cat Chorus (DC-1, original)",18,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Danelectro","Cool Cat Distortion (CD-1)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Danelectro","Cool Cat Drive (CO-1)",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","Cool Cat Fuzz (CF-1)",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Danelectro","Cool Cat Metal (CM-1)",9,20,"2.1mm","CN","drive",5,"M",0,""],
 ["Danelectro","Cool Cat Transparent Overdrive (CT-1)",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Danelectro","Cool Cat Vibe (CV-1)",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Danelectro","Corned Beef Reverb",9,40,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Danelectro","Daddy O (DO-1)",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","Dan-Echo (DE-1)",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","Dan-O-Matic Tuner (DT-1)",9,30,"2.1mm","CN","tuner",0,"M",0,""],
 ["Danelectro","Dan-O-Wah (DW-1)",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Danelectro","Eisenhower Fuzz",9,15,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Danelectro","FAB 600ms Delay (D-8)",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","FAB Chorus (D-5)",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","FAB Distortion (D-1)",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Danelectro","FAB Echo (D-4)",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","FAB Flange (D-6)",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","FAB Fuzz (D-7)",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Danelectro","FAB Metal (D-3)",9,10,"2.1mm","CN","drive",5,"M",0,""],
 ["Danelectro","FAB Overdrive (D-2)",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","Fab Tone (DD-1)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Danelectro","Fish & Chips 7-Band EQ (DJ-14)",9,10,"2.1mm","CN","eq",0,"M",0,""],
 ["Danelectro","Free Speech Talk Box (DTB-1)",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Danelectro","French Fries Auto Wah",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Danelectro","French Toast Octave Distortion (DJ-13)",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Danelectro","Hash Browns Flanger",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","Milkshake Chorus",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","Nichols 1966",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Danelectro","Pastrami Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","PB&J Delay",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","Reel Echo (DTE-1)",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Danelectro","Rocky Road Spinning Speaker",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Danelectro","Roebuck Distortion",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Danelectro","Spring King (DSR-1)",9,100,"2.1mm","CN","reverb",0,"M",0,""],
 ["Danelectro","Spring King Junior (SKJ-1)",9,100,"2.1mm","CN","reverb",0,"M",0,""],
 ["Danelectro","Surf & Turf Compressor",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Danelectro","T-Bone Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Danelectro","The Breakdown",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Danelectro","Tuna Melt Tremolo (DJ-5)",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Darkglass","ADAM",9,500,"2.1mm","CN","drive",4,"MS",0,"dg"],
 ["Darkglass","Alpha Omega",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Darkglass","Alpha Omega Photon",9,500,"2.1mm","CN","preamp",4,"MS",0,"dg"],
 ["Darkglass","Alpha Omega Ultra (v2/AUX)",9,130,"2.1mm","CN","preamp",4,"M",0,"dg"],
 ["Darkglass","Alpha Omicron",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Darkglass","Anagram",9,1700,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Darkglass","Duality Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Darkglass","Element",9,250,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Darkglass","Harmonic Booster",9,30,"2.1mm","CN","drive",1,"M",0,""],
 ["Darkglass","Hyper Luminal",9,250,"2.1mm","CN","comp",0,"M",0,"dg"],
 ["Darkglass","Kaamos",9,400,"2.1mm","CN","drive",4,"M",0,"dg"],
 ["Darkglass","Luminal Booster Ultra",9,400,"2.1mm","CN","preamp",1,"M",0,"dg"],
 ["Darkglass","Microtubes B1K",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Darkglass","Microtubes B3K (v2)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Darkglass","Microtubes B7K (v2)",9,26,"2.1mm","CN","preamp",4,"M",0,""],
 ["Darkglass","Microtubes B7K Ultra (v2/AUX)",9,120,"2.1mm","CN","preamp",4,"M",0,"dg"],
 ["Darkglass","Microtubes Infinity",9,500,"2.1mm","CN","multi",4,"M",0,"dg"],
 ["Darkglass","Microtubes X",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Darkglass","Microtubes X Ultra",9,200,"2.1mm","CN","preamp",4,"M",0,"dg"],
 ["Darkglass","Microtubes X7",9,100,"2.1mm","CN","preamp",4,"M",0,""],
 ["Darkglass","NSG",9,60,"2.1mm","CN","gate",0,"M",0,""],
 ["Darkglass","Super Symmetry",9,30,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Darkglass","Vintage Deluxe (v3)",9,30,"2.1mm","CN","preamp",2,"M",0,""],
 ["Darkglass","Vintage Microtubes",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Darkglass","Vintage Ultra (v2/AUX)",9,120,"2.1mm","CN","preamp",2,"M",0,"dg"],
 ["Dawner Prince","Boonar",9,180,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Dawner Prince","Boonar Tube Deluxe LTD",12,800,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Dawner Prince","Diktator MKII",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Dawner Prince","Eclipsa",9,150,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Dawner Prince","Pulse",9,70,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Dawner Prince","Red Rox",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Dawner Prince","Starla",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Dawner Prince","Viberator",9,75,"2.1mm","CN","mod",0,"MS",0,""],
 ["Dazatronyx","AC128 Arbitrary Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["Dazatronyx","Big Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","Big Fuzz Console",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","Biiig Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Dazatronyx","Black Russian",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","Black Russian XXL",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","Brown Sound",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["Dazatronyx","Class A Germanium Amplifier V2",9,3,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Dazatronyx","Discrete Boost",9,5,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Dazatronyx","FFS",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Dazatronyx","Harmonic Optical Tremolo MK1",9,50,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Dazatronyx","Optical Tremolo",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["Dazatronyx","Professional Drive XL",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Dazatronyx","Rad Distortion",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Dazatronyx","Stereo Panning Optical Tremolo",9,60,"2.1mm","CN","mod",0,"MS",0,"eol"],
 ["Dazatronyx","THD",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","TRANZISTOR",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dazatronyx","Tsuchi Fuzz V2",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["Dazatronyx","TSX Overdrive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Dazatronyx","TSX XXL",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Dazatronyx","Tweedsville",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Dazatronyx","Twin FET Booster",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Dazatronyx","Ultra Rad Distortion",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Death By Audio","Apocalypse",9,6,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Death By Audio","Bass War",9,33,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Death By Audio","Deep Animation",9,18,"2.1mm","CN","filter",0,"M",0,""],
 ["Death By Audio","Disturbance",9,67,"2.1mm","CN","mod",0,"M",0,""],
 ["Death By Audio","Echo Dream 2",9,40,"2.1mm","CN","delay",0,"M",0,""],
 ["Death By Audio","Echo Master",9,25,"2.1mm","CN","delay",0,"M",0,""],
 ["Death By Audio","Evil Filter",9,21,"2.1mm","CN","filter",0,"M",0,""],
 ["Death By Audio","Exploding Head",9,70,"2.1mm","CN","delay",0,"M",0,""],
 ["Death By Audio","Fuzz War",9,1,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Death By Audio","Germanium Filter",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Death By Audio","Interstellar Overdriver",9,1,"2.1mm","CN","drive",4,"M",0,""],
 ["Death By Audio","Micro Dream",9,28,"2.1mm","CN","delay",0,"M",0,""],
 ["Death By Audio","Reverberation Machine",9,66,"2.1mm","CN","reverb",0,"M",0,""],
 ["Death By Audio","Rooms",9,80,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Death By Audio","Space Bender",9,65,"2.1mm","CN","mod",0,"M",0,""],
 ["Death By Audio","Total Sonic Annihilation 2",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Death By Audio","Waveformer Destroyer",9,6,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Decibelics","Angry Swede V2",9,18,"2.1mm","CN","drive",4,"M",0,""],
 ["Decibelics","Big Klone",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Decibelics","Golden Horse",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Decibelics","Golden Royale",9,45,"2.1mm","CN","drive",2,"M",0,""],
 ["Decibelics","Rivus",9,18,"2.1mm","CN","drive",2,"M",0,""],
 ["Decibelics","The Reverend",9,18,"2.1mm","CN","drive",4,"M",0,""],
 ["Decibelics","The Reverend XX",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Deep Trip","BOG",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Deep Trip","Capivara",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Deep Trip","Hellbender",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Deep Trip","Kryptone",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Deep Trip","Malacaxeta",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Deep Trip","Muffasaur",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Deep Trip","Onca",9,1,"batt","NA","drive",2,"M",0,"ff"],
 ["Deep Trip","Pagebender",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Deep Trip","Stormy Monday",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Deep Trip","Sucuri",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["DevTech Audio","Custom Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["DevTech Audio","DG Original (Gilmour Muff)",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["DevTech Audio","DSOTM",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["DevTech Audio","Evolve",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["DevTech Audio","Powerdriver",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["DevTech Audio","Powerdriver 18",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["DevTech Audio","Precision1",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["DevTech Audio","Precision2",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["DevTech Audio","Rebellion",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["DevTech Audio","Skylight",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["DevTech Audio","Soft Drive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["DevTech Audio","ST BOOST",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["DevTech Audio","Summoner",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Diamond","Bass Comp Jr (classic)",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Bass Comp/EQ (current)",9,22,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Bass Compressor BCP-1 (classic)",18,30,"2.1mm","CP","comp",0,"M",0,""],
 ["Diamond","Boost-EQ BEQ-1 (classic)",9,13,"2.1mm","CN","eq",1,"M",0,""],
 ["Diamond","Boost/EQ (current)",9,22,"2.1mm","CN","eq",1,"M",0,""],
 ["Diamond","Comp Jr (classic)",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Comp SL (classic)",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Comp/EQ (current)",9,22,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Compressor CPR-1 (classic)",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Diamond","Counter Point (classic)",9,70,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Diamond","Dark Cloud (current)",9,45,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Diamond","Diamond Drive (current)",9,17,"2.1mm","CN","drive",3,"M",0,""],
 ["Diamond","F-Octave (current)",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Diamond","Fireburst FBR-1 (classic)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Diamond","Fireburst FBR-2 (classic)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Diamond","Halo Chorus (classic)",24,100,"P5/9.5mm","CP","mod",0,"S",0,""],
 ["Diamond","J-Drive MK3 (classic)",9,12,"2.1mm","CN","drive",2,"M",0,""],
 ["Diamond","Memory Lane (classic)",24,200,"P5/9.5mm","CP","delay",0,"M",0,""],
 ["Diamond","Memory Lane (current)",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Diamond","Memory Lane 2 (classic)",24,200,"P5/9.5mm","CP","delay",0,"M",0,""],
 ["Diamond","Memory Lane Jr (classic)",9,70,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Diamond","Nine Zero Two 902 (classic)",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Diamond","Phase (classic)",24,100,"2.1mm","CP","mod",0,"MS",0,""],
 ["Diamond","Phase (current)",9,80,"2.1mm","CN","mod",0,"M",0,""],
 ["Diamond","Quantum Leap QTL-1 (classic)",9,70,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Diamond","Tremolo (current)",9,21,"2.1mm","CN","mod",0,"M",0,""],
 ["Diamond","Tremolo TRM-1 (classic)",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Diamond","Vibrato (current)",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["Diamond","Vibrato VIB-1 (classic)",18,80,"2.1mm","CP","mod",0,"M",0,""],
 ["DigiTech","Dirty Robot",9,125,"2.1mm","CN","synth",0,"S",0,"dg"],
 ["DigiTech","Drop",9,250,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["DigiTech","FreqOut",9,235,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["DigiTech","JamMan Express XT",9,150,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["DigiTech","JamMan Solo XT",9,350,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["DigiTech","JamMan Stereo",0,0,"none","NA","looper",0,"S",0,"eol;dg"],
 ["DigiTech","Luxe",9,200,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["DigiTech","Mosaic",9,250,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["DigiTech","Nautila",9,75,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["DigiTech","Obscura",9,115,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["DigiTech","Polara",9,75,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["DigiTech","SDRUM",9,500,"2.1mm","CN","util",0,"MS",0,""],
 ["DigiTech","Trio+",9,800,"2.1mm","CN","looper",0,"MS",0,"eol;dg"],
 ["DigiTech","Ventura Vibe",9,75,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["DigiTech","Whammy 5",9,265,"2.1mm","CN","pitch",0,"M",1,"dg"],
 ["DigiTech","Whammy DT",9,288,"2.1mm","CN","pitch",0,"M",1,"dg"],
 ["DigiTech","Whammy Ricochet",9,235,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Dinosaural","3rd Law Booster",9,100,"2.1mm","CN","drive",1,"M",0,""],
 ["Dinosaural","Cogmeister",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Dinosaural","Dan Solo Booster",9,100,"2.1mm","CN","drive",1,"M",0,""],
 ["Dinosaural","Hypoid Drive",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Dinosaural","OPA-101 Overdriven Pre-amp",9,100,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Dinosaural","Tube Bender",9,100,"2.1mm","CP","fuzz",4,"M",0,"eol"],
 ["Disaster Area","DMC-4 Gen3",9,80,"2.1mm","CN","util",0,"M",0,""],
 ["Disaster Area","DMC-6 Gen3",9,80,"2.1mm","CN","util",0,"M",0,""],
 ["Disaster Area","DMC-8 Gen3",9,80,"2.1mm","CN","util",0,"M",0,""],
 ["Disaster Area","DMC.micro Gen4",9,40,"2.1mm","CN","util",0,"M",0,""],
 ["Disaster Area","MIDI Baby Gen4",9,40,"2.1mm","CN","util",0,"M",0,""],
 ["Disaster Area","SMARTClock Gen3",9,80,"2.1mm","CN","util",0,"M",0,""],
 ["DOD","250 Overdrive (1970s gray box, battery only)",9,4,"batt","NA","drive",3,"M",0,""],
 ["DOD","250 Overdrive (pre-1997)",9,5,"3.5mm","CP","drive",3,"M",0,""],
 ["DOD","250 Overdrive (reissue)",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["DOD","Bifet Boost 410 (reissue)",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["DOD","Boneshaker Distortion",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["DOD","Carcosa Fuzz",9,4,"2.1mm","CN","fuzz",4,"M",0,""],
 ["DOD","Envelope Filter 440 (reissue)",9,4,"2.1mm","CN","filter",0,"M",0,""],
 ["DOD","FX25 Envelope Filter (pre-1997)",9,4,"3.5mm","CP","filter",0,"M",0,""],
 ["DOD","FX25B Envelope Filter (1998+)",9,5,"2.5mm","CN","filter",0,"M",0,""],
 ["DOD","FX55 Supra Distortion (pre-1997)",9,10,"3.5mm","CP","drive",4,"M",0,""],
 ["DOD","FX56 American Metal (pre-1997)",9,15,"3.5mm","CP","drive",4,"M",0,""],
 ["DOD","FX65 Stereo Chorus (pre-1997)",9,20,"3.5mm","CP","mod",0,"MS",0,""],
 ["DOD","FX69 Grunge (pre-1997)",9,15,"3.5mm","CP","drive",5,"M",0,""],
 ["DOD","FX69B Grunge (1998+)",9,15,"2.5mm","CN","drive",5,"M",0,""],
 ["DOD","FX75B Stereo Flanger (pre-1997)",9,25,"3.5mm","CP","mod",0,"MS",0,""],
 ["DOD","FX90 Analog Delay (pre-1997)",9,30,"3.5mm","CP","delay",0,"MS",0,""],
 ["DOD","Gunslinger Mosfet Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["DOD","Looking Glass Overdrive",9,4,"2.1mm","CN","drive",2,"M",0,""],
 ["DOD","Meatbox Subsynth (reissue)",9,20,"2.1mm","CN","synth",0,"M",0,""],
 ["DOD","Mini Expression",0,0,"","","util",0,"M",0,""],
 ["DOD","Phasor 201 (reissue)",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["DOD","Rubberneck Analog Delay",9,150,"2.1mm","CN","delay",0,"M",0,""],
 ["Donner","Alpha Acoustic",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Donner","Alpha Bass",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Donner","Alpha Cruncher",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Donner","Alpha Force",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Donner","Alpha FX",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Donner","Arena 2000",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Donner","Black Devil",9,100,"2.1mm","CN","preamp",4,"M",0,"dg"],
 ["Donner","Blues Drive",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Donner","Boost Killer",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Donner","Circle Looper",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Donner","Dark Mouse",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Donner","Deluxe Looper",9,150,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Donner","DT Deluxe",9,50,"2.1mm","CN","tuner",0,"M",0,""],
 ["Donner","DT-1",9,30,"2.1mm","CN","tuner",0,"M",0,""],
 ["Donner","Dynamic Wah",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Donner","Echo Square",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Donner","Equalizer",9,30,"2.1mm","CN","eq",0,"M",0,""],
 ["Donner","Giant Metal",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Donner","Golden Tremolo",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Donner","Harmonic Square",9,100,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Donner","Jet Convolution",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["Donner","Metal Head",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Donner","Mod Square",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Donner","Morpher",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Donner","Noise Killer",9,30,"2.1mm","CN","gate",0,"M",0,""],
 ["Donner","Pearl Tremor",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Donner","Revecho",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Donner","Stylish Fuzz",9,20,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Donner","Tiny Looper",9,100,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Donner","Triple Looper",9,300,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Donner","Tube Drive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Donner","Tutti Love",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Donner","Ultimate Comp",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Donner","Verb Square",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Donner","Viper Mini",0,0,"none","NA","volume",0,"M",0,""],
 ["Donner","Vowel Mini",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Donner","Wah Cry",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Donner","Wave Delay",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Donner","Yellow Fall",9,40,"2.1mm","CN","delay",0,"M",0,""],
 ["Dr. No Effects","Bad MotherFuzzer",9,30,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Dr. No Effects","Black Magic",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dr. No Effects","Colossus",9,100,"2.1mm","CN","fuzz",3,"M",0,""],
 ["Dr. No Effects","Drive-O-Matic",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Dr. No Effects","Evil MotherFuzzer",9,30,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dr. No Effects","Holy Wahcamoly",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Dr. No Effects","Kafuzz!!!",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Dr. No Effects","KFC Crystal Boost",9,20,"2.1mm","CN","drive",0,"M",0,""],
 ["Dr. No Effects","Kukulcan",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["Dr. No Effects","Madfly",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dr. No Effects","Mini Turd Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Dr. No Effects","Moon Canyon",9,400,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Dr. No Effects","More Gary",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Dr. No Effects","MotherBrain Delay",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Dr. No Effects","Octofuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dr. No Effects","PowerDriver MkII",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Dr. No Effects","RoadRunner",9,50,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dr. No Effects","SkullFuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Dr. No Effects","Turd Fuzz",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Dr. No Effects","TVL Octavia",9,30,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dr. No Effects","TVL Raven",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["DryBell","Module 4",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["DryBell","The Engine",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["DryBell","Unit67",9,100,"2.1mm","CN","comp",1,"M",0,""],
 ["DryBell","Vibe Machine V-1",9,130,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["DryBell","Vibe Machine V-2",9,165,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["DryBell","Vibe Machine V-3",9,165,"2.1mm","CN","mod",0,"M",0,""],
 ["DSM & Humboldt","Black Clouds",9,40,"2.1mm","CN","drive",4,"M",0,""],
 ["DSM & Humboldt","ClearComp 1078",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["DSM & Humboldt","Dumblifier Overdrive Special",9,250,"2.1mm","CN","preamp",3,"MS",0,"amp"],
 ["DSM & Humboldt","OmniCabSim Deluxe",9,100,"2.1mm","CN","util",0,"M",0,"eol"],
 ["DSM & Humboldt","Silver Linings",9,40,"2.1mm","CN","drive",3,"M",0,""],
 ["DSM & Humboldt","Simplifier Bass Master",9,100,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["DSM & Humboldt","Simplifier Bass Station",9,100,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["DSM & Humboldt","Simplifier Classic",9,100,"2.1mm","CN","preamp",3,"MS",0,"amp"],
 ["DSM & Humboldt","Simplifier DLX",9,200,"2.1mm","CN","preamp",3,"S",0,"amp"],
 ["DSM & Humboldt","Simplifier MK-II",9,200,"2.1mm","CN","preamp",3,"MS",0,"amp"],
 ["DSM & Humboldt","Simplifier X",9,250,"2.1mm","CN","preamp",3,"S",0,"amp"],
 ["DSM & Humboldt","Sub-Atomic",9,100,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Dunlop","105Q Cry Baby Bass Wah",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","535Q Cry Baby Multi-Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","95Q Cry Baby Wah",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","CBJ95 Cry Baby Junior",9,3,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","CBM535Q Cry Baby Mini 535Q",9,3,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","CBM95 Cry Baby Mini",9,1,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","DVP1 Volume Pedal",0,0,"none","NA","volume",0,"M",0,""],
 ["Dunlop","DVP3 Volume (X)",0,0,"none","NA","volume",0,"M",0,""],
 ["Dunlop","DVP4 Volume (X) Mini",0,0,"none","NA","volume",0,"M",0,""],
 ["Dunlop","DVP5 Volume (X) 8",0,0,"none","NA","volume",0,"M",0,""],
 ["Dunlop","EP101 Echoplex Preamp",9,12,"2.1mm","CN","drive",1,"M",0,""],
 ["Dunlop","EP103 Echoplex Delay",9,240,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Dunlop","FFM1 Silicon Fuzz Face Mini",9,4,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dunlop","FFM2 Germanium Fuzz Face Mini",9,4,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dunlop","FFM3 Jimi Hendrix Fuzz Face Mini",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dunlop","FFM4 Joe Bonamassa Fuzz Face Mini",9,2,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dunlop","FFM6 Band of Gypsys Fuzz Face Mini",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Dunlop","GCB95 Cry Baby Wah",9,1,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","GCB95F Cry Baby Classic (Fasel)",9,2,"2.1mm","CN","wah",0,"M",0,""],
 ["Dunlop","JD4S Rotovibe",9,11,"2.1mm","CN","mod",0,"M",0,""],
 ["Dunlop","JDF2 Fuzz Face",9,1,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Dunlop","JHF1 Jimi Hendrix Fuzz Face",9,1,"batt","NA","fuzz",4,"M",0,"ff"],
 ["Dunlop","JHF3 Band of Gypsys Fuzz Face",9,1,"batt","NA","fuzz",4,"M",0,"ff"],
 ["Dunlop","JHM7 Jimi Hendrix Uni-Vibe",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["E.W.S.","Arion SCH-Z Chorus/Vibe Mod",9,4,"2.1mm","CN","mod",0,"M",0,""],
 ["E.W.S.","BMC (Bass Mid Control)",9,4,"2.1mm","CN","eq",0,"M",0,""],
 ["E.W.S.","BMC2 (Bass Mid Control 2)",9,7,"2.1mm","CN","eq",0,"M",0,""],
 ["E.W.S.","Brute Drive",9,11,"2.1mm","CN","drive",4,"M",0,""],
 ["E.W.S.","Brute Drive Eric Gales",9,11,"2.1mm","CN","drive",4,"M",0,""],
 ["E.W.S.","Fuzzy Drive",9,7,"2.1mm","CN","fuzz",5,"M",0,""],
 ["E.W.S.","LA Chorus",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["E.W.S.","Little Brute Drive",9,7,"2.1mm","CN","drive",4,"M",0,""],
 ["E.W.S.","Little Brute Drive 2",9,16,"2.1mm","CN","drive",4,"M",0,""],
 ["E.W.S.","Little Fuzzy Drive",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["E.W.S.","Stormy Bass Drive",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["E.W.S.","Subtle Volume Control",0,0,"none","NA","volume",0,"M",0,""],
 ["E.W.S.","Tri-Logic Bass Preamp 2",18,5,"2.1mm","CN","preamp",0,"M",0,""],
 ["E.W.S.","Tri-Logic Bass Preamp 3",9,7,"2.1mm","CN","preamp",0,"M",0,""],
 ["EarthQuaker Devices","Acapulco Gold",9,18,"2.1mm","CN","drive",4,"M",0,""],
 ["EarthQuaker Devices","Afterneath",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Aqueduct",9,68,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["EarthQuaker Devices","Arpanoid",9,65,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["EarthQuaker Devices","Arrows",9,8,"2.1mm","CN","drive",1,"M",0,""],
 ["EarthQuaker Devices","Astral Destiny",9,85,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Aurelius",9,75,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["EarthQuaker Devices","Avalanche Run",9,410,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["EarthQuaker Devices","Barrows",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["EarthQuaker Devices","Bellows (Legacy Reissue)",9,13,"2.1mm","CN","fuzz",4,"M",0,""],
 ["EarthQuaker Devices","Bit Commander",9,25,"2.1mm","CN","synth",0,"M",0,""],
 ["EarthQuaker Devices","Black Ash",9,20,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["EarthQuaker Devices","Blumes",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Chelsea",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["EarthQuaker Devices","Cloven Hoof",9,14,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Colby Fuzz Sound",9,3,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["EarthQuaker Devices","Data Corrupter",9,26,"2.1mm","CN","synth",0,"M",0,""],
 ["EarthQuaker Devices","Dirt Transmitter (Legacy Reissue)",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Disaster Transport (Legacy Reissue)",9,35,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Disaster Transport SR",9,107,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Dispatch Master",9,78,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Dunes",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Easy Listening",9,75,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["EarthQuaker Devices","Erupter",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Fuzz Master General (Legacy Reissue)",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Gary",9,20,"2.1mm","CN","fuzz",4,"M",0,""],
 ["EarthQuaker Devices","Ghost Echo",9,86,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Grand Orbiter",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["EarthQuaker Devices","Gray Channel",9,45,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Hizumitas",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Hoof",9,15,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Hoof Reaper",9,18,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["EarthQuaker Devices","Hummingbird",9,18,"2.1mm","CN","mod",0,"M",0,""],
 ["EarthQuaker Devices","Interstellar Orbiter",9,20,"2.1mm","CN","filter",0,"M",0,""],
 ["EarthQuaker Devices","Ledges",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Levitation",9,72,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Night Wire",9,65,"2.1mm","CN","mod",0,"M",0,""],
 ["EarthQuaker Devices","Organizer",9,81,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["EarthQuaker Devices","Palisades",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Park Fuzz Sound",9,3,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["EarthQuaker Devices","Pitch Bay",9,65,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["EarthQuaker Devices","Plumes",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Pyramids",9,460,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["EarthQuaker Devices","Rainbow Machine",9,68,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["EarthQuaker Devices","Scrolls",9,70,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Sea Machine",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["EarthQuaker Devices","Silos",9,75,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Space Spiral",9,38,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Spatial Delivery",9,75,"2.1mm","CN","filter",0,"M",0,""],
 ["EarthQuaker Devices","Speaker Cranker",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["EarthQuaker Devices","Special Cranker",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["EarthQuaker Devices","Spires",9,44,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","Sunn O))) HalfLife",9,15,"2.1mm","CN","drive",5,"M",0,""],
 ["EarthQuaker Devices","Sunn O))) Life Pedal V2",9,15,"2.1mm","CN","drive",5,"M",0,""],
 ["EarthQuaker Devices","Sunn O))) Life Pedal V3",9,15,"2.1mm","CN","drive",5,"M",0,""],
 ["EarthQuaker Devices","Swiss Things",9,15,"2.1mm","CN","util",0,"M",0,""],
 ["EarthQuaker Devices","Talons",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["EarthQuaker Devices","Tentacle",9,10,"2.1mm","CN","pitch",0,"M",0,""],
 ["EarthQuaker Devices","Terminal",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["EarthQuaker Devices","The Depths",9,21,"2.1mm","CN","mod",0,"M",0,""],
 ["EarthQuaker Devices","The Warden",9,31,"2.1mm","CN","comp",0,"M",0,""],
 ["EarthQuaker Devices","Time Shadows V2",9,75,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["EarthQuaker Devices","Tone Job",9,21,"2.1mm","CN","eq",0,"M",0,""],
 ["EarthQuaker Devices","Towers",9,85,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["EarthQuaker Devices","Transmisser",9,76,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["EarthQuaker Devices","Westwood",9,18,"2.1mm","CN","drive",2,"M",0,""],
 ["EarthQuaker Devices","White Light (Legacy Reissue)",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["EarthQuaker Devices","Zap Machine",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["EarthQuaker Devices","Zoar",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Effectrode","Atomic Isolator",0,0,"none","NA","util",0,"M",0,""],
 ["Effectrode","Blackbird (SR-71)",12,1000,"2.1mm","CP","preamp",0,"M",0,""],
 ["Effectrode","Blackbird Vintage Preamp",12,1000,"2.1mm","CP","preamp",0,"M",0,"amp"],
 ["Effectrode","Blue Bottle Booster",12,600,"2.1mm","CP","drive",1,"M",0,""],
 ["Effectrode","Delta-Trem",12,1000,"2.1mm","CP","mod",0,"M",0,""],
 ["Effectrode","Fire Bottle",12,600,"2.1mm","CP","drive",1,"M",0,""],
 ["Effectrode","Glass-A Buffer",12,600,"2.1mm","CP","util",0,"M",0,""],
 ["Effectrode","Helios Fuzz",12,600,"2.1mm","CP","fuzz",5,"M",0,""],
 ["Effectrode","LA-1A Leveling Amplifier",12,1000,"2.1mm","CP","comp",0,"M",0,""],
 ["Effectrode","Mercury Fuzz",12,600,"2.1mm","CP","fuzz",5,"M",0,""],
 ["Effectrode","PC-2A Compressor",12,600,"2.1mm","CP","comp",0,"M",0,""],
 ["Effectrode","Phaseomatic",12,1000,"2.1mm","CP","mod",0,"M",0,""],
 ["Effectrode","Tube Drive",12,1000,"2.1mm","CP","drive",4,"M",0,""],
 ["Effectrode","Tube Vibe",12,1000,"2.1mm","CP","mod",0,"M",0,""],
 ["Effectrode","Vibra-Chorus",12,1200,"2.1mm","CP","mod",0,"M",0,""],
 ["Electro-Faustus","Astral Whip (EF112)",0,0,"none","NA","synth",0,"M",0,""],
 ["Electro-Faustus","Blackfly (EF110)",0,0,"none","NA","synth",0,"M",0,""],
 ["Electro-Faustus","Drone King (EF209)",9,80,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Faustus","Drone Thing (EF109)",9,50,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Faustus","Drum Thing (EF105)",0,0,"none","NA","synth",0,"M",0,""],
 ["Electro-Faustus","FaustHammer (EF117)",0,0,"none","NA","synth",0,"M",0,""],
 ["Electro-Faustus","Fugue State (EF113)",9,30,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Faustus","Guitar Disruptor (EF103)",9,25,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Faustus","Infektor (EF116)",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Faustus","Photo Theremin (EF102)",9,20,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Faustus","Quad (EF104)",9,30,"2.1mm","CN","synth",0,"M",0,"eol"],
 ["Electro-Faustus","Simulacrum (EF114)",9,100,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Faustus","Theremorph (EF202)",9,100,"2.1mm","CP","synth",0,"M",0,""],
 ["Electro-Faustus","Vulcan's Hammer (EF118)",0,0,"none","NA","synth",0,"M",0,""],
 ["Electro-Harmonix","#1 Echo",9,185,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electro-Harmonix","1440 Stereo Looper",9,150,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","2020 Pedal Tuner",9,10,"2.1mm","CN","tuner",0,"M",0,""],
 ["Electro-Harmonix","22500 Dual Stereo Looper",9,240,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","2880 Super Multi-Track Looper",9,350,"2.5mm","CP","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","360 Nano Looper",9,90,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["Electro-Harmonix","45000 Multi-Track Looping Recorder",9,190,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","720 Stereo Looper",9,75,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","8 Step Program",9,100,"2.1mm","CN","util",0,"M",1,""],
 ["Electro-Harmonix","95000 Performance Loop Laboratory",9,320,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["Electro-Harmonix","Analogizer",9,18,"2.1mm","CN","drive",1,"M",0,""],
 ["Electro-Harmonix","Attack Decay",9,140,"2.1mm","CN","volume",0,"M",0,""],
 ["Electro-Harmonix","B9 Organ Machine",9,85,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Bad Stone",9,18,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Bass Big Muff Pi",9,7,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Bass Blogger",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Bass Clone",9,11,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Bass Micro Synth",9,55,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Harmonix","Bass Mono Synth",9,125,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Bass Preacher",9,33,"2.1mm","CN","comp",0,"M",0,""],
 ["Electro-Harmonix","Bass Soul Food",9,22,"2.1mm","CN","drive",2,"M",0,""],
 ["Electro-Harmonix","Bass9 Bass Machine",9,100,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","BassBalls (vintage/Sovtek)",9,3,"3.5mm","CP","filter",0,"M",0,""],
 ["Electro-Harmonix","BassBalls Nano",9,3,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Battalion Bass Preamp",9,100,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Electro-Harmonix","Big Muff Pi",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Big Muff Pi V1 Triangle (vintage)",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Big Muff Pi V2 Ram's Head (vintage)",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Big Muff Pi V4 Op-Amp (vintage)",9,5,"3.5mm","CP","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Big Muff Pi with Tone Wicker",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Blurst",9,56,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","C9 Organ Machine",9,85,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Canyon",9,150,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electro-Harmonix","Cathedral Stereo Reverb",9,145,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Electro-Harmonix","Clockworks",18,300,"2.1mm","CP","util",0,"M",0,""],
 ["Electro-Harmonix","Cock Fight",9,40,"2.1mm","CN","wah",0,"M",0,""],
 ["Electro-Harmonix","Cock Fight Plus",9,50,"2.1mm","CN","wah",0,"M",0,""],
 ["Electro-Harmonix","Crayon",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Deluxe Bass Big Muff Pi",9,14,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Deluxe Big Muff Pi",9,22,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Deluxe Electric Mistress (90s reissue)",24,100,"2.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Electric Mistress (vintage)",0,0,"none","NA","mod",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Electric Mistress XO",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Memory Boy",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Memory Man (current reissue/XO)",24,100,"2.5mm","CP","delay",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Memory Man (vintage 24V)",0,0,"none","NA","delay",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Memory Man 1100-TT",9,200,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Deluxe Memory Man 550-TT",9,200,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Doctor Q (vintage)",9,2,"3.5mm","CP","filter",0,"M",0,""],
 ["Electro-Harmonix","Double Muff",9,3,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Dual Expression Pedal",0,0,"none","NA","util",0,"M",0,""],
 ["Electro-Harmonix","East River Drive",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Eddy Vibrato/Chorus",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","EHX Tortion",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Electro-Harmonix","Electric Mistress (vintage 18V)",18,100,"3.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Electric Mistress V6 (vintage 9V)",9,40,"3.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Enigma: Q Balls",9,135,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Epitome",9,185,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Electro-Harmonix","Flanger Hoax",18,75,"2.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Flatiron Fuzz",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Freeze",9,96,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Germanium 4 Big Muff Pi",9,12,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Glove OD",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Good Vibes",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Grand Canyon",9,150,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electro-Harmonix","Graphic Fuzz",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Green Russian Big Muff Pi",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Hell Melter",9,140,"2.1mm","CN","drive",5,"M",0,""],
 ["Electro-Harmonix","HOG",0,0,"none","NA","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","HOG2",9,170,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Holier Grail",18,500,"2.5mm","CP","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Holy Grail (original)",9,225,"3.5mm","CP","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Holy Grail Max",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Holy Grail Nano",9,110,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Holy Grail Neo",9,75,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Holy Grail Plus",9,165,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Hot Tubes Nano",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Hot Wax",9,75,"2.1mm","CN","drive",3,"M",0,""],
 ["Electro-Harmonix","Hum Debugger",0,0,"none","NA","gate",0,"M",0,""],
 ["Electro-Harmonix","Intelligent Harmony Machine",9,26,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Iron Lung Vocoder",9,150,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","J Mascis Ram's Head Big Muff Pi",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Key9 Electric Piano Machine",9,100,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Lester G Rotary Speaker Emulator",9,79,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Electro-Harmonix","Lester K Stereo Rotary Speaker Emulator",9,135,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Electro-Harmonix","Little Big Muff Pi",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Lizard Queen",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","LPB-1",9,2,"2.1mm","CN","drive",1,"M",0,""],
 ["Electro-Harmonix","LPB-3",9,120,"2.1mm","CN","drive",1,"M",0,""],
 ["Electro-Harmonix","Mainframe Bit Crusher",9,90,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Mel9 Tape Replay Machine",9,100,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Memory Boy",9,45,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Memory Man (vintage)",0,0,"none","NA","delay",0,"M",0,""],
 ["Electro-Harmonix","Memory Toy",9,18,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Metal Muff with Top Boost",9,24,"2.1mm","CN","drive",5,"M",0,""],
 ["Electro-Harmonix","Micro Metal Muff",9,18,"2.1mm","CN","drive",5,"M",0,""],
 ["Electro-Harmonix","Micro POG",9,180,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["Electro-Harmonix","Micro Q-Tron",9,15,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Micro Synth",9,55,"2.1mm","CN","synth",0,"M",0,""],
 ["Electro-Harmonix","Mini Q-Tron",9,3,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Mod 11",9,150,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Electro-Harmonix","Mod Rex",9,100,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Electro-Harmonix","Mono Synth",9,125,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Muff Fuzz (vintage)",9,1,"batt","NA","fuzz",3,"M",0,""],
 ["Electro-Harmonix","Nano Bass Big Muff Pi",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Nano Battalion",9,45,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Electro-Harmonix","Nano Big Muff Pi",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Nano Clone",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Nano Deluxe Memory Man",9,150,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Nano Dr. Q",9,2,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Nano Metal Muff",9,24,"2.1mm","CN","drive",5,"M",0,""],
 ["Electro-Harmonix","Nano Operation Overlord",9,50,"2.1mm","CN","drive",4,"S",0,""],
 ["Electro-Harmonix","Nano POG",9,25,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["Electro-Harmonix","Nano Pulsar",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Electro-Harmonix","Nano Q-Tron",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Nano Small Stone",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Neo Clone",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Neo Mistress",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Oceans 11",9,137,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Oceans 12",9,150,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Electro-Harmonix","Oceans Abyss",9,500,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Electro-Harmonix","Octave Multiplexer",9,11,"2.1mm","CN","pitch",0,"M",0,""],
 ["Electro-Harmonix","Octavix",9,9,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Op-Amp Big Muff Pi",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Operation Overlord",9,90,"2.1mm","CN","drive",4,"S",0,""],
 ["Electro-Harmonix","Pico 360+ Looper",9,100,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["Electro-Harmonix","Pico Attack Decay",9,100,"2.1mm","CN","volume",0,"M",0,""],
 ["Electro-Harmonix","Pico Canyon Echo",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Deep Freeze",9,100,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Oceans 3-Verb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Pitch Fork",9,100,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Platform",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Electro-Harmonix","Pico POG",9,100,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Rerun",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electro-Harmonix","Pico Swello",9,100,"2.1mm","CN","volume",0,"M",0,""],
 ["Electro-Harmonix","Pico Triboro Bridge",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Electro-Harmonix","Pitch Fork",9,30,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Pitch Fork+",9,120,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["Electro-Harmonix","Platform Stereo Compressor",9,125,"2.1mm","CN","comp",0,"S",0,""],
 ["Electro-Harmonix","Pocket Metal Muff",9,9,"2.1mm","CN","drive",5,"M",0,""],
 ["Electro-Harmonix","POG (original)",18,500,"2.5mm","CP","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","POG2",9,180,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","POG3",9,300,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["Electro-Harmonix","Q-Tron (original)",24,100,"2.5mm","CP","filter",0,"M",0,""],
 ["Electro-Harmonix","Q-Tron+",24,100,"2.5mm","CP","filter",0,"M",0,""],
 ["Electro-Harmonix","Ram's Head Big Muff Pi",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Ravish Sitar",9,160,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Riddle: Q Balls",9,158,"2.1mm","CN","filter",0,"M",0,""],
 ["Electro-Harmonix","Ring Thing",9,190,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Electro-Harmonix","Ripped Speaker",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Electro-Harmonix","Satisfaction Fuzz",9,2,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Electro-Harmonix","Satisfaction Plus",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Electro-Harmonix","Silencer",9,22,"2.1mm","CN","gate",0,"M",0,""],
 ["Electro-Harmonix","Single Expression Pedal",0,0,"none","NA","util",0,"M",0,""],
 ["Electro-Harmonix","Slap-Back Echo",9,15,"2.1mm","CN","delay",0,"M",0,""],
 ["Electro-Harmonix","Small Clone (current EH4600)",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Small Clone (vintage)",9,10,"3.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Small Stone (current EH4800)",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Electro-Harmonix","Small Stone (vintage)",9,3,"3.5mm","CP","mod",0,"M",0,""],
 ["Electro-Harmonix","Soul Food",9,22,"2.1mm","CN","drive",2,"M",0,""],
 ["Electro-Harmonix","Soul POG",9,125,"2.1mm","CN","pitch",0,"MS",0,"dg"],
 ["Electro-Harmonix","Soul Preacher Nano",9,34,"2.1mm","CN","comp",0,"M",0,""],
 ["Electro-Harmonix","Sovtek Deluxe Big Muff Pi",9,22,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Sovtek Green Russian Big Muff (vintage)",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Stereo Clone Theory",9,14,"2.1mm","CN","mod",0,"MS",0,""],
 ["Electro-Harmonix","Stereo Electric Mistress",9,160,"2.1mm","CN","mod",0,"MS",0,""],
 ["Electro-Harmonix","Stereo Memory Man with Hazarai",9,170,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Electro-Harmonix","Stereo Polychorus (XO)",9,110,"2.1mm","CN","mod",0,"MS",0,""],
 ["Electro-Harmonix","Stereo Pulsar",9,17,"2.1mm","CN","mod",0,"MS",0,""],
 ["Electro-Harmonix","Stereo Talking Machine",9,185,"2.1mm","CN","filter",0,"MS",0,""],
 ["Electro-Harmonix","String9 String Ensemble",9,100,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Super Pulsar",9,165,"2.1mm","CN","mod",0,"S",0,""],
 ["Electro-Harmonix","Super Switcher",9,150,"2.1mm","CN","switcher",0,"M",0,""],
 ["Electro-Harmonix","Superego",9,140,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Superego+",9,140,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Synth9 Synthesizer Machine",9,100,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Electro-Harmonix","Tone Corset",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Electro-Harmonix","Tone Tattoo",9,75,"2.1mm","CN","multi",0,"M",0,""],
 ["Electro-Harmonix","Tri Parallel Mixer",9,45,"2.1mm","CN","util",0,"M",0,""],
 ["Electro-Harmonix","Triangle Big Muff Pi",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electro-Harmonix","Turnip Greens",9,125,"2.1mm","CN","drive",2,"M",0,""],
 ["Electro-Harmonix","V256 Vocoder",9,200,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Electro-Harmonix","Voice Box",9,200,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electro-Harmonix","Wailer Wah",9,6,"2.1mm","CN","wah",0,"M",0,""],
 ["Electro-Harmonix","Walking on the Moon",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Electronic Audio Experiments","0xEAE Boost",9,120,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Electronic Audio Experiments","Beholder",9,80,"2.1mm","CN","reverb",5,"M",0,"dg;eol"],
 ["Electronic Audio Experiments","Citadel",9,65,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Electronic Audio Experiments","Dagger",9,50,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Electronic Audio Experiments","Glaive",9,70,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Electronic Audio Experiments","Greathammer",9,70,"2.1mm","CN","drive",3,"M",0,""],
 ["Electronic Audio Experiments","Halberd",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Electronic Audio Experiments","Halberd + Germanium Boost",9,85,"2.1mm","CN","drive",3,"M",0,""],
 ["Electronic Audio Experiments","Limelight",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Electronic Audio Experiments","Longsword",9,95,"2.1mm","CN","drive",3,"M",0,""],
 ["Electronic Audio Experiments","Mirror House",9,95,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Electronic Audio Experiments","Model feT",9,65,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Electronic Audio Experiments","Prismatic Wall",9,200,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Electronic Audio Experiments","Sending",9,380,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Electronic Audio Experiments","Surveyor",9,70,"2.1mm","CN","drive",4,"M",0,""],
 ["Electronic Audio Experiments","The Bard",9,60,"2.1mm","CN","preamp",2,"M",0,""],
 ["Empress","Bass Compressor",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Empress","Buffer+",9,86,"2.1mm","CN","util",0,"M",0,""],
 ["Empress","Compressor",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Empress","Compressor MkII",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Empress","Echosystem",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Empress","Germ Drive",9,35,"2.1mm","CN","drive",2,"M",0,""],
 ["Empress","Heavy",9,200,"2.1mm","CN","drive",5,"M",0,""],
 ["Empress","Heavy Menace",9,250,"2.1mm","CN","drive",5,"M",0,""],
 ["Empress","Midibox 2",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["Empress","Multidrive",9,180,"2.1mm","CN","drive",4,"M",0,""],
 ["Empress","Nebulus",9,300,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Empress","ParaEQ",9,85,"2.1mm","CN","eq",0,"M",0,""],
 ["Empress","ParaEQ MkII Deluxe",9,300,"2.1mm","CN","eq",0,"M",0,""],
 ["Empress","Phaser",9,120,"2.1mm","CN","mod",0,"M",0,""],
 ["Empress","Reverb",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Empress","Superdelay",9,300,"2.1mm","CP","delay",0,"M",0,"dg"],
 ["Empress","Tremolo2",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Empress","Zoia",9,300,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Ernie Ball","MVP",9,100,"2.1mm","CN","volume",0,"M",0,""],
 ["Ernie Ball","VP 40th Anniversary",0,0,"none","NA","volume",0,"M",0,""],
 ["Ernie Ball","VP JR 25K",0,0,"none","NA","volume",0,"M",0,""],
 ["Eventide","Blackhole",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Eventide","H9 (all variants)",9,500,"2.5mm","CP","multi",0,"S",1,"dg"],
 ["Eventide","H90",12,600,"2.5mm","CP","multi",0,"S",1,"dg"],
 ["Eventide","MicroPitch",9,300,"2.1mm","CN","pitch",0,"S",1,"dg"],
 ["Eventide","ModFactor",9,500,"2.5mm","CP","mod",0,"S",1,"dg"],
 ["Eventide","PitchFactor",9,500,"2.5mm","CP","pitch",0,"S",1,"dg"],
 ["Eventide","Riptide",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Eventide","Rose",9,200,"2.1mm","CN","delay",0,"M",1,"dg"],
 ["Eventide","Space",9,500,"2.5mm","CP","reverb",0,"S",1,"dg"],
 ["Eventide","TimeFactor",9,500,"2.5mm","CP","delay",0,"S",1,"dg"],
 ["Eventide","TriceraChorus",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Eventide","UltraTap",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Fairfield Circuitry","~900",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Fairfield Circuitry","20% More",9,20,"2.1mm","CN","fuzz",3,"M",0,""],
 ["Fairfield Circuitry","Barbershop",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Fairfield Circuitry","Board Member",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Fairfield Circuitry","Conflict of Interest",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Fairfield Circuitry","Four Eyes",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Fairfield Circuitry","Hors d'Oeuvre?",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["Fairfield Circuitry","Long Life",9,150,"2.1mm","CN","eq",0,"M",0,""],
 ["Fairfield Circuitry","Meet Maude",9,60,"2.1mm","CN","delay",0,"M",0,""],
 ["Fairfield Circuitry","Modèle B",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Fairfield Circuitry","Randy's Revenge",9,85,"2.1mm","CN","mod",0,"M",0,""],
 ["Fairfield Circuitry","Roger That",9,30,"2.1mm","CN","fuzz",3,"M",0,""],
 ["Fairfield Circuitry","Shallow Water",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Fairfield Circuitry","The Accountant",9,12,"2.1mm","CN","comp",0,"M",0,""],
 ["Fairfield Circuitry","The Unpleasant Surprise",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Fender","2-Switch ABY",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Fender","Bubbler Analog Chorus",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Fender","Compugilist",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Fender","Downtown Express Bass Multi-Effect",9,400,"2.1mm","CN","multi",2,"M",0,""],
 ["Fender","Dual Marine Layer Reverb",9,200,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Fender","Duel Pugilist Distortion",9,165,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","Engager Boost",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["Fender","EXP-1 Expression Pedal",0,0,"n/a","","util",0,"M",0,""],
 ["Fender","Full Moon Distortion",9,110,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","Hammertone Chorus",9,75,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Fender","Hammertone Delay",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Fender","Hammertone Distortion",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","Hammertone Flanger",9,75,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Fender","Hammertone Fuzz",9,15,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Fender","Hammertone Metal",9,20,"2.1mm","CN","drive",5,"M",0,""],
 ["Fender","Hammertone Overdrive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Fender","Hammertone Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Fender","Hammertone Space Delay",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Fender","Level Set Buffer",9,60,"2.1mm","CN","util",0,"M",0,""],
 ["Fender","Lost Highway Phaser",9,80,"2.1mm","CN","mod",0,"M",0,""],
 ["Fender","Marine Layer Reverb",9,130,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Fender","Mirror Image Delay",9,138,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Fender","MTG Tube Distortion",9,290,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","MTG:LA Tube Distortion",9,260,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","Pour Over Envelope Filter",9,100,"2.1mm","CN","filter",0,"M",0,""],
 ["Fender","Preverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Fender","Pugilist Distortion",9,60,"2.1mm","CN","drive",3,"M",0,""],
 ["Fender","Reflecting Pool Delay/Reverb",9,300,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Fender","Santa Ana Overdrive",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Fender","Smolder Acoustic Overdrive",9,60,"2.1mm","CN","drive",2,"M",0,""],
 ["Fender","The Bends Compressor",9,60,"2.1mm","CN","comp",0,"M",0,""],
 ["Fender","The Pelt Fuzz",9,50,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Fender","The Pinwheel",9,310,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Fender","The Trapper Dual Fuzz",9,60,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fender","Trapper Bass Distortion",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["Fender","Tre-Verb",9,350,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Fjord Fuzz","Berserk III",9,250,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Fjord Fuzz","Bjorn",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fjord Fuzz","Dovre",9,250,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Fjord Fuzz","Fenris",9,70,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Fjord Fuzz","Fjaer",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Fjord Fuzz","Frei",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Fjord Fuzz","Loke",9,250,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Fjord Fuzz","Mane",9,100,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Fjord Fuzz","Midgard",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fjord Fuzz","Midnattssol",9,500,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fjord Fuzz","Odin",9,120,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fjord Fuzz","Sol",9,150,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Fjord Fuzz","Thor",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Flamma","FB200",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FC01",9,150,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Flamma","FC02",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Flamma","FC03",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Flamma","FC04",9,50,"2.1mm","CN","tuner",0,"M",0,""],
 ["Flamma","FC05",9,150,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Flamma","FC06",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Flamma","FC07",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Flamma","FC10",9,50,"2.1mm","CN","gate",0,"M",0,""],
 ["Flamma","FC11",9,50,"2.1mm","CN","filter",0,"M",0,""],
 ["Flamma","FC12",9,100,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Flamma","FC13",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Flamma","FC14",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Flamma","FC15",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Flamma","FC16",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Flamma","FC17",9,50,"2.1mm","CN","delay",0,"M",0,""],
 ["Flamma","FC18",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Flamma","FC19",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Flamma","FC20",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Flamma","FC21",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Flamma","FF01",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Flamma","FF02",9,300,"2.1mm","CN","util",0,"S",0,"dg"],
 ["Flamma","FF20",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Flamma","FG200",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FS01",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Flamma","FS02",9,300,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Flamma","FS03",9,300,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Flamma","FS05",9,300,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Flamma","FS06",9,300,"2.1mm","CN","preamp",0,"MS",0,"dg"],
 ["Flamma","FS07",9,300,"2.1mm","CN","util",0,"S",0,"dg"],
 ["Flamma","FS08",9,300,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Flamma","FS21",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Flamma","FS22 Ekoverb",9,300,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Flamma","FS23",9,300,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Flamma","FV01",9,300,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Flamma","FV02",9,300,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Flamma","FV03",9,300,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Flamma","FV04",9,300,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Flamma","FV05",9,300,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Flamma","FX100",9,300,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FX150",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FX150B",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FX200",9,1000,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Flamma","FX50",9,100,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Fortin","33 (Fredrik Thordendal Signature)",9,27,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Blade (Whitechapel Signature)",9,25,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Blade Blackout",9,25,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Fuzz )))",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fortin","Grind",9,25,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Grind Blackout",9,25,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Meshuggah",9,125,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Fortin","Mini 33",9,27,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Mini Grind",9,25,"2.1mm","CN","drive",1,"M",0,""],
 ["Fortin","Mini Zuul",9,40,"2.1mm","CN","gate",0,"M",0,""],
 ["Fortin","NATAS",9,150,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Fortin","Roach",9,4,"2.1mm","CN","util",0,"MS",0,""],
 ["Fortin","Zuul (original)",9,40,"2.1mm","CN","gate",0,"M",0,"eol"],
 ["Fortin","Zuul+",9,40,"2.1mm","CN","gate",0,"M",0,""],
 ["Fractal Audio","FM3",0,0,"none","NA","multi",4,"S",1,"dg"],
 ["Fractal Audio","FM9",0,0,"none","NA","multi",4,"S",1,"dg"],
 ["Fractal Audio","VP4",9,1300,"2.1mm","CN","multi",3,"S",0,"dg"],
 ["Free The Tone","Ambi Space AS-1R",9,280,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Free The Tone","ARC-4",12,750,"2.1mm","CN","util",0,"M",1,""],
 ["Free The Tone","ARC-53M",12,400,"2.1mm","CN","util",0,"M",1,""],
 ["Free The Tone","Fire Mist FM-1V",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Free The Tone","Flight Time FT-2Y",12,400,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Free The Tone","Future Factory FF-1Y",9,350,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Free The Tone","Gigs Boson GB-1V",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Free The Tone","Iron Forest IF-1D",9,9,"2.1mm","CN","drive",4,"M",0,""],
 ["Free The Tone","Motion Loop ML-1L",9,185,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["Free The Tone","MS SOV Special MS-1V",9,90,"2.1mm","CN","drive",3,"M",0,""],
 ["Free The Tone","Red Jasper RJ-2V",9,11,"2.1mm","CN","drive",2,"M",0,""],
 ["Free The Tone","Silky Comp SC-1",9,4,"2.1mm","CN","comp",0,"M",0,""],
 ["Free The Tone","String Slinger SS-1V",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Free The Tone","Tri Avatar TA-2H",9,150,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Friedman","BE-OD",9,10,"2.1mm","CN","drive",5,"M",0,""],
 ["Friedman","BE-OD Deluxe",18,40,"2.1mm","CN","drive",5,"M",0,""],
 ["Friedman","Buxom Boost",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Friedman","Dirty Shirley",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Friedman","Fuzz Fiend",12,500,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Friedman","Gold-72 Wah",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Friedman","Golden Pearl",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Friedman","IR-D",12,800,"2.1mm","CN","preamp",4,"M",1,"dg"],
 ["Friedman","IR-J",12,800,"2.1mm","CN","preamp",4,"M",1,"dg"],
 ["Friedman","IR-X",12,800,"2.1mm","CN","preamp",4,"M",1,"dg"],
 ["Friedman","Motor City Drive",12,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Friedman","Sir-Compre",9,20,"2.1mm","CN","comp",1,"M",0,""],
 ["Friedman","Smallbox Overdrive",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Fulltone","'69 Fuzz mkII",9,5,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Fulltone","'70 Fuzz BC",9,20,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Fulltone","Clyde Wah",9,8,"2.1mm","CN","wah",0,"M",0,""],
 ["Fulltone","Fat Boost FB-3",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Fulltone","Full-Drive 2",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Fulltone","Full-Drive 2 MOSFET",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Fulltone","Full-Drive 2 V2",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Fulltone","Full-Drive 3",9,13,"2.1mm","CN","drive",3,"M",0,""],
 ["Fulltone","Mini Deja Vibe MDV",18,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Fulltone","OCD Ge",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Fulltone","OCD V1",9,7,"2.1mm","CN","drive",4,"M",0,""],
 ["Fulltone","OCD V2",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Fulltone","Octafuzz OF-2",9,5,"2.1mm","CP","fuzz",5,"M",0,"ff"],
 ["Fulltone","Plimsoul",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["Fulltone","Secret Freq",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Fulltone","Supa-Trem",9,8,"2.1mm","CN","mod",0,"M",0,""],
 ["Fulltone","Supa-Trem 2",18,50,"2.1mm","CN","mod",0,"M",0,""],
 ["Fuzz Imp","Adventure Superfuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fuzz Imp","Amity Dual Overdrive",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Fuzz Imp","Bongfire",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fuzz Imp","Creature",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fuzz Imp","DRAT!",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Fuzz Imp","Echo Moon",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Fuzz Imp","Furia",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Fuzz Imp","Machina 2 Deluxe",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fuzz Imp","Obtainium",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Fuzz Imp","Sender V",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Fuzz Imp","Shroot",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Fuzz Imp","Shroot II Deluxe",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Gamechanger Audio","Auto Chorus",9,250,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Gamechanger Audio","Auto Delay",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Gamechanger Audio","Auto Reverb",9,250,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Gamechanger Audio","Bigsby Pedal",9,500,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Gamechanger Audio","Light Pedal",9,500,"2.1mm","CN","reverb",0,"MS",0,""],
 ["Gamechanger Audio","Plasma Coil",9,300,"2.1mm","CN","drive",5,"M",0,""],
 ["Gamechanger Audio","Plasma Pedal",9,300,"2.1mm","CN","drive",5,"M",0,""],
 ["Gamechanger Audio","Plus Pedal",9,250,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["GFI System","Cabzeus Mono",9,120,"2.1mm","CN","util",0,"M",0,"dg"],
 ["GFI System","Cabzeus Stereo",9,150,"2.1mm","CN","util",0,"S",1,"dg"],
 ["GFI System","Duophony",9,150,"2.1mm","CN","util",0,"S",0,""],
 ["GFI System","Enieqma",9,280,"2.1mm","CN","eq",0,"S",0,"dg"],
 ["GFI System","Jonassus Drive",9,40,"2.1mm","CN","drive",3,"M",0,""],
 ["GFI System","Orca",9,110,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["GFI System","Rossie",9,110,"2.1mm","CN","filter",0,"M",0,"dg"],
 ["GFI System","Skylar",9,110,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["GFI System","Solis Ventus",9,350,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["GFI System","Specular Tempus",9,100,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["GFI System","Synesthesia",9,240,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["GFI System","Triple Switch",0,0,"","","util",0,"M",0,""],
 ["God City Instruments","Ape Eye",9,50,"2.1mm","CN","preamp",2,"M",0,""],
 ["God City Instruments","Bad Larry",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["God City Instruments","Baracus",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","BJR (Brutalist Jr.)",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["God City Instruments","BLM Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","Brutalist",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["God City Instruments","Crimson Cock",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["God City Instruments","FACE",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","Jugendstil",9,25,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","Jugendtief",9,25,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","NOJOFUZZ",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","OGR Stage 4",9,60,"2.1mm","CN","comp",0,"M",0,""],
 ["God City Instruments","Onslaught",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["God City Instruments","Pariah",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["God City Instruments","Riffchild",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["God City Instruments","SBD",9,25,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Greer Amps","Arbuckle",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Greer Amps","Gorilla Warfare",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Greer Amps","Gorilla Warfare MkII",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Greer Amps","Lightspeed",9,11,"2.1mm","CN","drive",2,"M",0,""],
 ["Greer Amps","Moonshot",9,5,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Greer Amps","Relic Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Greer Amps","Soma 63",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Greer Amps","Southland",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Greer Amps","Special Request",9,6,"2.1mm","CN","drive",1,"M",0,""],
 ["Greer Amps","Sucker Punch",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Greer Amps","Supa Cobra",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Greer Amps","Tomahawk",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Haggtronix","606-Screamer",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Haggtronix","CCL Overdrive Preamp",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Haggtronix","Cerebral Specter",9,30,"2.1mm","CN","delay",0,"M",0,""],
 ["Haggtronix","Cryptkeeper V2",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Haggtronix","Dark Sorcerer",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","DarkVision Spring Reverb and Fuzz",9,60,"2.1mm","CN","reverb",5,"M",0,"eol"],
 ["Haggtronix","Evil Sorcerer",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Executioner Model T",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Fortune Teller Dual Modulation",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Haggtronix","Grassman Fuzz GIANT",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Harvester",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Haywood Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Haggtronix","HG-2 Chainsaw",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["Haggtronix","Illuminator Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Haggtronix","Klagg Klone",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Haggtronix","Mothman Dual Drive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Haggtronix","Night Drive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Haggtronix","Rat Bastard",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Haggtronix","Rotten Sorcerer",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Satori Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Haggtronix","Season Of The Witch Choruzz",9,20,"2.1mm","CN","mod",5,"M",0,""],
 ["Haggtronix","Triangle Wave Generator",9,20,"2.1mm","CN","synth",0,"M",0,""],
 ["Haggtronix","Two Headed Dog",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Haggtronix","Wastelander",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Hamstead Soundworks","Odyssey Intergalactic Driver",9,65,"2.1mm","CN","drive",3,"M",0,""],
 ["Hamstead Soundworks","Redwing Stereo Analogue Modulator",9,365,"2.1mm","CN","mod",0,"S",0,""],
 ["Hamstead Soundworks","Signature Analogue Tremolo MkII",9,250,"2.1mm","CN","mod",0,"M",0,""],
 ["Hamstead Soundworks","Subspace Intergalactic Driver",9,60,"2.1mm","CN","drive",3,"M",0,""],
 ["Hamstead Soundworks","Zenith Amplitude Controller",9,280,"2.1mm","CN","comp",1,"M",0,""],
 ["HeadRush","Core",12,3000,"2.1mm","CP","multi",0,"MS",0,"dg"],
 ["HeadRush","Flex Prime",12,3000,"2.1mm","CP","multi",0,"MS",0,"dg"],
 ["HeadRush","Gigboard",0,0,"none","NA","multi",0,"MS",1,"dg"],
 ["HeadRush","Looperboard",0,0,"none","NA","looper",0,"S",0,"dg"],
 ["HeadRush","MX5",12,3000,"2.1mm","CP","multi",0,"MS",0,"dg"],
 ["HeadRush","Pedalboard",0,0,"none","NA","multi",0,"MS",1,"dg"],
 ["HeadRush","Prime",0,0,"none","NA","multi",0,"MS",0,"dg"],
 ["Hello Sailor Effects","Abbey Road Fuzz (Germanium)",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Hello Sailor Effects","Abbey Road Fuzz (Silicon)",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Hello Sailor Effects","Brian May Treble Booster",9,5,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Hello Sailor Effects","Hofner Harmonic Preamp",9,10,"2.1mm","CN","preamp",2,"M",0,""],
 ["Hello Sailor Effects","Lighthouse Multi Effects Pedal",9,30,"2.1mm","CN","multi",5,"M",0,""],
 ["Hello Sailor Effects","Mullard OC45 Germanium Fuzzrite",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Hello Sailor Effects","Rangemaster Treble Booster (Lighthouse/Heart/Compass)",9,5,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Hologram","Chroma Console",9,500,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Hologram","Dream Sequence",9,150,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Hologram","Infinite Jets",9,200,"2.1mm","CN","synth",0,"MS",0,"dg"],
 ["Hologram","Microcosm",9,450,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Horrothia","Berkeley",9,60,"2.1mm","CN","mod",0,"M",0,""],
 ["Horrothia","Lutz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Horrothia","Teeth",9,55,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Horrothia","Teeth MkII X",9,55,"2.1mm","CN","drive",2,"M",0,""],
 ["Horrothia","Triage",9,100,"2.1mm","CN","preamp",2,"M",0,"eol"],
 ["Horrothia","Triage Deluxe",18,100,"2.1mm","CN","preamp",2,"M",0,""],
 ["Horrothia","Type One X",9,85,"2.1mm","CN","mod",0,"MS",0,""],
 ["Horrothia","XYXO",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["Hotone","Ampero",18,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Hotone","Ampero Control",9,100,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Hotone","Ampero II Press",0,0,"none","NA","volume",0,"M",0,""],
 ["Hotone","Ampero II Stage",9,1400,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Hotone","Ampero II Stomp",9,800,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Hotone","Ampero Mini",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Hotone","Ampero One",9,500,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Hotone","Ampero Press",0,0,"none","NA","volume",0,"M",0,""],
 ["Hotone","Ampero Press (25k Edition)",0,0,"none","NA","volume",0,"M",0,""],
 ["Hotone","Ampero Switch",0,0,"none","NA","util",0,"M",0,""],
 ["Hotone","Bass Press",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Hotone","Binary Amp",9,200,"2.1mm","CN","preamp",0,"S",0,"dg"],
 ["Hotone","Binary Cab",9,200,"2.1mm","CN","util",0,"S",0,"dg"],
 ["Hotone","Binary Eko",9,200,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Hotone","Binary Mod",9,200,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Hotone","Blues",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Hotone","Cab",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Hotone","Choir",9,14,"2.1mm","CN","mod",0,"M",0,""],
 ["Hotone","Chunk",9,18,"2.1mm","CN","drive",4,"M",0,""],
 ["Hotone","Djent",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Hotone","Eko",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Hotone","EQ-V",9,15,"2.1mm","CN","eq",0,"M",0,""],
 ["Hotone","Fat Buffer",9,12,"2.1mm","CN","util",0,"M",0,""],
 ["Hotone","Fury",9,3,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Hotone","Gate",9,34,"2.1mm","CN","gate",0,"M",0,""],
 ["Hotone","Golden Touch",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Hotone","Grass",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Hotone","Harmony",9,53,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Hotone","Komp",9,19,"2.1mm","CN","comp",0,"M",0,""],
 ["Hotone","Krush",9,60,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Hotone","Liftup",9,17,"2.1mm","CN","drive",1,"M",0,""],
 ["Hotone","Lush",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["Hotone","Octa",9,53,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Hotone","Phaze",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Hotone","Q-Box",9,65,"2.1mm","CN","filter",0,"M",0,"dg"],
 ["Hotone","Roto",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Hotone","Soul Press",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Hotone","Soul Press II",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Hotone","Tape Eko",9,56,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Hotone","Trem",9,17,"2.1mm","CN","mod",0,"M",0,""],
 ["Hotone","Tuner",9,65,"2.1mm","CN","tuner",0,"M",0,""],
 ["Hotone","Tuner Press",9,70,"2.1mm","CN","volume",0,"M",0,"dg"],
 ["Hotone","Verb",9,53,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Hotone","Vow Press",9,10,"2.1mm","CN","wah",0,"M",0,""],
 ["Hotone","Wally",9,37,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Hotone","Wally+",9,100,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Hotone","Whip",9,22,"2.1mm","CN","drive",4,"M",0,""],
 ["Hotone","Wong Press",9,30,"2.1mm","CN","wah",0,"M",0,""],
 ["Hotone","Wood",9,30,"2.1mm","CN","util",0,"M",0,""],
 ["Hotone","Xtomp",9,200,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Hotone","Xtomp Mini",9,250,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Hudson Electronics","Broadcast",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Hudson Electronics","Broadcast 24V (BC-24V)",9,50,"2.1mm","CN","drive",2,"M",0,""],
 ["Hudson Electronics","Broadcast Dual",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Hudson Electronics","Broadcast-AP",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Hudson Electronics","Sidecar",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Hudson Electronics","Stroll On",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Ibanez","AD202",0,0,"none","NA","delay",0,"M",0,""],
 ["Ibanez","AD9 Analog Delay",9,15,"2.1mm","CN","delay",0,"M",0,""],
 ["Ibanez","ADMINI Analog Delay Mini",9,23,"2.1mm","CN","delay",0,"M",0,""],
 ["Ibanez","AF2 Airplane Flanger",9,39,"2.1mm","CN","mod",0,"M",0,""],
 ["Ibanez","AF9 Auto Filter",9,17,"2.1mm","CN","filter",0,"M",0,""],
 ["Ibanez","BB9 Bottom Booster",9,38,"2.1mm","CN","drive",1,"M",0,""],
 ["Ibanez","CS9 Stereo Chorus",9,11,"2.1mm","CN","mod",0,"MS",0,""],
 ["Ibanez","CSMINI Chorus Mini",9,22,"2.1mm","CN","mod",0,"M",0,""],
 ["Ibanez","DL10 Delay III",9,45,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Ibanez","ES2 Echo Shifter",9,200,"2.1mm","CN","delay",0,"M",0,""],
 ["Ibanez","ES3 Echo Shifter",9,200,"2.1mm","CN","delay",0,"M",0,""],
 ["Ibanez","FL9 Flanger",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["Ibanez","MT10 Mostortion",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","NTS Nu Tubescreamer",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","PT909 Phase Tone (1977-79 narrow box, battery only)",9,10,"batt","NA","mod",0,"M",0,""],
 ["Ibanez","PT909 Phase Tone (1980-81, 3.5mm jack)",9,10,"3.5mm","CP","mod",0,"M",0,""],
 ["Ibanez","PTEQ Pentatone EQ",9,125,"2.1mm","CN","eq",0,"M",0,""],
 ["Ibanez","SD9 Sonic Distortion",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Ibanez","SMMINI Super Metal Mini",9,23,"2.1mm","CN","drive",4,"M",0,""],
 ["Ibanez","TS10 Tube Screamer Classic",9,7,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TS808",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TS808 (1979-81 original, 3.5mm jack)",9,8,"3.5mm","CP","drive",3,"M",0,""],
 ["Ibanez","TS808DX",9,43,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TS9",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TS9DX",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TSMINI",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","TSV808",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Ibanez","WH10 Wah",9,6,"2.1mm","CN","wah",0,"M",0,""],
 ["Ibanez","WH10V2 Wah",9,6,"2.1mm","CN","wah",0,"M",0,""],
 ["Ibanez","WH10V3 Wah",9,12,"2.1mm","CN","wah",0,"M",0,""],
 ["J. Rockett",".45 Caliber",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","10 Ton Hammer",9,6,"2.1mm","CN","drive",4,"M",0,""],
 ["J. Rockett","Afterburner",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Airchild Six Sixty",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["J. Rockett","Alien Echo",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["J. Rockett","Animal",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Aqueous Chorus",9,28,"2.1mm","CN","mod",0,"M",0,""],
 ["J. Rockett","Archer",9,26,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Archer Clean",9,28,"2.1mm","CN","drive",1,"M",0,""],
 ["J. Rockett","Archer Ikon",9,26,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Archer Select",9,28,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Blue Note",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Blue Note Select",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Blue Note Tour Series",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Boing Spring Reverb",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["J. Rockett","Clockwork Echo",9,100,"2.1mm","CN","delay",0,"MS",0,""],
 ["J. Rockett","Dude ODS V2",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","El Hombre",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Flex Drive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","GTO (Guthrie Trapp)",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Hooligan Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["J. Rockett","HRM Hot Rubber Monkey",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","HRM V2",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","I.Q. Compressor",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["J. Rockett","Immortal Echo",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["J. Rockett","Josh Smith Dual Trem",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["J. Rockett","Majestic",9,11,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Mark Sampson Hightop",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["J. Rockett","Mark Sampson MAX",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["J. Rockett","Mark Sampson Revolver",9,40,"2.1mm","CN","drive",1,"MS",0,""],
 ["J. Rockett","Melody (Mark Lettieri)",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Monkeyman",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","PXO",9,28,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Rockaway Archer",9,34,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Squeegee Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["J. Rockett","Steampunk Boost/Buffer",9,12,"2.1mm","CN","drive",1,"M",0,""],
 ["J. Rockett","The Dude",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","The Jeff Archer",9,26,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Tim Pierce Signature OD",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["J. Rockett","Touch Overdrive",9,12,"2.1mm","CN","drive",2,"M",0,""],
 ["J. Rockett","Tranquilizer",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["J. Rockett","Uni-Verb",9,150,"2.1mm","CN","mod",0,"M",0,""],
 ["J. Rockett","WTF Fuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Jackson Audio","1484 Twin Twelve",9,100,"2.1mm","CN","preamp",3,"M",0,""],
 ["Jackson Audio","Amp Mode Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Jackson Audio","Asabi",9,120,"2.1mm","CN","drive",4,"M",0,""],
 ["Jackson Audio","Belle Starr",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Jackson Audio","Bloom V1",9,300,"2.1mm","CN","comp",1,"M",0,""],
 ["Jackson Audio","Bloom V2 (MIDI)",9,300,"2.1mm","CN","comp",1,"M",0,""],
 ["Jackson Audio","Blossom",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Jackson Audio","Broken Arrow V2 (MIDI)",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Jackson Audio","El Guapo",9,200,"2.1mm","CN","drive",4,"M",0,""],
 ["Jackson Audio","FUZZ (Modular Fuzz)",9,50,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Jackson Audio","Golden Boy",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Jackson Audio","Golden Boy Mini",9,35,"2.1mm","CN","drive",3,"M",0,""],
 ["Jackson Audio","Hour Glass",9,60,"2.1mm","CN","comp",0,"M",0,""],
 ["Jackson Audio","New Wave",18,250,"2.1mm","CN","mod",0,"MS",0,""],
 ["Jackson Audio","PRISM",9,100,"2.1mm","CN","preamp",2,"M",0,""],
 ["Jackson Audio","The Optimist",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Jackson Audio","Twin Trem",9,35,"2.1mm","CN","mod",0,"S",0,""],
 ["JAM Pedals","Big Chill",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Boomster",9,4,"2.1mm","CN","drive",1,"M",0,""],
 ["JAM Pedals","Boomster MkII",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["JAM Pedals","Chill",9,6,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","CTRL BOX",9,12,"2.1mm","CN","util",0,"M",0,""],
 ["JAM Pedals","Delay Llama",9,120,"2.1mm","CN","delay",0,"M",0,""],
 ["JAM Pedals","Delay Llama +",9,30,"2.1mm","CN","delay",0,"M",0,""],
 ["JAM Pedals","Delay Llama Supreme",9,140,"2.1mm","CN","delay",0,"M",0,""],
 ["JAM Pedals","Delay Llama Xtreme",9,130,"2.1mm","CN","delay",0,"M",0,""],
 ["JAM Pedals","Double Dreamer",9,110,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Dyna-ssoR",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["JAM Pedals","Dyna-ssoR Bass",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["JAM Pedals","Eureka!",9,8,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JAM Pedals","Fuzz Phrase (vintage Ge)",9,3,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["JAM Pedals","Fuzz Phrase Ltd",9,3,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["JAM Pedals","Fuzz Phrase Si",9,3,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["JAM Pedals","Harmonious Fall",9,190,"2.1mm","CN","multi",0,"M",0,""],
 ["JAM Pedals","Harmonious Monk",9,35,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Harmonious Monk MkII",9,145,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Koch Ness Monster",9,400,"2.1mm","CN","multi",0,"M",0,""],
 ["JAM Pedals","Koch Ness Monster Supreme",12,750,"2.1mm","CP","multi",0,"M",0,""],
 ["JAM Pedals","Lucydreamer",9,66,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Lucydreamer Bass",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Lucydreamer Supreme",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Octaurus",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["JAM Pedals","Octaurus ltd",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["JAM Pedals","Octaurus NOS",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["JAM Pedals","Pink Flow",9,260,"2.1mm","CN","multi",0,"M",0,""],
 ["JAM Pedals","Rattler",9,95,"2.1mm","CN","drive",4,"M",0,""],
 ["JAM Pedals","Rattler Bass",9,40,"2.1mm","CN","drive",4,"M",0,""],
 ["JAM Pedals","Rattler ltd",9,6,"2.1mm","CN","drive",4,"M",0,""],
 ["JAM Pedals","Red Muck",9,60,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JAM Pedals","Red Muck Bass",9,12,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JAM Pedals","RetroVibe",9,65,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","RetroVibe MkIII",9,150,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","RetroVibe MkIV",9,120,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Ripple",9,9,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Ripply Fall",9,26,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","Seagull",9,45,"2.1mm","CN","wah",0,"M",0,""],
 ["JAM Pedals","TubeDreamer (2026)",9,60,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Tubedreamer +",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Tubedreamer 58",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Tubedreamer 72",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Tubedreamer 88",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["JAM Pedals","Wahcko",9,40,"2.1mm","CN","wah",0,"M",0,""],
 ["JAM Pedals","Wahcko +",9,5,"2.1mm","CN","wah",0,"M",0,""],
 ["JAM Pedals","Wahcko Bass",9,40,"2.1mm","CN","wah",0,"M",0,""],
 ["JAM Pedals","WaterFall",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["JAM Pedals","WaterFall Bass",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["JET Pedals","Eternity Delay",9,250,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["JET Pedals","JET Micro",9,100,"2.1mm","CN","switcher",0,"M",1,"dg"],
 ["JET Pedals","Lamb Overdrive",9,200,"2.1mm","CN","drive",3,"M",0,""],
 ["JET Pedals","Lion Distortion",9,200,"2.1mm","CN","drive",4,"M",0,""],
 ["JET Pedals","Red Sea",9,100,"2.1mm","CN","util",0,"S",0,""],
 ["JET Pedals","Revelation Reverb",9,250,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["JET Pedals","Unity6",9,200,"2.1mm","CN","switcher",0,"M",1,"dg"],
 ["JHS","3 Series Chorus",9,70,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","3 Series Compressor",9,8,"2.1mm","CN","comp",0,"M",0,""],
 ["JHS","3 Series Delay",9,71,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["JHS","3 Series Distortion",9,9,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","3 Series Flanger",9,70,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","3 Series Fuzz",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","3 Series Hall Reverb",9,70,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JHS","3 Series Harmonic Trem",9,65,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","3 Series Octave Reverb",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JHS","3 Series Overdrive",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","3 Series Phaser",9,70,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","3 Series Reverb",9,74,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JHS","3 Series Screamer",9,12,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","424 Gain Stage",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Alpine",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JHS","Angry Charlie V3",9,11,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Artificial Blonde",9,138,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","AT+",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Bender (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["JHS","Berkeley (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Bonsai",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Charlie Brown V4",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Cheese Ball",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Clover",9,46,"2.1mm","CN","drive",1,"M",0,""],
 ["JHS","Colour Box 10 (10th Anniversary)",9,193,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["JHS","Colour Box V2",9,193,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["JHS","Crayon",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Crimson (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Double Barrel V4",9,108,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Emperor V2",9,57,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","Flight Delay",9,85,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["JHS","Hard Drive",9,78,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Haunting Mids",9,13,"2.1mm","CN","eq",0,"M",0,""],
 ["JHS","Kilt V2",9,64,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Kodiak",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","Lucky Cat",9,75,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["JHS","Mary-K (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Milkman",9,27,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["JHS","Mini Foot Fuzz V2",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Moonshine V2",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Morning Glory (V1-V3)",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["JHS","Morning Glory Clean",9,60,"2.1mm","CN","drive",1,"M",0,""],
 ["JHS","Morning Glory V4",9,43,"2.1mm","CN","drive",2,"M",0,""],
 ["JHS","Muffuletta",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Notaklön",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["JHS","Overdrive Preamp",9,51,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","PackRat",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Panther Cub V2",9,67,"2.1mm","CN","delay",0,"M",0,""],
 ["JHS","PG-14",9,36,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Plugin (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Prestige",9,7,"2.1mm","CN","drive",1,"M",0,""],
 ["JHS","Pulp N Peel V4",9,32,"2.1mm","CN","comp",0,"M",0,""],
 ["JHS","Smiley (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["JHS","Space Commander",9,84,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["JHS","Spring Tank",9,73,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JHS","SuperBolt (V1)",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Superbolt V2",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Supreme (Legends of Fuzz)",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JHS","Sweet Tea V3",9,51,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","The Violet",9,55,"2.1mm","CN","drive",4,"M",0,""],
 ["JHS","Tidewater",9,3,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","Twin Twelve V2",9,34,"2.1mm","CN","drive",3,"M",0,""],
 ["JHS","Unicorn V2",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["JHS","Whitey Tighty",9,21,"2.1mm","CN","comp",0,"M",0,""],
 ["Joyo","PXL-Live",9,220,"2.1mm","CN","switcher",0,"M",0,""],
 ["Joyo","PXL8",9,200,"2.1mm","CN","switcher",0,"M",0,""],
 ["JPTR FX","Bleach",9,80,"2.1mm","CN","fuzz",4,"M",0,""],
 ["JPTR FX","DELUXE Jive",9,50,"2.1mm","CN","drive",2,"M",0,""],
 ["JPTR FX","Fernweh",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["JPTR FX","Kaleidoscope",9,120,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["JPTR FX","Kaleidoscope ULTRA",9,120,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["JPTR FX","Katastrophe",9,50,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["JPTR FX","Silvermachine",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JPTR FX","Super Weirdo",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JPTR FX","Warlow",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["JPTR FX","Warlow mini",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Karma","Machine Shop",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Karma","MTN-10",9,11,"2.1mm","CN","drive",3,"M",0,""],
 ["Karma","MTN-Bass",9,11,"2.1mm","CN","drive",3,"M",0,""],
 ["Karma","ODR-10",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Keeley","2-Knob Compressor",9,3,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","30ms Automatic Double Tracker",9,65,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Keeley","Abbey Chamber Verb",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Angry Orange",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Keeley","Aria Compressor Drive",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","Bassist Limiting Amplifier",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","Blues Disorder",9,27,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Bubble Tron Dynamic Flanger Phaser",9,65,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Keeley","C4 4-Knob Compressor",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","Caverns Delay Reverb V2",9,75,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Keeley","Compressor Plus",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","Compressor Pro",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","D&M Drive",9,55,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Dark Side Workstation",9,75,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Keeley","DDR Drive Delay Reverb",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Keeley","Delay Workstation",9,170,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Keeley","Eccos Delay Looper",9,146,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Keeley","El Rey Dorado",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Fuzz Bender",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Keeley","GC-2 Limiting Amplifier",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Keeley","Halo Andy Timmons Dual Echo",9,160,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Keeley","Halo Core",9,130,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Keeley","Hooke Spring Reverb",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Java Boost",9,5,"2.1mm","CN","fuzz",1,"M",0,"ff"],
 ["Keeley","Katana Clean Boost",9,2,"2.1mm","CN","drive",1,"M",0,""],
 ["Keeley","Katana Mini Boost",9,1,"2.1mm","CN","drive",1,"M",0,""],
 ["Keeley","Loomer Fuzz Reverb",9,75,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Mag Echo Modulated Tape Echo",9,45,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Keeley","Memphis Sun Lo-Fi Reverb Echo",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Monterey Rotary Fuzz Vibe",9,100,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Keeley","Muse Driver (Andy Timmons)",9,27,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Neutrino Envelope Filter V2",9,25,"2.1mm","CN","filter",0,"M",0,""],
 ["Keeley","Noble Screamer",9,26,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Nocturne Andy Timmons Reverb",9,130,"2.1mm","CN","reverb",0,"MS",1,"dg"],
 ["Keeley","Octa Psi Transfigurating Fuzz",9,150,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Keeley","Omni Reverb",9,70,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Oxblood Overdrive",9,23,"2.1mm","CN","drive",2,"M",0,""],
 ["Keeley","Parallax Spatial Generator",9,75,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Realizer Reverberator",9,75,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Red Dirt Mini",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Red Dirt Overdrive",9,14,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Rotary",9,130,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Keeley","Seafoam Plus Chorus",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Keeley","Super Phat Mod",9,22,"2.1mm","CN","drive",3,"M",0,""],
 ["Keeley","Super Rodent",9,26,"2.1mm","CN","drive",4,"M",0,""],
 ["Keeley","Synth-1 Wave Generator",9,70,"2.1mm","CN","synth",0,"M",0,""],
 ["Keeley","Vibe-o-Verb",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Keeley","Zoma Stereo Reverb Tremolo",9,150,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Kemper","Profiler Player",12,2000,"2.1mm","CN","multi",0,"MS",0,"amp;dg"],
 ["Kernom","Elipse",9,250,"2.1mm","CN","mod",0,"M",0,""],
 ["Kernom","Moho",9,250,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Kernom","Ridge",9,250,"2.1mm","CN","drive",4,"M",0,""],
 ["KGR Harmony","ARARE Overdrive",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["KGR Harmony","IRON808 Overdrive",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["KGR Harmony","KUROFUNE Fuzz",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["KGR Harmony","KUROFUNE SENGOKU Fuzz",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["KGR Harmony","KUROHAKO Buffer",9,8,"2.1mm","CN","util",0,"M",0,""],
 ["KGR Harmony","MIZORE Distortion",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["KGR Harmony","OROSHI Compressor",9,8,"2.1mm","CN","comp",0,"M",0,""],
 ["KGR Harmony","SHIZUKU Boost",9,4,"2.1mm","CN","drive",1,"M",0,""],
 ["King Tone","Blues Power",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["King Tone","Blues Power Deluxe",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["King Tone","HeavyHand",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["King Tone","Kingtone Buffer",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["King Tone","miniFUZZ Ge (V1)",9,5,"2.1mm","CP","fuzz",5,"M",0,"ff;eol"],
 ["King Tone","miniFUZZ Si (V1)",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["King Tone","miniFUZZ V2",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["King Tone","Octaland",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["King Tone","RISE",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["King Tone","Soloist Deluxe",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["King Tone","The 1968",18,100,"2.1mm","CN","mod",0,"M",0,""],
 ["King Tone","The Duellist",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["King Tone","The Soloist",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["King Tone","Vintage Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Kingsley","Alexander",9,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Kingsley","Artisan",9,500,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Kingsley","Bard",9,550,"2.1mm","CN","mod",0,"M",0,""],
 ["Kingsley","Constable",12,500,"2.1mm","CP","preamp",0,"M",0,"amp"],
 ["Kingsley","EQ Lift Boost",0,0,"none","NA","util",0,"M",0,""],
 ["Kingsley","Flying Buttress",0,0,"none","NA","util",0,"M",0,""],
 ["Kingsley","Harlot",9,500,"2.1mm","CN","drive",4,"M",0,""],
 ["Kingsley","Harlot GM Switch",0,0,"none","NA","util",0,"M",0,""],
 ["Kingsley","Hatchet",0,0,"none","NA","drive",2,"M",0,""],
 ["Kingsley","Herald",0,0,"none","NA","preamp",0,"M",0,"amp"],
 ["Kingsley","Jester",12,500,"2.1mm","CP","drive",3,"M",0,""],
 ["Kingsley","Jouster",12,500,"2.1mm","CP","drive",3,"M",0,""],
 ["Kingsley","Juggler",12,700,"2.1mm","CP","preamp",0,"M",0,"amp"],
 ["Kingsley","Juggler V2",12,500,"2.1mm","CP","preamp",0,"M",0,"amp"],
 ["Kingsley","Maiden",9,500,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Kingsley","Marauder",0,0,"none","NA","drive",3,"M",0,""],
 ["Kingsley","Merlin",0,0,"none","NA","util",0,"M",1,""],
 ["Kingsley","Minstrel",9,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Kingsley","Page",9,500,"2.1mm","CN","drive",2,"M",0,""],
 ["Kingsley","Page DS",9,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Kingsley","Page TS",9,500,"2.1mm","CN","drive",2,"M",0,""],
 ["Kingsley","Paso Doble",0,0,"none","NA","drive",3,"S",0,""],
 ["Kingsley","Peasant",9,500,"2.1mm","CN","drive",1,"M",0,""],
 ["Kingsley","Serf",9,500,"2.1mm","CN","drive",1,"M",0,""],
 ["Kingsley","Squire",9,500,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Kingsley","Squire 86",9,500,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Kingsley","Troubadour",0,0,"none","NA","preamp",0,"M",0,"amp"],
 ["Klon","Centaur",9,10,"3.5mm","CP","drive",2,"M",0,""],
 ["Klon","KTR",9,22,"2.1mm","CN","drive",2,"M",0,""],
 ["Lauren Audio","Aerocomet",9,100,"2.1mm","CN","preamp",3,"M",0,""],
 ["Lauren Audio","B100 Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Lauren Audio","Mustang GT",9,65,"2.1mm","CN","drive",3,"M",0,""],
 ["Lehle","Dual Expression",9,100,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","DL4",12,500,"2.5mm","CP","delay",0,"S",0,"dg"],
 ["Line 6","DL4 MkII",9,500,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Line 6","DM4",12,500,"2.5mm","CP","drive",4,"S",0,""],
 ["Line 6","FM4",12,500,"2.5mm","CP","filter",0,"S",0,""],
 ["Line 6","Helix Floor/LT",0,0,"none","NA","multi",0,"S",1,"amp;dg"],
 ["Line 6","HX Effects",9,2000,"2.5mm","CN","multi",0,"S",1,"dg"],
 ["Line 6","HX One",9,500,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Line 6","HX Stomp",9,1000,"2.5mm","CN","multi",0,"S",1,"dg"],
 ["Line 6","HX Stomp XL",9,1000,"2.5mm","CN","multi",0,"S",1,"dg"],
 ["Line 6","M13",12,800,"2.5mm","CP","multi",0,"S",1,"dg"],
 ["Line 6","M5",9,500,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Line 6","M9",12,600,"2.5mm","CP","multi",0,"S",1,"dg"],
 ["Line 6","MM4",12,500,"2.5mm","CP","mod",0,"S",0,"dg"],
 ["Line 6","POD Go",9,2500,"2.5mm","CN","multi",0,"MS",1,"amp;dg"],
 ["Line 6","Relay G10S",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","Relay G30",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","Relay G50",9,300,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","Relay G70",9,350,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","Relay G75",9,350,"2.1mm","CN","util",0,"M",0,""],
 ["Line 6","Relay G90",0,0,"none","NA","util",0,"M",0,""],
 ["Lovepedal","200lbs of Gold",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Amp Eleven",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Babyface Tremolo",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Lovepedal","Bonetender",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Lovepedal","COT50",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Lovepedal","Dover Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Englishman",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Eternity (Kanji)",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Lovepedal","Eternity Burst",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Lovepedal","Hermida EPH3",9,50,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Lovepedal","Hermida Zendrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Jubilee",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Kalamazoo",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Les Lius",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Pickle Vibe",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Lovepedal","Purple Plexi",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Lovepedal","Rubber Chicken",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Lovepedal","Tchula",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Lovepedal","Woodrow",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Eighty7",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["LPD Pedals","Eighty7 Deluxe",9,50,"2.1mm","CN","drive",4,"M",0,""],
 ["LPD Pedals","Fifty5",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["LPD Pedals","Head-On Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["LPD Pedals","JMP79",9,20,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["LPD Pedals","Seventy4",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Seventy4 Deluxe",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Sixty8",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Sixty8 Deluxe",9,35,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Sixty8X",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["LPD Pedals","Spearhead",9,40,"2.1mm","CN","preamp",2,"M",0,""],
 ["LPD Pedals","Supernode",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Amber Overdrive",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Big Tweedy Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Blueberry Bass Overdrive",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Bluebird Overdrive Delay",9,47,"2.1mm","CN","drive",3,"M",0,"dg"],
 ["Mad Professor","Deep Blue Delay",9,32,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mad Professor","Deep Blue Delay Handwired",9,32,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mad Professor","Double Moon",9,85,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mad Professor","Dual Blue Delay",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mad Professor","Electric Blue Chorus",9,40,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mad Professor","Electric Blue II Chorus/Vibrato",9,35,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mad Professor","Evolution Orange Underdrive",9,10,"2.1mm","CN","eq",0,"M",0,""],
 ["Mad Professor","Fire Red Fuzz",9,3,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mad Professor","Forest Green Compressor",9,14,"2.1mm","CN","comp",0,"M",0,""],
 ["Mad Professor","Golden Cello",9,43,"2.1mm","CN","drive",3,"M",0,"dg"],
 ["Mad Professor","Kosmos",9,90,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mad Professor","Little Green Wonder",9,4,"2.1mm","CN","drive",2,"M",0,""],
 ["Mad Professor","Little Green Wonder Handwired",9,6,"2.1mm","CN","drive",2,"M",0,""],
 ["Mad Professor","Little Tweedy Drive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Loud'n Proud",9,27,"2.1mm","CN","drive",4,"M",0,""],
 ["Mad Professor","Mellow Yellow Tremolo",9,6,"2.1mm","CN","mod",0,"M",0,""],
 ["Mad Professor","Mighty Red Distortion",9,11,"2.1mm","CN","drive",4,"M",0,""],
 ["Mad Professor","ONE (1)",9,82,"2.1mm","CN","drive",4,"M",0,"dg"],
 ["Mad Professor","Royal Blue Overdrive",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Royal Blue Overdrive Handwired",9,4,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Ruby Red Booster",9,6,"2.1mm","CN","drive",1,"M",0,""],
 ["Mad Professor","Silver Spring Reverb",9,80,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mad Professor","Simble Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Simble Predriver",9,3,"2.1mm","CN","preamp",1,"M",0,""],
 ["Mad Professor","Sky Blue Overdrive Handwired",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Snow White AutoWah (GB)",9,15,"2.1mm","CN","filter",0,"M",0,""],
 ["Mad Professor","Snow White Bass AutoWah Handwired",9,15,"2.1mm","CN","filter",0,"M",0,""],
 ["Mad Professor","Stone Grey Distortion",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Mad Professor","Super Black",9,27,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Super Black mini",9,27,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Supreme",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["Mad Professor","Sweet Honey Overdrive",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Sweet Honey Overdrive Deluxe",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","Sweet Honey Overdrive Handwired",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Mad Professor","The Green Wonder",9,4,"2.1mm","CN","drive",2,"M",0,""],
 ["Mad Professor","Tiny Orange Phaser",9,26,"2.1mm","CN","mod",0,"M",0,""],
 ["Mad Professor","Twimble",9,13,"2.1mm","CN","preamp",2,"M",0,""],
 ["Marshall","BB-2 Bluesbreaker II",9,8,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Marshall","Blues Breaker (1991)",9,4,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Marshall","Bluesbreaker Reissue",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Marshall","Drive Master (1991)",9,4,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Marshall","Drivemaster Reissue",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Marshall","ED-1 The Compressor",9,5,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Marshall","EH-1 Echohead",9,80,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Marshall","GV-2 Guv'nor Plus",9,9,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Marshall","JH-1 Jackhammer",9,13,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Marshall","RF-1 Reflector",9,80,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Marshall","RG-1 Regenerator",9,80,"2.1mm","CN","mod",0,"M",0,"dg;eol"],
 ["Marshall","Shred Master (1991)",9,8,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Marshall","Shredmaster Reissue",9,9,"2.1mm","CN","drive",4,"M",0,""],
 ["Marshall","Supa Fuzz",9,1,"batt","NA","fuzz",5,"M",0,"ff;eol"],
 ["Marshall","The Guv'nor (1988)",9,5,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Marshall","The Guv'nor Reissue",9,6,"2.1mm","CN","drive",4,"M",0,""],
 ["Marshall","VT-1 Vibratrem",9,16,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Massive Unity","T.A.E.",9,20,"2.1mm","CN","preamp",3,"M",0,"amp;eol"],
 ["Massive Unity","T.A.E. 10th Anniversary",9,20,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Massive Unity","The 1964 T.A.E.",9,20,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Mastro Valvola","Area",9,100,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Mastro Valvola","LEM",9,100,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Mastro Valvola","LFO",9,100,"2.1mm","CN","mod",0,"M",0,"dg;eol"],
 ["Mastro Valvola","Love Buzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Mastro Valvola","Millibar",9,10,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Mastro Valvola","Smog",9,50,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Mastro Valvola","Tempesta",9,10,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Mastro Valvola","TimeLab",9,100,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Matchless","Coolbox",0,0,"none","NA","preamp",1,"M",0,"amp;eol"],
 ["Matchless","Dirtbox",0,0,"none","NA","preamp",4,"M",0,"amp;eol"],
 ["Matchless","Hot Box",0,0,"none","NA","preamp",3,"M",0,"amp;eol"],
 ["Matchless","Hot Box II",0,0,"none","NA","preamp",3,"M",0,"amp;eol"],
 ["Matchless","Hot Box III",0,0,"none","NA","preamp",3,"M",0,"amp"],
 ["Matchless","Vibrobox",0,0,"none","NA","mod",0,"M",0,"eol"],
 ["Matthews Effects","Architect (V1-V3)",9,50,"2.1mm","CN","drive",2,"M",0,""],
 ["Matthews Effects","Architect V4",9,120,"2.1mm","CN","drive",2,"M",0,""],
 ["Matthews Effects","Astronomer V2",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Matthews Effects","Botanist",9,150,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Matthews Effects","Broker",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Matthews Effects","Cartographer (V1)",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Matthews Effects","Cartographer MKII",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Matthews Effects","Chemist V2",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Matthews Effects","Conductor V2",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Matthews Effects","Cosmonaut V2",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Matthews Effects","Futurist",9,150,"2.1mm","CN","util",0,"M",1,""],
 ["Matthews Effects","Harbinger",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Matthews Effects","Surgeon",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Matthews Effects","Technician",9,400,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Matthews Effects","Thief",9,30,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Matthews Effects","Traveler",9,120,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Matthews Effects","Whaler (V1)",9,20,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Matthews Effects","Whaler V2",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Maxon","AD-9 Pro",9,39,"2.1mm","CN","delay",0,"M",0,""],
 ["Maxon","AD999",9,46,"2.1mm","CN","delay",0,"M",0,""],
 ["Maxon","AD999 Pro",9,72,"2.1mm","CN","delay",0,"M",0,""],
 ["Maxon","AF-9",9,17,"2.1mm","CN","filter",0,"M",0,""],
 ["Maxon","ASC-10",9,20,"2.1mm","CN","mod",0,"MS",0,""],
 ["Maxon","CS-9 Pro",9,26,"2.1mm","CN","mod",0,"MS",0,""],
 ["Maxon","FL-9",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["Maxon","OD-9",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Maxon","OD808",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Maxon","OD808 (1979-81 original, 3.5mm jack)",9,5,"3.5mm","CP","drive",3,"M",0,""],
 ["Maxon","OD808X",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Maxon","OSD-9",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["Maxon","PAC-9",9,21,"2.1mm","CN","mod",0,"M",0,""],
 ["Maxon","PT-9 Pro+",9,32,"2.1mm","CN","mod",0,"M",0,""],
 ["Maxon","SD-9",9,6,"2.1mm","CN","drive",4,"M",0,""],
 ["Maxon","ST-9 Pro+",9,36,"2.1mm","CN","drive",3,"M",0,""],
 ["Maxon","VOP-9",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Menatone","Blue Collar",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Menatone","Das Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Menatone","Dumbstruck",9,15,"2.1mm","CN","drive",2,"M",0,"amp"],
 ["Menatone","El Pulso Caliente",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Menatone","Fish Factory",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Menatone","Fryzzl",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Menatone","Harmonic Shifty",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Menatone","Hindenburg",9,15,"2.1mm","CN","drive",3,"M",0,"amp"],
 ["Menatone","Howie",9,15,"2.1mm","CN","drive",3,"M",0,"amp"],
 ["Menatone","JAC Compressor",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Menatone","King of the Britains",9,10,"2.1mm","CN","drive",4,"M",0,"eol;amp"],
 ["Menatone","Mail Bomb",9,10,"2.1mm","CN","filter",0,"M",0,""],
 ["Menatone","MenaWatt",9,15,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Menatone","Ms. Foxy Brown",9,15,"2.1mm","CN","drive",3,"M",0,"amp"],
 ["Menatone","None More Black Deluxe",9,15,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Menatone","PiG",9,15,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Menatone","Pleasure Trem",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Menatone","Pork Bender",9,5,"2.1mm","CN","fuzz",4,"M",0,"eol;ff"],
 ["Menatone","Red Snapper",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Menatone","Redneck vs. Sputnik",9,15,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Menatone","Shut Up & Drive",9,15,"2.1mm","CN","drive",4,"M",0,"eol;amp"],
 ["Menatone","Simplexity",9,10,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Menatone","The Bark n The Bite",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Menatone","The Dirty Blonde",9,15,"2.1mm","CN","drive",3,"M",0,"amp"],
 ["Menatone","The King",9,10,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Menatone","The Law",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Menatone","The Law Bender Deluxe",9,2,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Menatone","Thundering Revival",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["Menatone","Top Boost in a Can",9,15,"2.1mm","CN","drive",3,"M",0,"amp"],
 ["Menatone","Workingman's Blue",9,15,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Menatone","Wreck'T",9,10,"2.1mm","CN","drive",4,"M",0,"amp"],
 ["Meris","440 Mic Preamp",0,0,"none","NA","preamp",0,"M",0,""],
 ["Meris","Enzo",9,150,"2.1mm","CN","synth",0,"S",1,"dg"],
 ["Meris","Enzo X",9,300,"2.1mm","CN","synth",0,"S",1,"dg"],
 ["Meris","Hedra",9,150,"2.1mm","CN","pitch",0,"S",1,"dg"],
 ["Meris","LVX",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Meris","Mercury7",9,150,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Meris","MercuryX",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Meris","MIDI I/O",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Meris","Ottobit Jr",9,150,"2.1mm","CN","synth",0,"S",1,"dg"],
 ["Meris","Polymoon",9,150,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Mesa/Boogie","Cleo",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Mesa/Boogie","DynaPlex",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Mesa/Boogie","Five-Band Graphic EQ",9,25,"2.1mm","CN","eq",0,"M",0,""],
 ["Mesa/Boogie","Flux-Drive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Mesa/Boogie","Flux-Five",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Mesa/Boogie","Gold Mine",9,15,"2.1mm","CN","drive",4,"M",0,""],
 ["Mesa/Boogie","Grid Slammer",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Mesa/Boogie","High-Wire Dual Buffer & Boost",9,55,"2.1mm","CN","util",0,"M",0,""],
 ["Mesa/Boogie","Stowaway Input Buffer",9,40,"2.1mm","CN","util",0,"M",0,""],
 ["Mesa/Boogie","Throttle Box",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Mesa/Boogie","Throttle Box EQ",9,45,"2.1mm","CN","drive",4,"M",0,""],
 ["Mesa/Boogie","Tone-Burst",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Milkman Sound","Benson The Amp",0,0,"none","NA","preamp",2,"M",0,"amp"],
 ["Milkman Sound","F-Stop",9,200,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Milkman Sound","Pop Top Boost",9,110,"2.1mm","CN","drive",1,"M",0,""],
 ["Milkman Sound","The Amp",0,0,"none","NA","preamp",1,"M",0,"amp"],
 ["Milkman Sound","The Amp 100",0,0,"none","NA","preamp",1,"M",0,"amp"],
 ["Milkman Sound","The Amp Stereo",0,0,"none","NA","preamp",1,"S",0,"amp"],
 ["Mission Engineering","EP-1",0,0,"none","NA","util",0,"M",0,""],
 ["Mission Engineering","EP-25K",0,0,"none","NA","util",0,"M",0,""],
 ["Mission Engineering","SP-1",0,0,"none","NA","util",0,"M",0,""],
 ["Mooer","A7 Ambiance",9,300,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mooer","Acoustikar",9,100,"2.1mm","CN","eq",0,"M",0,"dg"],
 ["Mooer","Ana Echo",9,26,"2.1mm","CN","delay",0,"M",0,""],
 ["Mooer","Baby Bomb 30",24,2000,"2.1mm","CN","util",0,"M",0,""],
 ["Mooer","Baby Tuner",9,90,"2.1mm","CN","tuner",0,"M",0,""],
 ["Mooer","Baby Water",9,130,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mooer","Black Secret",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","Black Truck",9,1000,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Mooer","Blade",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","Blue Comp",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Mooer","Blue Faze",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mooer","Blues Crab",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Mooer","Blues Mood",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mooer","Cruncher",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","D7 Delay",9,300,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mooer","D7 X2 Delay",9,300,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Mooer","E-Lady",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Mooer","E7 Synth",9,300,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Mooer","Echolizer",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mooer","Ensemble King",9,16,"2.1mm","CN","mod",0,"M",0,""],
 ["Mooer","Expline",0,0,"none","NA","util",0,"M",0,""],
 ["Mooer","Flex Boost",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Mooer","Fog",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mooer","Free Step",9,20,"2.1mm","CN","wah",0,"M",0,""],
 ["Mooer","Funky Monkey",9,50,"2.1mm","CN","filter",0,"M",0,""],
 ["Mooer","GE100",9,300,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Mooer","GE1000",9,1000,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["Mooer","GE1000 Li",9,1000,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["Mooer","GE150",9,300,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Mooer","GE200",9,1000,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["Mooer","GE250",9,1000,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["Mooer","GE300",9,3000,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["Mooer","GE300 Lite",9,3000,"2.1mm","CN","multi",0,"MS",1,"dg"],
 ["Mooer","Graphic B",9,20,"2.1mm","CN","eq",0,"M",0,""],
 ["Mooer","Graphic G",9,20,"2.1mm","CN","eq",0,"M",0,""],
 ["Mooer","Green Mile",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mooer","Grey Faze",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Mooer","Groove Loop",9,120,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Mooer","Groove Loop X2",9,300,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Mooer","Hustle Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mooer","LoFi Machine",9,160,"2.1mm","CN","filter",0,"M",0,"dg"],
 ["Mooer","Micro ABY",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Mooer","Micro DI",9,15,"2.1mm","CN","util",0,"M",0,""],
 ["Mooer","Micro Drummer",9,150,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Mooer","Micro Drummer II",9,150,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Mooer","Micro Looper",9,140,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Mooer","Micro Looper II",9,120,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 001 Gas Station",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 002 UK Gold 900",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 003 Power-Zone",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 004 Day Tripper",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 005 Brown Sound 3",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 006 US Classic Deluxe",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 007 Regal Tone",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 008 Cali-MK 3",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 009 Blacknight",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 010 Two Stones",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 011 Cali-Dual",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 012 US Gold 100",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 013 Matchbox",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 014 Taxidea Taxus",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 015 Brown Sound",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 016 Phoenix",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 017 Cali MK IV",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 018 Custom 100",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 019 UK Gold PLX",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Micro Preamp 020 Blueno",9,300,"2.1mm","CN","preamp",0,"M",0,"dg"],
 ["Mooer","Mod Factory",9,150,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mooer","Mod Factory Pro",9,300,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Mooer","Ninety Orange",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Mooer","Noise Killer",9,10,"2.1mm","CN","gate",0,"M",0,""],
 ["Mooer","Ocean Machine",9,500,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Mooer","Ocean Machine II",9,500,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Mooer","PE100",9,300,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Mooer","Pitch Box",9,120,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mooer","Pitch Step",9,200,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mooer","Preamp Live",12,1000,"2.1mm","CN","preamp",0,"MS",1,"dg"],
 ["Mooer","Preamp Model X2",9,300,"2.1mm","CN","preamp",0,"MS",0,"dg"],
 ["Mooer","Prime M1",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Mooer","Prime M2",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Mooer","Prime P1",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Mooer","Prime P2",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Mooer","Prime S1",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Mooer","Pure Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Mooer","Pure Octave",9,160,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mooer","R7 Reverb",9,300,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mooer","R7 X2 Reverb",9,300,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Mooer","Radar",12,300,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Mooer","Rage Machine",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","Red Truck",9,1000,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Mooer","Reecho",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mooer","Reecho Pro",9,300,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Mooer","Rumble Drive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Mooer","ShimVerb",9,128,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mooer","ShimVerb Pro",9,300,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Mooer","Skyverb",9,130,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mooer","Slow Engine",9,30,"2.1mm","CN","volume",0,"M",0,""],
 ["Mooer","Solo",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","Spark Boost",9,10,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Mooer","Spark Chorus",9,30,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Mooer","Spark Compressor",9,10,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Mooer","Spark Delay",9,100,"2.1mm","CN","delay",0,"M",0,"eol;dg"],
 ["Mooer","Spark Distortion",9,10,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Mooer","Spark Echo",9,100,"2.1mm","CN","delay",0,"M",0,"eol;dg"],
 ["Mooer","Spark Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Mooer","Sweeper",9,30,"2.1mm","CN","filter",0,"M",0,""],
 ["Mooer","Tender Octaver",9,120,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mooer","Tender Octaver Pro",9,300,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Mooer","Tender Octaver X2",9,300,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["Mooer","The Wahter",9,20,"2.1mm","CN","wah",0,"M",0,""],
 ["Mooer","Thunderball",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mooer","Trelicopter",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["Mooer","TresCab",9,160,"2.1mm","CN","util",0,"M",0,"dg"],
 ["Mooer","Triangle Buff",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mooer","Ultra Drive (MKII)",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Mooer","Yellow Comp",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Moog","CP-251 Control Processor",9,100,"2.1mm","CP","util",0,"M",0,""],
 ["Moog","EP-3",0,0,"none","NA","util",0,"M",0,""],
 ["Moog","MF-101 Lowpass Filter",9,100,"2.1mm","CP","filter",0,"M",0,""],
 ["Moog","MF-102 Ring Modulator",9,100,"2.1mm","CP","mod",0,"M",0,""],
 ["Moog","MF-103 12-Stage Phaser",9,100,"2.1mm","CP","mod",0,"MS",0,""],
 ["Moog","MF-104M Analog Delay",9,400,"2.1mm","CP","delay",0,"MS",1,""],
 ["Moog","MF-104Z Analog Delay",9,300,"2.1mm","CP","delay",0,"MS",0,""],
 ["Moog","MF-105 MuRF",9,240,"2.1mm","CP","filter",0,"MS",0,""],
 ["Moog","MF-105B Bass MuRF",9,240,"2.1mm","CP","filter",0,"MS",0,""],
 ["Moog","MF-107 FreqBox",9,200,"2.1mm","CP","pitch",0,"M",0,""],
 ["Moog","MF-108M Cluster Flux",9,300,"2.1mm","CP","mod",0,"MS",1,""],
 ["Moog","Minifooger MF Boost",9,8,"2.1mm","CN","drive",1,"M",0,""],
 ["Moog","Minifooger MF Chorus",9,20,"2.1mm","CN","mod",0,"MS",0,""],
 ["Moog","Minifooger MF Delay",9,25,"2.1mm","CN","delay",0,"M",0,""],
 ["Moog","Minifooger MF Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Moog","Minifooger MF Flange",9,30,"2.1mm","CN","mod",0,"MS",0,""],
 ["Moog","Minifooger MF Ring",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Moog","Minifooger MF Trem",9,11,"2.1mm","CN","mod",0,"M",0,""],
 ["Moollon","Bass Drive",9,14,"2.1mm","CN","drive",3,"M",0,""],
 ["Moollon","BASTET",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Moollon","Chorus",9,21,"2.1mm","CN","mod",0,"M",0,""],
 ["Moollon","Class A Boost",9,2,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["Moollon","Compressor",9,8,"2.1mm","CN","comp",0,"M",0,""],
 ["Moollon","Distortion",9,14,"2.1mm","CN","drive",3,"M",0,""],
 ["Moollon","KARMA",9,3,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Moollon","Lotus Octah",9,5,"2.1mm","CP","fuzz",5,"M",0,""],
 ["Moollon","Overdrive",9,14,"2.1mm","CN","drive",3,"M",0,""],
 ["Moollon","ReVibe",9,130,"2.1mm","CN","mod",0,"M",0,""],
 ["Moollon","Signal Boost",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Moollon","Tremolo MkII",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Moollon","Vintage Wah",9,5,"2.1mm","CN","wah",0,"M",0,""],
 ["Morningstar","MC3",9,120,"2.1mm","CN","util",0,"M",0,""],
 ["Morningstar","MC6 MkII",9,120,"2.1mm","CN","util",0,"M",0,""],
 ["Morningstar","MC6 Pro",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Morningstar","MC8",9,250,"2.1mm","CN","util",0,"M",0,""],
 ["Morningstar","MC8 Pro",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Morningstar","ML10X",9,160,"2.1mm","CN","switcher",0,"M",0,""],
 ["Morningstar","ML5",9,200,"2.1mm","CN","switcher",0,"M",0,""],
 ["Mountainking Electronics","Avalanche",9,2,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mountainking Electronics","Behemoth II",9,1,"2.1mm","CN","drive",2,"M",0,""],
 ["Mountainking Electronics","Decomposer",9,2,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Mountainking Electronics","Frequency~LSD",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Mountainking Electronics","Heavy Machine",9,1,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Mountainking Electronics","Magnetar-1",9,1,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Mountainking Electronics","Megalith",9,1,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Mountainking Electronics","Ruckus II",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Mr. Black","Ambience Reissue",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mr. Black","Analog Chorus/Vibrato Deluxe",9,62,"2.1mm","CN","mod",0,"M",0,""],
 ["Mr. Black","Analog Tremolo",9,17,"2.1mm","CN","mod",0,"M",0,""],
 ["Mr. Black","Bass OD Mk. II",9,27,"2.1mm","CN","drive",2,"M",0,""],
 ["Mr. Black","BB-74x",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Mr. Black","Black LTD. Bass OD",9,27,"2.1mm","CN","drive",2,"M",0,""],
 ["Mr. Black","Black LTD. Challenger Deep",9,59,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Digi-Delay",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Double Tracker",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. High-Five",9,59,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Necropolis",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Octave II",9,60,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Overdriver Mk. II",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["Mr. Black","Black LTD. Phaser Vibe",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Plates",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Power Drive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Mr. Black","Black LTD. Tri-Chorale",9,59,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Vintage Chorus",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Black LTD. Voltage Comp.",9,15,"2.1mm","CN","comp",0,"M",0,""],
 ["Mr. Black","BloodMoon",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","DeluxePlus Plus",9,60,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Mr. Black","Deuce Coupe",9,22,"2.1mm","CN","drive",3,"M",0,""],
 ["Mr. Black","DoubleChorus Diamond Sunset",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","DoubleTracker Stereo",9,73,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Mr. Black","Downward Spiral",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mr. Black","Drunken Monkey",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Eterna Custom",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","Eterna Gold Modified",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","FwonkBeta",9,59,"2.1mm","CN","filter",0,"M",0,"dg"],
 ["Mr. Black","GilaMondo",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","GilaMondo Throwback Special",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Heaven's Gate",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","High-Five",9,59,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Mr. Black","JDS-50",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Mr. Black","Mod.One",9,53,"2.1mm","CN","mod",0,"M",0,""],
 ["Mr. Black","Pana-Trem",9,69,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Mr. Black","Shepard's End",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Shepard's End Sub-Zero",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","SludgeMaster",9,9,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mr. Black","Stereo Vintage Ensemble",9,68,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Mr. Black","Stereo Vintage Ensemble Professional",9,74,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Mr. Black","SuperMoon",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","SuperMoon Chrome",9,60,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Mr. Black","SuperMoon Eclipse",9,70,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Mr. Black","Tapex 2",9,70,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Mr. Black","ThunderClaw",9,27,"2.1mm","CN","drive",4,"M",0,""],
 ["Mr. Black","TrancePortal",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Mr. Black","TunnelWorm",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","TunnelWorm Throwback Special",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Twin Lazers K1",9,73,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Mr. Black","Vintage Ensemble",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Mr. Black","Vintage Overdrive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["MusicomLab","EFX MK-VI",9,250,"2.1mm","CN","switcher",0,"M",0,""],
 ["MXR","Blue Box (1974-early 80s, battery only)",9,3,"batt","NA","fuzz",4,"M",0,""],
 ["MXR","CSP026 '74 Vintage Phase 90",9,3,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","CSP027 Timmy Overdrive",9,3,"2.1mm","CN","drive",2,"M",0,""],
 ["MXR","CSP028 '76 Vintage Dyna Comp",9,1,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","CSP033 Il Torino Overdrive",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["MXR","CSP039 Duke of Tone",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["MXR","CSP101SL Script Phase 90 w/LED",9,9,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","CSP102SL Script Dyna Comp",9,3,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","CSP105 '75 Vintage Phase 45",9,1,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","Distortion+ (1981-84 block logo with LED, 3.5mm jack)",9,3,"3.5mm","CP","drive",3,"M",0,""],
 ["MXR","Distortion+ (script & early block logo, battery only)",9,1,"batt","NA","drive",3,"M",0,""],
 ["MXR","Dyna Comp (1981-84 block logo with LED, 3.5mm jack)",9,4,"3.5mm","CP","comp",0,"M",0,""],
 ["MXR","Dyna Comp (script & early block logo, battery only)",9,3,"batt","NA","comp",0,"M",0,""],
 ["MXR","Envelope Filter (1976-81, battery only)",9,3,"batt","NA","filter",0,"M",0,""],
 ["MXR","EVH117 Flanger",18,35,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","EVH30 5150 Chorus",9,95,"2.1mm","CN","mod",0,"MS",0,""],
 ["MXR","EVH5150 Overdrive",9,15,"2.1mm","CN","drive",5,"M",0,""],
 ["MXR","EVH90 Phase 90",9,9,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","Flanger (1976-84 grey box, built-in AC mains cord)",0,0,"none","NA","mod",0,"M",0,""],
 ["MXR","M101 Phase 90",9,4,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M102 Dyna Comp",9,4,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","M104 Distortion+",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["MXR","M107 Phase 100",9,6,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M108 Ten Band EQ (original)",18,26,"2.1mm","CN","eq",0,"MS",0,""],
 ["MXR","M108S Ten Band EQ",18,48,"2.1mm","CN","eq",0,"MS",0,""],
 ["MXR","M109 Six Band EQ (original)",9,3,"2.1mm","CN","eq",0,"M",0,""],
 ["MXR","M109S Six Band EQ",9,15,"2.1mm","CN","eq",0,"M",0,""],
 ["MXR","M117R Flanger",18,39,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M133 Micro Amp",9,3,"2.1mm","CN","drive",1,"M",0,""],
 ["MXR","M134 Stereo Chorus",18,26,"2.1mm","CN","mod",0,"MS",0,""],
 ["MXR","M148 Micro Chorus",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M152 Micro Flanger",9,7,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M169 Carbon Copy Analog Delay",9,26,"2.1mm","CN","delay",0,"M",0,""],
 ["MXR","M228 Dyna Comp Deluxe",9,11,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","M233 Micro Amp+",9,7,"2.1mm","CN","drive",1,"M",0,""],
 ["MXR","M234 Analog Chorus",9,13,"2.1mm","CN","mod",0,"MS",0,""],
 ["MXR","M264 FET Driver",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["MXR","M269SE Carbon Copy Bright",9,26,"2.1mm","CN","delay",0,"M",0,""],
 ["MXR","M282 Dyna Comp Bass Compressor",9,11,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","M290 Phase 95",9,8,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M291 Dyna Comp Mini",9,4,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","M292 Carbon Copy Deluxe",9,44,"2.1mm","CN","delay",0,"M",0,""],
 ["MXR","M293 Booster Mini",9,13,"2.1mm","CN","drive",1,"M",0,""],
 ["MXR","M294 Sugar Drive",9,19,"2.1mm","CN","drive",2,"M",0,""],
 ["MXR","M299 Carbon Copy Mini",9,26,"2.1mm","CN","delay",0,"M",0,""],
 ["MXR","M300 Reverb",9,240,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["MXR","M68 Uni-Vibe Chorus/Vibrato",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["MXR","M75 Super Badass Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["MXR","M80 Bass D.I.+",9,9,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["MXR","M81 Bass Preamp",9,9,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["MXR","M87 Bass Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["MXR","M94SE Fat Sugar Drive",9,19,"2.1mm","CN","drive",2,"M",0,""],
 ["MXR","Micro Amp (1979-84 vintage, battery only)",9,2,"batt","NA","drive",1,"M",0,""],
 ["MXR","Noise Gate Line Driver (1974-81, battery only)",9,2,"batt","NA","gate",0,"M",0,""],
 ["MXR","Phase 100 (1981-84 block logo with LED, 3.5mm jack)",9,10,"3.5mm","CP","mod",0,"M",0,""],
 ["MXR","Phase 100 (script & early block logo, battery only)",9,8,"batt","NA","mod",0,"M",0,""],
 ["MXR","Phase 45 (1974-81, battery only)",9,3,"batt","NA","mod",0,"M",0,""],
 ["MXR","Phase 90 (1981-84 block logo with LED, 3.5mm jack)",9,6,"3.5mm","CP","mod",0,"M",0,""],
 ["MXR","Phase 90 (script & early block logo, battery only)",9,5,"batt","NA","mod",0,"M",0,""],
 ["MXR","Stereo Chorus (1979-84 big box, built-in AC mains cord)",0,0,"none","NA","mod",0,"MS",0,""],
 ["Mythos Pedals","1347 Silicon Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mythos Pedals","1N34A Mjolnir",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","210 Double Drive Deluxe",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Air Lane Drive",9,20,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Mythos Pedals","Argo Boost Deluxe",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Mythos Pedals","Argo Octave Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mythos Pedals","Argonaut Octave Up",9,10,"2.1mm","CN","pitch",1,"M",0,""],
 ["Mythos Pedals","AU-79 Fuzz",9,10,"2.1mm","CN","fuzz",3,"M",0,""],
 ["Mythos Pedals","Big Puft Fuzz Device",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Mythos Pedals","Buffer",9,10,"2.1mm","CN","util",0,"M",0,""],
 ["Mythos Pedals","Cestus Treble Booster",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Mythos Pedals","Chupacabra CMOS Overdrive",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Mythos Pedals","Chupacabra Overdrive/Fuzz V2",9,15,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Mythos Pedals","D-Style Herculean Overdrive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Envy Pro Overdrive",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Erlking Overdrive",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Extra Hot Dual Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Mythos Pedals","GE Mjolnir",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Golden Fleece Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Mythos Pedals","Hephaestus Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Mythos Pedals","Herculean Deluxe Overdrive",9,40,"2.1mm","CN","drive",3,"M",0,""],
 ["Mythos Pedals","High Road Fuzz Mini",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Mythos Pedals","Joey Landreth Mjolnir",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Luxury Drive Boost",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Mythos Pedals","Mjolnir Overdrive",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Olympus Overdrive",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Mythos Pedals","Oracle Analog Echo",9,35,"2.1mm","CN","delay",0,"M",0,""],
 ["Mythos Pedals","Positron Collider Fuzz",9,25,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mythos Pedals","Positron Fuzz",9,25,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Mythos Pedals","SusMaryOsep V2",9,100,"2.1mm","CN","multi",2,"M",0,"dg"],
 ["Mythos Pedals","The Fates Chorus",9,16,"2.1mm","CN","mod",0,"M",0,""],
 ["Mythos Pedals","Wildwood Mjolnir",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Neunaber","Echelon Echo v2",9,100,"2.1mm","CN","delay",0,"S",0,"dg;eol"],
 ["Neunaber","Iconoclast Speaker Emulator",9,120,"2.1mm","CN","util",0,"S",0,"dg"],
 ["Neunaber","Illumine Reverb",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Neunaber","Immerse Reverberator",9,70,"2.1mm","CN","reverb",0,"S",0,"dg;eol"],
 ["Neunaber","Immerse Reverberator Mk II",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Neunaber","Inspire Tri-Chorus Plus",9,95,"2.1mm","CN","mod",0,"S",0,"dg;eol"],
 ["Neunaber","Neuron Gain Intelligence",9,70,"2.1mm","CN","preamp",4,"M",0,"dg"],
 ["Neunaber","Seraphim Shimmer v2",9,100,"2.1mm","CN","reverb",0,"S",0,"dg;eol"],
 ["Neunaber","Slate v2",9,100,"2.1mm","CN","multi",0,"S",0,"dg;eol"],
 ["Neunaber","Wet Mono Reverb (Elements)",9,95,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Neunaber","Wet Stereo Reverb (Expanse)",9,100,"2.1mm","CN","reverb",0,"S",0,"dg;eol"],
 ["Neural DSP","Nano Cortex",9,600,"2.1mm","CN","preamp",0,"MS",1,"amp"],
 ["Neural DSP","Quad Cortex",12,2000,"2.1mm","CN","multi",0,"S",1,"amp;dg"],
 ["Nobels","CHO-mini",9,58,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Nobels","DEL-mini",9,58,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Nobels","MOD-mini",9,120,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Nobels","ODR-1 (BC)",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","ODR-1 30th Anniversary",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","ODR-1X",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","ODR-mini",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","ODR-mini2",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","ODR-S",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nobels","TR-X Tremolo",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["Nordland Electronics","MT-11 Mosland Overdrive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordland Electronics","ODR-C 30th Anniversary",9,25,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Nordland Electronics","ODR-C Custom Overdrive",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordland Electronics","ODR-C H/L Gain Overdrive",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordland Electronics","ODR-CC Compact",9,18,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordland Electronics","ODR-CC+ Compact",9,18,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordland Electronics","ODR-CS Custom Special",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordvang Custom","'83 Drive v2.5",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordvang Custom","Altitude",9,125,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordvang Custom","Gravity V2.5",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordvang Custom","Gravity V2.5 Deluxe",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordvang Custom","Mid Air",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordvang Custom","No.1 Signature",9,150,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Nordvang Custom","Skyline V2",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Nordvang Custom","Triple Gain",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Nordvang Custom","Wingman V2.0",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["NRG Effects","Fuzzer",9,30,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["NRG Effects","Gnawer",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["NRG Effects","Mauler",9,30,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["NRG Effects","Purrer",9,30,"2.1mm","CN","drive",2,"M",0,""],
 ["NUX","B-5RC Receiver",0,0,"none","NA","util",0,"M",0,""],
 ["NUX","B-8 Receiver",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Old Blood Noise Endeavors","Alpha Haunt",9,40,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Old Blood Noise Endeavors","Beam Splitter",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Old Blood Noise Endeavors","BL-52 Phase Repeater",9,110,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Dark Star",9,110,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Dark Star Stereo",9,350,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Old Blood Noise Endeavors","Dweller",9,110,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Excess",9,60,"2.1mm","CN","drive",4,"M",0,""],
 ["Old Blood Noise Endeavors","Excess V2",9,125,"2.1mm","CN","drive",4,"M",0,""],
 ["Old Blood Noise Endeavors","Flat Light",9,110,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Float",9,100,"2.1mm","CN","filter",0,"M",0,""],
 ["Old Blood Noise Endeavors","Haunt",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Old Blood Noise Endeavors","MAW",9,210,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Minim",9,170,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Procession",9,110,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Rêver",9,159,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Screen Violence",9,110,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Old Blood Noise Endeavors","Sunlight",9,110,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Visitor",9,110,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Old Blood Noise Endeavors","Whitecap",9,110,"2.1mm","CN","mod",0,"M",0,""],
 ["Oliver FX","Purple Ohm Fuzz",9,25,"2.1mm","CN","fuzz",4,"M",0,""],
 ["One Control","Caiman Tail Loop",9,220,"2.1mm","CN","switcher",0,"M",0,""],
 ["One Control","Crocodile Tail Loop OC10",9,450,"2.1mm","CN","switcher",0,"M",0,""],
 ["Orange","Acoustic Pedal",18,100,"2.1mm","CP","preamp",0,"M",0,""],
 ["Orange","Amp Detonator",9,15,"2.1mm","CN","util",0,"MS",0,""],
 ["Orange","Bax Bangeetar",9,60,"2.1mm","CN","preamp",0,"M",0,""],
 ["Orange","Distortion Pedal",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Orange","Fur Coat",9,3,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Orange","Getaway Driver",9,40,"2.1mm","CN","drive",3,"M",0,""],
 ["Orange","Kongpressor",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Orange","Phaser Pedal",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Orange","Sustain Pedal",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Orange","Two Stroke",9,30,"2.1mm","CN","drive",1,"M",0,""],
 ["Origin Effects","BASSRIG '64 Black Panel",9,150,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Origin Effects","BASSRIG Fifteen",9,200,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Origin Effects","BASSRIG Super Vintage",9,150,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Origin Effects","Cali76 Bass Compressor",9,200,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Compact (Cali76-C)",9,42,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Compact Bass (Cali76-CB)",9,78,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Compact Deluxe (Cali76-CD)",9,77,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 FET Compressor (FET76)",9,200,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Stacked Compressor",9,200,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Stacked Edition",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76 Standard (large format)",9,13,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76-TX",9,13,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76-TX-L",9,13,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76-TX-L-P",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","Cali76-TX-P",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","DCX Boost",9,90,"2.1mm","CN","drive",1,"M",0,""],
 ["Origin Effects","DELUXE55 Tweed Recreation",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Origin Effects","DELUXE61 Amp Tremolo & Drive",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Origin Effects","Halcyon Blue Overdrive",9,200,"2.1mm","CN","drive",2,"M",0,""],
 ["Origin Effects","Halcyon Gold Overdrive",9,200,"2.1mm","CN","drive",2,"M",0,""],
 ["Origin Effects","Halcyon Green Overdrive",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Origin Effects","M-EQ Driver",9,80,"2.1mm","CN","drive",2,"M",0,""],
 ["Origin Effects","MAGMA57 Amp Vibrato & Drive",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Origin Effects","RD Compact Hot Rod",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Origin Effects","RevivalDRIVE",9,120,"2.1mm","CN","drive",3,"M",0,""],
 ["Origin Effects","RevivalDRIVE Compact",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Origin Effects","RevivalDRIVE Custom",9,120,"2.1mm","CN","drive",3,"M",0,""],
 ["Origin Effects","RevivalDRIVE Hot Rod",9,120,"2.1mm","CN","drive",4,"M",0,""],
 ["Origin Effects","RevivalTREM Bias Tremolo",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Origin Effects","SlideRIG (large format)",9,10,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","SlideRIG Compact",9,50,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","SlideRIG Compact Deluxe",9,77,"2.1mm","CN","comp",0,"M",0,""],
 ["Origin Effects","SlideRIG Compact Deluxe Mk2",9,82,"2.1mm","CN","comp",0,"M",0,""],
 ["OTO Machines","BAM",18,500,"2.1mm","CP","reverb",0,"S",1,"dg"],
 ["OTO Machines","BIM",18,500,"2.1mm","CP","delay",0,"S",1,"dg"],
 ["OTO Machines","BOUM",18,500,"2.1mm","CP","drive",3,"S",1,""],
 ["PastFX","18V Power Booster",18,10,"2.1mm","CN","drive",2,"M",0,""],
 ["PastFX","80/A Flanger",18,35,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","80/A MN3007 Flanger",18,35,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","BLD",9,10,"2.1mm","CN","preamp",2,"M",0,""],
 ["PastFX","Canberra Overdrive",9,6,"2.1mm","CN","drive",2,"M",0,""],
 ["PastFX","Chorus Ensemble Deluxe",9,130,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Chorus Ensemble Mini",9,130,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Chorus Ensemble MN3007 (CE-7)",9,130,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Chorus Ensemble MN3007 Mini",9,130,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Classic Phase PX99",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Deluxe Elastic Mattress",18,160,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","DISTORTiiON",18,55,"2.1mm","CN","drive",3,"M",0,""],
 ["PastFX","Echo 600",18,85,"2.1mm","CN","delay",0,"M",0,""],
 ["PastFX","Echoflanger",18,80,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Elastic Mattress",18,25,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Gallstone",9,80,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Hot for Flanger",18,45,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","I.C. Mufnstuf",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["PastFX","JFet Fuzz Phaser (Jet Phaser)",9,15,"2.1mm","CN","mod",5,"M",0,""],
 ["PastFX","Kurt's Cologne",9,50,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","M-1-A",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["PastFX","Mischief Distortion",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["PastFX","New Division Chorus/Flange/Vibrato",18,150,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Nick James Foot Phaser",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","OG-1 Overdrive",9,80,"2.1mm","CN","drive",2,"M",0,""],
 ["PastFX","OG-2",9,55,"2.1mm","CN","drive",3,"M",0,""],
 ["PastFX","Patriarch",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["PastFX","Phase V",9,80,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Phaser Deluxe",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Poly Chorus",18,80,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Preamp Crunch Plus",9,55,"2.1mm","CN","preamp",2,"M",0,""],
 ["PastFX","Punkifriar PX76",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["PastFX","PX-101 Lowpass Filter",9,120,"2.1mm","CN","filter",0,"M",0,""],
 ["PastFX","PX-251 Control Processor",9,100,"2.1mm","CN","util",0,"M",0,""],
 ["PastFX","Reticon Flanger",18,50,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Retiklon",18,55,"2.1mm","CN","drive",2,"M",0,""],
 ["PastFX","Revolution",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["PastFX","Ring Modulator",18,50,"2.1mm","CN","mod",0,"M",0,""],
 ["PastFX","Rotary Phaser",9,45,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","Stereo Chorus PX65",9,10,"2.1mm","CN","mod",0,"MS",0,""],
 ["PastFX","TD-Y Overdrive",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Paul Cochrane","Tim V3",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Paul Cochrane","Timmy V2",9,9,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Paul Cochrane","Timmy V3",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Pete Cornish","3Q-1",9,20,"2.1mm","CN","eq",1,"M",0,""],
 ["Pete Cornish","BD-1",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Pete Cornish","CC-1",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Pete Cornish","Dual LD-3",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Pete Cornish","G-2",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Pete Cornish","GC-1",9,20,"2.1mm","CN","drive",4,"M",0,""],
 ["Pete Cornish","LD-1",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Pete Cornish","LD-3",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Pete Cornish","NB-3",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Pete Cornish","NBM-2",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Pete Cornish","NG-2",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Pete Cornish","NG-3",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Pete Cornish","OC-1",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Pete Cornish","P-1",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Pete Cornish","P-2",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Pete Cornish","SS-2",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Pete Cornish","SS-3",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Pete Cornish","ST-2",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Peterson","Stomp Classic",9,80,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Peterson","StroboStomp HD",9,85,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Peterson","StroboStomp LE",9,85,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Peterson","StroboStomp Mini",9,85,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Pigtronix","Aria",18,300,"2.1mm","CN","drive",4,"M",0,""],
 ["Pigtronix","Bass Envelope Phaser",18,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Pigtronix","Bob Weir's Real Deal",18,300,"2.1mm","CN","util",0,"M",0,""],
 ["Pigtronix","Class A Boost",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Pigtronix","Constellator",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Pigtronix","Cosmosis",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Pigtronix","Disnortion (original)",15,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Pigtronix","Disnortion Micro",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Pigtronix","Echolution (original)",15,300,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Pigtronix","Echolution 2",18,100,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Pigtronix","Envelope Phaser EP-2",18,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Pigtronix","FAT Drive",18,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Pigtronix","Gatekeeper Micro",9,20,"2.1mm","CN","gate",0,"M",0,""],
 ["Pigtronix","Gloamer",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Pigtronix","Infinity 2",9,100,"2.1mm","CN","looper",0,"S",0,"dg"],
 ["Pigtronix","Infinity 3",18,200,"2.1mm","CN","looper",0,"S",1,"dg"],
 ["Pigtronix","Infinity 3 Deluxe",18,200,"2.1mm","CN","looper",0,"S",1,"dg"],
 ["Pigtronix","Infinity Looper (original)",18,200,"2.1mm","CN","looper",0,"S",1,"dg"],
 ["Pigtronix","Keymaster",18,300,"2.1mm","CN","util",0,"M",0,""],
 ["Pigtronix","Moon Pool",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Pigtronix","Mothership (original)",48,520,"2.1mm","CN","synth",0,"M",0,""],
 ["Pigtronix","Mothership 2",18,300,"2.1mm","CN","synth",0,"M",0,""],
 ["Pigtronix","Octava",9,100,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Pigtronix","Philosopher's Gold",9,100,"2.1mm","CN","comp",2,"M",0,""],
 ["Pigtronix","Philosopher's Tone (current)",9,100,"2.1mm","CN","comp",0,"M",0,""],
 ["Pigtronix","Philosopher's Tone (original)",15,300,"2.1mm","CN","comp",0,"M",0,""],
 ["Pigtronix","Philosopher's Tone Micro",9,35,"2.1mm","CN","comp",0,"M",0,""],
 ["Pigtronix","Quantum Time Modulator",18,100,"2.1mm","CN","mod",0,"MS",0,""],
 ["Pigtronix","Resotron",18,300,"2.1mm","CN","filter",0,"M",0,""],
 ["Pigtronix","Ringmaster",18,300,"2.1mm","CN","mod",0,"M",0,""],
 ["Pigtronix","Rototron",18,100,"2.1mm","CN","mod",0,"S",0,""],
 ["Pigtronix","Space Rip",9,100,"2.1mm","CN","synth",0,"M",0,""],
 ["Pigtronix","Star Eater",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Pigtronix","Tremvelope",18,300,"2.1mm","CN","mod",0,"MS",0,""],
 ["Pinstripe Pedals","ABCS Amp Switcher",9,75,"2.1mm","CN","switcher",0,"MS",0,""],
 ["Pinstripe Pedals","Clean DI V2",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Pinstripe Pedals","DISO Plus (XLR Sum / PolRev / DLX)",0,0,"none","NA","util",0,"S",0,""],
 ["Pinstripe Pedals","DISO+ Dual Line Isolator",0,0,"none","NA","util",0,"S",0,""],
 ["Pinstripe Pedals","DISOe Buffered Dual Line Isolator",9,250,"2.1mm","CN","util",0,"S",0,""],
 ["Pinstripe Pedals","DISOxo Dual Line Isolator",0,0,"none","NA","util",0,"S",0,""],
 ["Pinstripe Pedals","HBFR High Performance Buffer",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Pinstripe Pedals","LWDI Little White DI",0,0,"none","NA","util",0,"M",0,""],
 ["Pinstripe Pedals","MBFR Multi Buffer",9,20,"2.1mm","CN","util",0,"MS",0,""],
 ["Pinstripe Pedals","MISO Mono Line Isolator",0,0,"none","NA","util",0,"M",0,""],
 ["Pinstripe Pedals","SWDI Stereo Direct Box",0,0,"none","NA","util",0,"S",0,""],
 ["Pinstripe Pedals","TXRX-M Signal Management (Send)",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Pinstripe Pedals","WRLS Wireless Signal Manager/Isolator",0,0,"none","NA","util",0,"M",0,""],
 ["Pirate MIDI","Bridge6",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["Poly Effects","Ample",9,500,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Poly Effects","Beebo",9,500,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Poly Effects","Digit",9,500,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Poly Effects","Hector",0,0,"none","NA","multi",0,"S",0,"dg"],
 ["Poly Effects","Josh Smith Flat V",9,150,"2.1mm","CN","drive",3,"M",0,""],
 ["Poly Effects","Kanso",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Poly Effects","Trails",9,500,"2.1mm","CN","multi",0,"S",0,"dg"],
 ["Poly Effects","Verbs",9,500,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Positive Grid","BIAS Delay",9,270,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Positive Grid","BIAS Delay Twin",9,270,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Positive Grid","BIAS Distortion",9,270,"2.1mm","CN","drive",4,"M",0,"dg"],
 ["Positive Grid","BIAS Distortion Twin",9,270,"2.1mm","CN","drive",4,"S",0,"dg"],
 ["Positive Grid","BIAS Modulation",9,270,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Positive Grid","BIAS Modulation Twin",9,270,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Positive Grid","Spark Control",0,0,"none","NA","util",0,"M",0,""],
 ["Positive Grid","Spark Control X",0,0,"none","NA","util",0,"M",0,""],
 ["Prescription Electronics","C.O.B. (Clean Octave Blend)",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Prescription Electronics","Depth Charge",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Prescription Electronics","Experience",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Prescription Electronics","Facelift",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff;eol"],
 ["Prescription Electronics","Germ",9,10,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Prescription Electronics","RX Overdriver",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Prescription Electronics","Throb",9,10,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Prescription Electronics","Vibe Unit",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Prescription Electronics","Yardbox",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ProCo","Fat RAT",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["ProCo","Lil' RAT",9,11,"2.1mm","CN","drive",4,"M",0,""],
 ["ProCo","RAT (1979-83 big box, battery only)",9,2,"batt","NA","drive",4,"M",0,""],
 ["ProCo","RAT (1984-2005, 3.5mm mini jack)",9,2,"3.5mm","CP","drive",4,"M",0,""],
 ["ProCo","RAT 2",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["ProCo","RAT 2 (pre-2018, 3.5mm mini jack)",9,5,"3.5mm","CP","drive",4,"M",0,""],
 ["ProCo","Turbo RAT",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["ProCo","Turbo RAT (pre-2018, 3.5mm mini jack)",9,5,"3.5mm","CP","drive",4,"M",0,""],
 ["ProCo","You Dirty RAT",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["ProCo","You Dirty RAT (pre-2018, 3.5mm mini jack)",9,5,"3.5mm","CP","drive",4,"M",0,""],
 ["Providence","Anadime Chorus ADC-4",9,26,"2.1mm","CN","mod",0,"MS",0,""],
 ["Providence","Bass Boot Comp BTC-1",9,25,"2.1mm","CN","comp",0,"M",0,""],
 ["Providence","Chrono Delay DLY-4",12,110,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Providence","Dual Bass Station DBS-1",12,80,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Providence","Flame Drive FDR-1F",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Providence","Phase Force PHF-1",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["Providence","Silky Drive SLD-1F",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["Providence","Sonic Drive SDR-5",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Providence","Stampede OD SOV-2",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Providence","Velvet Comp VLC-1",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["R Weaver FX","Face Of Spades Axis Edition",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["R Weaver FX","Face Of Spades Octave Edition",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["R Weaver FX","Lone Star Stranger",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["R Weaver FX","Midnight Vibe",18,250,"2.1mm","CN","mod",0,"M",0,""],
 ["R Weaver FX","Octav8",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["R Weaver FX","Silicon Face of Spades Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["R Weaver FX","Violet Vibe",18,200,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Radial","BigShot ABY",0,0,"2.1mm","CN","util",0,"M",0,""],
 ["Radial","BigShot EFX",0,0,"2.1mm","CN","switcher",0,"M",0,""],
 ["Radial","BigShot i/o",0,0,"2.1mm","CN","util",0,"M",0,""],
 ["Radial","Tonebone Bassbone OD",15,400,"2.1mm","CP","preamp",2,"M",0,""],
 ["Radial","Tonebone Bassbone V2",15,400,"2.1mm","CP","preamp",0,"M",0,""],
 ["Radial","Tonebone Classic",15,400,"2.1mm","CP","drive",3,"M",0,""],
 ["Radial","Tonebone Dragster",0,0,"","","util",0,"M",0,""],
 ["Radial","Tonebone Headbone VT",15,400,"2.1mm","CP","util",0,"M",0,""],
 ["Radial","Tonebone Hot British",15,400,"2.1mm","CP","drive",5,"M",0,""],
 ["Radial","Tonebone Loopbone",15,400,"2.1mm","CP","switcher",1,"M",0,""],
 ["Radial","Tonebone Plexitube",15,400,"2.1mm","CP","drive",4,"M",0,""],
 ["Radial","Tonebone PZ-Pre",15,400,"2.1mm","CP","preamp",0,"M",0,""],
 ["Radial","Tonebone Switchbone V2",15,400,"2.1mm","CP","util",1,"M",0,""],
 ["Radial","Tonebone Trimode",15,400,"2.1mm","CP","drive",4,"M",0,""],
 ["Radial","Twin-City ABY",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Rainger FX","Air Space Invader 2",9,30,"2.1mm","CN","filter",3,"M",0,"eol"],
 ["Rainger FX","Air Traffic Controller ATC-1",9,30,"2.1mm","CN","filter",3,"M",0,"eol"],
 ["Rainger FX","Binary Pulsar",9,165,"2.1mm","CN","volume",0,"S",0,"dg"],
 ["Rainger FX","Bleep",9,63,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Rainger FX","Break Box",9,60,"2.1mm","CN","synth",3,"M",0,"dg"],
 ["Rainger FX","Chop Fuzzz",9,63,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Rainger FX","Deep Space Pulsar",9,85,"2.1mm","CN","volume",0,"M",0,"eol"],
 ["Rainger FX","Dr Freakenstein Fuzz DRFF-3",9,30,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Rainger FX","Drone Rainger",9,80,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Rainger FX","Echo-X",9,29,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Rainger FX","Flanger-X",9,65,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Rainger FX","Minibar",9,14,"2.1mm","CN","drive",3,"M",0,""],
 ["Rainger FX","Minidrone",9,65,"2.1mm","CN","synth",0,"M",0,""],
 ["Rainger FX","Pull Focus",9,60,"2.1mm","CN","drive",4,"M",0,"dg"],
 ["Rainger FX","Razor Fuzz",9,70,"2.1mm","CN","fuzz",5,"M",0,"dg"],
 ["Rainger FX","Reverb-X",9,76,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Rainger FX","Snare Trap",9,65,"2.1mm","CN","synth",0,"M",0,""],
 ["Red Panda","Bitmap",9,85,"2.1mm","CN","synth",0,"M",0,"dg"],
 ["Red Panda","Bitmap V2",9,250,"2.1mm","CN","synth",0,"S",1,"dg"],
 ["Red Panda","Context",9,85,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Red Panda","Context V2",9,250,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Red Panda","Particle",9,85,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Red Panda","Particle V2",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Red Panda","Radius",9,200,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Red Panda","Raster",9,85,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Red Panda","Raster V2",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Red Panda","Tensor",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Redbeard Effects","Angry Rhubarb Paradynamic Overdrive MKII",9,100,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Redbeard Effects","Bearded Vulture Direct Drive",9,100,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Redbeard Effects","Hairy Squid Colossal Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Redbeard Effects","Honey Badger Octave Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Redbeard Effects","Red Mist MKIV",9,100,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Reeves Electro","2n2FACE",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","BHS-A BlackHatSound Alpha",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","Facet FF",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","Facet IZ",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","Izzrite",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","Leo Twelve",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Reeves Electro","TwinSound Octave Up Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Reeves Electro","ZO: Zonk Machine MK2",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["RJM Music","Mastermind GT/10",12,700,"2.1mm","CP","util",0,"M",0,""],
 ["RJM Music","Mastermind LT",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["RJM Music","Mastermind PBC/10",9,500,"2.1mm","CN","switcher",0,"M",0,""],
 ["RJM Music","Mastermind PBC/6X",9,220,"2.1mm","CN","switcher",0,"M",0,""],
 ["Rodenberg","GAS (OD/CB)",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","GAS-707 NG",9,20,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Rodenberg","GAS-707B NG",9,20,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Rodenberg","GAS-789 NG",9,250,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","GAS-789B NG",9,250,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","GAS-808 NG",9,20,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","GAS-808B NG",9,20,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","GAS-828 NG",9,200,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","GAS-909",9,20,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Rodenberg","Killmister",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Rodenberg","LDP (OD/CB)",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","LDP Deluxe",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","LDP Deluxe Victor Wooten",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","Luke Overdrive MK II",9,50,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","M2 Boost Marcus Miller",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["Rodenberg","M2-OD Marcus Miller",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","SL Boost",9,50,"2.1mm","CN","drive",1,"M",0,""],
 ["Rodenberg","SL-OD 2",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Rodenberg","SL-OD Deluxe",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Rodenberg","SL-OD DLX Drive",9,80,"2.1mm","CN","drive",4,"M",0,""],
 ["Rodenberg","TB Drive Shakedown Special",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Roland","AD-50 Double Beat",9,4,"batt","NA","fuzz",5,"M",0,""],
 ["Roland","AF-100 Bee Baa",9,4,"batt","NA","fuzz",5,"M",0,"ff"],
 ["Roland","AF-60 Bee Gee",9,3,"batt","NA","fuzz",5,"M",0,""],
 ["Roland","AG-5 Funny Cat",9,4,"batt","NA","filter",0,"M",0,""],
 ["Roland","AP-7 Jet Phaser",0,0,"none","NA","mod",0,"M",0,""],
 ["Roland","AS-1 Sustainer",0,0,"none","NA","comp",0,"M",0,""],
 ["Roland","AW-10 Wah Beat",9,1,"batt","NA","wah",0,"M",0,""],
 ["Roland","GR-55 Guitar Synth",9,700,"2.1mm","CN","synth",0,"MS",1,"dg"],
 ["Roland","RE-150 Space Echo",0,0,"none","NA","delay",0,"M",0,""],
 ["Roland","RE-201 Space Echo",0,0,"none","NA","delay",0,"M",0,""],
 ["Roland","RE-301 Chorus Echo",0,0,"none","NA","delay",0,"M",0,""],
 ["Sennheiser","XSW-D Pedalboard RX",9,500,"2.1mm","CN","util",0,"M",0,""],
 ["Seymour Duncan","805 Overdrive",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Seymour Duncan","Andromeda Dynamic Delay",9,150,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Seymour Duncan","Catalina Dynamic Chorus",9,23,"2.1mm","CN","mod",0,"MS",0,""],
 ["Seymour Duncan","Dark Sun (Mark Holcomb)",9,150,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Seymour Duncan","Deja Vu Tap Delay (SFX-10)",9,65,"2.1mm","CN","delay",0,"MS",0,"dg;eol"],
 ["Seymour Duncan","Diamondhead",9,200,"2.1mm","CN","drive",4,"M",0,""],
 ["Seymour Duncan","Dirty Deed Distortion",9,7,"2.1mm","CN","drive",4,"M",0,""],
 ["Seymour Duncan","Double Back Compressor (SFX-09)",9,5,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Seymour Duncan","Forza Overdrive",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Seymour Duncan","Killing Floor High Gain Boost",9,4,"2.1mm","CN","drive",1,"M",0,""],
 ["Seymour Duncan","Lava Box (SFX-05)",9,4,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["Seymour Duncan","Palladium Gain Stage",9,180,"2.1mm","CN","preamp",4,"M",0,""],
 ["Seymour Duncan","Paranormal Bass DI (SFX-06)",9,3,"2.1mm","CN","preamp",0,"M",0,"eol"],
 ["Seymour Duncan","Pickup Booster",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Seymour Duncan","Pickup Booster Mini",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Seymour Duncan","Polaron",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Seymour Duncan","Shape Shifter (SFX-07)",9,7,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Seymour Duncan","Shape Shifter Stereo Tremolo",9,13,"2.1mm","CN","mod",0,"S",0,""],
 ["Seymour Duncan","Silver Lake Dynamic Reverb",9,150,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Seymour Duncan","Studio Bass Compressor",9,21,"2.1mm","CN","comp",0,"M",0,""],
 ["Seymour Duncan","Tweak Fuzz (SFX-02)",9,2,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Seymour Duncan","Twin Tube Blue (SFX-11)",0,0,"none","NA","drive",2,"M",0,"eol"],
 ["Seymour Duncan","Twin Tube Classic (SFX-03)",0,0,"none","NA","drive",3,"M",0,"eol"],
 ["Seymour Duncan","Twin Tube Mayhem (SFX-04)",0,0,"none","NA","drive",4,"M",0,"eol"],
 ["Seymour Duncan","Vapor Trail Analog Delay",9,11,"2.1mm","CN","delay",0,"M",0,""],
 ["Seymour Duncan","Vapor Trail Deluxe",9,150,"2.1mm","CN","delay",0,"M",0,""],
 ["Seymour Duncan","Vise Grip Compressor",9,21,"2.1mm","CN","comp",0,"M",0,""],
 ["Shin-Ei","Astron FY-6 Super Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Shin-Ei","B1G 1 Preamp Gain Boost",9,100,"2.1mm","CN","preamp",1,"M",0,""],
 ["Shin-Ei","Companion FY-2 (vintage)",9,1,"batt","NA","fuzz",5,"M",0,"eol"],
 ["Shin-Ei","Companion FY-2 Fuzz Box (reissue)",9,1,"batt","NA","fuzz",5,"M",0,""],
 ["Shin-Ei","Companion FY-6 Super Fuzz (vintage)",9,1,"batt","NA","fuzz",5,"M",0,"eol"],
 ["Shin-Ei","FY-6 Super Fuzz (reissue)",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Shin-Ei","Not So B1G Preamp Gain Boost",9,100,"2.1mm","CN","preamp",1,"M",0,""],
 ["Shin-Ei","Screaming Sister Octave Boost",9,100,"2.1mm","CN","pitch",1,"M",0,""],
 ["Shin-Ei","Uni-Vibe (vintage)",0,0,"none","NA","mod",0,"M",0,"eol"],
 ["Shin-Ei","Vibe-2",24,400,"2.1mm","CN","mod",0,"M",0,""],
 ["Shin-Ei","Vibe-Bro",0,0,"none","NA","mod",0,"M",0,""],
 ["Shure","GLXD16+ (GLXD6+ receiver)",9,400,"2.1mm","CN","util",0,"M",0,""],
 ["Silktone","Expander",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Silktone","Fuzz",9,50,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Silktone","Fuzz+",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Silktone","Overdrive+",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["Skreddy Pedals","Angel Face",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Skreddy Pedals","BC109",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Skreddy Pedals","Cognitive Dissonance MkIV",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Direct In",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["Skreddy Pedals","Echo (original)",9,26,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Skreddy Pedals","Echo Infinity",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Skreddy Pedals","Echo Mini",9,30,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Skreddy Pedals","Echo Vintage",9,26,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Skreddy Pedals","Giant Meat Pie BC239",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Hybrid Fuzz Driver",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Skreddy Pedals","Klipper",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Little Miss Sunshine",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Skreddy Pedals","Lunar Module Deluxe (original)",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Skreddy Pedals","Lunar Module Mini Deluxe",9,5,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["Skreddy Pedals","Martian Tarantula",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Skreddy Pedals","Mayo MkIII",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Mayonaise MkII",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Mayonaise MkIII",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","P19",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Perestroika",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Pig Mine",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Rover Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Skreddy Pedals","Rust Rod",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Skreddy Pedals","Screw Driver Mini Dlx",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Skreddy Pedals","Screwdriver Deluxe (original)",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Skreddy Pedals","Serenity Fuzzdrive",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Skreddy Pedals","Skunk Drive",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Skreddy Pedals","Top Fuel",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Skreddy Pedals","Zero (Thick & Smooth)",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Slow Gear Electronics","ATS Buffer/Splitter",9,20,"2.1mm","CN","util",0,"MS",0,""],
 ["Slow Gear Electronics","M.A.I.D. Micro Active Iso/DI",9,40,"2.1mm","CN","util",0,"M",0,""],
 ["Slow Gear Electronics","Pedalboard Headphone Amp",9,200,"2.1mm","CN","util",0,"S",0,""],
 ["SM Pedals","SM Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["SM Pedals","SM Fuzz NKT275 Red Dot",9,5,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["SM Pedals","SM Octave Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["SM Pedals","SM Octaveon",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["SolidGoldFX","76 (Octave Fuzz)",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","76 MKII",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","76 Plus",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","Apollo",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["SolidGoldFX","Apollo II",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["SolidGoldFX","Athena",9,15,"2.1mm","CN","mod",0,"M",0,""],
 ["SolidGoldFX","Aurras",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["SolidGoldFX","Beta",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["SolidGoldFX","Beta DLX",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["SolidGoldFX","Beta-V",9,13,"2.1mm","CN","preamp",0,"M",0,""],
 ["SolidGoldFX","Commodore",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["SolidGoldFX","Communication Breakdown",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["SolidGoldFX","Counter Current",9,53,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["SolidGoldFX","Electroman",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["SolidGoldFX","Electroman MKII",9,55,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["SolidGoldFX","EM-III",9,39,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["SolidGoldFX","Ether",9,70,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["SolidGoldFX","Formula 76",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","Funkzilla",9,15,"2.1mm","CN","filter",0,"M",0,""],
 ["SolidGoldFX","If 6 Was 9 (BC108)",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["SolidGoldFX","If 6 Was 9 BC183 MKII",9,20,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["SolidGoldFX","If 6 Was 9 Germanium",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["SolidGoldFX","Imperial (BC183)",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","Imperial MKII",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["SolidGoldFX","Lysis",9,60,"2.1mm","CN","fuzz",4,"M",0,"dg"],
 ["SolidGoldFX","Lysis MKII",9,60,"2.1mm","CN","fuzz",4,"M",0,"dg"],
 ["SolidGoldFX","NU-33",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["SolidGoldFX","Oblivion",9,60,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["SolidGoldFX","Rosie Fuzz",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["SolidGoldFX","Spanish Castle",9,10,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["SolidGoldFX","Stutterbox",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["SolidGoldFX","Supa Funk",9,20,"2.1mm","CN","filter",0,"M",0,""],
 ["SolidGoldFX","Surf Rider III",9,55,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["SolidGoldFX","Surf Rider IV",9,65,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["SolidGoldFX","Zeta DLX",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Sonic Research","Turbo Tuner ST-200",9,50,"2.1mm","CN","tuner",0,"M",0,"dg;eol"],
 ["Sonic Research","Turbo Tuner ST-300",9,50,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["Sonic Research","Turbo Tuner ST-300 Mini",9,50,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["SoundLad Liverpool","Clean Machine V1.1",9,9,"2.1mm","CN","eq",1,"M",0,""],
 ["SoundLad Liverpool","Hungry Beaver V2",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["SoundLad Liverpool","NiceOne",9,30,"2.1mm","CN","drive",3,"M",0,""],
 ["SoundLad Liverpool","Scran 2",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["SoundLad Liverpool","Scran V1",9,6,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["SoundLad Liverpool","SKETCHY",9,250,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Source Audio","Aftershock Bass Distortion",9,165,"2.1mm","CN","drive",4,"S",1,""],
 ["Source Audio","Artifakt Lo-fi Elements",9,200,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Source Audio","Atlas Compressor",9,165,"2.1mm","CN","comp",0,"S",1,""],
 ["Source Audio","C4 Synth",9,165,"2.1mm","CN","synth",0,"S",1,"dg"],
 ["Source Audio","Collider Delay + Reverb",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Source Audio","EQ2 Programmable Equalizer",9,180,"2.1mm","CN","eq",0,"S",1,""],
 ["Source Audio","Gemini Chorus",9,165,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Source Audio","Kingmaker Fuzz",9,165,"2.1mm","CN","fuzz",5,"S",1,""],
 ["Source Audio","L.A. Lady Overdrive",9,165,"2.1mm","CN","drive",3,"S",1,""],
 ["Source Audio","Lunar Phaser",9,165,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Source Audio","Mercury Flanger",9,165,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Source Audio","Nemesis Delay (SA260)",9,200,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Source Audio","Nemesis Delay ADT",9,200,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Source Audio","Reflex Universal Expression",9,45,"2.1mm","CN","util",0,"M",0,""],
 ["Source Audio","Spectrum Intelligent Filter",9,165,"2.1mm","CN","filter",0,"S",1,""],
 ["Source Audio","True Spring Reverb",9,165,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Source Audio","Ultrawave Distortion Lab",9,165,"2.1mm","CN","drive",4,"S",1,""],
 ["Source Audio","Ventris Dual Reverb",9,280,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Source Audio","Vertigo Tremolo",9,165,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Source Audio","ZIO Analog Front End + Boost",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Spaceman Effects","Aphelion",9,9,"2.1mm","CN","drive",2,"M",0,""],
 ["Spaceman Effects","Artemis",9,72,"2.1mm","CN","filter",0,"M",0,""],
 ["Spaceman Effects","Delta II",9,45,"2.1mm","CN","mod",0,"M",0,""],
 ["Spaceman Effects","Explorer",9,51,"2.1mm","CN","mod",0,"M",0,""],
 ["Spaceman Effects","Gemini III",9,7,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Spaceman Effects","Gemini IV",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Spaceman Effects","Mission Control",9,29,"2.1mm","CN","util",0,"M",0,""],
 ["Spaceman Effects","Nebula",9,16,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Spaceman Effects","Orion",9,45,"2.1mm","CN","reverb",0,"M",0,""],
 ["Spaceman Effects","Polaris",9,17,"2.1mm","CN","filter",0,"M",0,""],
 ["Spaceman Effects","Saturn V",9,6,"2.1mm","CN","drive",1,"M",0,""],
 ["Spaceman Effects","Saturn VI",9,32,"2.1mm","CN","drive",1,"M",0,""],
 ["Spaceman Effects","Sputnik I",9,6,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Spaceman Effects","Sputnik II",9,6,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Spaceman Effects","Sputnik III",9,57,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Spaceman Effects","Titan II",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Spaceman Effects","Wow Signal",9,15,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Strymon","BigSky",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","BigSky MX",9,500,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","blueSky (V1)",9,250,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Strymon","blueSky V2",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","Brig",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","Brigadier",9,250,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Strymon","Canoga",9,50,"2.1mm","CN","fuzz",5,"S",0,"ff"],
 ["Strymon","Cloudburst",9,250,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","Compadre",9,150,"2.1mm","CN","comp",0,"M",1,""],
 ["Strymon","Conduit",9,50,"2.1mm","CN","util",0,"M",0,""],
 ["Strymon","Deco (V1)",9,250,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Strymon","Deco V2",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Strymon","DIG (V1)",9,250,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Strymon","DIG V2",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","EC-1",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","El Capistan (V1)",9,250,"2.1mm","CN","delay",0,"MS",0,"dg"],
 ["Strymon","El Capistan V2",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","Fairfax",9,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Strymon","Flint (V1)",9,250,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Strymon","Flint V2",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","Iridium",9,300,"2.1mm","CN","preamp",0,"MS",1,"amp"],
 ["Strymon","Lex (V1)",9,250,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Strymon","Lex V2",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Strymon","Mobius",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Strymon","NightSky",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Strymon","OB.1",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Strymon","Ola",9,250,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Strymon","Olivera",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","Orbit",9,250,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["Strymon","Riverside",9,250,"2.1mm","CN","drive",4,"M",1,""],
 ["Strymon","Sunset",9,250,"2.1mm","CN","drive",4,"M",1,""],
 ["Strymon","TimeLine",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","TimeLine MX",9,500,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","UltraViolet",9,250,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Strymon","Volante",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Strymon","Zelzah",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Suhr","Alexa",9,55,"2.1mm","CN","mod",0,"MS",0,""],
 ["Suhr","Discovery Analog Delay",18,220,"2.1mm","CN","delay",0,"S",0,""],
 ["Suhr","Eclipse",9,16,"2.1mm","CN","drive",4,"M",0,""],
 ["Suhr","Jack Rabbit",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Suhr","Koji Comp",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Suhr","Koko Boost",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Suhr","Koko Boost Reloaded",9,15,"2.1mm","CN","drive",1,"M",0,""],
 ["Suhr","Riot",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Suhr","Riot Mini",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Suhr","Riot Reloaded",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Suhr","Rufus",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Suhr","Rufus Reloaded",9,9,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Suhr","Shiba Drive",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Suhr","Shiba Drive Reloaded",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Suhr","Shiba Drive Reloaded Mini",9,8,"2.1mm","CN","drive",3,"M",0,""],
 ["Summer School Electronics","Class Reunion",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Summer School Electronics","Fuzz 101",9,10,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Summer School Electronics","Gus-Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Summer School Electronics","Gus-Plus",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Summer School Electronics","Middle School Chorus",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Summer School Electronics","Science Fair",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Supro","Boost (1303)",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Supro","Chorus (1307)",9,100,"2.1mm","CN","mod",0,"MS",0,""],
 ["Supro","Delay (1313)",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Supro","Drive (1305)",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Supro","Flanger (1309)",9,250,"2.1mm","CN","mod",0,"MS",0,""],
 ["Supro","Fuzz (1304)",9,20,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Supro","Tremolo (1310)",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Surfy Industries","Blossom Point",9,20,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Surfy Industries","StereoMaker",9,35,"2.1mm","CN","switcher",0,"MS",0,""],
 ["Surfy Industries","SurfyBear Classic",12,1000,"2.1mm","CN","reverb",0,"M",0,""],
 ["Surfy Industries","SurfyBear Compact Deluxe",12,200,"2.1mm","CN","reverb",0,"M",0,""],
 ["Surfy Industries","SurfyBear Metal",12,1000,"2.1mm","CN","reverb",0,"M",0,""],
 ["Surfy Industries","SurfyBear Studio",12,700,"2.1mm","CP","reverb",0,"S",0,""],
 ["Surfy Industries","SurfyFuzz",9,20,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Surfy Industries","SurfyMan",9,100,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Surfy Industries","SurfyTrem",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Surfy Industries","SurfyTrem Deluxe",9,30,"2.1mm","CN","mod",0,"S",0,""],
 ["Surfy Industries","SurfyVibe",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["T-Rex","Alberta",9,7,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Alberta II",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Bass Juice",9,14,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","Binson Echorec (T-Rex)",24,300,"2.0mm","CN","delay",0,"M",0,"dg"],
 ["T-Rex","Binson Stereophonica",24,350,"2.0mm","CN","delay",0,"S",1,"dg"],
 ["T-Rex","Bloody Mary",9,30,"2.1mm","CN","drive",5,"M",0,""],
 ["T-Rex","Comp-Nova",9,11,"2.1mm","CN","comp",0,"M",0,""],
 ["T-Rex","Creamer",9,70,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["T-Rex","Diva Drive",9,11,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Dr Swamp",9,13,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","Duck Tail",9,90,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["T-Rex","Fat Shuga",9,66,"2.1mm","CN","drive",1,"M",0,"dg"],
 ["T-Rex","Fuzztopia",9,60,"2.1mm","CN","fuzz",4,"M",0,""],
 ["T-Rex","Gristle King",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["T-Rex","Gull Wah",9,40,"2.1mm","CN","wah",0,"M",0,""],
 ["T-Rex","Hobo Drive",9,90,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Karma Boost",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["T-Rex","Luxury Drive",9,7,"2.1mm","CN","drive",1,"M",0,""],
 ["T-Rex","Mean Machine",9,26,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","Michael Angelo Batio Overdrive",9,7,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Moller",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Moller 2",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Mudhoney",9,6,"2.1mm","CN","fuzz",4,"M",0,""],
 ["T-Rex","Mudhoney II",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["T-Rex","NeoComp",9,24,"2.1mm","CN","comp",0,"M",0,""],
 ["T-Rex","Nitros Hyperdrive",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","Octavius",12,155,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["T-Rex","Quint Machine",9,145,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["T-Rex","Replay Box",9,110,"2.1mm","CN","looper",0,"M",0,"dg"],
 ["T-Rex","Replica (2022, 9V)",9,150,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["T-Rex","Replica (original, 12V)",12,300,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["T-Rex","Replicator",24,300,"2.1mm","CN","delay",0,"M",0,""],
 ["T-Rex","Replicator D'Luxe",12,300,"2.1mm","CN","delay",0,"M",0,""],
 ["T-Rex","Replicator Junior",12,200,"2.1mm","CN","delay",0,"M",0,""],
 ["T-Rex","Reptile",9,125,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["T-Rex","Reptile 2",9,120,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["T-Rex","Room-Mate",12,300,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["T-Rex","Room-Mate Junior",9,85,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["T-Rex","Shafter Wah",9,45,"2.1mm","CN","wah",0,"M",0,""],
 ["T-Rex","SoulMate",12,360,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["T-Rex","SoulMate Acoustic",12,560,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["T-Rex","SpinDoctor",12,1200,"2.1mm","CN","preamp",2,"M",0,""],
 ["T-Rex","Squeezer",12,260,"2.1mm","CN","comp",0,"M",0,""],
 ["T-Rex","Sweeper Bass Chorus",9,90,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["T-Rex","Tapster",9,90,"2.1mm","CN","util",0,"M",0,"dg"],
 ["T-Rex","Tonebug Booster",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["T-Rex","Tonebug Chorus+Flanger",9,75,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["T-Rex","Tonebug Distortion",9,7,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","Tonebug Fuzz",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["T-Rex","Tonebug Overdrive",9,7,"2.1mm","CN","drive",3,"M",0,""],
 ["T-Rex","Tonebug Phaser",9,75,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["T-Rex","Tonebug Reverb",9,75,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["T-Rex","Tonebug Sensewah",9,45,"2.1mm","CN","filter",0,"M",0,""],
 ["T-Rex","Tremonti Phase Shifter",9,85,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["T-Rex","Tremster",9,7,"2.1mm","CN","mod",0,"M",0,""],
 ["T-Rex","Tunemaster",9,68,"2.1mm","CN","tuner",0,"M",0,"dg"],
 ["T-Rex","Twinblaze",12,500,"2.1mm","CN","drive",4,"M",0,""],
 ["T-Rex","TwinBoost",9,33,"2.1mm","CN","drive",1,"M",0,""],
 ["T-Rex","Twister",9,85,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["T-Rex","Twister 2",9,85,"2.1mm","CN","mod",0,"MS",0,"dg"],
 ["T-Rex","Viper",12,165,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["T-Rex","Vulture",9,16,"2.1mm","CN","drive",4,"M",0,""],
 ["TC Electronic","3rd Dimension Chorus",9,25,"2.1mm","CN","mod",0,"M",0,""],
 ["TC Electronic","Aeon Infinite Sustainer",0,0,"none","NA","util",0,"M",0,""],
 ["TC Electronic","Afterglow Chorus",9,14,"2.1mm","CN","mod",0,"M",0,""],
 ["TC Electronic","Blood Moon Phaser",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["TC Electronic","Brainwaves Pitch Shifter",9,85,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["TC Electronic","Corona Chorus",9,75,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Corona Mini Chorus",9,68,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["TC Electronic","Crescendo Auto Swell",9,10,"2.1mm","CN","volume",0,"M",0,""],
 ["TC Electronic","Dark Matter Distortion",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["TC Electronic","Ditto Jam X2 Looper",9,150,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["TC Electronic","Ditto Looper",9,76,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["TC Electronic","Ditto Stereo Looper",9,100,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["TC Electronic","Ditto X2 Looper",9,100,"2.1mm","CN","looper",0,"S",0,"eol;dg"],
 ["TC Electronic","Ditto X4 Looper",9,300,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["TC Electronic","Ditto+ Looper",9,100,"2.1mm","CN","looper",0,"M",0,"eol;dg"],
 ["TC Electronic","Drip Spring Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["TC Electronic","El Mocambo Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["TC Electronic","Eyemaster Metal Distortion",9,10,"2.1mm","CN","drive",5,"M",0,""],
 ["TC Electronic","Fangs Metal Distortion",9,8,"2.1mm","CN","drive",5,"M",0,""],
 ["TC Electronic","Flashback 2 Delay",9,85,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["TC Electronic","Flashback 2 Mini",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["TC Electronic","Flashback Delay and Looper",9,86,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["TC Electronic","Flashback Mini",9,85,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["TC Electronic","Flashback Triple Delay",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["TC Electronic","Flashback X4 Delay",9,250,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["TC Electronic","Grand Magus Distortion",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["TC Electronic","Hall of Fame 2 Mini",9,74,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["TC Electronic","Hall of Fame 2 Reverb",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["TC Electronic","Hall of Fame 2 X4 Reverb",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["TC Electronic","Hall of Fame Mini",9,74,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["TC Electronic","Hall of Fame Reverb",9,90,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["TC Electronic","Helix Phaser",9,100,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Honey Pot Fuzz",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["TC Electronic","HyperGravity Compressor",9,65,"2.1mm","CN","comp",0,"S",0,""],
 ["TC Electronic","Mimiq Doubler",9,67,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","MojoMojo Overdrive",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["TC Electronic","Nova Delay ND-1",12,300,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["TC Electronic","Nova Drive NDR-1",12,380,"2.1mm","CN","drive",4,"M",1,""],
 ["TC Electronic","Nova Modulator NM-1",12,300,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Nova Repeater RPT-1",12,300,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["TC Electronic","Nova Reverb NR-1",12,300,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["TC Electronic","Pipeline Tap Tremolo",9,100,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Plethora X1",9,170,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["TC Electronic","Plethora X3",9,600,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["TC Electronic","Plethora X5",9,600,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["TC Electronic","PolyTune",9,46,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","PolyTune 2",9,45,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","PolyTune 3",9,44,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","PolyTune 3 Mini",9,100,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","PolyTune 3 Noir",9,100,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","PolyTune Mini",9,44,"2.1mm","CN","tuner",0,"M",0,""],
 ["TC Electronic","Quintessence Harmony",9,100,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["TC Electronic","Rusty Fuzz",9,7,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["TC Electronic","SCF Gold Stereo Chorus Flanger",9,150,"2.1mm","CN","mod",0,"MS",0,""],
 ["TC Electronic","SCF Stereo Chorus Flanger (vintage, mains cable)",0,0,"none","NA","mod",0,"MS",0,"eol"],
 ["TC Electronic","Sentry Noise Gate",9,75,"2.1mm","CN","gate",0,"S",0,""],
 ["TC Electronic","Shaker Mini Vibrato",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["TC Electronic","Shaker Vibrato",9,100,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Skysurfer Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["TC Electronic","Spark Booster",9,16,"2.1mm","CN","drive",1,"M",0,""],
 ["TC Electronic","Spark Mini Booster",9,40,"2.1mm","CN","drive",1,"M",0,""],
 ["TC Electronic","Sub'N'Up Mini Octaver",9,77,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["TC Electronic","Sub'N'Up Octaver",9,113,"2.1mm","CN","pitch",0,"S",0,"dg"],
 ["TC Electronic","Thunderstorm Flanger",9,5,"2.1mm","CN","mod",0,"M",0,""],
 ["TC Electronic","Tube Pilot Overdrive",9,400,"2.1mm","CN","drive",3,"M",0,""],
 ["TC Electronic","Vortex Flanger",9,80,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["TC Electronic","Vortex Mini Flanger",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["TC Electronic","Zeus Drive",9,5,"2.1mm","CN","drive",2,"M",0,""],
 ["Tech 21","Acoustic Fly Rig",9,100,"2.1mm","CN","multi",1,"M",0,"dg"],
 ["Tech 21","Bass Compactor",9,11,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Tech 21","Bass Fly Rig (v1)",9,100,"2.1mm","CN","multi",3,"M",0,"dg;eol"],
 ["Tech 21","Bass Fly Rig v2",9,100,"2.1mm","CN","multi",3,"M",0,"dg"],
 ["Tech 21","Boost Chorus",9,50,"2.1mm","CN","mod",0,"M",0,"dg;eol"],
 ["Tech 21","Boost DLA",9,50,"2.1mm","CN","delay",0,"M",0,"dg;eol"],
 ["Tech 21","Boost RVB",9,51,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Tech 21","Character Blonde",9,5,"2.1mm","CN","preamp",3,"M",0,"amp;eol"],
 ["Tech 21","Character British",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","Character California",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","Character Leeds",9,5,"2.1mm","CN","preamp",3,"M",0,"amp;eol"],
 ["Tech 21","Character Liverpool",9,5,"2.1mm","CN","preamp",3,"M",0,"amp;eol"],
 ["Tech 21","Character Oxford",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","Character Plus American Woman",9,10,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","Character Plus English Muffy",9,55,"2.1mm","CN","preamp",5,"M",0,"amp"],
 ["Tech 21","Character Plus Fuzzy Brit",9,55,"2.1mm","CN","preamp",5,"M",0,"amp"],
 ["Tech 21","Character Plus Mop Top Liverpool",9,55,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","Character Plus Screaming Blonde",9,55,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","Character US Steel",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","Comptortion",9,12,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Tech 21","Double Drive",9,5,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Tech 21","dUg Pinnick DP-3X",9,100,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Tech 21","Fly Rig 5 (v1)",12,100,"2.1mm","CN","multi",4,"M",0,"dg;eol"],
 ["Tech 21","Fly Rig 5 v2",9,150,"2.1mm","CN","multi",4,"M",0,"dg"],
 ["Tech 21","Hot Rod Plexi",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","MIDI Mongoose",9,15,"batt","NA","switcher",0,"M",1,""],
 ["Tech 21","MIDI Mouse",9,5,"batt","NA","switcher",0,"M",1,""],
 ["Tech 21","PL1 Paul Landers Fly Rig",9,92,"2.1mm","CN","multi",4,"M",0,"dg"],
 ["Tech 21","Q-Strip",9,5,"2.1mm","CN","eq",0,"M",0,""],
 ["Tech 21","Red Ripper",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Tech 21","Richie Kotzen OMG",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Tech 21","RK5 Richie Kotzen Fly Rig (v1)",12,100,"2.1mm","CN","multi",4,"M",0,"dg;eol"],
 ["Tech 21","RK5 Richie Kotzen Fly Rig v2",9,150,"2.1mm","CN","multi",4,"M",0,"dg"],
 ["Tech 21","SansAmp Bass Driver DI",9,6,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Tech 21","SansAmp Classic",9,6,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","SansAmp GT2",9,4,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Tech 21","SansAmp Para Driver DI",9,5,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Tech 21","SansAmp Programmable Bass Driver DI",9,7,"2.1mm","CN","preamp",2,"M",0,"amp"],
 ["Tech 21","SansAmp PSA 2.0",9,70,"2.1mm","CN","preamp",4,"M",0,"amp"],
 ["Tech 21","SansAmp Tri-A.C.",9,5,"2.1mm","CN","preamp",4,"M",0,"amp;eol"],
 ["Tech 21","SansAmp VT Bass DI",9,6,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","SansAmp YYZ Geddy Lee Signature",9,21,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","Steve Harris SH1",9,60,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Tech 21","XXL",9,6,"2.1mm","CN","drive",4,"M",0,"eol"],
 ["The Audio Kitchen","Fake Plastic Trees",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["The Audio Kitchen","The Big Trees",0,0,"none","NA","preamp",3,"M",0,"amp"],
 ["The Audio Kitchen","The Small Trees",12,1000,"2.1mm","CN","drive",1,"M",0,""],
 ["The Audio Kitchen","The Small Trees DI",12,1000,"2.1mm","CN","util",1,"M",0,""],
 ["TheGigRig","ABY-BABY",9,150,"2.1mm","CN","util",0,"MS",0,""],
 ["TheGigRig","Cinco Cinco",0,0,"none","NA","util",0,"M",0,""],
 ["TheGigRig","FSL Footswitch",0,0,"none","NA","util",0,"M",0,""],
 ["TheGigRig","FSM / Bank Manager",0,0,"none","NA","util",0,"M",0,""],
 ["TheGigRig","G2",9,850,"2.1mm","CN","switcher",0,"S",1,""],
 ["TheGigRig","G3",9,850,"2.1mm","CN","switcher",0,"S",1,""],
 ["TheGigRig","G3 Atom",9,850,"2.1mm","CN","switcher",0,"S",1,""],
 ["TheGigRig","G3S",9,850,"2.1mm","CN","switcher",0,"S",1,""],
 ["TheGigRig","G3S Atom",9,850,"2.1mm","CN","switcher",0,"S",1,""],
 ["TheGigRig","GrumpyBot Buffer",9,20,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","Guitar Tech",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","HumDinger",9,100,"2.1mm","CN","util",0,"S",0,""],
 ["TheGigRig","LatchMo",9,40,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","LatchMo 2",9,80,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","MIDI Cinco",0,0,"none","NA","util",0,"M",1,""],
 ["TheGigRig","MIDI Driver",9,20,"2.1mm","CN","util",0,"M",1,""],
 ["TheGigRig","MIDI-8",9,1000,"2.1mm","CN","util",0,"M",1,""],
 ["TheGigRig","More or Less",9,150,"2.1mm","CN","volume",0,"M",0,""],
 ["TheGigRig","PLUS2",9,100,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","PLUS4",9,200,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","QuarterMaster QMX-10",9,500,"2.1mm","CN","switcher",0,"M",0,""],
 ["TheGigRig","QuarterMaster QMX-4",9,200,"2.1mm","CN","switcher",0,"M",0,""],
 ["TheGigRig","QuarterMaster QMX-6",9,300,"2.1mm","CN","switcher",0,"M",0,""],
 ["TheGigRig","QuarterMaster QMX-8",9,400,"2.1mm","CN","switcher",0,"M",0,""],
 ["TheGigRig","Remote Loopy 2",9,220,"2.1mm","CN","switcher",0,"M",0,""],
 ["TheGigRig","RemoteX4",0,0,"none","NA","util",0,"M",0,""],
 ["TheGigRig","Three2One",9,150,"2.1mm","CN","util",0,"M",0,""],
 ["TheGigRig","Wet/Dry Machine",9,200,"2.1mm","CN","util",0,"MS",0,""],
 ["TheGigRig","Wetter Box (WBX)",9,185,"2.1mm","CN","util",0,"MS",0,""],
 ["Thermion","Black Sun",9,200,"2.1mm","CN","mod",0,"M",0,""],
 ["Thermion","Breakthru",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Thermion","Breathe",9,350,"2.1mm","CN","multi",1,"M",0,"dg"],
 ["Thermion","Freeway",9,500,"2.1mm","CN","preamp",1,"S",0,"amp"],
 ["Thermion","Gasoline",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Thermion","Heartbreaker",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Thermion","Outlaw",9,100,"2.1mm","CN","delay",1,"M",0,""],
 ["Thermion","PowerDrive",9,20,"2.1mm","CN","drive",3,"M",0,""],
 ["Thermion","PowerMuff",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Thermion","PowerTrem",9,35,"2.1mm","CN","mod",0,"M",0,""],
 ["Thermion","PowerVibe",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["Thermion","Stone Age",9,50,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Thermion","Uprising",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["Thermion","Zero",0,0,"none","NA","preamp",1,"S",0,"amp"],
 ["ThorpyFX","Camoflange",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["ThorpyFX","Chain Home",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["ThorpyFX","Deep Oggin",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["ThorpyFX","Electric Lightning",12,300,"2.1mm","CN","drive",3,"M",0,""],
 ["ThorpyFX","Fallout Cloud",9,20,"2.1mm","CN","fuzz",5,"M",0,""],
 ["ThorpyFX","Field Marshal",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["ThorpyFX","Gunshot",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["ThorpyFX","Heavy Water",9,24,"2.1mm","CN","drive",1,"M",0,""],
 ["ThorpyFX","Peacekeeper",9,25,"2.1mm","CN","drive",2,"M",0,""],
 ["ThorpyFX","Pulse Doppler",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["ThorpyFX","Scarlet Tunic",9,30,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["ThorpyFX","Team Medic",9,35,"2.1mm","CN","drive",1,"M",0,""],
 ["ThorpyFX","The Dane",9,34,"2.1mm","CN","drive",3,"M",0,""],
 ["ThorpyFX","The Dane MkII",9,34,"2.1mm","CN","drive",3,"M",0,""],
 ["ThorpyFX","Veteran",9,20,"2.1mm","CN","fuzz",4,"M",0,"ff"],
 ["ThorpyFX","Warthog",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["True North Pedals","Northern Lights Boost",9,10,"2.1mm","CN","drive",1,"M",0,"ff"],
 ["True North Pedals","The Lumberjack",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["True North Pedals","Tweed Deluxe",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["True North Pedals","Tweed Drive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["True North Pedals","Tweed Drive P.I.O.",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["True North Pedals","Tweed Jr.",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Truetone","GarageTone Axle Grease Delay",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Truetone","GarageTone Chainsaw Distortion",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Truetone","GarageTone Drivetrain Overdrive",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Truetone","GarageTone Oil Can Phaser",9,10,"2.1mm","CN","mod",0,"M",0,""],
 ["Truetone","GarageTone Tremolo",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Truetone","Open Road (V2)",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Truetone","Son of Hyde (V2)",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Truetone","V3 Dual Tap Delay",9,120,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Truetone","V3 H2O",9,56,"2.1mm","CN","multi",0,"M",0,"dg"],
 ["Truetone","V3 Jekyll & Hyde",9,49,"2.1mm","CN","drive",4,"M",0,""],
 ["Truetone","V3 Route 66",9,44,"2.1mm","CN","drive",3,"M",0,""],
 ["Truetone","V3 Tap Delay",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Truetone","V3 VS-XO Dual Overdrive",9,38,"2.1mm","CN","drive",3,"M",0,""],
 ["Universal Audio","1176 Studio Compressor",9,250,"2.1mm","CN","comp",0,"M",0,""],
 ["Universal Audio","ANTI 1992 High Gain Amp",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Universal Audio","Astra Modulation Machine",9,400,"2.1mm","CN","mod",0,"S",0,"dg"],
 ["Universal Audio","Del-Verb Ambience Companion",9,400,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Universal Audio","Dream '65 Reverb Amplifier",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Universal Audio","Evermore Studio Reverb",9,250,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Universal Audio","Galaxy '74 Tape Echo & Reverb",9,400,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Universal Audio","Golden Reverberator",9,400,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Universal Audio","Heavenly Plate Reverb",9,250,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Universal Audio","Knuckles '92 Rev F Dual Rec Amplifier",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Universal Audio","Lion '68 Super Lead Amp",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Universal Audio","Max Preamp & Dual Compressor",9,400,"2.1mm","CN","comp",0,"S",0,""],
 ["Universal Audio","Orion Tape Echo",9,250,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Universal Audio","Ruby '63 Top Boost Amplifier",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Universal Audio","Starlight Echo Station",9,400,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["Universal Audio","Woodrow '55 Instrument Amplifier",9,400,"2.1mm","CN","preamp",0,"S",0,"amp"],
 ["Vahlbruch","6-PHI-4 Phaser",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Vahlbruch","BBQ Buffer/Boost/EQ",9,40,"2.1mm","CN","eq",1,"M",0,""],
 ["Vahlbruch","BBQ-XL Buffer/Boost/EQ",9,50,"2.1mm","CN","eq",1,"M",0,""],
 ["Vahlbruch","Chorus",9,50,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Vahlbruch","Chorus Acoustic",9,40,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Vahlbruch","Fusionizer Compressor",9,15,"2.1mm","CN","comp",0,"M",0,"eol"],
 ["Vahlbruch","Jewel Drive",9,20,"2.1mm","CN","drive",2,"M",0,"eol"],
 ["Vahlbruch","Kaluna II HV Tube Drive",9,500,"2.1mm","CN","drive",3,"M",0,""],
 ["Vahlbruch","Line Driver",9,10,"2.1mm","CN","util",0,"MS",0,"eol"],
 ["Vahlbruch","Midboost",9,10,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Vahlbruch","Octavia (v1)",9,10,"2.1mm","CN","fuzz",5,"M",0,"eol"],
 ["Vahlbruch","Octavia v2 Fuzz/Octa",9,40,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Vahlbruch","Opto Trem",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Vahlbruch","Phaser (v1)",9,40,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Vahlbruch","Pion-Plus Booster",9,10,"2.1mm","CN","drive",1,"M",0,"eol"],
 ["Vahlbruch","Pipeline (v1) Spring Reverb",9,70,"2.1mm","CN","reverb",0,"M",0,"dg;eol"],
 ["Vahlbruch","Pipeline v2 Reverb",9,90,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Vahlbruch","Quantum Opto Compressor",9,40,"2.1mm","CN","comp",0,"M",0,""],
 ["Vahlbruch","Sapphire Drive",9,20,"2.1mm","CN","drive",3,"M",0,"eol"],
 ["Vahlbruch","SpaceTime Tap v2",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Vahlbruch","SpaceTime v3 Delay/Echo",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Vahlbruch","Twin Tremolo",9,20,"2.1mm","CN","mod",0,"M",0,"eol"],
 ["Vahlbruch","Xroads ABY Switch",9,30,"2.1mm","CN","switcher",0,"MS",0,""],
 ["Vemuram","Budi-G",9,2,"2.1mm","CN","drive",1,"M",0,""],
 ["Vemuram","Butter Machine",9,13,"2.1mm","CN","drive",4,"M",0,""],
 ["Vemuram","Galea",9,11,"2.1mm","CN","drive",2,"M",0,""],
 ["Vemuram","Jan Ray",9,6,"2.1mm","CN","drive",2,"M",0,""],
 ["Vemuram","Myriad Fuzz",9,2,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Vemuram","Rage E",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Vemuram","Shanks 4K",9,2,"2.1mm","CN","fuzz",3,"M",0,"ff"],
 ["Vemuram","Shanks ODS-1",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Victory","V1 The Copper",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["Victory","V1 The Duchess",9,16,"2.1mm","CN","drive",2,"M",0,""],
 ["Victory","V1 The Jack",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["Victory","V1 The Kraken",9,18,"2.1mm","CN","drive",4,"M",0,""],
 ["Victory","V1 The Sheriff",9,18,"2.1mm","CN","drive",3,"M",0,""],
 ["Victory","V4 The Copper",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Victory","V4 The Countess",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Victory","V4 The Duchess",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Victory","V4 The Jack",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Victory","V4 The Kraken",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Victory","V4 The Sheriff",12,800,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Voodoo Lab","Ground Control Pro",0,0,"none","NA","util",0,"M",0,""],
 ["Voodoo Lab","HEX",9,100,"2.1mm","CN","switcher",0,"M",0,""],
 ["Voodoo Lab","PX-8 Plus",9,100,"2.1mm","CN","switcher",0,"M",0,""],
 ["VOX","Big Bad Wah (Satriani)",9,4,"2.1mm","CN","wah",0,"M",0,""],
 ["VOX","Copperhead Drive (Valvenergy)",9,95,"2.1mm","CN","drive",4,"M",0,""],
 ["VOX","Cutting Edge (Valvenergy)",9,95,"2.1mm","CN","drive",4,"M",0,""],
 ["VOX","DelayLab",9,200,"2.1mm","CN","delay",0,"S",0,"dg"],
 ["VOX","Double Deca Delay (Tone Garage)",9,36,"2.1mm","CN","delay",0,"M",0,""],
 ["VOX","Flat 4 Boost (Tone Garage)",9,240,"2.1mm","CN","drive",1,"M",0,""],
 ["VOX","Fuel Injector (Valvenergy)",9,95,"2.1mm","CN","drive",3,"M",0,""],
 ["VOX","Ice 9 Overdrive (Satriani)",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["VOX","Mystic Edge (Valvenergy)",9,95,"2.1mm","CN","drive",3,"M",0,""],
 ["VOX","Power Burst (Valvenergy)",9,95,"2.1mm","CN","drive",1,"M",0,""],
 ["VOX","Satchurator (Satriani)",9,24,"2.1mm","CN","drive",4,"M",0,""],
 ["VOX","Silk Drive (Valvenergy)",9,95,"2.1mm","CN","drive",2,"M",0,""],
 ["VOX","Smooth Impact (Valvenergy)",9,95,"2.1mm","CN","comp",0,"M",0,""],
 ["VOX","StompLab IB",9,150,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["VOX","StompLab IG",9,150,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["VOX","StompLab IIB",9,150,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["VOX","StompLab IIG",9,150,"2.1mm","CN","multi",0,"MS",0,"dg"],
 ["VOX","Straight 6 Overdrive (Tone Garage)",9,240,"2.1mm","CN","drive",3,"M",0,""],
 ["VOX","Time Machine (Satriani)",9,60,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["VOX","Trike Fuzz (Tone Garage)",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["VOX","V845 Classic Wah",9,1,"2.1mm","CN","wah",0,"M",0,""],
 ["VOX","V846-HW Hand-Wired Wah",9,1,"batt","NA","wah",0,"M",0,""],
 ["VOX","V847 Wah (original, no DC jack)",9,1,"batt","NA","wah",0,"M",0,"eol"],
 ["VOX","V847-A Wah",9,1,"2.1mm","CN","wah",0,"M",0,""],
 ["Vs Audio","Aftermath",9,40,"2.1mm","CN","drive",4,"M",0,""],
 ["Vs Audio","Alchemy MKII",9,100,"2.1mm","CN","mod",0,"MS",0,""],
 ["Vs Audio","BlackBird",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Vs Audio","BlackBird Deluxe",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Vs Audio","Golden Royal Flush",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Vs Audio","JangleMaster",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Vs Audio","Pandora",9,100,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["Vs Audio","Platinum",9,100,"2.1mm","CN","preamp",3,"M",0,"amp"],
 ["Vs Audio","Project Diana",9,100,"2.1mm","CN","delay",0,"MS",0,""],
 ["Vs Audio","Royal Flush",9,25,"2.1mm","CN","drive",3,"M",0,""],
 ["Vs Audio","Royal Flush+",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Vs Audio","Straight Flush",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Vs Audio","Vibler",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","385 Overdrive",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Walrus Audio","385 Overdrive MkII",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Walrus Audio","Ages Five-State Overdrive",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Walrus Audio","ARP-87 Multi-Function Delay",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Walrus Audio","Badwater Bass Preamp & D.I.",9,300,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Walrus Audio","Bellwether Analog Delay",9,100,"2.1mm","CN","delay",0,"M",0,""],
 ["Walrus Audio","Canvas Clock",9,300,"2.1mm","CN","util",0,"M",1,""],
 ["Walrus Audio","Canvas Line Isolator/D.I.",0,0,"none","NA","util",0,"M",0,""],
 ["Walrus Audio","Canvas Passive Re-Amp",0,0,"none","NA","util",0,"M",0,""],
 ["Walrus Audio","Canvas Rehearsal",9,300,"2.1mm","CN","util",0,"MS",1,""],
 ["Walrus Audio","Canvas Stereo Dual Line Isolator/D.I.",0,0,"none","NA","util",0,"S",0,""],
 ["Walrus Audio","Canvas Tuner",9,300,"2.1mm","CN","tuner",0,"M",0,""],
 ["Walrus Audio","Canvas Volume Pedal",9,300,"2.1mm","CN","volume",0,"M",0,""],
 ["Walrus Audio","Deep Six Compressor (V1)",9,9,"2.1mm","CN","comp",0,"M",0,""],
 ["Walrus Audio","Deep Six Compressor V3",9,40,"2.1mm","CN","comp",0,"M",0,""],
 ["Walrus Audio","Descent Reverb/Octave Machine",9,130,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","DFX-1 Percussion Processing Unit",9,500,"2.1mm","CN","multi",0,"M",1,"dg"],
 ["Walrus Audio","EB-10 Preamp/EQ/Boost",9,100,"2.1mm","CN","eq",0,"M",0,""],
 ["Walrus Audio","Emissary Parallel Boost",9,100,"2.1mm","CN","drive",1,"M",0,""],
 ["Walrus Audio","Eons Five-State Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Eras Five-State Distortion",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Walrus Audio","Fable Granular Soundscape Generator",9,300,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Walrus Audio","Fathom Multi-Function Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Ambient",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Chorus",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Delay",9,100,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Distortion",9,100,"2.1mm","CN","drive",4,"M",0,""],
 ["Walrus Audio","Fundamental Drive",9,100,"2.1mm","CN","drive",3,"M",0,""],
 ["Walrus Audio","Fundamental Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Fundamental Phaser",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Fundamental Tremolo",9,100,"2.1mm","CN","mod",0,"M",0,"dg"],
 ["Walrus Audio","Highpoint Optical Compressor",9,500,"2.1mm","CN","comp",0,"M",0,""],
 ["Walrus Audio","Iron Horse LM308 Distortion V2",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Walrus Audio","Iron Horse LM308 Distortion V3",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Walrus Audio","Janus Fuzz/Tremolo",9,8,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Julia Analog Chorus/Vibrato (V1)",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Julia Analog Chorus/Vibrato V2",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Julianna Deluxe Chorus/Vibrato",9,100,"2.1mm","CN","mod",0,"S",0,""],
 ["Walrus Audio","Jupiter Multi-Clip Fuzz V2",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Kangra Filter Fuzz",9,100,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Lillian Multi-Stage Analog Phaser",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Lore Reverse Soundscape Generator",9,300,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Lüm Texture Engine",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Luminary Quad Octave Generator (V1)",9,250,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Walrus Audio","Luminary Quad Octave Generator V2",9,300,"2.1mm","CN","pitch",0,"M",0,"dg"],
 ["Walrus Audio","Mako ACS1 Amp+Cab Simulator (MkI)",9,300,"2.1mm","CN","preamp",0,"S",1,"amp"],
 ["Walrus Audio","Mako ACS1 Amp+Cab Simulator MkII",9,300,"2.1mm","CN","preamp",0,"S",1,"amp"],
 ["Walrus Audio","Mako D1 High-Fidelity Delay (MkI)",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Walrus Audio","Mako D1 High-Fidelity Delay MkII",9,300,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Walrus Audio","Mako M1 Modulation Machine (MkI)",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Walrus Audio","Mako M1 Modulation Machine MkII",9,300,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Walrus Audio","Mako R1 High-Fidelity Reverb (MkI)",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Walrus Audio","Mako R1 High-Fidelity Reverb MkII",9,300,"2.1mm","CN","reverb",0,"S",1,"dg"],
 ["Walrus Audio","Mantle Analog Bass Preamp/D.I.",9,500,"2.1mm","CN","preamp",0,"M",0,"amp"],
 ["Walrus Audio","Mayflower Overdrive",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Walrus Audio","Melee Wall of Noise",9,200,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Meraki Stereo Analog Dual Delay",9,500,"2.1mm","CN","delay",0,"S",1,""],
 ["Walrus Audio","Messner Overdrive",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Walrus Audio","Mira Optical Compressor",9,200,"2.1mm","CN","comp",0,"M",0,""],
 ["Walrus Audio","Monument Harmonic Tap Tremolo (V1)",9,40,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Monument Harmonic Tap Tremolo V2",9,100,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Monumental Harmonic Stereo Tremolo",9,100,"2.1mm","CN","mod",0,"S",0,""],
 ["Walrus Audio","Polychrome Analog Flanger",9,50,"2.1mm","CN","mod",0,"M",0,""],
 ["Walrus Audio","Qi Etherealizer",9,300,"2.1mm","CN","multi",0,"S",1,"dg"],
 ["Walrus Audio","Silt Harmonic Fuzz",9,300,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Walrus Audio","Slö Multi Texture Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Slöer Stereo Ambient Reverb",9,100,"2.1mm","CN","reverb",0,"S",0,"dg"],
 ["Walrus Audio","Slötvå Multi Texture Reverb",9,100,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Walrus Audio","Voyager Preamp/Overdrive",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Walrus Audio","Voyager Preamp/Overdrive MkII",9,100,"2.1mm","CN","drive",2,"M",0,""],
 ["Walrus Audio","Warhorn Mid-Range Overdrive",9,9,"2.1mm","CN","drive",2,"M",0,""],
 ["Walrus Audio","Xero Polylooper",9,300,"2.1mm","CN","looper",0,"S",1,"eol;dg"],
 ["Wampler","Andy Wood Gearbox",9,52,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Belle",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Wampler","Black '65",9,9,"2.1mm","CN","drive",2,"M",0,""],
 ["Wampler","Brent Mason Hot Wired v2",9,28,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Brent Mason ReWired",9,40,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Catacombs",9,130,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Wampler","cataPulp",9,27,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Clarksdale",9,28,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Claymore",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Wampler","Cory Wong Compressor",9,30,"2.1mm","CN","comp",0,"M",0,""],
 ["Wampler","Cranked AC",0,0,"none","NA","drive",3,"M",0,""],
 ["Wampler","Cryptid Fuzz",9,30,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Wampler","dB+ Boost/Independent Buffer",9,19,"2.1mm","CN","drive",1,"M",0,""],
 ["Wampler","Dracarys",9,31,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Ego 76 Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Wampler","Ego Compressor",9,22,"2.1mm","CN","comp",0,"M",0,""],
 ["Wampler","Equator",9,32,"2.1mm","CN","eq",0,"M",0,""],
 ["Wampler","Ethereal",9,68,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Wampler","Euphoria",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Faux Tape Echo",9,32,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Wampler","Faux Tape Echo v2",9,40,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Wampler","Fuzztration",9,24,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Wampler","Germanium Tumnus",9,19,"2.1mm","CN","drive",2,"M",0,""],
 ["Wampler","Germanium Tumnus Deluxe",9,80,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Golden Jubilee",9,30,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Latitude Deluxe Tremolo",9,30,"2.1mm","CN","mod",0,"M",0,""],
 ["Wampler","Latitude Standard Tremolo",9,34,"2.1mm","CN","mod",0,"M",0,""],
 ["Wampler","Low Blow Bass Overdrive",9,53,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Metaverse",9,130,"2.1mm","CN","delay",0,"S",1,"dg"],
 ["Wampler","Mini Ego 76 Compressor",9,20,"2.1mm","CN","comp",0,"M",0,""],
 ["Wampler","Mini Ego Compressor",9,22,"2.1mm","CN","comp",0,"M",0,""],
 ["Wampler","Mini Faux Spring Reverb",9,70,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Wampler","Mofetta",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Moxie",9,16,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Paisley Deluxe",9,40,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Paisley Drive",9,17,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Pantheon",9,19,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Pantheon Deluxe",9,55,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Phenom",9,5,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Pinnacle Deluxe v2",9,23,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Pinnacle Standard",9,10,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Plexi-Drive",9,22,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Plexi-Drive Deluxe",9,34,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Plexi-Drive Mini",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Plextortion",9,12,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Ratsbane",9,4,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Reflection",9,78,"2.1mm","CN","reverb",0,"M",0,"dg"],
 ["Wampler","Sovereign",9,17,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Syntax",9,20,"2.1mm","CN","util",0,"M",1,""],
 ["Wampler","tcd",9,25,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Terraform",9,155,"2.1mm","CN","mod",0,"S",1,"dg"],
 ["Wampler","The Doctor Lo-Fi Delay",9,63,"2.1mm","CN","delay",0,"M",0,"dg"],
 ["Wampler","The Fearbox",9,52,"2.1mm","CN","drive",4,"M",0,""],
 ["Wampler","Thirty Something",9,21,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Tom Quayle Dual Fusion",9,24,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Triple Wreck",9,23,"2.1mm","CN","drive",5,"M",0,""],
 ["Wampler","Triumph",9,21,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Tumnus",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["Wampler","Tumnus Deluxe",9,71,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Tweed '57",9,9,"2.1mm","CN","drive",3,"M",0,""],
 ["Wampler","Velvet Fuzz",9,23,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Way Huge","WHE202 Green Rhino MkII",9,17,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WHE203 Red Llama MkII",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WHE205 Saucy Box",9,15,"2.1mm","CN","drive",2,"M",0,""],
 ["Way Huge","WHE207 Green Rhino MkIV",9,19,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WHE208 Overrated Special",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WHE401 Swollen Pickle MkII/MkIIS",9,4,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Way Huge","WHE601 Blue Hippo MkII",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Way Huge","WHE701 Aqua-Puss MkII",9,16,"2.1mm","CN","delay",0,"M",0,""],
 ["Way Huge","WHE707 Supa-Puss Analog Delay",9,43,"2.1mm","CN","delay",0,"M",0,""],
 ["Way Huge","WM20 Smalls Conspiracy Theory",9,19,"2.1mm","CN","drive",2,"M",0,""],
 ["Way Huge","WM22 Smalls Green Rhino MkV",9,19,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WM23 Smalls Red Llama MkIII",9,10,"2.1mm","CN","drive",3,"M",0,""],
 ["Way Huge","WM41 Smalls Swollen Pickle",9,3,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Way Huge","WM61 Smalls Blue Hippo MkIII",9,12,"2.1mm","CN","mod",0,"M",0,""],
 ["Way Huge","WM71 Smalls Aqua-Puss MkIII",9,16,"2.1mm","CN","delay",0,"M",0,""],
 ["Way Huge","WM81 Smalls Stone Burner Sub Atomic Fuzz",9,8,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Way Huge","WM92 Smalls Attack Vector Phaser/Envelope",9,8,"2.1mm","CN","mod",0,"M",0,""],
 ["Wren and Cuff","Ace Octave Fuzz",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","ANNA (Claudio Sanchez)",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Blue-Violet Caprid OG",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Blue-Violet Caprid Small Foot",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Box of War OG Reissue",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Box of War Small Foot",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Caprid Small Foot",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","De La Riva BM20-Ultra",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Elephant Skin",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Eye See '78",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Eye See '78 OG",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Eye See Pi",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Fade Font '94",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Wren and Cuff","Forest for the Trees",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Hangman-2D",9,8,"2.1mm","CN","drive",4,"M",0,""],
 ["Wren and Cuff","J Mascis Garbage Face",9,8,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Wren and Cuff","J Mascis Garbage Face Jr",9,5,"2.1mm","CN","fuzz",5,"M",0,""],
 ["Wren and Cuff","Mercy Phuk",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Wren and Cuff","OG Caprid",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Phat Phuk B V2",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["Wren and Cuff","Phat Phuk G",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Wren and Cuff","Pickle Pie B",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Super Russian",9,8,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Suppa Phat Phuk",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Wren and Cuff","Tall Font Russian",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","The Good One",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Tri Pie '70",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Two-Five Drive Boost",9,8,"2.1mm","CN","drive",2,"M",0,""],
 ["Wren and Cuff","Violet World",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","White Elk Small Foot",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Wren and Cuff","Your Face 60's",9,5,"2.1mm","CP","fuzz",4,"M",0,"ff"],
 ["Wren and Cuff","Your Face 70's",9,5,"2.1mm","CN","fuzz",4,"M",0,""],
 ["Xotic","AC Booster",9,10,"2.1mm","CN","drive",2,"M",0,""],
 ["Xotic","BB Preamp",9,6,"2.1mm","CN","drive",3,"M",0,""],
 ["Xotic","BB Preamp MB",9,15,"2.1mm","CN","drive",3,"M",0,""],
 ["Xotic","EP Booster",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Xotic","RC Booster Classic",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Xotic","RC Booster Scott Henderson",9,5,"2.1mm","CN","drive",1,"M",0,""],
 ["Xotic","RC Booster V2",9,6,"2.1mm","CN","drive",1,"M",0,""],
 ["Xotic","SL Drive",9,5,"2.1mm","CN","drive",3,"M",0,""],
 ["Xotic","Soul Driven",9,4,"2.1mm","CN","drive",2,"M",0,""],
 ["Xotic","SP Compressor",9,5,"2.1mm","CN","comp",0,"M",0,""],
 ["Xotic","Super Clean Buffer",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Xotic","Wah XW-1",9,5,"2.1mm","CN","wah",0,"M",0,""],
 ["Xotic","Wah XW-2",9,5,"2.1mm","CN","wah",0,"M",0,""],
 ["Xotic","X-Blender",9,5,"2.1mm","CN","util",0,"M",0,""],
 ["Xvive","U2 Receiver",0,0,"none","NA","util",0,"M",0,""],
 ["Yamaha","FC7",0,0,"none","NA","util",0,"M",0,""],
 ["ZVEX","'59 Sound",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["ZVEX","Basstortion",9,2,"2.1mm","CN","drive",3,"M",0,""],
 ["ZVEX","Box of Rock",9,3,"2.1mm","CN","drive",3,"M",0,""],
 ["ZVEX","Channel 2",9,10,"2.1mm","CN","drive",1,"M",0,""],
 ["ZVEX","Distortron",9,2,"2.1mm","CN","drive",3,"M",0,""],
 ["ZVEX","Double Rock",9,2,"2.1mm","CN","drive",4,"M",0,""],
 ["ZVEX","Fat Fuzz Factory",9,4,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ZVEX","Fuzz Factory",9,3,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ZVEX","Fuzz Factory 7",9,50,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ZVEX","Fuzz Probe",9,20,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ZVEX","Fuzzolo",9,10,"2.1mm","CN","fuzz",5,"M",0,""],
 ["ZVEX","Instant Lo-Fi Junky",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["ZVEX","Jonny Octave",9,5,"2.1mm","CN","pitch",1,"M",0,""],
 ["ZVEX","Lo-Fi Loop Junky",9,12,"2.1mm","CN","looper",0,"M",0,""],
 ["ZVEX","Machine",9,10,"2.1mm","CN","fuzz",4,"M",0,""],
 ["ZVEX","Mastotron",9,1,"2.1mm","CN","fuzz",5,"M",0,""],
 ["ZVEX","Octane 3",9,4,"2.1mm","CN","fuzz",4,"M",0,""],
 ["ZVEX","Sonar",9,10,"2.1mm","CN","mod",1,"M",0,""],
 ["ZVEX","Super Duper 2-in-1",9,20,"2.1mm","CN","drive",2,"M",0,""],
 ["ZVEX","Super Hard On (SHO)",9,20,"2.1mm","CN","drive",1,"M",0,""],
 ["ZVEX","Super Ringtone",9,100,"2.1mm","CN","mod",0,"M",1,""],
 ["ZVEX","Super Seek Trem",9,100,"2.1mm","CN","mod",0,"M",1,""],
 ["ZVEX","Super Seek Wah",9,100,"2.1mm","CN","wah",0,"M",1,""],
 ["ZVEX","Tremolo Probe",9,20,"2.1mm","CN","mod",0,"M",0,""],
 ["ZVEX","Vertical Fuzz Factory",9,3,"2.1mm","CN","fuzz",5,"M",0,"ff"],
 ["ZVEX","Wah Probe",9,20,"2.1mm","CN","wah",1,"M",0,""],
 ["ZVEX","Woolly Mammoth",9,1,"2.1mm","CN","fuzz",5,"M",0,"ff"],
].map((p,i)=>({id:i, brand:p[0], model:p[1], v:p[2], ma:p[3], plug:p[4], pol:p[5],
  cat:p[6]||'util', gain:p[7]||0, stereo:p[8]||'M', midi:!!p[9], flags:p[10]||'', custom:false}));

const DEMOS = {
  classic:['Boss TU-3','Ibanez TS9','ProCo RAT 2','MXR M101 Phase 90','Boss CE-2W','MXR M169 Carbon Copy'],
  ambient:['TC PolyTune','Chase Bliss MOOD','Hologram Microcosm','Strymon Timeline','Strymon BigSky','Meris LVX'],
  monster:['Boss TU-3','Klon KTR','Fulltone OCD','EarthQuaker Plumes','Walrus Julia','Boss CE-2W','Strymon Timeline','Strymon BigSky','Line 6 DL4','Eventide H90','Universal Audio Golden','TC Hall of Fame','Boss RC-5','Chase Bliss MOOD','Origin Cali76','Xotic EP'],
  weird:['OTO Machines BIM','Electro-Harmonix Deluxe Memory Man','Fulltone Full-Drive 2','TC Electronic Nova Delay','Eventide H90','Boss BD-2']
};

/* ---------------- interesting points & special cables ---------------- */
const L6_VINTAGE = ['DL4','M9','M13','MM4','DM4','FM4'];
const FACTS = [
  {match:p=>p.brand==='Neural DSP' && /Quad Cortex/.test(p.model),
   text:'Neural ships this with a 3A supply — that’s the adapter’s rating, with headroom. The Quad Cortex runs happily on 12V at 2000mA, and the Gen X gets there with the two high-current outputs (the ones with the 9/12V switch): flick BOTH to 12V, link them in parallel — white tab to white tab, black tab to black tab — and take the feed from one pair of tabs. The diagram above is drawn exactly that way.'},
  {match:p=>p.brand==='Kemper' && /Profiler Player/.test(p.model),
   text:'Kemper ships this with a 9V 2.5A supply — but the Player happily takes 9–12V, and at 12V its 24-watt ceiling is exactly 2000mA. Same trick as the Quad Cortex: flick BOTH high-current outputs (the ones with the 9/12V switch) to 12V, link them in parallel — white tab to white tab, black tab to black tab — and feed it from one pair of tabs. The diagram above is drawn exactly that way.'},
  {match:p=>p.brand==='Fractal Audio' && /VP4/.test(p.model),
   text:'Fractal ships the VP4 with a 9V 1.3A adapter and warns against underrated supplies — and the Gen X covers it the same way we power a Quad Cortex: leave BOTH high-current outputs (the ones with the 9/12V switch) on 9V, link them in parallel — white tab to white tab, black tab to black tab — and take the feed from one pair of tabs. That’s an isolated 9V at 2000mA, headroom to spare. The diagram above is drawn exactly that way.'},
  {match:p=>p.brand==='Decibelics',
   text:'Decibelics pedals are strictly 9V — the Klon-style circuits double the supply internally to 18V, so feeding 12V or 18V destroys them. Every output in this plan feeds it exactly 9V.'},
  {match:p=>p.brand==='Nordvang Custom',
   text:'Nordvang builds run internal charge pumps for headroom — 9V in, always. Never feed them 18V, and note the draws are real (100–150mA) despite being analogue drives; the outputs in this plan are sized for it.'},
  {match:p=>p.brand==='Electronic Audio Experiments',
   text:'EAE pedals are 9V-only (relay switching and internal rails do the rest) and hungrier than they look — most want a 100mA-minimum isolated output, the Sending a 500mA-class one. This plan budgets the full figure.'},
  {match:p=>p.brand==='JET Pedals' && /^(Lamb|Lion)/.test(p.model),
   text:'Analog circuit, digital brain: JET’s drives carry presets and relay switching, so they want a 200mA+ output — and an internal 18V charge pump means the supply must stay at 9V.'},
  {match:p=>p.brand==='Lauren Audio' && /Mustang GT/.test(p.model),
   text:'The Mustang GT is 9V ONLY — an internal multiplier already generates 24V rails inside, so overvolting will destroy it.'},
  {match:p=>p.brand==='JPTR FX' && /Bleach/.test(p.model),
   text:'JPTR FX says anything above 9V can damage the Bleach — unusual for their range, where several models take 9-18V. Keep it at 9V.'},
  {match:p=>p.brand==='Paul Cochrane' && /^Tim V3/.test(p.model),
   text:'The Tim V3 has an internal voltage-converter IC — Paul Cochrane specifies 9V strictly, no 12V or 18V, and there’s no battery option in the V3.'},
  {match:p=>p.brand==='LPD Pedals' && /^Eighty7/.test(p.model),
   text:'The Eighty7 makes its own 24V rails from a 9V input — never feed it 18V. LPD prints the spec on every model; this one is the exception to their usual 9-18V flexibility.'},
  {match:p=>p.brand==='Horrothia' && /^(Lutz|Berkeley)/.test(p.model),
   text:'Two hard ceilings in the Horrothia range: the Lutz must never see more than 9V and the Berkeley tops out at 10V — unlike the Triage and Teeth, which happily take 9-18V. The mini-jack on the Berkeley is an expression input, not power.'},
  {match:p=>p.brand==='PastFX' && p.v===18,
   text:'PastFX’s 18V models have no internal charge pump — they want a true, regulated 18V feed, and the maker warns that 9V+9V voltage-doubler cables can sag under load. The Doubler in your parts list is a regulated 18V output, which is exactly the right way to do it.'},
  {match:p=>p.brand==='Pete Cornish',
   text:'Cornish specifies a noise-free, fully stabilised supply capable of at least 20mA per pedal — and unlike vintage-style fuzzes, Cornish fuzzes have RFI-rejecting buffered inputs, so they don’t need to sit first in the chain.'},
  {match:p=>p.brand==='Tech 21' && /Fly Rig/.test(p.model),
   text:'Check the generation: first-generation Fly Rigs (Fly Rig 5, RK5 v1) run on 12V, while the v2 generation switched to standard 9V centre-negative at 150mA. Same name, different power — the plan above follows the model you picked.'},
  {match:p=>(p.brand==='Chicago Iron') || (p.brand==='SM Pedals' && /^SM Fuzz/.test(p.model)) || (p.brand==='Prescription Electronics' && /Yardbox/.test(p.model)),
   text:'This one is a positive-ground circuit hiding behind a normal-looking centre-negative jack. On a daisy chain it would short the supply — but every Gen X output is fully isolated, so the output in this plan powers it safely.'},
  {match:p=>p.brand==='Deep Trip' && p.plug==='batt',
   text:'Deep Trip’s Fauna series is battery-only by design — no DC jack at all — and the maker recommends zinc-carbon (not alkaline) 9V cells for the right voicing. The Virtual Battery in your parts list sits on an isolated output and feeds the battery clip exactly what it expects.'},
  {match:p=>p.brand==='Fjord Fuzz',
   text:'Forget the old rumour that Fjord Fuzz pedals take any polarity — current documentation says standard 9V centre-negative only. And they’re hungry for fuzzes: relay switching and DSP sections mean 70-250mA, with the Midnattssol wanting a 500mA-rated output.'},
  {match:p=>p.brand==='Surfy Industries' && /SurfyBear/.test(p.model),
   text:'Real spring reverb needs real current: SurfyBears run at 12V and draw up to 1000mA (Classic/Metal). The high-current output in this plan is switched to 12V for it — a standard 100mA outlet won’t move the springs.'},
  {match:p=>p.v===12 && p.ma>1000 && p.ma<=2000,
   text:'Too big for one output — but not for two. Flick BOTH high-current outputs (the ones with the 9/12V switch) to 12V and link them in parallel: white tab to white tab, black tab to black tab. Take the feed from one pair of tabs and you’ve got 12V at 2000mA. The diagram above is drawn exactly that way.'},
  {match:p=>p.v===9 && p.ma>1000 && p.ma<=2000,
   text:'Too big for one output — but not for two. Leave BOTH high-current outputs (the ones with the 9/12V switch) on 9V and link them in parallel: white tab to white tab, black tab to black tab. Take the feed from one pair of tabs and you’ve got 9V at 2000mA. The diagram above is drawn exactly that way.'},
  {match:p=>p.brand==='Moog' && (/^MF-1/.test(p.model) || /CP-251/.test(p.model)),
   text:'Every classic Moogerfooger is centre-POSITIVE — Moog’s own manuals put the + terminal on the centre pin. The red reverse-polarity cable in your parts list is essential, not optional. And never feed a Minifooger from a Moogerfooger supply: Minifoogers are centre-negative like everything else, and Moog warns the wrong one can cause harm.'},
  {match:p=>p.brand==='Diamond' && p.pol==='CP',
   text:'Diamond’s classic big-box pedals run 18–24V centre-POSITIVE — the reverse of the usual standard, and the Memory Lane family uses Diamond’s own large P5 barrel plug. The ElectroMan adapter gives the right voltage and polarity; check the plug end against your unit (Diamond’s own adapter cable fits the P5 socket). The current reissues are ordinary 9V centre-negative — don’t mix the supplies up between eras.'},
  {match:p=>p.brand==='RJM Music' && /Mastermind GT/.test(p.model),
   text:'The Mastermind GT wants 12V centre-POSITIVE — the reverse of the usual pedal standard. The red reverse-polarity cable in your parts list is essential, not optional. (Its little brother the Mastermind LT is easier-going: it takes either polarity.)'},
  {match:p=>p.brand==='Voodoo Lab' && /Ground Control Pro/.test(p.model),
   text:'The Ground Control Pro runs on 9V AC — alternating current, which no DC pedal output provides. Power it from the supply Voodoo Lab includes, or over the MIDI cable from a GCX. Never from a DC output.'},
  {match:p=>p.brand==='Sennheiser' && /XSW-D/.test(p.model),
   text:'Sennheiser publishes the voltage for this receiver (9–15V) but not the polarity — check the marking next to the DC socket on the unit itself before wiring it in. If in doubt, use the supply Sennheiser includes.'},
  {match:p=>p.brand==='MusicomLab',
   text:'The EFX is fussy about voltage: it only operates between 8.4V and 9.6V and resets outside that window. Keep it on a clean 9V output — never a 12V one.'},
  {match:p=>p.brand==='Line 6' && L6_VINTAGE.includes(p.model),
   text:'The label says 9V AC — but open the battery compartment: batteries are DC, and so is the pedal inside. These run great on 12V DC from a Supa Nova with a Line 6 cable adapter on the end.'},
  {match:p=>p.brand==='Line 6' && /HX Stomp/.test(p.model),
   text:'Line 6 labels this 9V / 3A — but that’s the rating of the included adapter, not the pedal. Real-world draw is 800–1000mA, so a high-current output handles it comfortably.'},
  {match:p=>/Whammy 5|Whammy DT/.test(p.model),
   text:'The 1.3A printed on the DigiTech supply is the adapter’s rating — the pedal itself draws under 290mA.'},
  {match:p=>/Sun Face|Sun Bender|Sun Lion|'69 Fuzz|Octafuzz|Fuzz Phrase \(vintage|Fuzz Phrase Ltd|Your Face 60/.test(p.model),
   text:'Positive-ground fuzz — on a shared daisy chain this shorts the supply out. It needs its own isolated output/ which is exactly what every output here is.'},
  {match:p=>p.brand==='Klon' && p.model==='Centaur',
   text:'This one hides a trap: the DC socket is a 3.5mm mini-jack wired tip-positive — not the standard barrel. The cable adapter in your parts list handles it.'},
  {match:p=>p.brand==='OTO Machines',
   text:'OTO’s spec says 15V at 500mA — and our 15V adapter (the El Paso) tops out at 400mA/ just short. So the recipe is the Doubler at 18V with a reverse-polarity cable on the end: full current/ correct polarity.'},
  {match:p=>p.brand==='J. Rockett',
   text:'J. Rockett pedals run on 9V centre-negative — and 9V ONLY. Several of them (the Archer family, the Dude, the Uni-Verb, the Clockwork Echo) already make higher voltages inside with a charge pump, so feeding 18V in destroys the pedal and the warranty with it. A standard 9V output here is exactly right.'},
  {match:p=>p.brand==='Carl Martin' && !p.v,
   text:'Carl Martin built this one with the power supply INSIDE — a captive mains lead, no DC jack at all. Nothing to budget for on the pedalboard supply, but mind the voltage on tour: the US and European versions are wired for different mains and the wrong country cooks them. Post-2016 versions of the same pedals run on ordinary 9V — check the back panel.'},
  {match:p=>p.brand==='T-Rex' && /Replicator|Binson/.test(p.model),
   text:'T-Rex tape and Binson units are a voltage circus: the original Replicator wants 24V, the D’Luxe and Junior want 12V, and the Binson Echorec and Stereophonica want 24V through a 2.0mm pin — a hair smaller than the standard 2.1mm, so the right cable matters as much as the right voltage. Check the model name twice before wiring.'},
  {match:p=>p.brand==='DOD' && p.plug==='3.5mm',
   text:'Vintage DOD pedals hide the same trap as the old RAT: a 3.5mm mini-jack power socket wired TIP-POSITIVE — the reverse of the modern standard. The mini-jack cable adapter in your parts list handles both the plug and the polarity. And the very earliest 1970s units have no power jack at all — battery only.'},
  {match:p=>p.brand==='Radial' && p.v===15,
   text:'Radial’s Tonebone range runs 15V centre-POSITIVE — there’s a real 12AX7 valve in the tube models and 15V is not a suggestion. Happily our 15V adapter (the El Paso) is centre-positive natively, so it plugs straight in: right voltage, right polarity, no adapters-on-adapters.'},
  {match:p=>p.brand==='Wren and Cuff',
   text:'Wren and Cuff build with 16V-rated components and say so plainly: 9V ONLY, never 18V, whatever a pedal-riser forum tells you. Every output here is 9V unless you ask otherwise, so you’re safe.'},
  {match:p=>p.brand==='Cornerstone',
   text:'Cornerstone pedals boost their voltage internally, so the rule is 9V in and ONLY 9V — with one exception: the Aquarium vibe is 18V-only (there’s a real bulb in there). The plan above already gives each one the right output, but worth knowing if you ever re-wire the board yourself.'},
  {match:p=>p.brand==='JAM Pedals' && /Koch Ness Monster Supreme/.test(p.model),
   text:'JAM ships the Supreme with its own universal supply and recommends using it. Powering it from the Gen X instead? It wants 12V at up to 750mA and is TIP-POSITIVE — the red reverse-polarity cable in your parts list is essential/ not optional. (The standard Koch Ness Monster is the opposite: 9V tip-NEGATIVE.)'},
  {match:p=>p.brand==='Effectrode' && p.pol==='CP',
   text:'Effectrode tube pedals want 12V centre-POSITIVE — the reverse of the usual standard, and Effectrode’s own FAQ warns the wrong polarity damages the pedal. The red reverse-polarity cable in your parts list is essential, not optional. They’re hungry too (real vacuum tubes inside), so the plan gives them a high-current feed.'},
  {match:p=>p.brand==='Chase Tone' && p.pol==='CP',
   text:'This is a positive-ground germanium build, and Chase Tone say it plainly: a standard centre-negative supply will not work. It needs its own isolated output with the red reverse-polarity cable — never a shared feed with anything else. The plan above is wired exactly that way.'},
  {match:p=>p.brand==='HeadRush' && p.v===12,
   text:'HeadRush’s compact units want 12V at a full 3 amps, centre-POSITIVE — more than any pedalboard supply output, linked pair included. Keep it on the HeadRush adapter and let your Gen X power everything around it.'},
  {match:p=>p.brand==='Orange' && /Acoustic/.test(p.model),
   text:'The Orange Acoustic Pedal is the odd one out of the Orange line: 18V centre-POSITIVE, with its own adapter in the box. From a Doubler adapter you’ll need the red reverse-polarity cable — the rest of the Orange range is ordinary 9–12V centre-negative.'},
  {match:p=>p.brand==='Supro' && /Delay/.test(p.model),
   text:'The Supro Delay is strictly a 9V pedal — it doubles the voltage internally for its analog chips, so feeding it 18V is a genuinely dangerous idea. A standard 9V output here is exactly right.'},
  {match:p=>p.brand==='Poly Effects' && p.v===9,
   text:'Poly Effects are firm about it: exactly 9V, never more — the manual says “do not use more than 9V” and means it. They’re digital and hungry, so the plan gives them a proper high-current 9V feed.'},
  {match:p=>p.brand==='E.W.S.' && p.v===9 && p.pol==='CN',
   text:'E.W.S. pedals boost their voltage internally — several run at 16–18V inside from a 9V feed — so the rule is a regulated 9V supply and ONLY 9V. Every output here is regulated and isolated, so you’re safe.'},
  {match:p=>p.brand==='Crowther Audio',
   text:'Paul Crowther’s designs are famously easy-going about power — the Hot Cake is happy anywhere in the 6–18V region and draws next to nothing. At 9V on any standard output it sounds exactly as intended. (Yes, that Paul Crowther — Split Enz’s original drummer.)'},
  {match:p=>p.brand==='Mooer' && p.v>9,
   text:'Most of the Mooer range is ordinary 9V centre-negative — but not this one. The Radar wants 12V, the Preamp Live wants 12V at a full amp, and the Baby Bomb power amp wants 24V at 2A (beyond a pedal supply — use its own adapter). Check the wiring plan above rather than assuming 9V.'},
  {match:p=>p.brand==='29 Pedals',
   text:'29 Pedals build the most relaxed power input in the business: the “WHATEVER” jack takes roughly 7.5–35V, AC or DC, either polarity, and sorts itself out internally. A standard 9V output is fine — it genuinely cannot be wired wrong.'},
  {match:p=>p.brand==='Cusack Music' && /Twirl|Tiny Tap-A-Delay/.test(p.model),
   text:'This one has no bypass switch at all — Cusack built it specifically to live in a loop switcher, engaged and disengaged from there. In other words: it’s expecting something like a G3 in front of it.'},
  {match:p=>p.brand==='Electro-Faustus' && p.pol==='CP',
   text:'The Theremorph is centre-POSITIVE, and Electro-Faustus warn against sharing its power with anything else. Give it its own isolated output with the red reverse-polarity cable and it behaves itself.'},
  {match:p=>p.plug==='batt',
   text:'No DC jack on this one — it was built for a 9V battery and nothing else. That’s what the Virtual Battery in your parts list is for: it clips onto the battery snap and feeds the pedal filtered, isolated 9V from a standard output. All the reasons these pedals sound best on batteries — total isolation, no daisy-chain noise — with none of the dead-battery-mid-gig drawbacks.'},
  {match:p=>(p.flags||'').split(';').includes('aca'),
   text:'Check the label on the bottom: if it says ACA, this BOSS wants the old unregulated 12V ACA adapter — there’s a dropping circuit inside, so a modern regulated 9V leaves it under-fed (dim LED, flat sound). The ACA AOK module in your parts list was built for exactly this: it sits on a standard 9V output and gives the pedal isolated 12V, just like BOSS intended. If your label says PSA, it’s a later unit — ordinary 9V, no module needed.'},
  {match:p=>p.brand==='MXR' && (p.plug==='batt' || (p.plug==='3.5mm' && /1981-84/.test(p.model))),
   text:'Dating a vintage MXR is one glance at the front: no LED and no jack (script or block logo) = battery-only, 1974–1980 — the Virtual Battery clips straight on. LED plus a little side-mounted mini-jack = 1981–84, and that jack is 9V TIP-POSITIVE — the mini-jack cable adapter handles plug and polarity in one go. The modern Dunlop reissues are ordinary 2.1mm centre-negative, so pick the row that matches YOUR pedal, not its reissue.'},
  {match:p=>p.brand==='ProCo' && (p.plug==='batt' || p.plug==='3.5mm'),
   text:'RAT dating is all in the power socket: no socket at all = 1979–83 big box (the Virtual Battery clips onto its battery snap). A headphone-style mini-jack marked +9V = 1984–2017 — ProCo’s own manual says TIP-POSITIVE, and the mini-jack cable adapter in your parts list handles it. A normal barrel jack = current production, ordinary 9V centre-negative, nothing special needed.'},
  {match:p=>p.brand==='Electro-Harmonix' && p.plug==='3.5mm',
   text:'Vintage Electro-Harmonix hides the same trap as old DOD and MXR: the little 3.5mm power jack is wired TIP-POSITIVE. The mini-jack cable adapter in your parts list handles both the plug and the polarity. And the very earliest units (Triangle and Ram’s Head Big Muffs among them) have no jack at all — battery only, which is what the Virtual Battery is for.'},
  {match:p=>p.plug==='3.5mm',
   text:'The DC socket on this one is a 3.5mm mini-jack wired TIP-POSITIVE — the reverse of the modern standard, on a smaller plug. One cable sorts both: the mini-jack cable adapter in your parts list is wired tip-positive by design.'},
];
const factFor = p => { const f=FACTS.find(f=>f.match(p)); return f?f.text:null; };
const cableFor = p => (p.brand==='Line 6' && L6_VINTAGE.includes(p.model)) ? 'Line 6 cable adapter' : null;

/* ---------------- signal path: switchers, categories, chain rules ---------------- */
const SWITCHERS = {
  ATOM: {key:'ATOM', name:'G3 Atom', loops:6, aux:true, trs:true, price:995, presets:true, url:'/products/g3-atom-switching-system',
    vars:{UK:'45240018698524',US:'45240018731292',EU:'45240018764060',AU:'45240018796828'},
    sub:'6 loops + AUX · presets · MIDI · tuner out'},
  SATOM:{key:'SATOM', name:'G3S Atom', loops:6, aux:true, trs:true, price:1195, presets:true, screens:true, url:'/products/g3s-atom',
    vars:{UK:'46283884101916',US:'46283884134684',EU:'46283884167452',AU:'46283884200220'},
    sub:'6 loops + AUX · a screen per footswitch'},
  G3:  {key:'G3', name:'G3', loops:12, aux:true, pair:true, price:1295, presets:true, url:'/products/g3-switching-system',
    vars:{UK:'45231722266908',EU:'45231722299676',US:'45231722332444',AU:'45231722365212'},
    sub:'12 loops + AUX · presets · MIDI · tuner out'},
  G3S: {key:'G3S', name:'G3S', loops:12, aux:true, pair:true, price:1595, presets:true, screens:true, url:'/products/g3s',
    vars:{UK:'46283896324380',US:'46283896357148',EU:'46283896389916',AU:'46283896422684'},
    sub:'12 loops + AUX · a screen per footswitch'},
  QMX2:{key:'QMX2', name:'QuarterMaster QMX-2', loops:2, price:169, url:'/products/quartermaster-qmx-2', vars:'45245687234844', sub:'2-loop true-bypass strip'},
  QMX4:{key:'QMX4', name:'QuarterMaster QMX-4', loops:4, price:219, url:'/products/quartermaster-qmx-4', vars:'45245791338780', sub:'4-loop true-bypass strip'},
  QMX6:{key:'QMX6', name:'QuarterMaster QMX-6', loops:6, price:279, url:'/products/quartermaster-qmx-6', vars:'45245830201628', sub:'6-loop true-bypass strip'},
  QMX8:{key:'QMX8', name:'QuarterMaster QMX-8', loops:8, price:329, url:'/products/quartermaster-qmx-8', vars:'45245868900636', sub:'8-loop true-bypass strip'},
  QMX10:{key:'QMX10', name:'QuarterMaster QMX-10', loops:10, price:399, url:'/products/quartermaster-qmx-10', vars:'45245880205596', sub:'10-loop true-bypass strip'}
};
/* the AUX loop is one TRS jack — tip = send (to pedal in), ring = return (from pedal out);
   one stereo-jack-to-two-mono-plugs cable wires it (Dan, 10 Jul 2026) */
const AUX_CABLE = {price:7, variant:'45254735003932', url:'/collections/cables/products/stereo-jack-to-2-x-mono-jack-plugs-cable-50cm', name:'Stereo Jack to 2 × Mono Jack Plugs Cable · 50cm'};
const MIDI_CABLE = {price:6.5, variant:'56477317726586', url:'/products/cable-adapters-copy', name:'MIDI Cable · 30cm'};
/* loop expansions for the G3 family — run out of loops? add a PLUS unit instead of stepping up a model */
const EXPANSIONS = {
  P2:{key:'P2', name:'PLUS2 Remote FX Loops', short:'PLUS2', loops:2, price:132, url:'/products/plus2', variant:'55459698966906', dbModel:'PLUS2'},
  P4:{key:'P4', name:'PLUS 4 Remote FX Loops', short:'PLUS4', loops:4, price:189, url:'/products/plus4', variant:'55643750695290', dbModel:'PLUS4'}
};

/* category metadata: label, colour, rank in the classic chain order */
const CATMETA = {
  tuner: {n:'Tuner',      c:'#5d6a78', r:1},
  wah:   {n:'Wah',        c:'#a2701f', r:2},
  filter:{n:'Filter',     c:'#a2701f', r:3},
  comp:  {n:'Compressor', c:'#4a7c59', r:4},
  pitch: {n:'Pitch',      c:'#a2701f', r:5},
  synth: {n:'Synth',      c:'#a2701f', r:6},
  fuzz:  {n:'Fuzz',       c:'#9e4a78', r:8},
  drive: {n:'Drive',      c:'#b03a2e', r:8},
  eq:    {n:'EQ',         c:'#33707a', r:9},
  gate:  {n:'Noise gate', c:'#99917f', r:10},
  preamp:{n:'Preamp/Amp', c:'#6b4f9e', r:11},
  mod:   {n:'Modulation', c:'#6b4f9e', r:12},
  volume:{n:'Volume',     c:'#5d6a78', r:13},
  multi: {n:'Multi-FX',   c:'#33707a', r:14},
  delay: {n:'Delay',      c:'#a2701f', r:15},
  reverb:{n:'Reverb',     c:'#33707a', r:16},
  looper:{n:'Looper',     c:'#5d6a78', r:17},
  util:  {n:'Utility',    c:'#99917f', r:99},
  switcher:{n:'Switcher', c:'#b03a2e', r:99},
  ampgain:{n:'Amp gain',  c:'#a2701f', r:8}
};
const AMPGAIN = {virtual:true, brand:'', model:'Your amp’s gain channel', cat:'ampgain', gain:4, stereo:'M', midi:false, flags:''};

/* ---------------- state ---------------- */
let board = [];      // array of pedal objects (instances)
let nextCustomId = 10000;
let mode = 'power';  // 'power' | 'signal'
const rig = {amps:'one', fourCM:false, style:'auto', screens:true, modPos:'post', always:new Set(), stereoOn:new Set(), gainOrder:[], gainTouched:false, loopOrder:[], loopTouched:false, gigrigWay:false};   // stereo is OPT-IN — nothing runs stereo until they tick it  // screens ON as standard — the S is the default recommendation

/* ---------------- allocator ---------------- */
function classify(p){
  // returns null if powerable, else a reason string
  if(!p.v) return 'needs nothing from a pedal power supply — it’s passive, powered by its host unit, or runs straight off the mains. Nothing to budget for here.';
  if(![9,12,15,18,24].includes(p.v)) return p.v+'V isn’t a voltage the Gen X range provides — power it from its own adapter.';
  if(p.v===9  && p.ma>2000) return 'Draws '+p.ma+'mA at 9V — beyond even a parallel-linked pair of high-current outputs. Keep it on its own mains adapter.';
  if(p.v===12 && p.ma>2000) return 'Draws '+p.ma+'mA at 12V — beyond even a parallel-linked pair of high-current outputs. Keep it on its own mains adapter.';
  if(p.v!==9 && p.v!==12 && p.ma>ADAPTERS[p.v].maxMa) return 'Draws '+p.ma+'mA at '+p.v+'V — beyond the '+ADAPTERS[p.v].name+' adapter’s '+ADAPTERS[p.v].maxMa+'mA. Keep it on its own mains adapter.';
  return null;
}

function buildKitCandidates(){
  const mains=[['X8'],['X14'],['X14','X8'],['X14','X14']];
  const kits=[];
  for(const m of mains) for(let lc=0;lc<=3;lc++){
    const k=m.concat(Array(lc).fill('X4LC'));
    kits.push({units:k, price:k.reduce((s,c)=>s+SUPPLIES[c].price,0)});
  }
  kits.sort((a,b)=>a.price-b.price);
  return kits;
}

function tryKit(unitCodes, pedals){
  const units = unitCodes.map((code,i)=>({inst:i, code, def:SUPPLIES[code], label:SUPPLIES[code].name+(unitCodes.filter(c=>c===code).length>1?' #'+(unitCodes.slice(0,i+1).filter(c=>c===code).length):'')}));
  const outs=[];
  units.forEach(u=>{
    SUPPLIES[u.code].outs.forEach((o,idx)=>{
      outs.push({unit:u, n:idx+1, volts:o.v, ma:o.ma, pedal:null, adapter:null, mode:null, feedFor:null, fedBy:null});
    });
  });
  const free = o=>!o.pedal && !o.feedFor && !o.adapter && !o.parallelFor;
  // every unit after the first is an expansion fed from the primary unit's 24V link output
  units.forEach((u,i)=>{ if(i>0) u.linkFed=true; });
  // order: adapter voltages first, then 12V, then 9V by draw descending
  const sorted=[...pedals].sort((a,b)=>{
    const r=v=>v===24?0:v===18?1:v===15?2:v===12?3:4;
    return r(a.v)-r(b.v) || b.ma-a.ma;
  });
  // adapters are isolated and take 9–36V in, so they run from the 24V link output
  const linkHost = units.find(u=>SUPPLIES[u.code].link);
  const linkChain=[], adaptersUsed=[];
  for(const p of sorted){
    if(p.v===9){
      const cand=outs.filter(o=>free(o) && o.volts.includes(9) && o.mode!==12 && o.ma>=p.ma)
        .sort((a,b)=>a.ma-b.ma || a.volts.length-b.volts.length);
      if(cand.length){ cand[0].pedal=p; cand[0].mode=9; continue; }
      if(p.ma>ADAPTERS[9].maxMa){
        // Dan's parallel-link trick works at 9V too: both high-current outputs stay
        // on 9V and link white↔white / black↔black — one pair of tabs gives 9V 2000mA
        const host=units.find(u=>outs.filter(o=>o.unit===u && free(o) && o.volts.includes(12)).length>=2);
        if(!host) return null;
        const pair=outs.filter(o=>o.unit===host && free(o) && o.volts.includes(12));
        if(pair[0].ma+pair[1].ma<p.ma) return null;
        pair[0].pedal=p; pair[0].mode=9; pair[0].parallelWith=pair[1];
        pair[1].mode=9; pair[1].parallelFor=pair[0];
        continue;
      }
      // every output taken (or too small) — a Mr Universe on the 24V link output
      // gives this pedal its own isolated 9V/1000mA, no bigger unit needed
      if(!linkHost) return null;
      linkChain.push({pedal:p, adapter:ADAPTERS[9]}); adaptersUsed.push(ADAPTERS[9]);
    }else if(p.v===12){
      if(p.ma>1000){
        // Dan's parallel-link trick: both high-current outputs switched to 12V and
        // linked white↔white / black↔black — one pair of tabs then gives 12V 2000mA
        const host=units.find(u=>outs.filter(o=>o.unit===u && free(o) && o.volts.includes(12)).length>=2);
        if(!host) return null;
        const pair=outs.filter(o=>o.unit===host && free(o) && o.volts.includes(12));
        if(pair[0].ma+pair[1].ma<p.ma) return null;
        pair[0].pedal=p; pair[0].mode=12; pair[0].parallelWith=pair[1];
        pair[1].mode=12; pair[1].parallelFor=pair[0];
        continue;
      }
      const sw=outs.filter(o=>free(o) && o.volts.includes(12) && o.ma>=p.ma).sort((a,b)=>a.ma-b.ma)[0];
      if(sw){ sw.pedal=p; sw.mode=12; continue; }
      if(!linkHost || p.ma>ADAPTERS[12].maxMa) return null;
      linkChain.push({pedal:p, adapter:ADAPTERS[12]}); adaptersUsed.push(ADAPTERS[12]);
    }else{
      if(!linkHost) return null;
      linkChain.push({pedal:p, adapter:ADAPTERS[p.v]}); adaptersUsed.push(ADAPTERS[p.v]);
    }
  }
  const plan={units, outs, linkChain, linkHost, adaptersUsed};
  // one physical link socket — more than one consumer needs the Distributor (1 in → 6 out)
  plan.linkConsumers = adaptersUsed.length + (units.length-1);
  plan.distributors = plan.linkConsumers>1 ? Math.ceil(plan.linkConsumers/DISTRIBUTOR.outs) : 0;
  // every powered pedal with its supply limit and the connector its cable starts from
  plan.placements=()=>outs.filter(o=>o.pedal).map(o=>({pedal:o.pedal, max:o.ma+(o.parallelWith?o.parallelWith.ma:0), src:{plug:'2.1mm', pol:'CN'}}))
    .concat(linkChain.map(l=>({pedal:l.pedal, max:l.adapter.maxMa, src:l.adapter})));
  return plan;
}

function solve(pedals){
  const cannot=[], ok=[];
  pedals.forEach(p=>{ const r=classify(p); r?cannot.push({p,reason:r}):ok.push(p); });
  if(!ok.length) return {cannot, plan:null};
  // a smaller unit plus link-output adapters can beat the next unit up on price,
  // so cost every candidate in full (units + adapters + Distributors) and take the cheapest
  let best=null, bestPrice=Infinity;
  for(const kit of buildKitCandidates()){
    const plan=tryKit(kit.units, ok);
    if(!plan) continue;
    const price=plan.units.reduce((s,u)=>s+SUPPLIES[u.code].price,0)
      +plan.adaptersUsed.reduce((s,a)=>s+a.price,0)
      +plan.distributors*DISTRIBUTOR.price;
    if(price<bestPrice){ best=plan; bestPrice=price; }
  }
  if(best) return {cannot, plan:best};
  return {cannot, plan:null, overflow:true};
}

/* ---------------- rendering ---------------- */
const $=id=>document.getElementById(id);
const esc=s=>String(s).replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));

function pedalLabel(p){ return p.brand? p.brand+' '+p.model : p.model; }

function renderBoard(){
  const ul=$('board'); ul.innerHTML='';
  board.forEach((p,i)=>{
    const li=document.createElement('li');
    const m=CATMETA[p.cat||'util'];
    const spec = mode==='signal'
      ? catChip(p.cat||'util')+(p.midi?' <span class="catchip" style="color:#33707a;border:1px solid #33707a55">MIDI</span>':'')
      : '<span class="spec">'+(p.plug==='batt'?'9V battery':p.v?p.v+'V · '+p.ma+'mA':'—')+'</span>';
    li.innerHTML='<span class="vdot" style="background:'+(mode==='signal'?m.c:(VHEX[p.v]||'#99917f'))+'"></span>'+
      '<span class="nm">'+esc(pedalLabel(p))+(p.custom?' <small style="color:var(--warn)">· custom</small>':'')+'</span>'+
      spec+
      '<button class="rm" title="Remove" aria-label="Remove '+esc(pedalLabel(p))+'">×</button>';
    li.querySelector('.rm').onclick=()=>{ board.splice(i,1); update(); };
    ul.appendChild(li);
  });
  $('emptyBoard').style.display = board.length? 'none':'block';
  $('quick').style.display = board.length? 'none':'block';
  $('startHere').style.display = board.length? 'none':'block';
  renderSaves();
}

function renderOutput(){
  if(mode==='signal') return renderSignalOutput();
  return renderPowerOutput();
}

function renderPowerOutput(){
  const host=$('output');
  if(!board.length){
    host.innerHTML='<div class="empty-state"><b>Your power path appears here.</b><br>Add pedals on the left and we’ll pick the right GigRig power kit and draw the wiring for you.</div>';
    updateStickyVerdict();
    return;
  }
  const {cannot, plan, overflow}=solve(board);
  let html='';

  if(plan){
    const powered=plan.outs.filter(o=>o.pedal).length+plan.linkChain.length;
    const total=plan.outs.reduce((s,o)=>s+(o.pedal?o.pedal.ma:0),0)+plan.linkChain.reduce((s,l)=>s+l.pedal.ma,0);
    const kitName=plan.units.map(u=>u.label).join(' + ');
    const adPrice=plan.adaptersUsed.reduce((s,a)=>s+a.price,0);
    const kitPrice=plan.units.reduce((s,u)=>s+SUPPLIES[u.code].price,0)+adPrice+(plan.distributors?DISTRIBUTOR.price*plan.distributors:0);
    html+='<div class="stats">'+
      '<div class="stat kitcard"><div class="k">Recommended kit</div><div class="v">'+esc(kitName)+(plan.adaptersUsed.length?' <small>+ '+plan.adaptersUsed.length+' adapter'+(plan.adaptersUsed.length>1?'s':'')+'</small>':'')+(plan.distributors?' <small>+ Distributor</small>':'')+'</div></div>'+
      '<div class="stat"><div class="k">Pedals powered</div><div class="v">'+powered+'<small> of '+board.length+'</small></div></div>'+
      '<div class="stat"><div class="k">Total draw</div><div class="v">'+(total>=1000?(total/1000).toFixed(2)+'<small> A</small>':total+'<small> mA</small>')+'</div></div>'+
      '<div class="stat"><div class="k">Kit price</div><div class="v">£'+kitPrice+'</div></div>'+
      '</div>';
  }

  // warnings
  const warns=[];
  cannot.forEach(c=>warns.push(c.p.v
    ? '<div class="warning bad"><span class="ic">✕</span><span><b>'+esc(pedalLabel(c.p))+'</b> — '+esc(c.reason)+'</span></div>'
    : '<div class="warning"><span class="ic">i</span><span><b>'+esc(pedalLabel(c.p))+'</b> '+esc(c.reason)+'</span></div>'));
  if(overflow) warns.push('<div class="warning bad"><span class="ic">✕</span><span>That’s a serious board — it doesn’t fit our stock kit combinations. Get in touch and we’ll spec it by hand.</span></div>');
  if(plan){
    plan.placements().forEach(({pedal:p, max, src})=>{
      if(p.ma>=max*0.95) warns.push('<div class="warning"><span class="ic">!</span><span><b>'+esc(pedalLabel(p))+'</b> uses nearly all of its supply’s '+max+'mA — that’s fine, but there’s no headroom to spare.</span></div>');
      if(cableFor(p)) return;
      if(p.plug==='batt'){ warns.push('<div class="warning"><span class="ic">i</span><span><b>'+esc(pedalLabel(p))+'</b> has no DC jack at all — battery only. The Virtual Battery in your parts list clips straight onto its battery snap and feeds it clean, isolated 9V.</span></div>'); return; }
      if((p.flags||'').split(';').includes('aca')){ warns.push('<div class="warning"><span class="ic">i</span><span><b>'+esc(pedalLabel(p))+'</b> is an ACA-era BOSS — it wants BOSS’s old unregulated 12V ACA adapter, not a modern regulated 9V. The ACA AOK module in your parts list sits on a standard 9V output and feeds it exactly what it expects.</span></div>'); return; }
      if(p.plug==='3.5mm'){ warns.push('<div class="warning"><span class="ic">!</span><span><b>'+esc(pedalLabel(p))+'</b> takes a 3.5mm mini-jack wired tip-positive — the mini-jack cable adapter in your parts list handles both the plug and the polarity.</span></div>'); return; }
      if(p.pol!==src.pol) warns.push('<div class="warning"><span class="ic">!</span><span><b>'+esc(pedalLabel(p))+'</b> is centre-'+(p.pol==='CP'?'positive':'negative')+' — use the reverse-polarity cable adapter shown in the diagram.</span></div>');
      if(p.plug!==src.plug) warns.push('<div class="warning"><span class="ic">!</span><span><b>'+esc(pedalLabel(p))+'</b> takes a '+esc(p.plug)+' plug — a cable adapter is included in the parts list.</span></div>');
    });
  }
  if(warns.length) html+='<div class="warnings">'+warns.join('')+'</div>';

  const facts=[...new Set(board.map(p=>factFor(p)).filter(Boolean))];
  if(plan){
    // 9V/12V pedals only land on the link chain when the numbered outputs ran out —
    // worth telling the customer why that beats stepping up to a bigger unit
    const ov=plan.linkChain.filter(l=>l.pedal.v===9||l.pedal.v===12);
    if(ov.length) facts.unshift('The '+plan.linkHost.label+'’s 24V link output is doing extra duty here: '+
      ov.map(l=>'a '+l.adapter.name+' on the link is a proper isolated '+l.adapter.out+' supply in its own right, and it powers your '+pedalLabel(l.pedal)).join('; ')+
      ' — no need to step up to a bigger unit for that. The link output happily runs any of the high-current adapters, a Distributor full of them, or even another Gen X.');
  }
  if(plan && plan.distributors) facts.unshift('The '+plan.units[0].label+' has one link output and this rig hangs '+plan.linkConsumers+' things off it — that’s exactly what the Distributor is for: a fancy daisy chain, one DC in and six high-current outs. Your '+(plan.adaptersUsed.length?'adapters':'')+(plan.adaptersUsed.length&&plan.units.length>1?' and ':'')+(plan.units.length>1?'expansion units':'')+' all feed from it. One thing the Distributor does NOT do is isolate — that’s the adapters’ job, and it’s why each pedal keeps its own: the Distributor splits, the adapters isolate. It’s in your parts list.');
  if(plan && !facts.length) facts.push('The great thing about this power setup: every pedal on your board receives all the current it needs from a very high-quality isolated supply.');
  if(facts.length) html+='<section class="card facts"><h2>Interesting points</h2>'+facts.map(f=>'<p>'+esc(f)+'</p>').join('')+'</section>';

  if(plan){
    html+='<section class="card diagram-card"><div class="dhead"><h2>2 · Your power path</h2><button type="button" id="printBtn" class="printbtn">Print / save PDF</button><button type="button" class="sheetopen">Open full sheet ⤡</button></div><div class="diagram-scroll">'+drawDiagram(plan)+'</div>'+
      '<div class="legend">'+[9,12,15,18,24].map(v=>'<span><i style="background:'+VHEX[v]+'"></i>'+v+'V</span>').join('')+
      '<span style="margin-left:auto">one pedal per isolated output · expansion units &amp; adapters run from the 24V link output</span></div></section>';
    html+=renderBOM(plan);
    html+=titleBlock('PEDAL POWER PATH');
    html+='<section class="card crosslink"><p><b>Power sorted — now the signal.</b> Same pedals, other half of the puzzle: the best order, a loop for everything, and the right switcher.</p><button type="button" id="xlink">Build my signal path →</button></section>';
  }
  host.innerHTML=html;
  bindOutputControls();
}

function drawDiagram(plan){
  const ROW=56, HEAD=46, GAP=26, W=920;
  const PSU_X=8, PSU_W=178, JACK_X=PSU_X+PSU_W, PED_X=560, PED_W=340, AD_X=308, AD_W=170;
  // build row list grouped by unit
  const groups=[];
  plan.units.forEach(u=>{
    const uouts=plan.outs.filter(o=>o.unit===u);
    const rows=uouts.filter(o=>o.pedal||o.feedFor||o.parallelFor).map(o=>({type:o.feedFor?'feed':(o.parallelFor?'pair':'pedal'),out:o}));
    const spare=uouts.filter(o=>!o.pedal && !o.feedFor && !o.parallelFor).length;
    if(spare) rows.push({type:'spare',count:spare});
    if(u===plan.linkHost) plan.linkChain.forEach((l,i)=>rows.push({type:'link',item:l,first:i===0}));
    if(rows.length) groups.push({unit:u, rows});
  });
  let H=8;
  groups.forEach(g=>{ if(g.unit.linkFed) H+=44; g.y=H; g.h=HEAD+g.rows.length*ROW+14; H+=g.h+GAP; });
  H-=GAP-4;
  let s='<svg viewBox="0 0 '+W+' '+H+'" width="'+W+'" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Power path diagram">';
  groups.forEach(g=>{
    const gh=HEAD+g.rows.length*ROW+14;
    // PSU body
    s+='<rect x="'+PSU_X+'" y="'+g.y+'" width="'+PSU_W+'" height="'+gh+'" rx="2" fill="#fbfaf6" stroke="#2b2a28"/>';
    s+='<rect x="'+PSU_X+'" y="'+g.y+'" width="'+PSU_W+'" height="34" rx="2" fill="#1c1c1c"/>';
    s+='<rect x="'+PSU_X+'" y="'+(g.y+22)+'" width="'+PSU_W+'" height="12" fill="#1c1c1c"/>';
    s+='<text x="'+(PSU_X+14)+'" y="'+(g.y+23)+'" fill="#fff" font-size="15" font-weight="700" letter-spacing="1">'+esc(g.unit.label)+'</text>';
    s+='<text x="'+(PSU_X+14)+'" y="'+(g.y+HEAD+2)+'" fill="#6b6559" font-size="10.5">'+esc(g.unit.linkFed?'fed from '+plan.units[0].label+' LINK · 24V':SUPPLIES[g.unit.code].sub)+'</text>';
    const linkYs=[];
    g.rows.forEach((r,ri)=>{
      const cy=g.y+HEAD+12+ri*ROW+ROW/2-6;
      if(r.type==='spare'){
        s+='<text x="'+(PSU_X+14)+'" y="'+(cy+4)+'" fill="#99917f" font-size="12">+ '+r.count+' spare output'+(r.count>1?'s':'')+'</text>';
        return;
      }
      if(r.type==='link'){
        const p=r.item.pedal, ad=r.item.adapter, vc=VHEX[p.v];
        if(r.first){
          s+='<text class="mono" x="'+(PSU_X+14)+'" y="'+(cy)+'" fill="#2b2a28" font-size="12" font-weight="600">LINK</text>';
          s+='<text class="mono" x="'+(PSU_X+14)+'" y="'+(cy+15)+'" fill="#6b6559" font-size="10.5">24V link out</text>';
          s+='<circle cx="'+JACK_X+'" cy="'+(cy+3)+'" r="5" fill="#fbfaf6" stroke="'+VHEX[24]+'" stroke-width="1.5"/>';
        }
        linkYs.push(cy+3);
        s+='<rect x="'+AD_X+'" y="'+(cy-15)+'" width="'+AD_W+'" height="36" rx="2" fill="#f5f3ec" stroke="'+vc+'"/>';
        s+='<text x="'+(AD_X+AD_W/2)+'" y="'+(cy-1)+'" text-anchor="middle" fill="#2b2a28" font-size="12" font-weight="600">'+esc(ad.name)+'</text>';
        s+='<text class="mono" x="'+(AD_X+AD_W/2)+'" y="'+(cy+14)+'" text-anchor="middle" fill="#6b6559" font-size="10">9–36V in → '+ad.out+' '+ad.maxMa+'mA</text>';
        s+='<line x1="'+(AD_X+AD_W)+'" y1="'+(cy+3)+'" x2="'+PED_X+'" y2="'+(cy+3)+'" stroke="'+vc+'" stroke-width="3"/>';
        const ov=cableFor(p);
        const notes=ov?[ov]:[];
        if(!ov && p.plug==='batt') notes.push('VIRTUAL BATTERY on the battery clip');
        else if(!ov && (p.flags||'').split(';').includes('aca')) notes.push('ACA AOK module (9V in → 12V ACA out)');
        else if(!ov && p.plug==='3.5mm') notes.push('MINI-JACK cable (tip-positive)');
        else{
          if(!ov && p.pol!==ad.pol) notes.push('RED reverse-polarity cable adapter');
          if(!ov && p.plug!==ad.plug) notes.push(p.plug+' plug adapter');
        }
        if(notes.length) s+='<text x="'+((AD_X+AD_W+PED_X)/2)+'" y="'+(cy+18)+'" text-anchor="middle" fill="'+(!ov&&p.pol!==ad.pol?'#b03a2e':'#6b6559')+'" font-size="10.5" font-weight="600">'+esc(notes.join(' + '))+'</text>';
        s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+vc+'" stroke-width="1.5"/>';
        s+='<text x="'+(PED_X+14)+'" y="'+(cy+1)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(pedalLabel(p))+'</text>';
        s+='<text class="mono" x="'+(PED_X+14)+'" y="'+(cy+16)+'" fill="#6b6559" font-size="10.5">'+p.v+'V · '+p.ma+'mA · '+(p.plug==='batt'?'battery clip':esc(p.plug)+' · '+(p.pol==='CN'?'centre −':'centre +'))+'</text>';
        return;
      }
      const o=r.out;
      // output label + jack
      s+='<text class="mono" x="'+(PSU_X+14)+'" y="'+(cy)+'" fill="#2b2a28" font-size="12" font-weight="600">OUT '+o.n+'</text>';
      s+='<text class="mono" x="'+(PSU_X+14)+'" y="'+(cy+15)+'" fill="#6b6559" font-size="10.5">'+(o.mode===12?'12V':'9V')+' · '+(o.parallelWith?'2 × '+o.ma+'mA linked':o.ma+'mA max')+'</text>';
      s+='<circle cx="'+JACK_X+'" cy="'+(cy+3)+'" r="5" fill="#fbfaf6" stroke="#6b6559" stroke-width="1.5"/>';
      if(r.type==='pair'){
        // the second half of a parallel-linked high-current pair: bus up to its partner one row above
        const vc12=VHEX[12];
        s+='<path d="M '+(JACK_X+5)+' '+(cy+3)+' H '+(JACK_X+26)+' V '+(cy+3-ROW)+'" fill="none" stroke="'+vc12+'" stroke-width="3"/>';
        s+='<path d="M '+(JACK_X+5)+' '+(cy+7)+' H '+(JACK_X+22)+' V '+(cy+7-ROW)+'" fill="none" stroke="'+vc12+'" stroke-width="1.5"/>';
        s+='<text x="'+(JACK_X+36)+'" y="'+(cy+1)+'" fill="#6b6559" font-size="11">linked in parallel with OUT '+o.parallelFor.n+' — both '+(o.mode===12?'switched to 12V':'on 9V')+'</text>';
        s+='<text x="'+(JACK_X+36)+'" y="'+(cy+15)+'" fill="#b03a2e" font-size="10.5" font-weight="600">white tab → white tab · black tab → black tab</text>';
        return;
      }
      if(r.type==='feed'){
        s+='<line x1="'+(JACK_X+5)+'" y1="'+(cy+3)+'" x2="'+PED_X+'" y2="'+(cy+3)+'" stroke="'+VHEX[9]+'" stroke-width="3" stroke-dasharray="7 5"/>';
        s+='<text x="'+(JACK_X+16)+'" y="'+(cy-6)+'" fill="#6b6559" font-size="11">powers the '+esc(o.feedFor.label)+' below</text>';
        s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="38" rx="2" fill="none" stroke="#2b2a28" stroke-dasharray="4 4"/>';
        s+='<text x="'+(PED_X+14)+'" y="'+(cy+8)+'" fill="#6b6559" font-size="12.5">→ '+esc(o.feedFor.label)+' (Isolator V2)</text>';
        return;
      }
      const p=o.pedal, vc=VHEX[p.v];
      const endX=PED_X;
      s+='<line x1="'+(JACK_X+5)+'" y1="'+(cy+3)+'" x2="'+endX+'" y2="'+(cy+3)+'" stroke="'+vc+'" stroke-width="3"/>';
      const cap=o.ma+(o.parallelWith?o.parallelWith.ma:0);
      const head=(o.mode===12?'12V':'9V')+(o.parallelWith?' · paired outputs':'')+' · '+p.ma+'mA draw · '+(cap-p.ma)+'mA spare';
      s+='<text class="mono" x="'+((JACK_X+endX)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">'+head+'</text>';
      // cable note under line
      const ov=cableFor(p);
      const notes=ov?[ov]:[];
      if(!ov && p.plug==='batt') notes.push('VIRTUAL BATTERY on the battery clip');
      else if(!ov && (p.flags||'').split(';').includes('aca')) notes.push('ACA AOK module (9V in → 12V ACA out)');
      else if(!ov && p.plug==='3.5mm') notes.push('MINI-JACK cable (tip-positive)');
      else{
        if(!ov && p.pol==='CP') notes.push('RED reverse-polarity cable');
        if(!ov && p.plug!=='2.1mm') notes.push(p.plug+' plug adapter');
      }
      if(notes.length) s+='<text x="'+((JACK_X+endX)/2)+'" y="'+(cy+18)+'" text-anchor="middle" fill="'+(!ov&&p.pol==='CP'?'#b03a2e':'#6b6559')+'" font-size="10.5" font-weight="600">'+esc(notes.join(' + '))+'</text>';
      // pedal box
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+vc+'" stroke-width="1.5"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+1)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(pedalLabel(p))+'</text>';
      s+='<text class="mono" x="'+(PED_X+14)+'" y="'+(cy+16)+'" fill="#6b6559" font-size="10.5">'+p.v+'V · '+p.ma+'mA · '+(p.plug==='batt'?'battery clip':esc(p.plug)+' · '+(p.pol==='CN'?'centre −':'centre +'))+'</text>';
    });
    if(linkYs.length){
      const busX=JACK_X+26, y0=linkYs[0], y1=linkYs[linkYs.length-1];
      s+='<path d="M '+(JACK_X+5)+' '+y0+' H '+busX+' V '+y1+'" fill="none" stroke="'+VHEX[24]+'" stroke-width="3"/>';
      linkYs.forEach(y=>{ s+='<line x1="'+busX+'" y1="'+y+'" x2="'+AD_X+'" y2="'+y+'" stroke="'+VHEX[24]+'" stroke-width="3"/>'; });
      if(plan.distributors){
        const cxm=(busX+AD_X)/2;
        s+='<rect x="'+(cxm-64)+'" y="'+(y0-26)+'" width="128" height="18" rx="2" fill="#1c1c1c"/>';
        s+='<text x="'+cxm+'" y="'+(y0-13)+'" text-anchor="middle" fill="#fff" font-size="9.5" letter-spacing="1">DISTRIBUTOR · 1 IN → 6 OUT</text>';
      } else {
        s+='<text class="mono" x="'+((busX+AD_X)/2)+'" y="'+(y0-10)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">24V LINK</text>';
      }
    }
  });
  // physical 24V link cable from each unit down into the link-fed unit below it
  for(let i=1;i<groups.length;i++){
    const a=groups[i-1], b=groups[i];
    if(!b.unit.linkFed) continue;
    const x=PSU_X+28, y1=a.y+a.h, y2=b.y;
    s+='<line x1="'+x+'" y1="'+y1+'" x2="'+x+'" y2="'+y2+'" stroke="'+VHEX[24]+'" stroke-width="4"/>';
    s+='<circle cx="'+x+'" cy="'+y1+'" r="5" fill="#fbfaf6" stroke="'+VHEX[24]+'" stroke-width="1.5"/>';
    s+='<circle cx="'+x+'" cy="'+y2+'" r="5" fill="#fbfaf6" stroke="'+VHEX[24]+'" stroke-width="1.5"/>';
    s+='<text class="mono" x="'+(x+12)+'" y="'+((y1+y2)/2+4)+'" fill="'+VHEX[24]+'" font-size="10.5" font-weight="600">'+(a.unit.linkFed?'LINK THRU · 24V':'LINK OUT · 24V')+'</text>';
  }
  s+='</svg>';
  return s;
}

function renderBOM(plan){
  const V=SHOP.variants, rows=[];
  plan.units.forEach(u=>{
    const d=SUPPLIES[u.code];
    const variant = u.code==='X4LC' ? V.X4LC : V[u.code][region];
    rows.push({name:u.label+' DC Power Supply', why:d.sub, price:d.price, url:SHOP.products[u.code], cart:[variant,1]});
  });
  const adCount={};
  plan.adaptersUsed.forEach(a=>{ adCount[a.name]=(adCount[a.name]||0)+1; });
  Object.entries(adCount).forEach(([name,n])=>{
    const a=Object.values(ADAPTERS).find(x=>x.name===name);
    rows.push({name:(n>1?n+' × ':'')+name+' High Current Adapter', why:'9–36V in → '+a.out+' out, up to '+a.maxMa+'mA', price:a.price*n, url:SHOP.products.adapter, cart:[V.adapters[name],n]});
  });
  if(plan.distributors){
    const n=plan.distributors;
    rows.push({name:(n>1?n+' × ':'')+'Distributor', why:'one DC in → six high-current outs — feeds the '+plan.linkConsumers+' things running from the link output', price:DISTRIBUTOR.price*n, url:DISTRIBUTOR.url, cart:[DISTRIBUTOR.variant,n]});
  }
  const placements=plan.placements();
  const cableCounts={reverse:0, to25:0, mini:0, line6:0, vb:0, aca:0, other:0};
  placements.forEach(x=>{
    if(cableFor(x.pedal)){ cableCounts.line6++; return; }
    if(x.pedal.plug==='batt'){ cableCounts.vb++; return; }
    if((x.pedal.flags||'').split(';').includes('aca')){ cableCounts.aca++; return; }
    if(x.pedal.pol!==x.src.pol && x.pedal.plug!=='3.5mm') cableCounts.reverse++;
    if(x.pedal.plug!==x.src.plug){
      if(x.pedal.plug==='2.5mm') cableCounts.to25++;
      else if(x.pedal.plug==='3.5mm') cableCounts.mini++;
      else cableCounts.other++;
    }
  });
  const CABLE_LABELS={reverse:['2.1mm Reverse-Polarity Cable Adapter','for centre-positive pedals'], to25:['2.1mm to 2.5mm Cable Adapter','for 2.5mm pedal jacks'], mini:['2.1mm to Mini-Jack Cable Adapter','for 3.5mm mini-jack pedals (Klon / vintage RAT)'], line6:['Line 6 Cable Adapter','for vintage Line 6 units on 12V'], vb:['Virtual Battery (battery-clip type)','isolated 9V that clips straight onto the battery snap — for pedals with no DC jack'], aca:['ACA AOK Power Supply Module','for early BOSS pedals labelled ACA — 9V in, isolated 12V ACA out'], other:['Cable Adapter (special)','choose the right type on the product page']};
  const CABLE_PRICES={reverse:6, to25:6, mini:6, line6:6, vb:39, aca:53, other:6};
  const CABLE_URLS={vb:'/products/virtual-battery', aca:'/products/aca-aok'};
  Object.entries(cableCounts).forEach(([k,n])=>{
    if(!n) return;
    rows.push({name:(n>1?n+' × ':'')+CABLE_LABELS[k][0], why:CABLE_LABELS[k][1], price:CABLE_PRICES[k]*n, url:CABLE_URLS[k]||SHOP.products.cable, cart:V.cables[k]?[V.cables[k],n]:null});
  });
  const total=rows.reduce((s,r)=>s+r.price,0);
  let h='<section class="card bom"><h2>3 · Parts list</h2><table>';
  rows.forEach(r=>{ h+='<tr><td><a href="'+SHOP.base+r.url+'" target="_blank" rel="noopener">'+esc(r.name)+'</a><div class="why">'+esc(r.why)+'</div></td><td class="price">£'+r.price.toFixed(2)+'</td></tr>'; });
  h+='<tr><td>Total</td><td class="price">£'+total.toFixed(2)+'</td></tr></table>';
  const cartRows=rows.filter(r=>r.cart);
  const customs=board.filter(p=>p.custom);
  const noteText=customs.length?'POWER PATH BUILDER - customer-added pedals to verify for the database: '+customs.map(p=>p.brand+' '+p.model+' ('+p.v+'V / '+p.ma+'mA / '+(p.plug==='batt'?'battery clip only':p.plug+' / '+(p.pol==='CN'?'centre neg':'centre pos'))+')').join(' | '):'';
  cartData={items:cartRows.map(r=>({id:Number(r.cart[0]), quantity:r.cart[1]})), note:noteText};
  const permalink=SHOP.base+'/cart/'+cartRows.map(r=>r.cart[0]+':'+r.cart[1]).join(',')+'?attributes[Designer]=Power+Path'+(noteText?'&note='+encodeURIComponent(noteText):'');
  h+='<div class="bom-foot">'+
     '<label>Mains lead <select id="regionSel"><option'+(region==='UK'?' selected':'')+'>UK</option><option'+(region==='EU'?' selected':'')+'>EU</option><option'+(region==='US'?' selected':'')+'>US</option><option'+(region==='AU'?' selected':'')+'>AU</option></select></label>'+
     '<a class="buy" id="buyBtn" href="'+permalink+'"'+(ON_SHOP?'':' target="_blank" rel="noopener"')+'>'+(ON_SHOP?'Add kit to cart':'Buy this kit at shop.thegigrig.com')+'</a>'+
     '</div><p class="buy-note">'+(ON_SHOP?'Adds every part above to your cart — you can keep browsing.':'Takes you to TheGigRig checkout with every part above already in the basket.')+'<br>Working draft, remember — if anything looks off for your rig, ask us first. We’d rather get it right than make a sale.</p></section>';
  return h;
}

/* ================= SIGNAL PATH MODE ================= */
const puid = p => p._u;
const isGain = x => x.cat==='fuzz' || x.cat==='drive' || x.cat==='ampgain';
const hasFlag = (p,f) => (p.flags||'').split(';').includes(f);
const WETCATS = ['delay','reverb','looper','multi'];
const isStereoRun = x => rig.amps!=='one' && !x.virtual && (x.stereo==='MS'||x.stereo==='S') && rig.stereoOn.has(puid(x));

function sigParts(){
  const chain=[], skipped=[];
  board.forEach(p=>{
    const cat=p.cat||'util';
    if(cat==='switcher' || cat==='util'){ skipped.push(p); return; }
    chain.push(p);
  });
  if(rig.fourCM) chain.push({...AMPGAIN, _u:'_ampgain'});
  return {chain, skipped};
}

/* keep the user's gain-stage order across board edits */
function gainList(chain){
  const items = chain.filter(x=>isGain(x) && !hasFlag(x,'ff'));
  const have = new Set(items.map(puid));
  items.sort((a,b)=>(a.gain||3)-(b.gain||3) || pedalLabel(a).localeCompare(pedalLabel(b)));
  if(!rig.gainTouched){
    // until the player rearranges, always propose lowest → highest gain, however the pedals arrived
    rig.gainOrder = items.map(puid);
  } else {
    rig.gainOrder = rig.gainOrder.filter(u=>have.has(u));
    items.forEach(x=>{ if(!rig.gainOrder.includes(puid(x))) rig.gainOrder.push(puid(x)); });
  }
  return rig.gainOrder.map(u=>items.find(x=>puid(x)===u)).filter(Boolean);
}

function orderChain(chain){
  const gains = gainList(chain);
  const gpos = new Map(gains.map((x,i)=>[puid(x),i]));
  const bpos = new Map(chain.map((x,i)=>[puid(x),i]));
  const rk = x => hasFlag(x,'ff')?0 : isGain(x)?8 : (x.cat==='mod' && rig.modPos==='pre')?6.5 : CATMETA[x.cat].r;
  return [...chain].sort((a,b)=>{
    const ra = rk(a);
    const rb = rk(b);
    if(ra!==rb) return ra-rb;
    if(ra===8) return (gpos.get(puid(a))??99)-(gpos.get(puid(b))??99);
    return (bpos.get(puid(a))??0)-(bpos.get(puid(b))??0);
  });
}

const GIGRIG_SW_NAMES={'G3 Atom':'ATOM','G3S Atom':'SATOM','G3':'G3','G3S':'G3S',
  'QuarterMaster QMX-2':'QMX2','QuarterMaster QMX-4':'QMX4','QuarterMaster QMX-6':'QMX6',
  'QuarterMaster QMX-8':'QMX8','QuarterMaster QMX-10':'QMX10'};
function ownedSwitcher(){
  const own = board.find(p=>p.cat==='switcher' && GIGRIG_SW_NAMES[p.model]);
  return own ? SWITCHERS[GIGRIG_SW_NAMES[own.model]] : null;
}
/* a switcher from another company on the board: we power it and give the chain order,
   but the loop plumbing (the rich content) is GigRig-only — unless the customer asks */
function foreignSwitcher(){
  return board.find(p=>p.cat==='switcher' && !GIGRIG_SW_NAMES[p.model]) || null;
}

function planSignal(){
  const {chain, skipped} = sigParts();
  if(!chain.length) return null;
  let ordered = orderChain(chain);
  // stereo pedals live at the very END of the chain — the last loop pairs before the amps.
  // no mono pedal ever sits after a stereo one (relative order among stereo pedals is preserved)
  if(rig.amps!=='one'){
    const stTail = ordered.filter(x=>isStereoRun(x));
    if(stTail.length) ordered = [...ordered.filter(x=>!isStereoRun(x)), ...stTail];
  }
  // four-cable method: only DIGITAL effects can live after the amp's preamp —
  // analog circuits can't take valve-preamp levels, so they stay in front of the amp
  let analogMoved = [];
  if(rig.fourCM){
    const ai = ordered.findIndex(x=>x.cat==='ampgain');
    if(ai>=0){
      const LEVEL_SENSITIVE=['mod','delay','reverb','pitch','synth','looper','multi'];
      const pre=ordered.slice(0,ai), rest=ordered.slice(ai+1);
      analogMoved=rest.filter(x=>LEVEL_SENSITIVE.includes(x.cat) && !hasFlag(x,'dg'));
      const post=rest.filter(x=>!analogMoved.includes(x));
      ordered=[...pre, ...analogMoved, ordered[ai], ...post];
    }
  }
  const front=[], tail=[], mid=[];
  ordered.forEach(x=>{
    // wah = the guitar input: true bypass, straight into the front of the switcher, no loop needed
    if(!x.virtual && x.cat==='wah'){ front.push(x); return; }
    if(x.virtual || !rig.always.has(puid(x))){ mid.push(x); return; }
    const r = isGain(x)?8:CATMETA[x.cat].r;
    (r<=11 ? front : tail).push(x);
  });
  const owned = ownedSwitcher();
  const tuner = mid.find(x=>x.cat==='tuner');
  const midNoTuner = mid.filter(x=>x!==tuner);
  const ffPedals = mid.filter(x=>hasFlag(x,'ff'));
  const ffFirst = ffPedals[0]||null;
  // AUX = an extra loop right at the chain start — but it shares the TUNER/AUX jack, so using it
  // as a loop costs a tuner pedal its dedicated out (net zero when a tuner pedal is on the board).
  // PLUS expansions go at the very FRONT: guitar → PLUS loops → switcher input. With an expansion
  // a fuzz simply takes PLUS loop 1, leaving the AUX jack free for the tuner.
  const auxBonus = 1;   // the AUX is always usable: if it claims the tuner jack, the tuner pedal takes a spare loop or stays home (built-in tuner)
  const stereoRunList = midNoTuner.filter(isStereoRun);   // pedals actually running stereo (user-tickable)
  const needNoExp = midNoTuner.length - (ffFirst?1:0);
  const needExp   = midNoTuner.length;
  // G3/G3S pair loops for stereo: each stereo pedal costs one extra loop there
  const needFor = (b,e) => (e? needExp : needNoExp) + (b.pair? stereoRunList.length : 0);
  const loopsQMX = mid.length;                    // QMX: tuner takes a loop (mute/tune trick)
  const hasMidi = chain.some(x=>x.midi);
  const needsParallel = rig.amps==='wetdry' || rig.amps==='wdw';

  let wantPresets;
  if(owned) wantPresets = !!owned.presets;
  else if(rig.style==='presets') wantPresets = true;
  else if(rig.style==='simple') wantPresets = false;
  else wantPresets = hasMidi || needsParallel || rig.fourCM || rig.amps!=='one' || loopsQMX>4;

  const warns=[];
  if(!wantPresets && stereoRunList.length && !owned){
    wantPresets = true;
    warns.push('QuarterMaster loops are mono — running pedals in stereo needs the G3 family: TRS stereo loops on the Atom, paired loops on the G3.');
  }
  if(!wantPresets && needsParallel && !owned){
    wantPresets = true;
    warns.push('Wet/dry rigs need the parallel mixing built into the G3 family — a loop strip alone can’t blend a wet signal alongside your dry amp, so we’ve recommended accordingly.');
  }

  let sw, expansion=null, overflow=false;
  if(owned){
    sw = owned;
    if(owned.presets){
      const fitBare = needFor(owned,null) <= owned.loops + (ffFirst?0:1);
      if(!fitBare){
        const deficit = needFor(owned,EXPANSIONS.P2) - (owned.loops + auxBonus);
        if(deficit>0 && deficit<=4) expansion = deficit<=2 ? EXPANSIONS.P2 : EXPANSIONS.P4;
        else if(deficit>4) warns.push('Your '+owned.name+' is more than a PLUS4 short for this board — mark more pedals as always-on, or talk to us about the best way to grow the rig.');
      }
    } else if(loopsQMX > owned.loops){
      warns.push('Your '+owned.name+' has '+owned.loops+' loops but this board wants '+loopsQMX+' — mark more pedals as always-on, or step up a model.');
    }
  } else if(wantPresets){
    // cheapest combination of base switcher + (nothing / PLUS2 / PLUS4) that fits, AUX included
    const bases = rig.screens? [SWITCHERS.SATOM, SWITCHERS.G3S] : [SWITCHERS.ATOM, SWITCHERS.G3];
    const cands=[];
    bases.forEach(b=>[null, EXPANSIONS.P2, EXPANSIONS.P4].forEach(e=>{
      const need = needFor(b,e);
      const bonus = e? 1 : (ffFirst?0:1);
      cands.push({sw:b, exp:e, ok: need <= b.loops+(e?e.loops:0)+bonus, price:b.price+(e?e.price:0)});
    }));
    cands.sort((a,b)=>a.price-b.price);
    const pick = cands.find(c=>c.ok);
    if(pick){ sw=pick.sw; expansion=pick.exp; }
    else {
      sw = rig.screens?SWITCHERS.G3S:SWITCHERS.G3; expansion=EXPANSIONS.P4; overflow=true;
      warns.push('More switched pedals than even a G3 with a PLUS4 — mark some as always-on, or talk to us about an Extension Kit rig.');
    }
  } else {
    sw = [SWITCHERS.QMX2,SWITCHERS.QMX4,SWITCHERS.QMX6,SWITCHERS.QMX8,SWITCHERS.QMX10].find(s=>s.loops>=loopsQMX);
    if(!sw){ sw = rig.screens?SWITCHERS.G3S:SWITCHERS.G3; wantPresets=true;
      warns.push('That’s more loops than the biggest QuarterMaster — the G3 takes it in its stride, so that’s our recommendation.'); }
  }
  const presets = !!sw.presets;
  const cap = sw.loops + (expansion?expansion.loops:0);
  let auxPedal = null;
  if(presets && sw.aux){
    if(!expansion && ffFirst) auxPedal = ffFirst;
    else if(needFor(sw,expansion) > cap){
      const cand = midNoTuner[Math.min(expansion?expansion.loops:0, midNoTuner.length-1)];
      if(cand && !isStereoRun(cand)) auxPedal = cand;   // the AUX is a mono loop
    }
  }
  // tuner disposition: dedicated out if the AUX jack is free; else a spare loop if one exists; else stay home — the built-in tuner covers it
  let tunerOut=null, tunerDropped=false;
  let tunerInLoop=false;
  if(presets && tuner){
    if(!auxPedal) tunerOut = tuner;
    else {
      const mainNeed = needFor(sw,expansion) - ((auxPedal && !(ffFirst && !expansion)) ? 1 : 0);
      if(cap - mainNeed >= 1) tunerInLoop = true;
      else tunerDropped = true;
    }
  }
  let looped = (presets ? ((tuner && tunerInLoop) ? mid : midNoTuner) : mid).filter(x=>x!==auxPedal);
  // the customer's hand-tuned loop order wins once touched; new pedals append at their rule position
  if(rig.loopTouched){
    const have = new Set(looped.map(puid));
    rig.loopOrder = rig.loopOrder.filter(u=>have.has(u));
    looped.forEach(x=>{ if(!rig.loopOrder.includes(puid(x))) rig.loopOrder.push(puid(x)); });
    looped = rig.loopOrder.map(u=>looped.find(x=>puid(x)===u)).filter(Boolean);
  } else {
    rig.loopOrder = looped.map(puid);
  }

  // stereo split
  let stereoFrom = -1, monoAfter = [];
  if(rig.amps!=='one'){
    stereoFrom = looped.findIndex(isStereoRun);
    if(stereoFrom>=0) monoAfter = looped.slice(stereoFrom+1).filter(x=>(!x.stereo||x.stereo==='M') && !x.virtual);
  }
  // wet section (wet/dry rigs): trailing run of wet-category pedals
  let wetFrom = -1;
  if(needsParallel){
    for(let i=looped.length-1;i>=0;i--){ if(WETCATS.includes(looped[i].cat)) wetFrom=i; else break; }
    if(wetFrom<0) warns.push('A wet/dry rig needs some wet effects — delays and reverbs — at the end of the chain, and this board doesn’t have any yet.');
  }

  const alt = (()=>{  // budget / step-up alternative
    if(owned || overflow) return null;
    if(presets && expansion===EXPANSIONS.P4 && (sw===SWITCHERS.ATOM || sw===SWITCHERS.SATOM)){
      const g = rig.screens?SWITCHERS.G3S:SWITCHERS.G3;
      return {sw:g, text:'This many loops is decision territory. The '+sw.name+' + PLUS4 does it for £'+(sw.price+EXPANSIONS.P4.price)+' — but the '+g.name+' (£'+g.price+') brings 14 presets per bank against the Atom’s 8, with 12 loops plus AUX on one board. If you live in presets, the step up is worth it.'};
    }
    if(presets && !hasMidi && !needsParallel && !rig.fourCM && rig.amps==='one' && loopsQMX<=10){
      const q=[SWITCHERS.QMX2,SWITCHERS.QMX4,SWITCHERS.QMX6,SWITCHERS.QMX8,SWITCHERS.QMX10].find(s=>s.loops>=loopsQMX);
      return q?{sw:q, text:'On a budget? A '+q.name+' switches these loops one at a time for £'+q.price+' — no presets or MIDI, but the same true-bypass purity.'}:null;
    }
    if(!presets){
      const g = needNoExp<=6+auxBonus?SWITCHERS.ATOM:SWITCHERS.G3;
      return {sw:g, text:'Step up to the '+g.name+' (£'+g.price+') and one tap recalls a whole sound — every loop, MIDI patch and amp channel changes together.'};
    }
    return null;
  })();

  const stereoRun = new Set(stereoRunList.filter(x=>looped.includes(x)).map(puid));
  const expNcount = expansion ? Math.min(expansion.loops, looped.length) : 0;
  const consumed = looped.reduce((t,x,i)=> t + ((i>=expNcount && stereoRun.has(puid(x)) && sw.pair)?2:1), 0);
  return {chain, ordered, skipped, front, tail, looped, tuner, tunerOut, tunerDropped, auxPedal, sw, expansion, presets, owned, alt, analogMoved,
    capacity: sw.loops + (expansion?expansion.loops:0), stereoRun,
    loopsNeeded:consumed, hasMidi, needsParallel, stereoFrom, monoAfter, wetFrom, warns, overflow};
}

/* ---------------- signal rendering ---------------- */
function catChip(cat){ const m=CATMETA[cat]; return '<span class="catchip" style="color:'+m.c+';border:1px solid '+m.c+'55;background:'+m.c+'14">'+m.n+'</span>'; }

function ampNodes(){
  return rig.amps==='one'   ? ['Amp'] :
         rig.amps==='stereo'? ['Amp left','Amp right'] :
         rig.amps==='wetdry'? ['Dry amp','Wet amp'] : ['Wet left','Dry amp','Wet right'];
}

function chainStrip(plan, lite){
  let h='<div class="chainstrip"><span class="cend">Guitar</span>';
  const arr='<span class="carr">▸</span>';
  const node=(x,tag)=>{
    const m=CATMETA[x.cat];
    return arr+'<span class="cnode" style="border-color:'+m.c+'">'+esc(pedalLabel(x))+'<small style="color:'+m.c+'">'+m.n+(tag?' · '+tag:'')+'</small></span>';
  };
  if(lite){
    // order only — no loop numbers, no AUX/tuner-out plumbing: that belongs to a GigRig plan
    plan.front.forEach(x=>h+=node(x, x.cat==='wah' ? 'in front' : 'always on'));
    if(plan.auxPedal) h+=node(plan.auxPedal, 'first in chain');
    if(plan.tunerOut) h+=node(plan.tunerOut,'');
    plan.looped.forEach((x,i)=>{
      if(i===plan.stereoFrom && rig.amps!=='one') h+=arr+'<span class="cend" style="color:var(--v15);border-color:var(--v15)">stereo from here</span>';
      h+=node(x, plan.stereoRun.has(puid(x))?'stereo':'');
    });
    plan.tail.forEach(x=>h+=node(x,'always on'));
    ampNodes().forEach(a=>h+=arr+'<span class="cend">'+esc(a)+'</span>');
    return h+'</div>';
  }
  plan.front.forEach(x=>h+=node(x, x.cat==='wah' ? 'in front' : 'always on'));
  const expN = plan.expansion ? Math.min(plan.expansion.loops, plan.looped.length) : 0;
  const scAll = plan.sw.pair ? plan.looped.slice(expN).filter(x=>plan.stereoRun.has(puid(x))).length : 0;
  let lnum=1, pairNum = plan.sw.loops - 2*scAll + 1;
  const emit=(x,i)=>{
    if(i===plan.stereoFrom && rig.amps!=='one') h+=arr+'<span class="cend" style="color:var(--v15);border-color:var(--v15)">stereo from here</span>';
    if(i===plan.wetFrom && plan.needsParallel) h+=arr+'<span class="cend" style="color:var(--v18);border-color:var(--v18)">wet section</span>';
    let tag;
    if(i<expN) tag=plan.expansion.short+' · '+(i+1);
    else {
      const pair=plan.stereoRun.has(puid(x))&&plan.sw.pair, trs=plan.stereoRun.has(puid(x))&&plan.sw.trs;
      if(pair){ tag='loops '+pairNum+'-'+(pairNum+1)+' · stereo'; pairNum+=2; }
      else { tag='loop '+lnum+(trs?' · TRS stereo':''); lnum+=1; }
    }
    h+=node(x, tag);
  };
  plan.looped.slice(0,expN).forEach((x,i)=>emit(x,i));           // PLUS loops sit at the very front
  if(plan.auxPedal) h+=node(plan.auxPedal,'AUX loop');
  plan.looped.slice(expN).forEach((x,i)=>emit(x,expN+i));
  if(plan.tunerOut) h+=node(plan.tunerOut,'tuner out');
  plan.tail.forEach(x=>h+=node(x,'always on'));
  ampNodes().forEach(a=>h+=arr+'<span class="cend">'+esc(a)+'</span>');
  return h+'</div>';
}

function drawSignalDiagram(plan){
  const ROW=56, HEAD=46, GAP=34, W=920;
  const SW_X=8, SW_W=196, JACK_X=SW_X+SW_W, PED_X=560, PED_W=340;
  const expN = plan.expansion ? Math.min(plan.expansion.loops, plan.looped.length) : 0;
  const agIdx = plan.looped.findIndex(x=>x.cat==='ampgain');
  const rowFor=(x,gi,lbl,expl,n)=>({type:'loop', lbl, expl, n, p:x,
    wet: plan.wetFrom>=0 && gi>=plan.wetFrom,
    st:  plan.stereoFrom>=0 && gi>=plan.stereoFrom,
    post: agIdx>=0 && gi>agIdx});

  // the PLUS unit is its own chassis, in front of the switcher: guitar in, its loops, out to the switcher
  const groups=[];
  if(plan.expansion){
    const prows=[{type:'in', src:'guitar'}];
    plan.looped.slice(0,expN).forEach((x,i)=>prows.push(rowFor(x,i,'LOOP '+(i+1),true,0)));
    const pspare = plan.expansion.loops-expN;
    if(pspare>0) prows.push({type:'spare', count:pspare});
    groups.push({title:plan.expansion.short, sub:plan.expansion.loops+' remote FX loops · your input unit — guitar goes in here first', rows:prows});
  }
  const mrows=[{type:'in', src: plan.expansion? 'exp':'guitar'}];
  if(plan.auxPedal) mrows.push({type:'aux', p:plan.auxPedal});
  // G3 stereo pairs are FIXED odd-even pairs (fw menu: loop 1-2 ... 11-12); stereo takes the top pairs
  const mainList = plan.looped.slice(expN);
  const scount = plan.sw.pair ? mainList.filter(x=>plan.stereoRun.has(puid(x))).length : 0;
  const monoZone = plan.sw.loops - 2*scount;
  let mono=1, pairAt = monoZone+1;
  mainList.forEach((x,i)=>{
    const pair = plan.stereoRun.has(puid(x)) && plan.sw.pair;
    const trs  = plan.stereoRun.has(puid(x)) && plan.sw.trs;
    let lbl,n,over;
    if(pair){ n=pairAt; lbl='LOOPS '+n+'-'+(n+1); over=(n+1)>plan.sw.loops||n<1; pairAt+=2; }
    else { n=mono; lbl='LOOP '+n; over=n>monoZone; mono+=1; }
    const r = rowFor(x,expN+i, over?'NO LOOP':lbl, false, n);
    r.pair=pair; r.trs=trs; r.span=pair?2:1; r.over=over;
    mrows.push(r);
  });
  const spare = monoZone - (mono-1);
  if(spare>0) mrows.push({type:'spare', count:spare});
  if(plan.tunerOut) mrows.push({type:'tuner', p:plan.tunerOut});
  ampNodes().forEach((a,i)=>mrows.push({type:'out', label:a, i}));
  groups.push({title:plan.sw.name.toUpperCase(), sub:plan.sw.sub, rows:mrows});

  let H=8;
  groups.forEach(g=>{ g.y=H; g.h=HEAD+g.rows.length*ROW+14; H+=g.h+GAP; });
  H-=GAP-8;
  let s='<svg viewBox="0 0 '+W+' '+H+'" width="'+W+'" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Signal path diagram">';
  const line=(y,color,double,dash)=>{
    if(double) return '<line x1="'+(JACK_X+5)+'" y1="'+(y-2)+'" x2="'+PED_X+'" y2="'+(y-2)+'" stroke="'+color+'" stroke-width="2"'+(dash?' stroke-dasharray="7 5"':'')+'/>'+
                      '<line x1="'+(JACK_X+5)+'" y1="'+(y+3)+'" x2="'+PED_X+'" y2="'+(y+3)+'" stroke="'+color+'" stroke-width="2"'+(dash?' stroke-dasharray="7 5"':'')+'/>';
    return '<line x1="'+(JACK_X+5)+'" y1="'+y+'" x2="'+PED_X+'" y2="'+y+'" stroke="'+color+'" stroke-width="3"'+(dash?' stroke-dasharray="7 5"':'')+'/>';
  };
  const jack=(y,color)=>'<circle cx="'+JACK_X+'" cy="'+y+'" r="5" fill="#fbfaf6" stroke="'+(color||'#6b6559')+'" stroke-width="1.5"/>';

  groups.forEach(g=>{
    s+='<rect x="'+SW_X+'" y="'+g.y+'" width="'+SW_W+'" height="'+g.h+'" rx="2" fill="#fbfaf6" stroke="#2b2a28"/>';
    s+='<rect x="'+SW_X+'" y="'+g.y+'" width="'+SW_W+'" height="34" rx="2" fill="#1c1c1c"/><rect x="'+SW_X+'" y="'+(g.y+22)+'" width="'+SW_W+'" height="12" fill="#1c1c1c"/>';
    s+='<text x="'+(SW_X+14)+'" y="'+(g.y+23)+'" fill="#fff" font-size="15" font-weight="700" letter-spacing="1">'+esc(g.title)+'</text>';
    s+='<text x="'+(SW_X+14)+'" y="'+(g.y+48)+'" fill="#6b6559" font-size="10.5">'+esc(g.sub)+'</text>';
    g.rows.forEach((r,ri)=>{
    const cy = g.y + HEAD + 12 + ri*ROW + ROW/2 - 6;
    const y = cy+3;
    if(r.type==='in'){
      if(r.src==='exp'){
        s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="#2b2a28" font-size="12" font-weight="600">IN</text>';
        s+=jack(y,'#a2701f')+line(y,'#a2701f');
        s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">from the '+esc(plan.expansion.short)+' output</text>';
        s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="none" stroke="#a2701f" stroke-width="1.5" stroke-dasharray="4 4"/>';
        s+='<text x="'+(PED_X+14)+'" y="'+(cy+6)+'" fill="#6b6559" font-size="12.5">'+esc(plan.expansion.short)+' OUT — see unit above</text>';
        return;
      }
      const via = plan.front.length? ' via '+plan.front.map(x=>pedalLabel(x)).join(' → ') : '';
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="#2b2a28" font-size="12" font-weight="600">IN</text>';
      s+=jack(y)+line(y,'#5d6a78');
      s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">'+esc('guitar'+via)+'</text>';
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="#5d6a78" stroke-width="1.5"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+6)+'" fill="#2b2a28" font-size="13" font-weight="600">Guitar'+(plan.front.length?' → '+esc(plan.front.map(x=>pedalLabel(x)).join(' → ')):'')+'</text>';
      return;
    }
    if(r.type==='spare'){
      s+='<text x="'+(SW_X+14)+'" y="'+(cy+4)+'" fill="#99917f" font-size="12">+ '+r.count+' spare loop'+(r.count>1?'s':'')+'</text>';
      return;
    }
    if(r.type==='aux'){
      const p=r.p, m=CATMETA[p.cat], c=m.c;
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="#2b2a28" font-size="12" font-weight="600">AUX</text>';
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+(cy+15)+'" fill="'+c+'" font-size="10.5">pre-gain loop · TRS jack</text>';
      s+=jack(y,c)+line(y,c);
      const auxNote = hasFlag(p,'ff') ? 'relay before the pre-gain — sees your pickup · pre-gain buffers after' : 'extra loop before the pre-gain — used because the board needs it';
      s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">'+auxNote+'</text>';
      s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy+18)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">one TRS → 2×mono cable · tip = send → pedal IN · ring = return ← pedal OUT</text>';
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+c+'" stroke-width="1.5"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+1)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(pedalLabel(p))+'</text>';
      s+='<text class="mono" x="'+(PED_X+14)+'" y="'+(cy+16)+'" fill="'+c+'" font-size="10.5">'+m.n.toUpperCase()+' · guitar-first</text>';
      return;
    }
    if(r.type==='tuner'){
      const p=r.p, c=CATMETA.tuner.c;
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="#2b2a28" font-size="12" font-weight="600">TUNER</text>';
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+(cy+15)+'" fill="#6b6559" font-size="10.5">dedicated out</text>';
      s+=jack(y,c)+line(y,c,false,true);
      s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">silent tuning · no loop used · or use the built-in tuner</text>';
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="none" stroke="'+c+'" stroke-dasharray="4 4"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+6)+'" fill="#6b6559" font-size="12.5">'+esc(pedalLabel(p))+'</text>';
      return;
    }
    if(r.type==='out'){
      const st = rig.amps==='stereo' || (rig.amps==='wdw' && r.label!=='Dry amp');
      const wet = r.label.startsWith('Wet');
      const c = wet? '#6b4f9e' : '#5d6a78';
      s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="#2b2a28" font-size="12" font-weight="600">OUT'+(ampNodes().length>1?' '+(r.i+1):'')+'</text>';
      if(wet||st) s+='<text class="mono" x="'+(SW_X+14)+'" y="'+(cy+15)+'" fill="#6b6559" font-size="10.5">'+(wet?'wet mix':'stereo')+'</text>';
      s+=jack(y,c)+line(y,c);   // one output, one cable — always a single line
      const via = plan.tail.length && !wet ? 'via '+plan.tail.map(x=>pedalLabel(x)).join(' → ') : '';
      if(via) s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">'+esc(via)+'</text>';
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+c+'" stroke-width="1.5"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+6)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(r.label)+'</text>';
      return;
    }
    // loop row
    const p=r.p, m=CATMETA[p.cat], c=m.c;
    const over = !!r.over;
    const lbl = r.lbl;
    s+='<text class="mono" x="'+(SW_X+14)+'" y="'+cy+'" fill="'+(over?'#b03a2e':'#2b2a28')+'" font-size="12" font-weight="600">'+lbl+'</text>';
    if(over) s+='<text class="mono" x="'+(SW_X+14)+'" y="'+(cy+15)+'" fill="#b03a2e" font-size="10.5">doesn’t fit</text>';
    const sub=[]; if(r.post) sub.push('amp fx loop'); if(r.wet) sub.push('wet');
    if(r.pair) sub.push('stereo pair · L+R'); else if(r.trs) sub.push('TRS stereo'); else if(r.st) sub.push('stereo');
    if(sub.length && !over) s+='<text class="mono" x="'+(SW_X+14)+'" y="'+(cy+15)+'" fill="'+(r.wet?'#6b4f9e':'#33707a')+'" font-size="10.5">'+sub.join(' · ')+'</text>';
    s+=jack(y,c)+line(y,c,r.pair||r.trs);
    s+='<text class="mono" x="'+((JACK_X+PED_X)/2)+'" y="'+(cy-8)+'" text-anchor="middle" fill="#6b6559" font-size="10.5">send → pedal → return</text>';
    if(p.cat==='ampgain'){
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+c+'" stroke-width="1.5" stroke-dasharray="6 3"/>';
      s+='<text x="'+(PED_X+14)+'" y="'+(cy+1)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(p.model)+'</text>';
      s+='<text class="mono" x="'+(PED_X+14)+'" y="'+(cy+16)+'" fill="#6b6559" font-size="10.5">send → amp input · amp FX send → return</text>';
    } else {
      s+='<rect x="'+PED_X+'" y="'+(cy-16)+'" width="'+PED_W+'" height="40" rx="2" fill="#fbfaf6" stroke="'+c+'" stroke-width="1.5"/>';
      if(p.custom){
        s+='<rect x="'+(PED_X+10)+'" y="'+(cy-10)+'" width="'+(PED_W-110)+'" height="17" rx="1" fill="#1c1c1c" transform="rotate(-0.7 '+(PED_X+100)+' '+cy+')"/>';
        s+='<text class="mono" x="'+(PED_X+16)+'" y="'+(cy+2)+'" fill="#f5f5f5" font-size="10.5" letter-spacing="0.14em">'+esc(pedalLabel(p).toUpperCase())+'</text>';
      } else {
        s+='<text x="'+(PED_X+14)+'" y="'+(cy+1)+'" fill="#2b2a28" font-size="13" font-weight="600">'+esc(pedalLabel(p))+'</text>';
      }
      s+='<text class="mono" x="'+(PED_X+14)+'" y="'+(cy+16)+'" fill="'+c+'" font-size="10.5">'+m.n.toUpperCase()+(p.midi?' · MIDI':'')+(p.stereo==='S'?' · stereo':p.stereo==='MS'?' · stereo out':'')+(p.custom?' · CUSTOM':'')+'</text>';
    }
    });
  });
  // patch cable: PLUS OUT down into the switcher IN
  if(groups.length===2){
    const a=groups[0], b=groups[1], x=SW_X+28;
    s+='<line x1="'+x+'" y1="'+(a.y+a.h)+'" x2="'+x+'" y2="'+b.y+'" stroke="#a2701f" stroke-width="3"/>';
    s+='<circle cx="'+x+'" cy="'+(a.y+a.h)+'" r="5" fill="#fbfaf6" stroke="#a2701f" stroke-width="1.5"/>';
    s+='<circle cx="'+x+'" cy="'+b.y+'" r="5" fill="#fbfaf6" stroke="#a2701f" stroke-width="1.5"/>';
    s+='<text class="mono" x="'+(x+12)+'" y="'+((a.y+a.h+b.y)/2+4)+'" fill="#a2701f" font-size="10.5" font-weight="600">'+esc(plan.expansion.short)+' OUT → '+esc(plan.sw.name.toUpperCase())+' IN</text>';
  }
  s+='</svg>';
  return s;
}
function renderSignalBOM(plan){
  const rows=[];
  if(!plan.owned){
    const v = plan.presets ? plan.sw.vars[region] : plan.sw.vars;
    rows.push({name:plan.sw.name+' Switching System', why:plan.sw.sub, price:plan.sw.price, url:plan.sw.url, cart:[v,1]});
  }
  if(plan.expansion){
    rows.push({name:plan.expansion.name, why:'adds '+plan.expansion.loops+' remote FX loops to the '+plan.sw.name, price:plan.expansion.price, url:plan.expansion.url, cart:[plan.expansion.variant,1]});
  }
  if(plan.hasMidi && plan.presets){
    const n = plan.chain.filter(x=>x.midi).length;
    rows.push({name:(n>1?n+' × ':'')+MIDI_CABLE.name, why:'preset patch changes for your MIDI pedals', price:MIDI_CABLE.price*n, url:MIDI_CABLE.url, cart:[MIDI_CABLE.variant,n]});
  }
  if(plan.auxPedal){
    rows.push({name:AUX_CABLE.name, why:'wires the AUX loop — TRS tip is the send into '+pedalLabel(plan.auxPedal)+', ring is the return from it', price:AUX_CABLE.price, url:AUX_CABLE.url, cart:[AUX_CABLE.variant,1]});
  }
  const total=rows.reduce((s,r)=>s+r.price,0);
  let h='<section class="card bom"><h2>4 · Parts list</h2>';
  if(plan.owned) h+='<p style="margin:0 0 10px;color:var(--muted);font-size:14px">Built around the <b style="color:var(--ink)">'+esc(plan.owned.name)+'</b> already on your board — nothing else to buy'+(rows.length?' except the extras below':'')+'.</p>';
  if(rows.length){
    h+='<table>';
    rows.forEach(r=>{ h+='<tr><td><a href="'+SHOP.base+r.url+'" target="_blank" rel="noopener">'+esc(r.name)+'</a><div class="why">'+esc(r.why)+'</div></td><td class="price">£'+r.price.toFixed(2)+'</td></tr>'; });
    h+='<tr><td>Total</td><td class="price">£'+total.toFixed(2)+'</td></tr></table>';
    cartData={items:rows.map(r=>({id:Number(r.cart[0]), quantity:r.cart[1]})), note:''};
    const permalink=SHOP.base+'/cart/'+rows.map(r=>r.cart[0]+':'+r.cart[1]).join(',')+'?attributes[Designer]=Signal+Path';
    h+='<div class="bom-foot">'+
      (plan.presets && !plan.owned ? '<label>Mains lead <select id="regionSel">'+['UK','EU','US','AU'].map(x=>'<option'+(region===x?' selected':'')+'>'+x+'</option>').join('')+'</select></label>' : '')+
      '<a class="buy" id="buyBtn" href="'+permalink+'"'+(ON_SHOP?'':' target="_blank" rel="noopener"')+'>'+(ON_SHOP?'Add to cart':'Buy at shop.thegigrig.com')+'</a></div>'+
      '<p class="buy-note">'+(ON_SHOP?'Adds everything above to your cart — you can keep browsing.':'Takes you to TheGigRig checkout with everything above already in the basket.')+'<br>Working draft, remember — if anything looks off for your rig, ask us first. We’d rather get it right than make a sale.</p>';
  }
  return h+'</section>';
}

function renderSignalOutput(){
  const host=$('output');
  const plan=planSignal();
  if(!plan){
    host.innerHTML='<div class="empty-state"><b>Your signal path appears here.</b><br>Add pedals on the left, answer a couple of questions about your rig, and we’ll work out the best order, assign the loops and draw the wiring.</div>';
    updateStickyVerdict();
    return;
  }
  const foreign=foreignSwitcher();
  const lite=!!foreign && !plan.owned && !rig.gigrigWay;
  let html='';
  if(lite){
    html+='<div class="stats">'+
      '<div class="stat kitcard"><div class="k">Your switcher</div><div class="v">'+esc(pedalLabel(foreign))+'</div></div>'+
      '<div class="stat"><div class="k">Pedals in chain</div><div class="v">'+plan.chain.filter(x=>!x.virtual).length+'</div></div>'+
      '</div>';
  }else{
    html+='<div class="stats">'+
      '<div class="stat kitcard"><div class="k">'+(plan.owned?'Your switcher':'Recommended switcher')+'</div><div class="v">'+esc(plan.sw.name)+(plan.expansion?' <small>+ '+esc(plan.expansion.short)+'</small>':'')+'</div></div>'+
      '<div class="stat"><div class="k">Loops used</div><div class="v">'+plan.loopsNeeded+'<small> of '+plan.sw.loops+(plan.expansion?'+'+plan.expansion.loops:'')+(plan.auxPedal?' + AUX':'')+'</small></div></div>'+
      '<div class="stat"><div class="k">Pedals in chain</div><div class="v">'+plan.chain.filter(x=>!x.virtual).length+'</div></div>'+
      (plan.owned?'':'<div class="stat"><div class="k">Price</div><div class="v">£'+(plan.sw.price+(plan.expansion?plan.expansion.price:0))+'</div></div>')+
      '</div>';
  }

  const warns=[...plan.warns];
  if(rig.loopTouched){
    // hand-tuned order: the rules watch and speak up, but the customer holds the pen
    if(rig.fourCM){
      const ai=plan.looped.findIndex(x=>x.cat==='ampgain');
      if(ai>=0) plan.looped.slice(ai+1).filter(x=>!x.virtual && !hasFlag(x,'dg')).forEach(x=>
        warns.push('<b>'+esc(pedalLabel(x))+'</b> is an analog circuit and your order puts it after the amp’s preamp — valve preamp levels will overload it. Dan would pull it back in front, but it’s your rig.'));
    }
    plan.looped.forEach((x,i)=>{
      if(hasFlag(x,'ff') && i>0) warns.push('<b>'+esc(pedalLabel(x))+'</b> is a guitar-first fuzz and your order puts pedals in front of it — it reacts to your pickup, so Dan would run it first. Your call.');
      if(x.cat==='filter' && plan.looped.slice(0,i).some(y=>isGain(y))) warns.push('<b>'+esc(pedalLabel(x))+'</b> now sits after a gain stage — it reacts to pick attack, and there won’t be much left to react to. Dan would put it up front.');
    });
  }
  plan.monoAfter.forEach(x=>warns.push('<b>'+esc(pedalLabel(x))+'</b> is mono and sits after your chain goes stereo — it will fold the stereo image back to mono at that point. If you can live without it there, move it earlier.'));
  if(rig.amps!=='one' && plan.stereoFrom<0){
    const capable=plan.chain.some(x=>!x.virtual && (x.stereo==='MS'||x.stereo==='S'));
    warns.push(capable
      ? 'You’ve chosen a two-amp rig but nothing is running stereo yet — tick the pedals you want in stereo in the “Which of these do you want to run in stereo?” box.'
      : 'You’ve chosen a two-amp rig but nothing on the board can run stereo — both amps will get the same mono signal. Stereo delays, reverbs and modulation are where two amps come alive.');
  }
  let wh=''; warns.forEach(w=>wh+='<div class="warning"><span class="ic">!</span><span>'+w+'</span></div>');
  if(wh) html+='<div class="warnings">'+wh+'</div>';

  const facts=[];
  if(lite) facts.push(pedalLabel(foreign)+' runs the switching on this board — we’ll leave its loop assignments to its own manual. The order below is how we’d run these pedals, whichever loops they end up in.');
  if(rig.gigrigWay && foreign && !plan.owned) facts.push('This is the rig rebuilt the GigRig way — the '+plan.sw.name+' takes over the switching, so your '+pedalLabel(foreign)+' wouldn’t be needed. The order of your pedals stays exactly the same either way.');
  plan.chain.filter(x=>hasFlag(x,'ff')).forEach(x=>{
    if(x===plan.auxPedal && !lite) facts.push(pedalLabel(x)+' lives in the '+plan.sw.name+'’s AUX loop — a relay that sits before the pre-gain, so the fuzz sees your pickup exactly as if it were plugged straight into the guitar. And because the pre-gain sits right after it, it acts as a buffer driving everything downstream. This is what the AUX loop was made for.');
    else facts.push(pedalLabel(x)+' wants to see your guitar first — vintage fuzz circuits react to the pickup itself, so it takes the first '+(lite?'spot':'loop')+' in the chain.');
  });
  if(!lite){
  if(plan.auxPedal && !hasFlag(plan.auxPedal,'ff')) facts.push(pedalLabel(plan.auxPedal)+' takes the AUX loop — the board is one loop over, and the AUX is effectively an extra loop sitting just before the pre-gain. Normal pedals use the main loops first; the AUX is the overflow (and the pre-gain buffers everything after it).');
  if(plan.tuner && plan.auxPedal && plan.presets && !plan.tunerOut && !plan.tunerDropped) facts.push('The AUX loop and the tuner out share one jack — with '+pedalLabel(plan.auxPedal)+' in the AUX, '+pedalLabel(plan.tuner)+' takes a normal loop as a mute-and-tune stop. Or leave it at home: the '+plan.sw.name+' has a tuner built in.');
  if(plan.tunerDropped) facts.push('Every loop is spoken for and the AUX has claimed the tuner jack — good news: the '+plan.sw.name+' has a superb tuner built in, so '+pedalLabel(plan.tuner)+' can stay at home. Nothing lost.');
  if(plan.auxPedal) facts.push('Wiring the AUX loop: it’s all in one TRS jack. The tip is the send — that goes to '+pedalLabel(plan.auxPedal)+'’s input — and the ring is the return, coming back from its output. One stereo-jack-to-two-mono-plugs cable does the whole job, and it’s in your parts list.');
  }
  plan.front.filter(x=>x.cat==='wah').forEach(x=>facts.push(pedalLabel(x)+' is your guitar input: guitar into the wah, wah into '+(lite?'your switcher':'the '+plan.sw.name)+'. With good true bypass that’s where a wah belongs 99% of the time — and it never costs you a loop. (Want it switchable as a master filter? It can take a loop instead — just ask.)'));
  plan.chain.filter(x=>x.cat==='filter').forEach(x=>facts.push(pedalLabel(x)+' reacts to your pick attack, so it sits right at the front of the chain — after a compressor or a drive it would have no dynamics left to react to.'));
  if(plan.expansion && !plan.owned && !lite){
    const stepUp = rig.screens?SWITCHERS.G3S:SWITCHERS.G3;
    const save = stepUp.price - (plan.sw.price+plan.expansion.price);
    if(plan.sw.loops<12 && save>0) facts.push('This board needs '+plan.loopsNeeded+' loops — a '+plan.sw.name+' plus a '+plan.expansion.short+' covers it and saves £'+save+' against stepping up to the '+stepUp.name+'. Outgrow it later? PLUS2 and PLUS4 expansions bolt on any time.');
    else facts.push('The '+plan.expansion.short+' adds '+plan.expansion.loops+' remote FX loops to your '+plan.sw.name+' — the G3 family grows with your board.');
  }
  if(plan.expansion && plan.owned){
    const short=plan.loopsNeeded-plan.owned.loops;
    facts.push('Your '+plan.owned.name+' is '+short+' loop'+(short>1?'s':'')+' short for this board — add a '+plan.expansion.short+' (£'+plan.expansion.price+') and everything fits. No need to change switchers.');
  }
  if(plan.expansion && !lite) facts.push('The '+plan.expansion.short+' sits right at the front: guitar into the '+plan.expansion.short+', out into the '+plan.sw.name+'. Its loops are the home for pedals whose order never changes.');
  if(plan.expansion && plan.expansion.loops===4 && rig.amps!=='one' && !lite) facts.push('A PLUS4 can also run as two stereo loops at the very end of a chain — but the '+plan.sw.name+'’s second output is isolated, and joining output 1 and output 2’s earths that way means re-isolating with a HumDinger. Keeping the PLUS4 at the front, nothing needs re-isolating — which is exactly why we draw it there. Ask us if the stereo-end rig is what you’re after.');
  if(plan.tunerOut && !lite) facts.push(pedalLabel(plan.tunerOut)+' sits on the '+plan.sw.name+'’s dedicated tuner out — silent tuning, no loop used. Or leave it at home: the '+plan.sw.name+' has a superb tuner built in, right on the display. Your call — the tuner out is there either way.');
  if(!plan.tuner && plan.presets && !lite) facts.push('No tuner on the board? Sorted anyway — the '+plan.sw.name+' has one built in: silent tuning on the main display, any time.');
  if(plan.tuner && !plan.presets && !lite) facts.push('On a QuarterMaster, put the tuner on a loop send with the supplied grounded plug in the return — engage that loop and you get silent tuning with the signal muted.');
  if(rig.fourCM){
    facts.push('Four-cable method: your amp’s preamp sits in its own loop, ordered with your gain pedals. Every preset can then choose pedal drive, amp drive, or both stacked.');
    const digPost = plan.looped.filter(x=>hasFlag(x,'dg') && plan.looped.indexOf(x)>plan.looped.findIndex(y=>y.cat==='ampgain'));
    if(plan.analogMoved.length) facts.push(plan.analogMoved.map(x=>pedalLabel(x)).join(', ')+' — analog circuit'+(plan.analogMoved.length>1?'s':'')+', so '+(plan.analogMoved.length>1?'they stay':'it stays')+' in front of the amp. Analog effects can’t take the level coming off a valve preamp; only digital effects belong after your amp’s gain.');
    if(digPost.length) facts.push(digPost.map(x=>pedalLabel(x)).join(', ')+' — digital, so '+(digPost.length>1?'they sit':'it sits')+' happily after your amp’s preamp, right where '+(digPost.length>1?'they':'it')+' sound'+(digPost.length>1?'':'s')+' best in a four-cable rig.');
  }
  if(plan.hasMidi && plan.presets && !lite) facts.push('The '+plan.sw.name+' speaks MIDI: '+plan.chain.filter(x=>x.midi).map(x=>pedalLabel(x)).join(', ')+' can change patches with every preset — sound changes become one tap.');
  if(plan.needsParallel && plan.presets && !lite) facts.push('Your wet effects run in the marked loops so the '+plan.sw.name+'’s parallel mixing can blend them alongside the dry amp — that’s the wet/dry magic.');
  if(plan.stereoRun.size && plan.sw.pair && !lite){
    const stList=plan.looped.filter(x=>plan.stereoRun.has(puid(x)));
    const start=plan.sw.loops-2*stList.length+1;
    const names=stList.map((x,i)=>pedalLabel(x)+' on loops '+(start+2*i)+'-'+(start+2*i+1)).join(', ');
    facts.push('Stereo on the '+plan.sw.name+' uses its fixed loop pairs — '+names+' — one loop for the left side, one for the right, exactly as the manual pairs them. They sit at the very end of the chain, so nothing after them can fold the image back to mono.');
  }
  if(plan.stereoRun.size && plan.sw.trs && !lite){
    const names=plan.looped.filter(x=>plan.stereoRun.has(puid(x))).map(x=>pedalLabel(x)).join(', ');
    facts.push('Stereo on the '+plan.sw.name+' is tidy: the loop itself switches to stereo and runs TRS cables — '+names+' each keep a single loop. They sit at the very end of the chain, so nothing after them can fold the image back to mono.');
  }
  if(plan.stereoRun.size && lite) facts.push('Your stereo pedals sit at the very end of the chain — nothing after them can fold the image back to mono. How the loops handle stereo is one for your switcher’s manual.');
  plan.chain.filter(x=>x.cat==='multi').forEach(x=>facts.push(pedalLabel(x)+' covers several effect types at once — we’ve placed it with your time effects, and its own internal routing handles the rest.'));
  const plumb=plan.skipped.filter(x=>x!==foreign);
  if(plumb.length) facts.push(plumb.map(x=>pedalLabel(x)).join(', ')+' — '+(plumb.length>1?'these are':'this is')+' rig plumbing rather than chain effects, so '+(plumb.length>1?'they don’t':'it doesn’t')+' take a loop. Ask us about the neatest way to wire '+(plumb.length>1?'them':'it')+' in.');
  if(!facts.length) facts.push('Every pedal gets its own true-bypass loop — when it’s off, it is completely out of your signal. That’s the whole point.');
  html+='<section class="card facts"><h2>Interesting points</h2>'+[...new Set(facts)].map(f=>'<p>'+esc(f)+'</p>').join('')+'</section>';

  if(lite){
    html+='<section class="card diagram-card"><div class="dhead"><h2>3 · Your pedal order</h2><button type="button" id="printBtn" class="printbtn">Print / save PDF</button><button type="button" class="sheetopen">Open full sheet ⤡</button></div>'+
      chainStrip(plan, true)+
      '<div class="legend">'+['comp','drive','fuzz','mod','delay','reverb'].map(c=>'<span><i style="background:'+CATMETA[c].c+'"></i>'+CATMETA[c].n+'</span>').join('')+
      '<span style="margin-left:auto">drawn to Dan’s ordering rules — works on any switcher</span></div></section>';
    html+=titleBlock('PEDAL ORDER');
    html+='<section class="card crosslink" style="border-left-color:var(--v15)"><p><b>Curious what this rig looks like built the GigRig way?</b> The loops, the presets, the AUX trick, exactly what it would cost — one click, no obligation.</p><button type="button" id="ggway">Show me the GigRig version →</button></section>';
  }else{
    html+='<section class="card diagram-card"><div class="dhead"><h2>3 · Your signal path</h2><button type="button" id="printBtn" class="printbtn">Print / save PDF</button><button type="button" class="sheetopen">Open full sheet ⤡</button></div>'+
      chainStrip(plan)+
      '<div class="diagram-scroll">'+drawSignalDiagram(plan)+'</div>'+
      '<div class="legend">'+['comp','drive','fuzz','mod','delay','reverb'].map(c=>'<span><i style="background:'+CATMETA[c].c+'"></i>'+CATMETA[c].n+'</span>').join('')+
      '<span style="margin-left:auto">every loop is true bypass · loop order = chain order</span></div></section>';
    html+=renderSignalBOM(plan);
    html+=titleBlock('SIGNAL PATH');
    if(plan.alt && !rig.gigrigWay) html+='<section class="card crosslink" style="border-left-color:var(--v15)"><p>'+esc(plan.alt.text)+'</p></section>';
    if(rig.gigrigWay && foreign && !plan.owned) html+='<section class="card crosslink" style="border-left-color:var(--v15)"><p>No pressure — this sheet is yours either way.</p><button type="button" id="ggback">← Back to the plan around my '+esc(foreign.model)+'</button></section>';
  }
  html+='<section class="card crosslink"><p><b>Now let’s power it.</b> '+(plan.owned||lite?'Your switcher':'The '+plan.sw.name)+' and every pedal here need clean isolated power — that’s the other half of this tool.</p><button type="button" id="xlink">Build my power path →</button></section>';
  host.innerHTML=html;
  bindOutputControls();
}

/* ---------------- rig question card ---------------- */
function renderRig(){
  const {chain} = sigParts();
  const real = chain.filter(x=>!x.virtual);
  // always-on chips
  const wrap=$('qAlwaysWrap'), chips=$('qAlways');
  const chippable = real.filter(x=>x.cat!=='wah');  // wah already lives in front — no loop either way
  if(chippable.length){ wrap.hidden=false; chips.innerHTML='';
    chippable.forEach(x=>{
      const b=document.createElement('button');
      b.type='button'; b.textContent=pedalLabel(x);
      if(rig.always.has(puid(x))) b.className='on';
      b.onclick=()=>{ const u=puid(x); rig.always.has(u)?rig.always.delete(u):rig.always.add(u); update(); };
      chips.appendChild(b);
    });
  } else wrap.hidden=true;
  // gain order list
  const gains=gainList(chain);
  const dwrap=$('qDrivesWrap'), ol=$('qDrives');
  if(gains.length>1){ dwrap.hidden=false; ol.innerHTML='';
    gains.forEach((x,i)=>{
      const li=document.createElement('li');
      if(x.cat==='ampgain') li.className='ampg';
      const n=gains.length;
      const g=Math.max(1,Math.min(5,Math.round(1+(4*i)/Math.max(1,n-1))));   // bars follow stack position: reorder and the graph follows
      li.innerHTML='<span class="dnm">'+esc(pedalLabel(x))+'</span><span class="glvl">'+(x.cat==='ampgain'?'amp':'gain '+'▮'.repeat(g)+'▯'.repeat(5-g))+'</span>'+
        '<span class="mv"><button type="button" '+(i===0?'disabled':'')+' aria-label="Move up">▲</button><button type="button" '+(i===gains.length-1?'disabled':'')+' aria-label="Move down">▼</button></span>';
      const [up,dn]=li.querySelectorAll('.mv button');
      up.onclick=()=>{ rig.gainTouched=true; const o=rig.gainOrder; [o[i-1],o[i]]=[o[i],o[i-1]]; update(); };
      dn.onclick=()=>{ rig.gainTouched=true; const o=rig.gainOrder; [o[i+1],o[i]]=[o[i],o[i+1]]; update(); };
      ol.appendChild(li);
    });
  } else dwrap.hidden=true;
  // whole-chain fine-tune list (signal mode): the customer can move any loop; rules warn, never block
  const lwrap=$('qLoopsWrap'), lol=$('qLoops'), lreset=$('qLoopsReset');
  const lplan = mode==='signal' ? planSignal() : null;
  if(lplan && lplan.looped.length>1){
    lwrap.hidden=false; lol.innerHTML='';
    lreset.hidden = !rig.loopTouched;
    lreset.onclick=()=>{ rig.loopTouched=false; rig.loopOrder=[]; update(); };
    lplan.looped.forEach((x,i)=>{
      const li=document.createElement('li');
      if(x.cat==='ampgain') li.className='ampg';
      const m=CATMETA[x.cat]||CATMETA.util;
      li.innerHTML='<span class="dnm">'+esc(pedalLabel(x))+'</span><span class="glvl" style="color:'+m.c+'">'+m.n.toLowerCase()+'</span>'+
        '<span class="mv"><button type="button" '+(i===0?'disabled':'')+' aria-label="Move up">▲</button><button type="button" '+(i===lplan.looped.length-1?'disabled':'')+' aria-label="Move down">▼</button></span>';
      const [up,dn]=li.querySelectorAll('.mv button');
      up.onclick=()=>{ rig.loopTouched=true; const o=rig.loopOrder; [o[i-1],o[i]]=[o[i],o[i-1]]; update(); };
      dn.onclick=()=>{ rig.loopTouched=true; const o=rig.loopOrder; [o[i+1],o[i]]=[o[i],o[i+1]]; update(); };
      lol.appendChild(li);
    });
  } else lwrap.hidden=true;
  // screens toggle visible only when a G3-family rec is in play
  $('qScreensWrap').hidden = rig.style==='simple';
  // modulation position only matters when there's mod AND gain on the board
  $('qModWrap').hidden = !(real.some(x=>x.cat==='mod') && real.some(x=>isGain(x)));
  // stereo chips: only on multi-amp rigs with stereo-capable pedals
  const swrap=$('qStereoWrap'), schips=$('qStereo');
  const capable = real.filter(x=>x.stereo==='MS'||x.stereo==='S');
  if(rig.amps!=='one' && capable.length){
    swrap.hidden=false; schips.innerHTML='';
    capable.forEach(x=>{
      const b=document.createElement('button');
      b.type='button'; b.textContent=pedalLabel(x);
      if(rig.stereoOn.has(puid(x))) b.className='on';
      b.onclick=()=>{ const u=puid(x); rig.stereoOn.has(u)?rig.stereoOn.delete(u):rig.stereoOn.add(u); update(); };
      schips.appendChild(b);
    });
  } else swrap.hidden=true;
  const HINTS={one:'', stereo:'We’ll show where your chain goes stereo and feed both amps from the switcher.',
    wetdry:'Dry amp stays pure; delays and reverbs get blended in alongside it.',
    wdw:'Dry amp in the middle, a stereo wet pair either side — the big-stage rig.'};
  $('ampsHint').textContent=HINTS[rig.amps];
}


/* the drafted title block — every sheet leaves the works signed */
function titleBlock(doc){
  const d=new Date();
  const roman=['','I','II','III','IV','V','VI','VII','VIII','IX','X','XI','XII'][d.getMonth()+1];
  return '<div class="tblock">'+
    '<div class="trow"><div class="tcell tbig">THE GIGRIG</div><div class="tcell" style="flex:1.6"><span class="tlab">Works</span>ROYAL WOOTTON BASSETT · ENGLAND</div></div>'+
    '<div class="trow"><div class="tcell" style="flex:2"><span class="tlab">Document</span>'+doc+'</div><div class="tcell"><span class="tlab">Pedals</span>'+board.length+'</div></div>'+
    '<div class="trow"><div class="tcell"><span class="tlab">Drawn to</span>DAN\u2019S RULES</div><div class="tcell"><span class="tlab">Checked</span>D.S.</div><div class="tcell"><span class="tlab">Date</span>'+d.getDate()+' \u00b7 '+roman+' \u00b7 '+d.getFullYear()+'</div></div></div>';
}
/* ---------------- shared output control binding ---------------- */
function bindOutputControls(){
  const rs=document.getElementById('regionSel');
  if(rs) rs.onchange=()=>{ region=rs.value; renderOutput(); };
  const pb=document.getElementById('printBtn');
  if(pb) pb.onclick=()=>window.print();
  const gw=document.getElementById('ggway');
  if(gw) gw.onclick=()=>{ rig.gigrigWay=true; renderOutput(); };
  const gb=document.getElementById('ggback');
  if(gb) gb.onclick=()=>{ rig.gigrigWay=false; renderOutput(); };
  const xl=document.getElementById('xlink');
  if(xl) xl.onclick=()=>{
    if(mode==='signal'){
      const plan=planSignal();
      if(plan && !plan.owned){
        const hit=DB.find(p=>p.brand==='TheGigRig' && p.model===plan.sw.name);
        const already=board.some(p=>p.cat==='switcher');
        if(hit && !already) addPedal(hit);
      }
      if(plan && plan.expansion && !board.some(p=>p.brand==='TheGigRig' && p.model===plan.expansion.dbModel)){
        const eh=DB.find(p=>p.brand==='TheGigRig' && p.model===plan.expansion.dbModel);
        if(eh) addPedal(eh);
      }
      setMode('power');
    } else setMode('signal');
  };
  const bb=document.getElementById('buyBtn');
  if(bb && ON_SHOP) bb.onclick=async e=>{
    e.preventDefault();
    bb.textContent='Adding…';
    try{
      const res=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:cartData.items})});
      if(!res.ok) throw new Error('add failed');
      const upd={attributes:{'Designer':mode==='power'?'Power Path':'Signal Path'}};
      if(cartData.note){
        const cur=await fetch('/cart.js').then(r=>r.json()).catch(()=>({note:''}));
        upd.note=(cur.note?cur.note+'\n':'')+cartData.note;
      }
      await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(upd)}).catch(()=>{});
      window.location.href='/cart';
    }catch(err){ window.location.href=bb.href; }
  };
  /* quick add-to-cart beside the verdict — the parts list below stays the source of truth */
  const qstats=document.querySelector('#output .stats');
  if(bb && qstats && !document.getElementById('quickBuyBtn')){
    const tot=document.querySelector('#output .card.bom table tr:last-child .price');
    const qb=document.createElement('div');
    qb.className='quickbuy';
    const qa=document.createElement('a');
    qa.className='buy'; qa.id='quickBuyBtn';
    qa.href=bb.getAttribute('href');
    if(!ON_SHOP){ qa.target='_blank'; qa.rel='noopener'; }
    qa.textContent=bb.textContent+(tot?' — '+tot.textContent.trim():'');
    const qp=document.createElement('a');
    qp.className='qb-parts'; qp.href='#'; qp.textContent='Full parts list ↓';
    qb.append(qa,qp);
    qstats.insertAdjacentElement('afterend',qb);
    if(ON_SHOP) qa.onclick=e=>{ e.preventDefault(); qa.textContent='Adding…'; bb.click(); };
    qp.onclick=e=>{ e.preventDefault(); scrollToEl(document.querySelector('#output .card.bom')); };
  }
  document.querySelectorAll('.sheetopen').forEach(b=>b.onclick=openSheetView);
  const dsvg=document.querySelector('#output .diagram-scroll svg');
  if(dsvg) dsvg.addEventListener('click',()=>{ if(window.matchMedia('(max-width:700px)').matches) openSheetView(); });
  updateStickyVerdict();
}

/* ---------------- mobile sticky verdict bar + full-sheet viewer ---------------- */
function scrollToEl(el){
  if(!el) return;
  const y0=window.scrollY;
  el.scrollIntoView({behavior:'smooth',block:'start'});
  /* some embedded browsers silently ignore smooth scrolling — jump if nothing moved */
  setTimeout(()=>{ if(Math.abs(window.scrollY-y0)<4 && Math.abs(el.getBoundingClientRect().top)>40) el.scrollIntoView({block:'start'}); window.dispatchEvent(new Event('scroll')); },450);
}
let svScrollFn=null;
function updateStickyVerdict(){
  const bar=document.getElementById('stickyVerdict');
  if(!bar) return;
  const kitEl=document.querySelector('#output .stats .stat.kitcard .v');
  if(!kitEl){ document.body.classList.remove('has-verdict'); if(svScrollFn){ window.removeEventListener('scroll',svScrollFn); window.removeEventListener('resize',svScrollFn); svScrollFn=null; } return; }
  const kitName=((kitEl.childNodes[0]&&kitEl.childNodes[0].textContent)||kitEl.textContent||'').trim();
  const firstStat=document.querySelector('#output .stats .stat:not(.kitcard) .v');
  const statTxt=firstStat?firstStat.textContent.trim().replace(/\s+/g,' '):'';
  const totCell=document.querySelector('#output .card.bom table tr:last-child .price');
  const bits=[statTxt?statTxt+(mode==='power'?' powered':' in play'):'', totCell?totCell.textContent.trim():''].filter(Boolean);
  const txt=bar.querySelector('.sv-text');
  txt.textContent='';
  const bEl=document.createElement('b'); bEl.textContent=kitName; txt.appendChild(bEl);
  if(bits.length) txt.appendChild(document.createTextNode(' \u00b7 '+bits.join(' \u00b7 ')));
  const bb=document.getElementById('buyBtn');
  const btn=document.getElementById('svBtn');
  const statsRow=document.querySelector('#output .stats');
  if(svScrollFn){ window.removeEventListener('scroll',svScrollFn); window.removeEventListener('resize',svScrollFn); svScrollFn=null; }
  let atOutput=false;
  const setLabel=()=>{ btn.textContent=(atOutput&&bb)?(ON_SHOP?'Add to cart':'Buy this kit'):'See my path \u2193'; };
  /* plain scroll listener, not IntersectionObserver — IO callbacks are suspended in some webviews (verified in embedded panes; FB/IG in-app browsers are the audience risk) */
  svScrollFn=()=>{ if(!document.contains(statsRow)) return; atOutput=statsRow.getBoundingClientRect().top<window.innerHeight*0.65; setLabel(); };
  window.addEventListener('scroll',svScrollFn,{passive:true});
  window.addEventListener('resize',svScrollFn,{passive:true});
  svScrollFn();
  btn.onclick=()=>{ if(atOutput&&bb){ btn.textContent='Adding\u2026'; bb.click(); } else scrollToEl(statsRow); };
  document.body.classList.add('has-verdict');
}
function openSheetView(){
  const src=document.querySelector('#output .diagram-scroll svg');
  if(!src) return;
  const view=document.getElementById('sheetView');
  const body=view.querySelector('.shv-body');
  body.innerHTML='';
  body.appendChild(src.cloneNode(true));
  view.classList.add('open');
  document.body.style.overflow='hidden';
}
function closeSheetView(){
  const view=document.getElementById('sheetView');
  if(!view.classList.contains('open')) return;
  view.classList.remove('open');
  view.querySelector('.shv-body').innerHTML='';
  document.body.style.overflow='';
}
document.getElementById('shvClose').onclick=closeSheetView;
document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeSheetView(); });

/* ---------------- mode switching ---------------- */
function setMode(m){
  mode=m;
  $('modePower').classList.toggle('on', m==='power');
  $('modePower').setAttribute('aria-selected', m==='power');
  $('modeSignal').classList.toggle('on', m==='signal');
  $('modeSignal').setAttribute('aria-selected', m==='signal');
  $('rigCard').hidden = m!=='signal';
  $('tagline').textContent = m==='power' ? 'Pick your pedals. We’ll work out the power.' : 'Pick your pedals. We’ll work out the order, the loops and the switcher.';
  update();
  window.scrollTo({top:0, behavior:'smooth'});
}
$('modePower').onclick=()=>setMode('power');
$('modeSignal').onclick=()=>setMode('signal');

function bindOpts(id, get, set){
  document.querySelectorAll('#'+id+' button').forEach(b=>{
    b.onclick=()=>{ set(b.dataset.v); document.querySelectorAll('#'+id+' button').forEach(x=>x.classList.toggle('on', x===b)); update(); };
  });
}
bindOpts('qAmps', ()=>rig.amps, v=>rig.amps=v);
bindOpts('q4cm', ()=>rig.fourCM, v=>rig.fourCM=(v==='yes'));
bindOpts('qModPos', ()=>rig.modPos, v=>rig.modPos=v);
bindOpts('qStyle', ()=>rig.style, v=>rig.style=v);
$('qScreens').onchange=e=>{ rig.screens=e.target.checked; update(); };

/* ---------------- search ---------------- */
const searchEl=$('search'), resEl=$('results');
const BRAND_ALIAS={'Electro-Harmonix':'EHX','EarthQuaker':'EQD EarthQuaker Devices','Universal Audio':'UA UAFX','TC Electronic':'TC','Ibanez':'Tube Screamer','Vahlbruch':'Valbrook Valbruch Vallbruch','Hamstead Soundworks':'Hampstead','Behringer':'Beringer Berringer'};
const hay=p=>(p.brand+' '+p.model+' '+(BRAND_ALIAS[p.brand]||'')).toLowerCase();
const sqz=s=>s.replace(/[^a-z0-9]+/g,'');  /* "ge-7"/"GE 7"/"ge7" all match: compare with punctuation and spaces squeezed out */
const pHayC=p=>p._hayC||(p._hayC=hay(p));
const pHayS=p=>p._hayS||(p._hayS=sqz(pHayC(p)));
function doSearch(){
  const q=searchEl.value.trim().toLowerCase();
  const words=q.split(/\s+/).filter(Boolean);
  const hits=(q? DB.filter(p=>words.every(w=>{const ws=sqz(w);return pHayC(p).includes(w)||(ws&&pHayS(p).includes(ws));})) : DB.slice())
    .sort((a,b)=>a.brand.localeCompare(b.brand)||a.model.localeCompare(b.model));
  resEl.innerHTML='';
  if(!hits.length){
    resEl.innerHTML='<div class="none">No match for “<b>'+esc(searchEl.value.trim())+'</b>” — add it below with its voltage and current, and it’ll join the database.</div>';
  }else{
    const n=document.createElement('div');
    n.className='none';
    n.textContent=hits.length+' pedal'+(hits.length>1?'s':'')+(hits.length>8?' — scroll for more':'');
    resEl.appendChild(n);
    hits.forEach(p=>{
      const b=document.createElement('button');
      b.type='button';
      b.innerHTML='<span>'+esc(p.brand)+' <b>'+esc(p.model)+'</b></span><span class="spec">'+(p.plug==='batt'?'9V battery':p.v?p.v+'V · '+p.ma+'mA':'passive')+'</span>';
      b.onclick=()=>{ addPedal(p); searchEl.value=''; doSearch(); searchEl.focus(); };
      resEl.appendChild(b);
    });
  }
  resEl.classList.add('open');
}
searchEl.addEventListener('input',doSearch);
searchEl.addEventListener('focus',doSearch);
searchEl.addEventListener('keydown',e=>{
  if(e.key==='Enter'){ const first=resEl.querySelector('button'); if(first) first.click(); }
  if(e.key==='Escape') resEl.classList.remove('open');
});
document.addEventListener('click',e=>{ if(!e.target.closest('.searchbox')) resEl.classList.remove('open'); });

function addPedal(p){ board.push({...p}); update(); }

/* custom pedal form */
// deliberately conservative blocklist — real pedal names get cheeky (EHX Cock Fight, Swollen Pickle),
// so only unambiguous vulgarity and slurs are stopped; anything borderline is caught at human review
const BANNED=['fuck','shit','cunt','wank','twat','bitch','arsehole','asshole','nigg','fagg','spastic','retard','piss','bollock','ballbag','jizz','spunk'];
const isClean=s=>{const t=s.toLowerCase().replace(/[^a-z]/g,''); return !BANNED.some(w=>t.includes(w.replace(/[^a-z]/g,'')));};
let pendingPedal=null;
$('cAdd').onclick=()=>{
  const brand=$('cBrand').value.trim(), name=$('cName').value.trim(), ma=parseInt($('cMa').value,10);
  $('cConfirm').hidden=true;
  if(!brand || !name || !ma || ma<1){ $('cToast').textContent='Give the manufacturer, the pedal name, and its current draw in mA.'; $('cToast').className='toast show'; $('cToast').style.color='var(--bad)'; return; }
  if(!isClean(brand) || !isClean(name)){ $('cToast').textContent='Let’s keep it clean — enter the pedal’s real name as the manufacturer spells it.'; $('cToast').className='toast show'; $('cToast').style.color='var(--bad)'; return; }
  const ccat=$('cCat').value;
  pendingPedal={id:nextCustomId++, brand, model:name, v:parseInt($('cVolt').value,10), ma, plug:$('cPlug').value, pol:$('cPol').value,
    cat:ccat, gain:ccat==='fuzz'?5:ccat==='drive'?3:0, stereo:$('cStereo').value, midi:$('cMidi').value==='1', flags:$('cCirc').value, custom:true};
  $('cToast').className='toast';
  $('cConfirmSpec').textContent=brand+' '+name+' — '+pendingPedal.v+'V · '+pendingPedal.ma+'mA · '+(pendingPedal.plug==='batt'?'battery clip only':pendingPedal.plug+' · '+(pendingPedal.pol==='CN'?'centre negative':'centre positive'));
  $('cGoogle').href='https://www.google.com/search?q='+encodeURIComponent(brand+' '+name+' pedal power requirements');
  $('cConfirm').hidden=false;
};
$('cYes').onclick=()=>{
  if(!pendingPedal) return;
  DB.push(pendingPedal); addPedal(pendingPedal);
  pendingPedal=null;
  $('cConfirm').hidden=true;
  $('cBrand').value=''; $('cName').value=''; $('cMa').value='';
  $('cToast').style.color='var(--v9)';
  $('cToast').textContent='Added — your power path has updated. If you order this kit, the pedal’s details reach TheGigRig automatically and (once verified as the real deal) join the database for everyone.';
  $('cToast').className='toast show';
};
$('cNo').onclick=()=>{ pendingPedal=null; $('cConfirm').hidden=true; };

/* demo boards */
document.querySelectorAll('.quick button').forEach(b=>{
  b.onclick=()=>{
    board=[];
    DEMOS[b.dataset.demo].forEach(frag=>{
      const q=frag.toLowerCase();
      const hit=DB.find(p=>(p.brand+' '+p.model).toLowerCase().includes(q)||q.split(' ').every(w=>(p.brand+' '+p.model).toLowerCase().includes(w)));
      if(hit) board.push({...hit});
    });
    update();
  };
});

let nextUid=1;
function update(){
  board.forEach(p=>{ if(!p._u) p._u='u'+(nextUid++); });
  renderBoard();
  if(mode==='signal') renderRig();
  renderOutput();
  saveLocal();
}

/* ---------------- save & restore builds ---------------- */
// A build is tiny (pedal identities + rig choices), so it lives in a link — no account, no server.
// DB pedals are referenced by brand+model (stable if the DB grows); custom pedals carry their full spec.
// The per-pedal toggles/orders reference runtime _u ids, so we serialise them as board indices and
// re-map them back to fresh _u ids on restore. '_ampgain' is the virtual 4CM amp row → sentinel -1.
const SAVE_KEY='gigrig_designer_build_v1';
function serializeBuild(){
  const idx=new Map(board.map((p,i)=>[p._u,i]));
  const enc=p=>p.custom
    ? {c:1,d:[p.brand,p.model,p.v,p.ma,p.plug,p.pol,p.cat,p.gain,p.stereo,p.midi?1:0,p.flags||'']}
    : {k:[p.brand,p.model]};
  const ord=arr=>(arr||[]).map(u=>u==='_ampgain'?-1:(idx.has(u)?idx.get(u):null)).filter(v=>v!==null);
  const set=s=>[...s].map(u=>idx.get(u)).filter(v=>v!=null);
  return {ver:1,mode,board:board.map(enc),rig:{
    amps:rig.amps,fourCM:rig.fourCM,style:rig.style,screens:rig.screens,modPos:rig.modPos,
    gigrigWay:rig.gigrigWay,gainTouched:rig.gainTouched,loopTouched:rig.loopTouched,
    always:set(rig.always),stereoOn:set(rig.stereoOn),gainOrder:ord(rig.gainOrder),loopOrder:ord(rig.loopOrder)}};
}
function restoreBuild(o){
  if(!o||o.ver!==1||!Array.isArray(o.board)) return false;
  mode = o.mode==='signal'?'signal':'power';
  board = o.board.map(ref=>{
    if(ref&&ref.c&&Array.isArray(ref.d)){
      const d=ref.d;
      let p=DB.find(x=>x.custom&&x.brand===d[0]&&x.model===d[1]);   // reuse if a previous load already added it
      if(!p){ p={id:nextCustomId++,brand:d[0],model:d[1],v:d[2],ma:d[3],plug:d[4],pol:d[5],cat:d[6],gain:d[7],stereo:d[8],midi:!!d[9],flags:d[10]||'',custom:true}; DB.push(p); }
      return {...p};
    }
    if(ref&&Array.isArray(ref.k)){ const hit=DB.find(p=>p.brand===ref.k[0]&&p.model===ref.k[1]); return hit?{...hit}:null; }
    return null;
  }).filter(Boolean);
  board.forEach(p=>{ if(!p._u) p._u='u'+(nextUid++); });
  const byIdx=i=>board[i]&&board[i]._u;
  const r=o.rig||{};
  rig.amps=r.amps||'one'; rig.fourCM=!!r.fourCM; rig.style=r.style||'auto';
  rig.screens=r.screens!==false; rig.modPos=r.modPos||'post'; rig.gigrigWay=!!r.gigrigWay;
  rig.gainTouched=!!r.gainTouched; rig.loopTouched=!!r.loopTouched;
  rig.always=new Set((r.always||[]).map(byIdx).filter(Boolean));
  rig.stereoOn=new Set((r.stereoOn||[]).map(byIdx).filter(Boolean));
  rig.gainOrder=(r.gainOrder||[]).map(i=>i===-1?'_ampgain':byIdx(i)).filter(Boolean);
  rig.loopOrder=(r.loopOrder||[]).map(i=>i===-1?'_ampgain':byIdx(i)).filter(Boolean);
  return true;
}
const b64=s=>btoa(unescape(encodeURIComponent(s))).replace(/\+/g,'-').replace(/\//g,'_').replace(/=+$/,'');
const unb64=s=>decodeURIComponent(escape(atob(s.replace(/-/g,'+').replace(/_/g,'/'))));
function saveLocal(){ try{ localStorage.setItem(SAVE_KEY, JSON.stringify(serializeBuild())); localStorage.setItem(ACTIVE_KEY, activeSaveId||''); }catch(e){} }
function buildLink(){
  const url=location.origin+location.pathname+'#build='+b64(JSON.stringify(serializeBuild()));
  return url;
}
function bootRestore(){
  // 1) a shared/emailed link wins (a fresh, unsaved board); 2) otherwise resume this device's last board
  const m=location.hash.match(/[#&]build=([^&]+)/);
  if(m){ try{ if(restoreBuild(JSON.parse(unb64(m[1])))){ activeSaveId=null; syncControls(); return; } }catch(e){} }
  try{ const raw=localStorage.getItem(SAVE_KEY);
    if(raw && restoreBuild(JSON.parse(raw))){
      const a=localStorage.getItem(ACTIVE_KEY); if(a && loadSaves().some(x=>x.id===a)) activeSaveId=a;
      syncControls();
    } }catch(e){}
}

/* ---------------- named boards: keep several projects, switch between them ---------------- */
// Working board still auto-saves (resume on return). On top of that, a customer can save any number
// of NAMED boards to this device — great for board-builders juggling projects — and reopen them.
const SAVES_KEY='gigrig_designer_saves_v1', ACTIVE_KEY='gigrig_designer_active_v1';
let activeSaveId=null, saveSeq=0;
const loadSaves=()=>{ try{ return JSON.parse(localStorage.getItem(SAVES_KEY))||[]; }catch(e){ return []; } };
const writeSaves=a=>{ try{ localStorage.setItem(SAVES_KEY, JSON.stringify(a)); }catch(e){} };
const newSaveId=()=>'s'+Date.now().toString(36)+(saveSeq++);
function upsertSave(name){
  const saves=loadSaves(), data=serializeBuild();
  let s=activeSaveId && saves.find(x=>x.id===activeSaveId);
  if(s){ s.name=name; s.data=data; s.ts=Date.now(); }
  else { s={id:newSaveId(),name,data,ts:Date.now()}; saves.push(s); activeSaveId=s.id; }
  writeSaves(saves); saveLocal(); renderSaves();
}
function loadSave(id){
  const s=loadSaves().find(x=>x.id===id); if(!s) return;
  if(restoreBuild(s.data)){ activeSaveId=id; if(location.hash) history.replaceState(null,'',location.pathname+location.search); syncControls(); update(); window.scrollTo({top:0,behavior:'smooth'}); }
}
function deleteSave(id){ writeSaves(loadSaves().filter(x=>x.id!==id)); if(activeSaveId===id) activeSaveId=null; saveLocal(); renderSaves(); }
function openNamePanel(prefill){ $('saveName').value=prefill||''; $('namePanel').style.display='flex'; $('saveName').focus(); $('saveName').select(); }
const closeNamePanel=()=>{ $('namePanel').style.display='none'; };
function flashSaved(){ const b=$('saveBoard'); b.textContent='✓ Saved'; setTimeout(renderSaves,1500); }
function renderSaves(){
  const saves=loadSaves().sort((a,b)=>b.ts-a.ts);
  const active=activeSaveId && saves.find(x=>x.id===activeSaveId);
  $('saveActions').style.display = board.length? 'flex':'none';
  $('savedBoards').style.display = saves.length? 'block':'none';
  $('saveBar').style.display = (board.length||saves.length)? 'block':'none';
  if(!board.length){ closeNamePanel(); closeEmailPanel(); }
  $('saveBoard').textContent = active ? 'Update “'+active.name+'”' : 'Save this board';
  $('copyBoard').hidden = !(active && board.length);
  $('emailBtn').style.display = (EMAIL_CAPTURE_ON && board.length) ? 'inline-block' : 'none';
  const list=$('savedList'); list.innerHTML='';
  saves.forEach(s=>{
    const cnt=(s.data&&s.data.board)?s.data.board.length:0, isA=s.id===activeSaveId;
    const row=document.createElement('div');
    row.style.cssText='display:flex;align-items:center;gap:10px;padding:8px 11px;border:1px solid '+(isA?'var(--red)':'var(--faint)')+';border-radius:8px;margin-bottom:7px;background:'+(isA?'rgba(176,58,46,.05)':'transparent');
    row.innerHTML='<span style="flex:1;min-width:0"><b style="color:var(--ink)">'+esc(s.name)+'</b>'+(isA?' <span style="color:var(--red);font-size:11.5px">· editing</span>':'')+'<br><span style="color:var(--muted);font-size:12px">'+cnt+' pedal'+(cnt===1?'':'s')+' · '+new Date(s.ts).toLocaleDateString()+'</span></span>';
    const load=document.createElement('button'); load.type='button'; load.textContent=isA?'Open':'Open';
    load.style.cssText='font-family:var(--body);font-size:13px;color:var(--red);background:transparent;border:1px solid var(--red);border-radius:6px;padding:5px 12px;cursor:pointer;visibility:'+(isA?'hidden':'visible');
    load.onclick=()=>loadSave(s.id);
    const del=document.createElement('button'); del.type='button'; del.textContent='✕'; del.title='Delete this board';
    del.style.cssText='font-family:var(--body);font-size:13px;color:var(--muted);background:transparent;border:1px solid var(--faint);border-radius:6px;padding:5px 10px;cursor:pointer';
    del.onclick=()=>{ if(confirm('Delete “'+s.name+'”? This can’t be undone.')) deleteSave(s.id); };
    row.appendChild(load); row.appendChild(del); list.appendChild(row);
  });
}
$('saveBoard').onclick=()=>{
  const active=activeSaveId && loadSaves().find(x=>x.id===activeSaveId);
  if(active){ upsertSave(active.name); flashSaved(); }
  else openNamePanel('My board '+(loadSaves().length+1));
};
$('copyBoard').onclick=()=>{
  const src=loadSaves().find(x=>x.id===activeSaveId);
  activeSaveId=null; openNamePanel(src? src.name+' copy' : 'My board '+(loadSaves().length+1));
};
$('nameConfirm').onclick=()=>{ const nm=$('saveName').value.trim(); if(!nm){ $('saveName').focus(); return; } upsertSave(nm); closeNamePanel(); flashSaved(); };
$('nameCancel').onclick=()=>{ closeNamePanel(); };
$('saveName').addEventListener('keydown',e=>{ if(e.key==='Enter'){ e.preventDefault(); $('nameConfirm').click(); } if(e.key==='Escape') closeNamePanel(); });

/* footer copy stats always match the shipped DB — no more hand-updated counts drifting stale */
{ const pc=$('dbPedalCount'), bc=$('dbBrandCount'); if(pc) pc.textContent=DB.length.toLocaleString('en-GB'); if(bc) bc.textContent=String(new Set(DB.map(p=>p.brand)).size); }

/* ---- email me my build (phase 2 — separate, explicit marketing opt-in; saving never depends on it) ---- */
let EMAIL_CAPTURE_ON=true;    // LIVE 6 Sept 2026 — Vercel endpoint configured + Omnisend 'designer build saved' automation
const EMAIL_ENDPOINT='https://gigrig-designer-api.vercel.app/api/email-build';
const closeEmailPanel=()=>{ $('emailPanel').style.display='none'; $('emailMsg').textContent=''; };
$('emailBtn').onclick=()=>{ closeNamePanel(); $('emailPanel').style.display='flex'; $('emailAddr').focus(); };
$('emailCancel').onclick=closeEmailPanel;
$('emailSend').onclick=async()=>{
  const email=$('emailAddr').value.trim(), msg=$('emailMsg');
  if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)){ msg.style.color='var(--bad)'; msg.textContent='Enter a valid email address.'; $('emailAddr').focus(); return; }
  const btn=$('emailSend'), old=btn.textContent; btn.disabled=true; btn.textContent='Sending…'; msg.textContent='';
  const active=activeSaveId && loadSaves().find(x=>x.id===activeSaveId);
  try{
    const r=await fetch(EMAIL_ENDPOINT,{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({email, optIn:$('emailOptin').checked, buildUrl:buildLink(), boardName: active?active.name:''})});
    if(!r.ok) throw new Error('http '+r.status);
    msg.style.color='var(--v9)'; msg.textContent='✓ On its way — check your inbox for your Pedal Path Planner.';
    $('emailAddr').value=''; $('emailOptin').checked=false;
    setTimeout(closeEmailPanel,3800);
  }catch(e){ msg.style.color='var(--bad)'; msg.textContent='Couldn’t send just now — your Copy link above still works.'; }
  btn.disabled=false; btn.textContent=old;
};
$('emailAddr').addEventListener('keydown',e=>{ if(e.key==='Enter'){ e.preventDefault(); $('emailSend').click(); } if(e.key==='Escape') closeEmailPanel(); });
function setSeg(id,val){ document.querySelectorAll('#'+id+' button').forEach(b=>b.classList.toggle('on', b.dataset.v===String(val))); }
function syncControls(){
  setSeg('qAmps',rig.amps); setSeg('q4cm',rig.fourCM?'yes':'no'); setSeg('qModPos',rig.modPos); setSeg('qStyle',rig.style);
  $('qScreens').checked=rig.screens;
  $('modePower').classList.toggle('on',mode==='power'); $('modePower').setAttribute('aria-selected',mode==='power');
  $('modeSignal').classList.toggle('on',mode==='signal'); $('modeSignal').setAttribute('aria-selected',mode==='signal');
  $('rigCard').hidden=mode!=='signal';
  $('tagline').textContent = mode==='power' ? 'Pick your pedals. We’ll work out the power.' : 'Pick your pedals. We’ll work out the order, the loops and the switcher.';
}
$('copyLink').onclick=async()=>{
  const link=buildLink(), btn=$('copyLink'), old=btn.textContent;
  try{ await navigator.clipboard.writeText(link); }
  catch(e){ const t=document.createElement('textarea'); t.value=link; document.body.appendChild(t); t.select(); try{document.execCommand('copy');}catch(_){}
    document.body.removeChild(t); }
  btn.textContent='✓ Link copied — paste it anywhere'; setTimeout(()=>{ btn.textContent=old; },2600);
};
$('clearBoard').onclick=()=>{
  board=[]; rig.always.clear(); rig.stereoOn.clear();
  rig.gainOrder=[]; rig.loopOrder=[]; rig.gainTouched=false; rig.loopTouched=false;
  activeSaveId=null; closeNamePanel();
  if(location.hash) history.replaceState(null,'',location.pathname+location.search);
  update();
};

// a build link pasted into the same open tab only changes the hash (no reload) — handle it live
window.addEventListener('hashchange',()=>{
  const m=location.hash.match(/[#&]build=([^&]+)/);
  if(!m) return;
  try{ if(restoreBuild(JSON.parse(unb64(m[1])))){ activeSaveId=null; syncControls(); update(); window.scrollTo({top:0,behavior:'smooth'}); } }catch(e){}
});

bootRestore();
update();
